import { Component as e } from "@theme/component";
import { DialogCloseEvent as t, DialogOpenEvent as n } from "@theme/dialog";
import { isMobileBreakpoint as r, prefersReducedMotion as i } from "@theme/utilities";
import { formatMoney as a } from "@theme/money-formatting";
//#region \0rolldown/runtime.js
var o = Object.create, s = Object.defineProperty, c = Object.getOwnPropertyDescriptor, l = Object.getOwnPropertyNames, u = Object.getPrototypeOf, d = Object.prototype.hasOwnProperty, f = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, p = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), m = (e, t) => {
	let n = {};
	for (var r in e) s(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || s(n, Symbol.toStringTag, { value: "Module" }), n;
}, h = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = l(t), a = 0, o = i.length, u; a < o; a++) u = i[a], !d.call(e, u) && u !== n && s(e, u, {
		get: ((e) => t[e]).bind(null, u),
		enumerable: !(r = c(t, u)) || r.enumerable
	});
	return e;
}, g = (e, t, n) => (n = e == null ? {} : o(u(e)), h(t || !e || !e.__esModule ? s(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), _ = (e) => d.call(e, "module.exports") ? e["module.exports"] : h(s({}, "__esModule", { value: !0 }), e);
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/createRef.js
function v(e) {
	return { current: e };
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/debounce.js
function y(e, t) {
	var n = void 0;
	return function() {
		var r = [...arguments];
		n && clearTimeout(n), n = setTimeout(function() {
			return e.apply(void 0, r);
		}, t);
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/flatten.js
function b(e) {
	return e.reduce(function(e, t) {
		return e.concat(t);
	}, []);
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/generateAutocompleteId.js
var x = 0;
function S() {
	return `autocomplete-${x++}`;
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/getAttributeValueByPath.js
function C(e, t) {
	return t.reduce(function(e, t) {
		return e && e[t];
	}, e);
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/getItemsCount.js
function w(e) {
	return e.collections.length === 0 ? 0 : e.collections.reduce(function(e, t) {
		return e + t.items.length;
	}, 0);
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/isEqual.js
function T(e) {
	return e !== Object(e);
}
function E(e, t) {
	if (e === t) return !0;
	if (T(e) || T(t) || typeof e == "function" || typeof t == "function") return e === t;
	if (Object.keys(e).length !== Object.keys(t).length) return !1;
	for (var n = 0, r = Object.keys(e); n < r.length; n++) {
		var i = r[n];
		if (!(i in t) || !E(e[i], t[i])) return !1;
	}
	return !0;
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/noop.js
var D = function() {};
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/safelyRunOnBrowser.js
function ee(e) {
	if (typeof window < "u") return e({ window });
}
//#endregion
//#region node_modules/@algolia/autocomplete-shared/dist/esm/version.js
var O = "1.19.9", k = [{
	segment: "autocomplete-core",
	version: O
}];
//#endregion
//#region node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/createClickedEvent.js
function A(e) {
	var t = e.item, n = e.items, r = n === void 0 ? [] : n;
	return {
		index: t.__autocomplete_indexName,
		items: [t],
		positions: [1 + r.findIndex(function(e) {
			return e.objectID === t.objectID;
		})],
		queryID: t.__autocomplete_queryID,
		algoliaSource: ["autocomplete"]
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/isModernInsightsClient.js
function j(e, t) {
	return ie(e) || re(e, t) || ne(e, t) || te();
}
function te() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ne(e, t) {
	if (e) {
		if (typeof e == "string") return M(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? M(e, t) : void 0;
	}
}
function M(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function re(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t === 0) {
				if (Object(n) !== n) return;
				c = !1;
			} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function ie(e) {
	if (Array.isArray(e)) return e;
}
function ae(e) {
	var t = j((e.version || "").split(".").map(Number), 2), n = t[0], r = t[1];
	return n >= 3 || n === 2 && r >= 4 || n === 1 && r >= 10;
}
//#endregion
//#region node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/createSearchInsightsApi.js
var oe = ["items"], se = ["items"];
function N(e) {
	"@babel/helpers - typeof";
	return N = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, N(e);
}
function ce(e) {
	return fe(e) || de(e) || ue(e) || le();
}
function le() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ue(e, t) {
	if (e) {
		if (typeof e == "string") return pe(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pe(e, t) : void 0;
	}
}
function de(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function fe(e) {
	if (Array.isArray(e)) return pe(e);
}
function pe(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function me(e, t) {
	if (e == null) return {};
	var n, r, i = he(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function he(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function ge(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function _e(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ge(Object(n), !0).forEach(function(t) {
			ve(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ge(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function ve(e, t, n) {
	return (t = ye(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ye(e) {
	var t = be(e, "string");
	return N(t) == "symbol" ? t : t + "";
}
function be(e, t) {
	if (N(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (N(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function xe(e) {
	for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, n = [], r = 0; r < e.objectIDs.length; r += t) n.push(_e(_e({}, e), {}, { objectIDs: e.objectIDs.slice(r, r + t) }));
	return n;
}
function Se(e) {
	return e.map(function(e) {
		var t = e.items, n = me(e, oe);
		return _e(_e({}, n), {}, { objectIDs: t?.map(function(e) {
			return e.objectID;
		}) || n.objectIDs });
	});
}
function Ce(e) {
	var t = ae(e);
	function n(n, r, i) {
		if (t && i !== void 0) {
			var a = i[0].__autocomplete_algoliaCredentials, o = {
				"X-Algolia-Application-Id": a.appId,
				"X-Algolia-API-Key": a.apiKey
			};
			e.apply(void 0, [n].concat(ce(r), [{ headers: o }]));
		} else e.apply(void 0, [n].concat(ce(r)));
	}
	return {
		init: function(t, n) {
			e("init", {
				appId: t,
				apiKey: n
			});
		},
		setAuthenticatedUserToken: function(t) {
			e("setAuthenticatedUserToken", t);
		},
		setUserToken: function(t) {
			e("setUserToken", t);
		},
		clickedObjectIDsAfterSearch: function() {
			var e = [...arguments];
			e.length > 0 && n("clickedObjectIDsAfterSearch", Se(e), e[0].items);
		},
		clickedObjectIDs: function() {
			var e = [...arguments];
			e.length > 0 && n("clickedObjectIDs", Se(e), e[0].items);
		},
		clickedFilters: function() {
			var t = [...arguments];
			t.length > 0 && e.apply(void 0, ["clickedFilters"].concat(t));
		},
		convertedObjectIDsAfterSearch: function() {
			var e = [...arguments];
			e.length > 0 && n("convertedObjectIDsAfterSearch", Se(e), e[0].items);
		},
		convertedObjectIDs: function() {
			var e = [...arguments];
			e.length > 0 && n("convertedObjectIDs", Se(e), e[0].items);
		},
		convertedFilters: function() {
			var t = [...arguments];
			t.length > 0 && e.apply(void 0, ["convertedFilters"].concat(t));
		},
		viewedObjectIDs: function() {
			var e = [...arguments];
			e.length > 0 && e.reduce(function(e, t) {
				var n = t.items, r = me(t, se);
				return [].concat(ce(e), ce(xe(_e(_e({}, r), {}, { objectIDs: n?.map(function(e) {
					return e.objectID;
				}) || r.objectIDs })).map(function(e) {
					return {
						items: n,
						payload: e
					};
				})));
			}, []).forEach(function(e) {
				var t = e.items, r = e.payload;
				return n("viewedObjectIDs", [r], t);
			});
		},
		viewedFilters: function() {
			var t = [...arguments];
			t.length > 0 && e.apply(void 0, ["viewedFilters"].concat(t));
		}
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/createViewedEvents.js
function we(e) {
	var t = e.items.reduce(function(e, t) {
		return e[t.__autocomplete_indexName] = (e[t.__autocomplete_indexName] ?? []).concat(t), e;
	}, {});
	return Object.keys(t).map(function(e) {
		return {
			index: e,
			items: t[e],
			algoliaSource: ["autocomplete"]
		};
	});
}
//#endregion
//#region node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/isAlgoliaInsightsHit.js
function Te(e) {
	return e.objectID && e.__autocomplete_indexName && e.__autocomplete_queryID;
}
//#endregion
//#region node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/createAlgoliaInsightsPlugin.js
function Ee(e) {
	"@babel/helpers - typeof";
	return Ee = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Ee(e);
}
function De(e) {
	return je(e) || Ae(e) || ke(e) || Oe();
}
function Oe() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ke(e, t) {
	if (e) {
		if (typeof e == "string") return Me(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Me(e, t) : void 0;
	}
}
function Ae(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function je(e) {
	if (Array.isArray(e)) return Me(e);
}
function Me(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Ne(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Pe(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Ne(Object(n), !0).forEach(function(t) {
			Fe(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ne(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Fe(e, t, n) {
	return (t = Ie(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Ie(e) {
	var t = Le(e, "string");
	return Ee(t) == "symbol" ? t : t + "";
}
function Le(e, t) {
	if (Ee(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Ee(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
var P = 400, Re = "2.15.0", ze = `https://cdn.jsdelivr.net/npm/search-insights@${Re}/dist/search-insights.min.js`, Be = y(function(e) {
	var t = e.onItemsChange, n = e.items, r = e.insights, i = e.state;
	t({
		insights: r,
		insightsEvents: we({ items: n }).map(function(e) {
			return Pe({ eventName: "Items Viewed" }, e);
		}),
		state: i
	});
}, P);
function Ve(e) {
	var t = Ue(e), n = t.insightsClient, r = t.insightsInitParams, i = t.onItemsChange, a = t.onSelect, o = t.onActive, s = t.__autocomplete_clickAnalytics, c = n;
	if (n || ee(function(e) {
		var t = e.window, n = t.AlgoliaAnalyticsObject || "aa";
		typeof n == "string" && (c = t[n]), c || (t.AlgoliaAnalyticsObject = n, t[n] || (t[n] = function() {
			t[n].queue || (t[n].queue = []);
			var e = [...arguments];
			t[n].queue.push(e);
		}), t[n].version = Re, c = t[n], We(t));
	}), !c) return {};
	r && c("init", Pe({ partial: !0 }, r));
	var l = Ce(c), u = v([]), d = y(function(e) {
		var t = e.state;
		if (t.isOpen) {
			var n = t.collections.reduce(function(e, t) {
				return [].concat(De(e), De(t.items));
			}, []).filter(Te);
			E(u.current.map(function(e) {
				return e.objectID;
			}), n.map(function(e) {
				return e.objectID;
			})) || (u.current = n, n.length > 0 && Be({
				onItemsChange: i,
				items: n,
				insights: l,
				state: t
			}));
		}
	}, 0);
	return {
		name: "aa.algoliaInsightsPlugin",
		subscribe: function(e) {
			var t = e.setContext, n = e.onSelect, r = e.onActive;
			function i(e) {
				t({ algoliaInsightsPlugin: {
					__algoliaSearchParameters: Pe(Pe({}, s ? { clickAnalytics: !0 } : {}), e ? { userToken: Ge(e) } : {}),
					insights: l
				} });
			}
			c("addAlgoliaAgent", "insights-plugin"), i(), c("onUserTokenChange", function(e) {
				i(e);
			}), c("getUserToken", null, function(e, t) {
				i(t);
			}), n(function(e) {
				var t = e.item, n = e.state, r = e.event, i = e.source;
				Te(t) && a({
					state: n,
					event: r,
					insights: l,
					item: t,
					insightsEvents: [Pe({ eventName: "Item Selected" }, A({
						item: t,
						items: i.getItems().filter(Te)
					}))]
				});
			}), r(function(e) {
				var t = e.item, n = e.source, r = e.state, i = e.event;
				Te(t) && o({
					state: r,
					event: i,
					insights: l,
					item: t,
					insightsEvents: [Pe({ eventName: "Item Active" }, A({
						item: t,
						items: n.getItems().filter(Te)
					}))]
				});
			});
		},
		onStateChange: function(e) {
			var t = e.state;
			d({ state: t });
		},
		__autocomplete_pluginOptions: e
	};
}
function He() {
	var e, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 ? arguments[1] : void 0;
	return [].concat(De(t), ["autocomplete-internal"], De((e = n.algoliaInsightsPlugin) != null && e.__automaticInsights ? ["autocomplete-automatic"] : []));
}
function Ue(e) {
	return Pe({
		onItemsChange: function(e) {
			var t = e.insights, n = e.insightsEvents, r = e.state;
			t.viewedObjectIDs.apply(t, De(n.map(function(e) {
				return Pe(Pe({}, e), {}, { algoliaSource: He(e.algoliaSource, r.context) });
			})));
		},
		onSelect: function(e) {
			var t = e.insights, n = e.insightsEvents, r = e.state;
			t.clickedObjectIDsAfterSearch.apply(t, De(n.map(function(e) {
				return Pe(Pe({}, e), {}, { algoliaSource: He(e.algoliaSource, r.context) });
			})));
		},
		onActive: D,
		__autocomplete_clickAnalytics: !0
	}, e);
}
function We(e) {
	var t = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
	try {
		var n = e.document.createElement("script");
		n.async = !0, n.src = ze, n.onerror = function() {
			console.error(t);
		}, document.body.appendChild(n);
	} catch {
		console.error(t);
	}
}
function Ge(e) {
	return typeof e == "number" ? e.toString() : e;
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/createCancelablePromise.js
function Ke(e, t) {
	var n = t;
	return {
		then: function(t, r) {
			return Ke(e.then(Ye(t, n, e), Ye(r, n, e)), n);
		},
		catch: function(t) {
			return Ke(e.catch(Ye(t, n, e)), n);
		},
		finally: function(t) {
			return t && n.onCancelList.push(t), Ke(e.finally(Ye(t && function() {
				return n.onCancelList = [], t();
			}, n, e)), n);
		},
		cancel: function() {
			n.isCanceled = !0;
			var e = n.onCancelList;
			n.onCancelList = [], e.forEach(function(e) {
				e();
			});
		},
		isCanceled: function() {
			return n.isCanceled === !0;
		}
	};
}
function qe(e) {
	return Ke(new Promise(function(t, n) {
		return e(t, n);
	}), {
		isCanceled: !1,
		onCancelList: []
	});
}
qe.resolve = function(e) {
	return Je(Promise.resolve(e));
}, qe.reject = function(e) {
	return Je(Promise.reject(e));
};
function Je(e) {
	return Ke(e, {
		isCanceled: !1,
		onCancelList: []
	});
}
function Ye(e, t, n) {
	return e ? function(n) {
		return t.isCanceled ? n : e(n);
	} : n;
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/createCancelablePromiseList.js
var Xe = !0, Ze;
function Qe() {
	var e = [];
	return {
		add: function(t) {
			return e.push(t), t.finally(function() {
				e = e.filter(function(e) {
					return e !== t;
				});
			});
		},
		cancelAll: function() {
			e.forEach(function(e) {
				return e.cancel();
			});
		},
		isEmpty: function() {
			return e.length === 0;
		},
		wait: function(t) {
			return Xe ? (Xe = !1, Ze = t ? Promise.race([Promise.all(e), new Promise(function(e) {
				return setTimeout(e, t);
			})]) : Promise.all(e), Ze.then(function() {
				Xe = !0;
			})) : Ze;
		}
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/createConcurrentSafePromise.js
function $e() {
	var e = -1, t = -1, n = void 0;
	return function(r) {
		e++;
		var i = e;
		return Promise.resolve(r).then(function(e) {
			return n && i < t ? n : (t = i, n = e, e);
		});
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/getNextActiveItemId.js
function et(e, t, n, r) {
	if (!n) return null;
	if (e < 0 && (t === null || r !== null && t === 0)) return n + e;
	var i = (t === null ? -1 : t) + e;
	return i <= -1 || i >= n ? r === null ? null : 0 : i;
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/getNormalizedSources.js
function tt(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function nt(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? tt(Object(n), !0).forEach(function(t) {
			rt(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tt(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function rt(e, t, n) {
	return (t = it(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function it(e) {
	var t = F(e, "string");
	return at(t) == "symbol" ? t : t + "";
}
function F(e, t) {
	if (at(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (at(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function at(e) {
	"@babel/helpers - typeof";
	return at = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, at(e);
}
function ot(e, t) {
	var n = [];
	return Promise.resolve(e(t)).then(function(e) {
		return Promise.all(e.filter(function(e) {
			return !!e;
		}).map(function(e) {
			if (e.sourceId, n.includes(e.sourceId)) throw Error(`[Autocomplete] The \`sourceId\` ${JSON.stringify(e.sourceId)} is not unique.`);
			n.push(e.sourceId);
			var t = {
				getItemInputValue: function(e) {
					return e.state.query;
				},
				getItemUrl: function() {},
				onSelect: function(e) {
					var t = e.setIsOpen;
					t(!1);
				},
				onActive: D,
				onResolve: D
			};
			Object.keys(t).forEach(function(e) {
				t[e].__default = !0;
			});
			var r = nt(nt({}, t), e);
			return Promise.resolve(r);
		}));
	});
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/getPluginSubmitPromise.js
function st(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (!n) {
		if (Array.isArray(e) || (n = ct(e)) || t && e && typeof e.length == "number") {
			n && (e = n);
			var r = 0, i = function() {};
			return {
				s: i,
				n: function() {
					return r >= e.length ? { done: !0 } : {
						done: !1,
						value: e[r++]
					};
				},
				e: function(e) {
					throw e;
				},
				f: i
			};
		}
		throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	var a, o = !0, s = !1;
	return {
		s: function() {
			n = n.call(e);
		},
		n: function() {
			var e = n.next();
			return o = e.done, e;
		},
		e: function(e) {
			s = !0, a = e;
		},
		f: function() {
			try {
				o || n.return == null || n.return();
			} finally {
				if (s) throw a;
			}
		}
	};
}
function ct(e, t) {
	if (e) {
		if (typeof e == "string") return lt(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? lt(e, t) : void 0;
	}
}
function lt(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
var ut = function(e, t) {
	var n = !1, r = [], i = st(e), a;
	try {
		for (i.s(); !(a = i.n()).done;) {
			var o, s = (o = a.value.__autocomplete_pluginOptions)?.awaitSubmit?.call(o);
			if (typeof s == "number") r.push(s);
			else if (s === !0) {
				n = !0;
				break;
			}
		}
	} catch (e) {
		i.e(e);
	} finally {
		i.f();
	}
	if (n) return t.wait();
	if (r.length > 0) return t.wait(Math.max.apply(Math, r));
};
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/getActiveItem.js
function dt(e) {
	var t = e.collections.map(function(e) {
		return e.items.length;
	}).reduce(function(e, t, n) {
		var r = (e[n - 1] || 0) + t;
		return e.push(r), e;
	}, []).reduce(function(t, n) {
		return n <= e.activeItemId ? t + 1 : t;
	}, 0);
	return e.collections[t];
}
function ft(e) {
	for (var t = e.state, n = e.collection, r = !1, i = 0, a = 0; r === !1;) {
		var o = t.collections[i];
		if (o === n) {
			r = !0;
			break;
		}
		a += o.items.length, i++;
	}
	return t.activeItemId - a;
}
function pt(e) {
	var t = dt(e);
	if (!t) return null;
	var n = t.items[ft({
		state: e,
		collection: t
	})], r = t.source;
	return {
		item: n,
		itemInputValue: r.getItemInputValue({
			item: n,
			state: e
		}),
		itemUrl: r.getItemUrl({
			item: n,
			state: e
		}),
		source: r
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/getAutocompleteElementId.js
function mt(e, t, n) {
	return [
		e,
		n?.sourceId,
		t
	].filter(Boolean).join("-").replace(/\s/g, "");
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/isOrContainsNode.js
function ht(e, t) {
	return e === t || e.contains(t);
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/isSamsung.js
var gt = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
function _t(e) {
	return !!(e && e.match(gt));
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/mapToAlgoliaResponse.js
function vt(e) {
	return {
		results: e,
		hits: e.map(function(e) {
			return e.hits;
		}).filter(Boolean),
		facetHits: e.map(function(e) {
			return e.facetHits?.map(function(e) {
				return {
					label: e.value,
					count: e.count,
					_highlightResult: { label: { value: e.highlighted } }
				};
			});
		}).filter(Boolean)
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/utils/getNativeEvent.js
function yt(e) {
	return e.nativeEvent || e;
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/createStore.js
function bt(e) {
	"@babel/helpers - typeof";
	return bt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, bt(e);
}
function xt(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function St(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? xt(Object(n), !0).forEach(function(t) {
			Ct(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Ct(e, t, n) {
	return (t = wt(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function wt(e) {
	var t = Tt(e, "string");
	return bt(t) == "symbol" ? t : t + "";
}
function Tt(e, t) {
	if (bt(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (bt(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Et(e, t, n) {
	var r = t.initialState;
	return {
		getState: function() {
			return r;
		},
		dispatch: function(i, a) {
			var o = St({}, r);
			r = e(r, {
				type: i,
				props: t,
				payload: a
			}), n({
				state: r,
				prevState: o
			});
		},
		pendingRequests: Qe()
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/getAutocompleteSetters.js
function Dt(e) {
	"@babel/helpers - typeof";
	return Dt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Dt(e);
}
function Ot(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function kt(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Ot(Object(n), !0).forEach(function(t) {
			At(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ot(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function At(e, t, n) {
	return (t = jt(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function jt(e) {
	var t = Mt(e, "string");
	return Dt(t) == "symbol" ? t : t + "";
}
function Mt(e, t) {
	if (Dt(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Dt(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Nt(e) {
	var t = e.store;
	return {
		setActiveItemId: function(e) {
			t.dispatch("setActiveItemId", e);
		},
		setQuery: function(e) {
			t.dispatch("setQuery", e);
		},
		setCollections: function(e) {
			var n = 0, r = e.map(function(e) {
				return kt(kt({}, e), {}, { items: b(e.items).map(function(e) {
					return kt(kt({}, e), {}, { __autocomplete_id: n++ });
				}) });
			});
			t.dispatch("setCollections", r);
		},
		setIsOpen: function(e) {
			t.dispatch("setIsOpen", e);
		},
		setStatus: function(e) {
			t.dispatch("setStatus", e);
		},
		setContext: function(e) {
			t.dispatch("setContext", e);
		}
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/getDefaultProps.js
function Pt(e) {
	"@babel/helpers - typeof";
	return Pt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Pt(e);
}
function Ft(e) {
	return zt(e) || Rt(e) || Lt(e) || It();
}
function It() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Lt(e, t) {
	if (e) {
		if (typeof e == "string") return Bt(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Bt(e, t) : void 0;
	}
}
function Rt(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function zt(e) {
	if (Array.isArray(e)) return Bt(e);
}
function Bt(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Vt(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ht(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Vt(Object(n), !0).forEach(function(t) {
			Ut(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vt(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Ut(e, t, n) {
	return (t = Wt(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Wt(e) {
	var t = Gt(e, "string");
	return Pt(t) == "symbol" ? t : t + "";
}
function Gt(e, t) {
	if (Pt(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Pt(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Kt(e, t) {
	var n = typeof window < "u" ? window : {}, r = e.plugins || [];
	return Ht(Ht({
		debug: !1,
		openOnFocus: !1,
		enterKeyHint: void 0,
		ignoreCompositionEvents: !1,
		placeholder: "",
		autoFocus: !1,
		defaultActiveItemId: null,
		stallThreshold: 300,
		insights: void 0,
		environment: n,
		shouldPanelOpen: function(e) {
			var t = e.state;
			return w(t) > 0;
		},
		reshape: function(e) {
			return e.sources;
		}
	}, e), {}, {
		id: e.id ?? S(),
		plugins: r,
		initialState: Ht({
			activeItemId: null,
			query: "",
			completion: null,
			collections: [],
			isOpen: !1,
			status: "idle",
			context: {}
		}, e.initialState),
		onStateChange: function(t) {
			var n;
			(n = e.onStateChange) == null || n.call(e, t), r.forEach(function(e) {
				return e.onStateChange?.call(e, t);
			});
		},
		onSubmit: function(t) {
			var n;
			(n = e.onSubmit) == null || n.call(e, t), r.forEach(function(e) {
				return e.onSubmit?.call(e, t);
			});
		},
		onReset: function(t) {
			var n;
			(n = e.onReset) == null || n.call(e, t), r.forEach(function(e) {
				return e.onReset?.call(e, t);
			});
		},
		getSources: function(n) {
			return Promise.all([].concat(Ft(r.map(function(e) {
				return e.getSources;
			})), [e.getSources]).filter(Boolean).map(function(e) {
				return ot(e, n);
			})).then(function(e) {
				return b(e);
			}).then(function(e) {
				return e.map(function(e) {
					return Ht(Ht({}, e), {}, {
						onSelect: function(n) {
							e.onSelect(n), t.forEach(function(e) {
								return e.onSelect?.call(e, n);
							});
						},
						onActive: function(n) {
							e.onActive(n), t.forEach(function(e) {
								return e.onActive?.call(e, n);
							});
						},
						onResolve: function(n) {
							e.onResolve(n), t.forEach(function(e) {
								return e.onResolve?.call(e, n);
							});
						}
					});
				});
			});
		},
		navigator: Ht({
			navigate: function(e) {
				var t = e.itemUrl;
				n.location.assign(t);
			},
			navigateNewTab: function(e) {
				var t = e.itemUrl;
				n.open(t, "_blank", "noopener")?.focus();
			},
			navigateNewWindow: function(e) {
				var t = e.itemUrl;
				n.open(t, "_blank", "noopener");
			}
		}, e.navigator)
	});
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/reshape.js
function qt(e) {
	"@babel/helpers - typeof";
	return qt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, qt(e);
}
function Jt(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Yt(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Jt(Object(n), !0).forEach(function(t) {
			Xt(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jt(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Xt(e, t, n) {
	return (t = Zt(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Zt(e) {
	var t = Qt(e, "string");
	return qt(t) == "symbol" ? t : t + "";
}
function Qt(e, t) {
	if (qt(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (qt(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function $t(e) {
	var t = e.collections, n = e.props, r = e.state, i = t.reduce(function(e, t) {
		return Yt(Yt({}, e), {}, Xt({}, t.source.sourceId, Yt(Yt({}, t.source), {}, { getItems: function() {
			return b(t.items);
		} })));
	}, {}), a = n.plugins.reduce(function(e, t) {
		return t.reshape ? t.reshape(e) : e;
	}, {
		sourcesBySourceId: i,
		state: r
	}).sourcesBySourceId;
	return b(n.reshape({
		sourcesBySourceId: a,
		sources: Object.values(a),
		state: r
	})).filter(Boolean).map(function(e) {
		return {
			source: e,
			items: e.getItems()
		};
	});
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/resolve.js
function en(e) {
	"@babel/helpers - typeof";
	return en = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, en(e);
}
function tn(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function nn(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? tn(Object(n), !0).forEach(function(t) {
			rn(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tn(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function rn(e, t, n) {
	return (t = an(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function an(e) {
	var t = on(e, "string");
	return en(t) == "symbol" ? t : t + "";
}
function on(e, t) {
	if (en(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (en(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function sn(e) {
	return dn(e) || un(e) || ln(e) || cn();
}
function cn() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ln(e, t) {
	if (e) {
		if (typeof e == "string") return fn(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? fn(e, t) : void 0;
	}
}
function un(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function dn(e) {
	if (Array.isArray(e)) return fn(e);
}
function fn(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function pn(e) {
	return !!e.execute;
}
function mn(e) {
	return !!e?.execute;
}
function hn(e, t, n) {
	if (mn(e)) {
		var r = e.requesterId === "algolia" ? Object.assign.apply(Object, [{}].concat(sn(Object.keys(n.context).map(function(e) {
			return n.context[e]?.__algoliaSearchParameters;
		})))) : {};
		return nn(nn({}, e), {}, { requests: e.queries.map(function(n) {
			return {
				query: e.requesterId === "algolia" ? nn(nn({}, n), {}, { params: nn(nn({}, r), n.params) }) : n,
				sourceId: t,
				transformResponse: e.transformResponse
			};
		}) });
	}
	return {
		items: e,
		sourceId: t
	};
}
function gn(e) {
	var t = e.reduce(function(e, t) {
		if (!pn(t)) return e.push(t), e;
		var n = t.searchClient, r = t.execute, i = t.requesterId, a = t.requests, o = e.find(function(e) {
			return pn(t) && pn(e) && e.searchClient === n && !!i && e.requesterId === i;
		});
		if (o) {
			var s;
			(s = o.items).push.apply(s, sn(a));
		} else {
			var c = {
				execute: r,
				requesterId: i,
				items: a,
				searchClient: n
			};
			e.push(c);
		}
		return e;
	}, []).map(function(e) {
		if (!pn(e)) return Promise.resolve(e);
		var t = e, n = t.execute, r = t.items, i = t.searchClient;
		return n({
			searchClient: i,
			requests: r
		});
	});
	return Promise.all(t).then(function(e) {
		return b(e);
	});
}
function _n(e, t, n) {
	return t.map(function(t) {
		var r = e.filter(function(e) {
			return e.sourceId === t.sourceId;
		}), i = r.map(function(e) {
			return e.items;
		}), a = r[0].transformResponse, o = a ? a(vt(i)) : i;
		return t.onResolve({
			source: t,
			results: i,
			items: o,
			state: n.getState()
		}), o.every(Boolean), `${t.sourceId}${JSON.stringify(void 0)}`, {
			source: t,
			items: o
		};
	});
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/onInput.js
function vn(e) {
	"@babel/helpers - typeof";
	return vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, vn(e);
}
var yn = [
	"event",
	"nextState",
	"props",
	"query",
	"refresh",
	"store"
];
function bn(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function xn(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? bn(Object(n), !0).forEach(function(t) {
			Sn(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bn(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Sn(e, t, n) {
	return (t = Cn(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Cn(e) {
	var t = wn(e, "string");
	return vn(t) == "symbol" ? t : t + "";
}
function wn(e, t) {
	if (vn(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (vn(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Tn(e, t) {
	if (e == null) return {};
	var n, r, i = En(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function En(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
var Dn = null, On = $e();
function kn(e) {
	var t = e.event, n = e.nextState, r = n === void 0 ? {} : n, i = e.props, a = e.query, o = e.refresh, s = e.store, c = Tn(e, yn);
	Dn && i.environment.clearTimeout(Dn);
	var l = c.setCollections, u = c.setIsOpen, d = c.setQuery, f = c.setActiveItemId, p = c.setStatus, m = c.setContext;
	if (d(a), f(i.defaultActiveItemId), !a && i.openOnFocus === !1) {
		var h = s.getState().collections.map(function(e) {
			return xn(xn({}, e), {}, { items: [] });
		});
		p("idle"), l(h), u(r.isOpen ?? i.shouldPanelOpen({ state: s.getState() }));
		var g = Je(On(h).then(function() {
			return Promise.resolve();
		}));
		return s.pendingRequests.add(g);
	}
	p("loading"), Dn = i.environment.setTimeout(function() {
		p("stalled");
	}, i.stallThreshold);
	var _ = Je(On(i.getSources(xn({
		query: a,
		refresh: o,
		state: s.getState()
	}, c)).then(function(e) {
		return Promise.all(e.map(function(e) {
			return Promise.resolve(e.getItems(xn({
				query: a,
				refresh: o,
				state: s.getState()
			}, c))).then(function(t) {
				return hn(t, e.sourceId, s.getState());
			});
		})).then(gn).then(function(t) {
			var n = t.some(function(e) {
				var t = e.items;
				return An(t);
			});
			return n && m({ algoliaInsightsPlugin: xn(xn({}, s.getState().context?.algoliaInsightsPlugin || {}), {}, { __automaticInsights: n }) }), _n(t, e, s);
		}).then(function(e) {
			return $t({
				collections: e,
				props: i,
				state: s.getState()
			});
		});
	}))).then(function(e) {
		p("idle"), l(e);
		var n = i.shouldPanelOpen({ state: s.getState() });
		u(r.isOpen ?? (i.openOnFocus && !a && n || n));
		var d = pt(s.getState());
		if (s.getState().activeItemId !== null && d) {
			var f = d.item, m = d.itemInputValue, h = d.itemUrl, g = d.source;
			g.onActive(xn({
				event: t,
				item: f,
				itemInputValue: m,
				itemUrl: h,
				refresh: o,
				source: g,
				state: s.getState()
			}, c));
		}
	}).finally(function() {
		p("idle"), Dn && i.environment.clearTimeout(Dn);
	});
	return s.pendingRequests.add(_);
}
function An(e) {
	return !Array.isArray(e) && !!e?._automaticInsights;
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/onKeyDown.js
function jn(e) {
	"@babel/helpers - typeof";
	return jn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, jn(e);
}
var Mn = [
	"event",
	"props",
	"refresh",
	"store"
];
function Nn(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Pn(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Nn(Object(n), !0).forEach(function(t) {
			Fn(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nn(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Fn(e, t, n) {
	return (t = In(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function In(e) {
	var t = Ln(e, "string");
	return jn(t) == "symbol" ? t : t + "";
}
function Ln(e, t) {
	if (jn(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (jn(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Rn(e, t) {
	if (e == null) return {};
	var n, r, i = zn(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function zn(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function Bn(e) {
	var t = e.event, n = e.props, r = e.refresh, i = e.store, a = Rn(e, Mn);
	if (t.key === "ArrowUp" || t.key === "ArrowDown") {
		var o = function() {
			var e = pt(i.getState()), t = n.environment.document.getElementById(mt(n.id, `item-${i.getState().activeItemId}`, e?.source));
			t && t.scrollIntoView({
				block: "nearest",
				inline: "nearest"
			});
		}, s = function() {
			var e = pt(i.getState());
			if (i.getState().activeItemId !== null && e) {
				var n = e.item, o = e.itemInputValue, s = e.itemUrl, c = e.source;
				c.onActive(Pn({
					event: t,
					item: n,
					itemInputValue: o,
					itemUrl: s,
					refresh: r,
					source: c,
					state: i.getState()
				}, a));
			}
		};
		t.preventDefault(), i.getState().isOpen === !1 && (n.openOnFocus || i.getState().query) ? kn(Pn({
			event: t,
			props: n,
			query: i.getState().query,
			refresh: r,
			store: i
		}, a)).then(function() {
			i.dispatch(t.key, { nextActiveItemId: n.defaultActiveItemId }), s(), setTimeout(o, 0);
		}) : (i.dispatch(t.key, {}), s(), o());
	} else if (t.key === "Escape") t.preventDefault(), i.dispatch(t.key, null), i.pendingRequests.cancelAll();
	else if (t.key === "Tab") i.dispatch("blur", null), i.pendingRequests.cancelAll();
	else if (t.key === "Enter") {
		if (i.getState().activeItemId === null || i.getState().collections.every(function(e) {
			return e.items.length === 0;
		})) {
			var c = ut(n.plugins, i.pendingRequests);
			c === void 0 ? n.debug || i.pendingRequests.cancelAll() : c.then(i.pendingRequests.cancelAll);
			return;
		}
		t.preventDefault();
		var l = pt(i.getState()), u = l.item, d = l.itemInputValue, f = l.itemUrl, p = l.source;
		if (t.metaKey || t.ctrlKey) f !== void 0 && (p.onSelect(Pn({
			event: t,
			item: u,
			itemInputValue: d,
			itemUrl: f,
			refresh: r,
			source: p,
			state: i.getState()
		}, a)), n.navigator.navigateNewTab({
			itemUrl: f,
			item: u,
			state: i.getState()
		}));
		else if (t.shiftKey) f !== void 0 && (p.onSelect(Pn({
			event: t,
			item: u,
			itemInputValue: d,
			itemUrl: f,
			refresh: r,
			source: p,
			state: i.getState()
		}, a)), n.navigator.navigateNewWindow({
			itemUrl: f,
			item: u,
			state: i.getState()
		}));
		else if (!t.altKey) {
			if (f !== void 0) {
				p.onSelect(Pn({
					event: t,
					item: u,
					itemInputValue: d,
					itemUrl: f,
					refresh: r,
					source: p,
					state: i.getState()
				}, a)), n.navigator.navigate({
					itemUrl: f,
					item: u,
					state: i.getState()
				});
				return;
			}
			kn(Pn({
				event: t,
				nextState: { isOpen: !1 },
				props: n,
				query: d,
				refresh: r,
				store: i
			}, a)).then(function() {
				p.onSelect(Pn({
					event: t,
					item: u,
					itemInputValue: d,
					itemUrl: f,
					refresh: r,
					source: p,
					state: i.getState()
				}, a));
			});
		}
	}
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/getPropGetters.js
function Vn(e) {
	"@babel/helpers - typeof";
	return Vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Vn(e);
}
var Hn = [
	"props",
	"refresh",
	"store"
], Un = [
	"inputElement",
	"formElement",
	"panelElement"
], Wn = ["inputElement"], Gn = ["inputElement", "maxLength"], Kn = ["source"], qn = ["item", "source"];
function Jn(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Yn(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Jn(Object(n), !0).forEach(function(t) {
			Xn(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jn(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Xn(e, t, n) {
	return (t = Zn(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Zn(e) {
	var t = Qn(e, "string");
	return Vn(t) == "symbol" ? t : t + "";
}
function Qn(e, t) {
	if (Vn(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Vn(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function $n(e, t) {
	if (e == null) return {};
	var n, r, i = er(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function er(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function tr(e) {
	var t = e.props, n = e.refresh, r = e.store, i = $n(e, Hn);
	return {
		getEnvironmentProps: function(e) {
			var n = e.inputElement, i = e.formElement, a = e.panelElement, o = $n(e, Un);
			function s(e) {
				!(r.getState().isOpen || !r.pendingRequests.isEmpty()) || e.target === n || [i, a].some(function(t) {
					return ht(t, e.target);
				}) === !1 && (r.dispatch("blur", null), t.debug || r.pendingRequests.cancelAll());
			}
			return Yn({
				onTouchStart: s,
				onMouseDown: s,
				onTouchMove: function(e) {
					r.getState().isOpen === !1 || n !== t.environment.document.activeElement || e.target === n || n.blur();
				}
			}, o);
		},
		getRootProps: function(e) {
			return Yn({
				role: "combobox",
				"aria-expanded": r.getState().isOpen,
				"aria-haspopup": "listbox",
				"aria-controls": r.getState().isOpen ? r.getState().collections.map(function(e) {
					var n = e.source;
					return mt(t.id, "list", n);
				}).join(" ") : void 0,
				"aria-labelledby": mt(t.id, "label")
			}, e);
		},
		getFormProps: function(e) {
			e.inputElement;
			var a = $n(e, Wn), o = function(a) {
				var o;
				t.onSubmit(Yn({
					event: a,
					refresh: n,
					state: r.getState()
				}, i)), r.dispatch("submit", null), (o = e.inputElement) == null || o.blur();
			};
			return Yn({
				action: "",
				noValidate: !0,
				role: "search",
				onSubmit: function(e) {
					e.preventDefault();
					var n = ut(t.plugins, r.pendingRequests);
					n === void 0 ? o(e) : n.then(function() {
						return o(e);
					});
				},
				onReset: function(a) {
					var o;
					a.preventDefault(), t.onReset(Yn({
						event: a,
						refresh: n,
						state: r.getState()
					}, i)), r.dispatch("reset", null), (o = e.inputElement) == null || o.focus();
				}
			}, a);
		},
		getLabelProps: function(e) {
			return Yn({
				htmlFor: mt(t.id, "input"),
				id: mt(t.id, "label")
			}, e);
		},
		getInputProps: function(e) {
			function a(e) {
				(t.openOnFocus || r.getState().query) && kn(Yn({
					event: e,
					props: t,
					query: r.getState().completion || r.getState().query,
					refresh: n,
					store: r
				}, i)), r.dispatch("focus", null);
			}
			var o = e || {};
			o.inputElement;
			var s = o.maxLength, c = s === void 0 ? 512 : s, l = $n(o, Gn), u = pt(r.getState()), d = _t(t.environment.navigator?.userAgent || ""), f = t.enterKeyHint || (u != null && u.itemUrl && !d ? "go" : "search");
			return Yn({
				"aria-autocomplete": "both",
				"aria-activedescendant": r.getState().isOpen && r.getState().activeItemId !== null ? mt(t.id, `item-${r.getState().activeItemId}`, u?.source) : void 0,
				"aria-controls": r.getState().isOpen ? r.getState().collections.filter(function(e) {
					return e.items.length > 0;
				}).map(function(e) {
					var n = e.source;
					return mt(t.id, "list", n);
				}).join(" ") : void 0,
				"aria-labelledby": mt(t.id, "label"),
				value: r.getState().completion || r.getState().query,
				id: mt(t.id, "input"),
				autoComplete: "off",
				autoCorrect: "off",
				autoCapitalize: "off",
				enterKeyHint: f,
				spellCheck: "false",
				autoFocus: t.autoFocus,
				placeholder: t.placeholder,
				maxLength: c,
				type: "search",
				onChange: function(e) {
					var a = e.currentTarget.value;
					if (t.ignoreCompositionEvents && yt(e).isComposing) {
						i.setQuery(a);
						return;
					}
					kn(Yn({
						event: e,
						props: t,
						query: a.slice(0, c),
						refresh: n,
						store: r
					}, i));
				},
				onCompositionEnd: function(e) {
					kn(Yn({
						event: e,
						props: t,
						query: e.currentTarget.value.slice(0, c),
						refresh: n,
						store: r
					}, i));
				},
				onKeyDown: function(e) {
					yt(e).isComposing || Bn(Yn({
						event: e,
						props: t,
						refresh: n,
						store: r
					}, i));
				},
				onFocus: a,
				onBlur: D,
				onClick: function(n) {
					e.inputElement === t.environment.document.activeElement && !r.getState().isOpen && a(n);
				}
			}, l);
		},
		getPanelProps: function(e) {
			return Yn({
				onMouseDown: function(e) {
					e.preventDefault();
				},
				onMouseLeave: function() {
					r.dispatch("mouseleave", null);
				}
			}, e);
		},
		getListProps: function(e) {
			var n = e || {}, r = n.source, i = $n(n, Kn);
			return Yn({
				role: "listbox",
				"aria-labelledby": mt(t.id, "label"),
				id: mt(t.id, "list", r)
			}, i);
		},
		getItemProps: function(e) {
			var a = e.item, o = e.source, s = $n(e, qn);
			return Yn({
				id: mt(t.id, `item-${a.__autocomplete_id}`, o),
				role: "option",
				"aria-selected": r.getState().activeItemId === a.__autocomplete_id,
				onMouseMove: function(e) {
					if (a.__autocomplete_id !== r.getState().activeItemId) {
						r.dispatch("mousemove", a.__autocomplete_id);
						var t = pt(r.getState());
						if (r.getState().activeItemId !== null && t) {
							var o = t.item, s = t.itemInputValue, c = t.itemUrl, l = t.source;
							l.onActive(Yn({
								event: e,
								item: o,
								itemInputValue: s,
								itemUrl: c,
								refresh: n,
								source: l,
								state: r.getState()
							}, i));
						}
					}
				},
				onMouseDown: function(e) {
					e.preventDefault();
				},
				onClick: function(e) {
					var s = o.getItemInputValue({
						item: a,
						state: r.getState()
					}), c = o.getItemUrl({
						item: a,
						state: r.getState()
					});
					(c ? Promise.resolve() : kn(Yn({
						event: e,
						nextState: { isOpen: !1 },
						props: t,
						query: s,
						refresh: n,
						store: r
					}, i))).then(function() {
						o.onSelect(Yn({
							event: e,
							item: a,
							itemInputValue: s,
							itemUrl: c,
							refresh: n,
							source: o,
							state: r.getState()
						}, i));
					});
				}
			}, s);
		}
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/metadata.js
function nr(e) {
	"@babel/helpers - typeof";
	return nr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, nr(e);
}
function rr(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ir(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? rr(Object(n), !0).forEach(function(t) {
			ar(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rr(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function ar(e, t, n) {
	return (t = or(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function or(e) {
	var t = sr(e, "string");
	return nr(t) == "symbol" ? t : t + "";
}
function sr(e, t) {
	if (nr(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (nr(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function cr(e) {
	var t = e.plugins, n = e.options, r = (n.__autocomplete_metadata?.userAgents || [])[0]?.segment, i = r ? ar({}, r, Object.keys(n.__autocomplete_metadata?.options || {})) : {};
	return {
		plugins: t.map(function(e) {
			return {
				name: e.name,
				options: Object.keys(e.__autocomplete_pluginOptions || [])
			};
		}),
		options: ir({ "autocomplete-core": Object.keys(n) }, i),
		ua: k.concat(n.__autocomplete_metadata?.userAgents || [])
	};
}
function lr(e) {
	var t, n = e.metadata, r = e.environment;
	if ((t = r.navigator) != null && t.userAgent?.includes("Algolia Crawler")) {
		var i = r.document.createElement("meta"), a = r.document.querySelector("head");
		i.name = "algolia:metadata", setTimeout(function() {
			i.content = JSON.stringify(n), a.appendChild(i);
		}, 0);
	}
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/getCompletion.js
function ur(e) {
	var t = e.state;
	return t.isOpen === !1 || t.activeItemId === null ? null : pt(t)?.itemInputValue || null;
}
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/stateReducer.js
function dr(e) {
	"@babel/helpers - typeof";
	return dr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, dr(e);
}
function fr(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function I(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? fr(Object(n), !0).forEach(function(t) {
			pr(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fr(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function pr(e, t, n) {
	return (t = mr(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function mr(e) {
	var t = hr(e, "string");
	return dr(t) == "symbol" ? t : t + "";
}
function hr(e, t) {
	if (dr(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (dr(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
var gr = function(e, t) {
	switch (t.type) {
		case "setActiveItemId": return I(I({}, e), {}, { activeItemId: t.payload });
		case "setQuery": return I(I({}, e), {}, {
			query: t.payload,
			completion: null
		});
		case "setCollections": return I(I({}, e), {}, { collections: t.payload });
		case "setIsOpen": return I(I({}, e), {}, { isOpen: t.payload });
		case "setStatus": return I(I({}, e), {}, { status: t.payload });
		case "setContext": return I(I({}, e), {}, { context: I(I({}, e.context), t.payload) });
		case "ArrowDown":
			var n = I(I({}, e), {}, { activeItemId: t.payload.hasOwnProperty("nextActiveItemId") ? t.payload.nextActiveItemId : et(1, e.activeItemId, w(e), t.props.defaultActiveItemId) });
			return I(I({}, n), {}, { completion: ur({ state: n }) });
		case "ArrowUp":
			var r = I(I({}, e), {}, { activeItemId: et(-1, e.activeItemId, w(e), t.props.defaultActiveItemId) });
			return I(I({}, r), {}, { completion: ur({ state: r }) });
		case "Escape": return e.isOpen ? I(I({}, e), {}, {
			activeItemId: null,
			isOpen: !1,
			completion: null
		}) : I(I({}, e), {}, {
			activeItemId: null,
			query: "",
			status: "idle",
			collections: []
		});
		case "submit": return I(I({}, e), {}, {
			activeItemId: null,
			isOpen: !1,
			status: "idle"
		});
		case "reset": return I(I({}, e), {}, {
			activeItemId: t.props.openOnFocus === !0 ? t.props.defaultActiveItemId : null,
			status: "idle",
			completion: null,
			query: ""
		});
		case "focus": return I(I({}, e), {}, {
			activeItemId: t.props.defaultActiveItemId,
			isOpen: (t.props.openOnFocus || !!e.query) && t.props.shouldPanelOpen({ state: e })
		});
		case "blur": return t.props.debug ? e : I(I({}, e), {}, {
			isOpen: !1,
			activeItemId: null
		});
		case "mousemove": return I(I({}, e), {}, { activeItemId: t.payload });
		case "mouseleave": return I(I({}, e), {}, { activeItemId: t.props.defaultActiveItemId });
		default: return `${JSON.stringify(t.type)}`, e;
	}
};
//#endregion
//#region node_modules/@algolia/autocomplete-core/dist/esm/createAutocomplete.js
function _r(e) {
	"@babel/helpers - typeof";
	return _r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, _r(e);
}
function vr(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function yr(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? vr(Object(n), !0).forEach(function(t) {
			br(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vr(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function br(e, t, n) {
	return (t = xr(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function xr(e) {
	var t = Sr(e, "string");
	return _r(t) == "symbol" ? t : t + "";
}
function Sr(e, t) {
	if (_r(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (_r(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Cr(e) {
	var t = [], n = Kt(e, t), r = Et(gr, n, o), i = Nt({ store: r }), a = tr(yr({
		props: n,
		refresh: s,
		store: r,
		navigator: n.navigator
	}, i));
	function o(e) {
		var t, r, a = e.prevState, o = e.state;
		if (n.onStateChange(yr({
			prevState: a,
			state: o,
			refresh: s,
			navigator: n.navigator
		}, i)), !l() && (t = o.context) != null && (r = t.algoliaInsightsPlugin) != null && r.__automaticInsights && n.insights !== !1) {
			var u = Ve({ __autocomplete_clickAnalytics: !1 });
			n.plugins.push(u), c([u]);
		}
	}
	function s() {
		return kn(yr({
			event: new Event("input"),
			nextState: { isOpen: r.getState().isOpen },
			props: n,
			navigator: n.navigator,
			query: r.getState().query,
			refresh: s,
			store: r
		}, i));
	}
	function c(e) {
		e.forEach(function(e) {
			return e.subscribe?.call(e, yr(yr({}, i), {}, {
				navigator: n.navigator,
				refresh: s,
				onSelect: function(e) {
					t.push({ onSelect: e });
				},
				onActive: function(e) {
					t.push({ onActive: e });
				},
				onResolve: function(e) {
					t.push({ onResolve: e });
				}
			}));
		});
	}
	function l() {
		return n.plugins.some(function(e) {
			return e.name === "aa.algoliaInsightsPlugin";
		});
	}
	if (n.insights && !l()) {
		var u = typeof n.insights == "boolean" ? {} : n.insights;
		n.plugins.push(Ve(u));
	}
	return c(n.plugins), lr({
		metadata: cr({
			plugins: n.plugins,
			options: e
		}),
		environment: n.environment
	}), yr(yr({
		refresh: s,
		navigator: n.navigator
	}, a), i);
}
//#endregion
//#region node_modules/htm/dist/htm.module.js
var wr = function(e, t, n, r) {
	var i;
	t[0] = 0;
	for (var a = 1; a < t.length; a++) {
		var o = t[a++], s = t[a] ? (t[0] |= o ? 1 : 2, n[t[a++]]) : t[++a];
		o === 3 ? r[0] = s : o === 4 ? r[1] = Object.assign(r[1] || {}, s) : o === 5 ? (r[1] = r[1] || {})[t[++a]] = s : o === 6 ? r[1][t[++a]] += s + "" : o ? (i = e.apply(s, wr(e, s, n, ["", null])), r.push(i), s[0] ? t[0] |= 2 : (t[a - 2] = 0, t[a] = i)) : r.push(s);
	}
	return r;
}, Tr = /* @__PURE__ */ new Map();
function Er(e) {
	var t = Tr.get(this);
	return t || (t = /* @__PURE__ */ new Map(), Tr.set(this, t)), (t = wr(this, t.get(e) || (t.set(e, t = function(e) {
		for (var t, n, r = 1, i = "", a = "", o = [0], s = function(e) {
			r === 1 && (e || (i = i.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? o.push(0, e, i) : r === 3 && (e || i) ? (o.push(3, e, i), r = 2) : r === 2 && i === "..." && e ? o.push(4, e, 0) : r === 2 && i && !e ? o.push(5, 0, !0, i) : r >= 5 && ((i || !e && r === 5) && (o.push(r, 0, i, n), r = 6), e && (o.push(r, e, 0, n), r = 6)), i = "";
		}, c = 0; c < e.length; c++) {
			c && (r === 1 && s(), s(c));
			for (var l = 0; l < e[c].length; l++) t = e[c][l], r === 1 ? t === "<" ? (s(), o = [o], r = 3) : i += t : r === 4 ? i === "--" && t === ">" ? (r = 1, i = "") : i = t + i[0] : a ? t === a ? a = "" : i += t : t === "\"" || t === "'" ? a = t : t === ">" ? (s(), r = 1) : r && (t === "=" ? (r = 5, n = i, i = "") : t === "/" && (r < 5 || e[c][l + 1] === ">") ? (s(), r === 3 && (o = o[0]), r = o, (o = o[0]).push(2, 0, r), r = 0) : t === " " || t === "	" || t === "\n" || t === "\r" ? (s(), r = 2) : i += t), r === 3 && i === "!--" && (r = 4, o = o[0]);
		}
		return s(), o;
	}(e)), t), arguments, [])).length > 1 ? t : t[0];
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/elements/ClearIcon.js
var Dr = function(e) {
	var t = e.environment, n = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
	n.setAttribute("class", "aa-ClearIcon"), n.setAttribute("viewBox", "0 0 24 24"), n.setAttribute("width", "18"), n.setAttribute("height", "18"), n.setAttribute("fill", "currentColor");
	var r = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
	return r.setAttribute("d", "M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"), n.appendChild(r), n;
};
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/utils/getHTMLElement.js
function Or(e, t) {
	if (typeof t == "string") {
		var n = e.document.querySelector(t);
		return `${JSON.stringify(t)}`, n;
	}
	return t;
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/utils/mergeClassNames.js
function kr() {
	return [...arguments].reduce(function(e, t) {
		return Object.keys(t).forEach(function(n) {
			var r = e[n], i = t[n];
			r !== i && (e[n] = [r, i].filter(Boolean).join(" "));
		}), e;
	}, {});
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/utils/mergeDeep.js
function Ar(e) {
	return Pr(e) || Nr(e) || Mr(e) || jr();
}
function jr() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Mr(e, t) {
	if (e) {
		if (typeof e == "string") return Fr(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Fr(e, t) : void 0;
	}
}
function Nr(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Pr(e) {
	if (Array.isArray(e)) return Fr(e);
}
function Fr(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Ir(e) {
	"@babel/helpers - typeof";
	return Ir = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Ir(e);
}
var Lr = function(e) {
	return e && Ir(e) === "object" && Object.prototype.toString.call(e) === "[object Object]";
};
function Rr() {
	return [...arguments].reduce(function(e, t) {
		return Object.keys(t).forEach(function(n) {
			var r = e[n], i = t[n];
			Array.isArray(r) && Array.isArray(i) ? e[n] = r.concat.apply(r, Ar(i)) : Lr(r) && Lr(i) ? e[n] = Rr(r, i) : e[n] = i;
		}), e;
	}, {});
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/utils/pickBy.js
function zr(e) {
	"@babel/helpers - typeof";
	return zr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, zr(e);
}
function Br(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Vr(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Br(Object(n), !0).forEach(function(t) {
			Hr(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Br(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Hr(e, t, n) {
	return (t = Ur(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Ur(e) {
	var t = Wr(e, "string");
	return zr(t) == "symbol" ? t : t + "";
}
function Wr(e, t) {
	if (zr(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (zr(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Gr(e, t) {
	return Xr(e) || Yr(e, t) || qr(e, t) || Kr();
}
function Kr() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function qr(e, t) {
	if (e) {
		if (typeof e == "string") return Jr(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Jr(e, t) : void 0;
	}
}
function Jr(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Yr(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t === 0) {
				if (Object(n) !== n) return;
				c = !1;
			} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function Xr(e) {
	if (Array.isArray(e)) return e;
}
function Zr(e, t) {
	return Object.entries(e).reduce(function(e, n) {
		var r = Gr(n, 2), i = r[0], a = r[1];
		return t({
			key: i,
			value: a
		}) ? Vr(Vr({}, e), {}, Hr({}, i, a)) : e;
	}, {});
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/utils/setProperties.js
var Qr = [
	"ontouchstart",
	"ontouchend",
	"ontouchmove",
	"ontouchcancel"
];
function $r(e, t, n) {
	n === null ? e[t] = "" : typeof n == "number" ? e[t] = n + "px" : e[t] = n;
}
function ei(e) {
	var t;
	this === null || this === void 0 || (t = this._listeners) == null || t[e.type](e);
}
function ti(e, t, n) {
	var r, i, a = e[t];
	if (t === "style") if (typeof n == "string") e.style = n;
	else if (n === null) e.style = "";
	else for (t in n) (!a || n[t] !== a[t]) && $r(e.style, t, n[t]);
	else t[0] === "o" && t[1] === "n" ? (r = t !== (t = t.replace(/Capture$/, "")), i = t.toLowerCase(), (i in e || Qr.includes(i)) && (t = i), t = t.slice(2), e._listeners ||= {}, e._listeners[t] = n, n ? a || e.addEventListener(t, ei, r) : e.removeEventListener(t, ei, r)) : t !== "list" && t !== "tagName" && t !== "form" && t !== "type" && t !== "size" && t !== "download" && t !== "href" && t in e ? e[t] = n ?? "" : typeof n != "function" && t !== "dangerouslySetInnerHTML" && (n == null || n === !1 && !/^ar/.test(t) ? e.removeAttribute(t) : e.setAttribute(t, n));
}
function ni(e) {
	switch (e) {
		case "onChange": return "onInput";
		case "onCompositionEnd": return "oncompositionend";
		default: return e;
	}
}
function ri(e, t) {
	for (var n in t) ti(e, ni(n), t[n]);
}
function ii(e, t) {
	for (var n in t) n[0] === "o" && n[1] === "n" || ti(e, ni(n), t[n]);
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/getCreateDomElement.js
var ai = ["children"];
function oi(e) {
	return ui(e) || li(e) || ci(e) || si();
}
function si() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ci(e, t) {
	if (e) {
		if (typeof e == "string") return di(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? di(e, t) : void 0;
	}
}
function li(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ui(e) {
	if (Array.isArray(e)) return di(e);
}
function di(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function fi(e, t) {
	if (e == null) return {};
	var n, r, i = pi(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function pi(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function mi(e) {
	return function(t, n) {
		var r = n.children, i = r === void 0 ? [] : r, a = fi(n, ai), o = e.document.createElement(t);
		return ri(o, a), o.append.apply(o, oi(i)), o;
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/elements/Input.js
function hi(e) {
	"@babel/helpers - typeof";
	return hi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, hi(e);
}
var gi = [
	"autocompleteScopeApi",
	"environment",
	"classNames",
	"getInputProps",
	"getInputPropsCore",
	"isDetached",
	"state"
];
function _i(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function vi(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? _i(Object(n), !0).forEach(function(t) {
			yi(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _i(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function yi(e, t, n) {
	return (t = bi(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function bi(e) {
	var t = xi(e, "string");
	return hi(t) == "symbol" ? t : t + "";
}
function xi(e, t) {
	if (hi(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (hi(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Si(e, t) {
	if (e == null) return {};
	var n, r, i = Ci(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function Ci(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
var wi = function(e) {
	var t = e.autocompleteScopeApi, n = e.environment;
	e.classNames;
	var r = e.getInputProps, i = e.getInputPropsCore, a = e.isDetached, o = e.state, s = Si(e, gi), c = mi(n)("input", s), l = r(vi({
		state: o,
		props: i({ inputElement: c }),
		inputElement: c
	}, t));
	return ri(c, vi(vi({}, l), {}, { onKeyDown: function(e) {
		a && e.key === "Tab" || l.onKeyDown(e);
	} })), c;
}, Ti = function(e) {
	var t = e.environment.document.createElementNS("http://www.w3.org/2000/svg", "svg");
	return t.setAttribute("class", "aa-LoadingIcon"), t.setAttribute("viewBox", "0 0 100 100"), t.setAttribute("width", "20"), t.setAttribute("height", "20"), t.innerHTML = "<circle\n  cx=\"50\"\n  cy=\"50\"\n  fill=\"none\"\n  r=\"35\"\n  stroke=\"currentColor\"\n  stroke-dasharray=\"164.93361431346415 56.97787143782138\"\n  stroke-width=\"6\"\n>\n  <animateTransform\n    attributeName=\"transform\"\n    type=\"rotate\"\n    repeatCount=\"indefinite\"\n    dur=\"1s\"\n    values=\"0 50 50;90 50 50;180 50 50;360 50 50\"\n    keyTimes=\"0;0.40;0.65;1\"\n  />\n</circle>", "pauseAnimations" in t && function e() {
		if (!t.parentElement) {
			setTimeout(e, 0);
			return;
		}
		t.pauseAnimations();
	}(), t;
}, Ei = function(e) {
	var t = e.environment, n = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
	n.setAttribute("class", "aa-SubmitIcon"), n.setAttribute("viewBox", "0 0 24 24"), n.setAttribute("width", "20"), n.setAttribute("height", "20"), n.setAttribute("fill", "currentColor");
	var r = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
	return r.setAttribute("d", "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"), n.appendChild(r), n;
};
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/createAutocompleteDom.js
function Di(e) {
	"@babel/helpers - typeof";
	return Di = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Di(e);
}
function Oi(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ki(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Oi(Object(n), !0).forEach(function(t) {
			Ai(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Oi(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Ai(e, t, n) {
	return (t = ji(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ji(e) {
	var t = Mi(e, "string");
	return Di(t) == "symbol" ? t : t + "";
}
function Mi(e, t) {
	if (Di(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Di(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Ni(e) {
	var t = e.autocomplete, n = e.autocompleteScopeApi, r = e.classNames, i = e.environment, a = e.isDetached, o = e.placeholder, s = o === void 0 ? "Search" : o, c = e.propGetters, l = e.setIsModalOpen, u = e.state, d = e.translations, f = mi(i), p = c.getRootProps(ki({
		state: u,
		props: t.getRootProps({})
	}, n)), m = f("div", ki({ class: r.root }, p)), h = f("div", {
		class: r.detachedContainer,
		onMouseDown: function(e) {
			e.stopPropagation();
		}
	}), g = f("div", {
		class: r.detachedOverlay,
		children: [h],
		onMouseDown: function() {
			l(!1), t.setIsOpen(!1);
		}
	}), _ = c.getLabelProps(ki({
		state: u,
		props: t.getLabelProps({})
	}, n)), v = f("button", {
		class: r.submitButton,
		type: "submit",
		title: d.submitButtonTitle,
		children: [Ei({ environment: i })]
	}), y = f("label", ki({
		class: r.label,
		children: [v],
		ariaLabel: d.submitButtonTitle
	}, _)), b = f("button", {
		class: r.clearButton,
		type: "reset",
		title: d.clearButtonTitle,
		children: [Dr({ environment: i })]
	}), x = f("div", {
		class: r.loadingIndicator,
		children: [Ti({ environment: i })]
	}), S = wi({
		class: r.input,
		environment: i,
		state: u,
		getInputProps: c.getInputProps,
		getInputPropsCore: t.getInputProps,
		autocompleteScopeApi: n,
		isDetached: a
	}), C = f("div", {
		class: r.inputWrapperPrefix,
		children: [y, x]
	}), w = f("div", {
		class: r.inputWrapperSuffix,
		children: [b]
	}), T = f("div", {
		class: r.inputWrapper,
		children: [S]
	}), E = c.getFormProps(ki({
		state: u,
		props: t.getFormProps({ inputElement: S })
	}, n)), D = f("form", ki({
		class: r.form,
		children: [
			C,
			T,
			w
		]
	}, E)), ee = c.getPanelProps(ki({
		state: u,
		props: t.getPanelProps({})
	}, n)), O = f("div", ki({ class: r.panel }, ee)), k = f("div", {
		class: r.detachedSearchButtonQuery,
		textContent: u.query
	}), A = f("div", {
		class: r.detachedSearchButtonPlaceholder,
		hidden: !!u.query,
		textContent: s
	});
	if (a) {
		var j = f("div", {
			class: r.detachedSearchButtonIcon,
			ariaLabel: d.detachedSearchButtonTitle,
			children: [Ei({ environment: i })]
		}), te = f("button", {
			type: "button",
			class: r.detachedSearchButton,
			title: d.detachedSearchButtonTitle,
			id: _.id,
			onClick: function() {
				l(!0);
			},
			children: [
				j,
				A,
				k
			]
		}), ne = f("button", {
			type: "button",
			class: r.detachedCancelButton,
			textContent: d.detachedCancelButtonText,
			onTouchStart: function(e) {
				e.stopPropagation();
			},
			onClick: function() {
				t.setIsOpen(!1), l(!1);
			}
		}), M = f("div", {
			class: r.detachedFormContainer,
			children: [D, ne]
		});
		h.appendChild(M), m.appendChild(te);
	} else m.appendChild(D);
	return {
		detachedContainer: h,
		detachedOverlay: g,
		detachedSearchButtonQuery: k,
		detachedSearchButtonPlaceholder: A,
		inputWrapper: T,
		input: S,
		root: m,
		form: D,
		label: y,
		submitButton: v,
		clearButton: b,
		loadingIndicator: x,
		panel: O
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/createEffectWrapper.js
function Pi() {
	var e = [], t = [];
	function n(n) {
		e.push(n);
		var r = n();
		t.push(r);
	}
	return {
		runEffect: n,
		cleanupEffects: function() {
			var e = t;
			t = [], e.forEach(function(e) {
				e();
			});
		},
		runEffects: function() {
			var t = e;
			e = [], t.forEach(function(e) {
				n(e);
			});
		}
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/createReactiveWrapper.js
function Fi() {
	var e = [];
	return {
		reactive: function(t) {
			var n = {
				_fn: t,
				_ref: { current: t() },
				get value() {
					return this._ref.current;
				},
				set value(e) {
					this._ref.current = e;
				}
			};
			return e.push(n), n;
		},
		runReactives: function() {
			e.forEach(function(e) {
				e._ref.current = e._fn();
			});
		}
	};
}
//#endregion
//#region node_modules/preact/dist/preact.module.js
var Ii, L, Li, Ri, zi, Bi, Vi, Hi, Ui, Wi, Gi, Ki, qi, Ji, Yi = {}, Xi = [], Zi = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, Qi = Array.isArray;
function $i(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function ea(e) {
	e && e.parentNode && e.parentNode.removeChild(e);
}
function R(e, t, n) {
	var r, i, a, o = {};
	for (a in t) a == "key" ? r = t[a] : a == "ref" ? i = t[a] : o[a] = t[a];
	if (arguments.length > 2 && (o.children = arguments.length > 3 ? Ii.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (a in e.defaultProps) o[a] === void 0 && (o[a] = e.defaultProps[a]);
	return ta(e, o, r, i, null);
}
function ta(e, t, n, r, i) {
	var a = {
		type: e,
		props: t,
		key: n,
		ref: r,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: i ?? ++Li,
		__i: -1,
		__u: 0
	};
	return i == null && L.vnode != null && L.vnode(a), a;
}
function na() {
	return { current: null };
}
function ra(e) {
	return e.children;
}
function ia(e, t) {
	this.props = e, this.context = t;
}
function aa(e, t) {
	if (t == null) return e.__ ? aa(e.__, e.__i + 1) : null;
	for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
	return typeof e.type == "function" ? aa(e) : null;
}
function oa(e) {
	if (e.__P && e.__d) {
		var t = e.__v, n = t.__e, r = [], i = [], a = $i({}, t);
		a.__v = t.__v + 1, L.vnode && L.vnode(a), _a(e.__P, a, t, e.__n, e.__P.namespaceURI, 32 & t.__u ? [n] : null, r, n ?? aa(t), !!(32 & t.__u), i), a.__v = t.__v, a.__.__k[a.__i] = a, ya(r, a, i), t.__e = t.__ = null, a.__e != n && sa(a);
	}
}
function sa(e) {
	if ((e = e.__) != null && e.__c != null) return e.__e = e.__c.base = null, e.__k.some(function(t) {
		if (t != null && t.__e != null) return e.__e = e.__c.base = t.__e;
	}), sa(e);
}
function ca(e) {
	(!e.__d && (e.__d = !0) && Ri.push(e) && !la.__r++ || zi != L.debounceRendering) && ((zi = L.debounceRendering) || Bi)(la);
}
function la() {
	try {
		for (var e, t = 1; Ri.length;) Ri.length > t && Ri.sort(Vi), e = Ri.shift(), t = Ri.length, oa(e);
	} finally {
		Ri.length = la.__r = 0;
	}
}
function ua(e, t, n, r, i, a, o, s, c, l, u) {
	var d, f, p, m, h, g, _, v = r && r.__k || Xi, y = t.length;
	for (c = da(n, t, v, c, y), d = 0; d < y; d++) (p = n.__k[d]) != null && (f = p.__i != -1 && v[p.__i] || Yi, p.__i = d, g = _a(e, p, f, i, a, o, s, c, l, u), m = p.__e, p.ref && f.ref != p.ref && (f.ref && Sa(f.ref, null, p), u.push(p.ref, p.__c || m, p)), h == null && m != null && (h = m), (_ = !!(4 & p.__u)) || f.__k === p.__k ? (c = fa(p, c, e, _), _ && f.__e && (f.__e = null)) : typeof p.type == "function" && g !== void 0 ? c = g : m && (c = m.nextSibling), p.__u &= -7);
	return n.__e = h, c;
}
function da(e, t, n, r, i) {
	var a, o, s, c, l, u = n.length, d = u, f = 0;
	for (e.__k = Array(i), a = 0; a < i; a++) (o = t[a]) != null && typeof o != "boolean" && typeof o != "function" ? (typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? o = e.__k[a] = ta(null, o, null, null, null) : Qi(o) ? o = e.__k[a] = ta(ra, { children: o }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? o = e.__k[a] = ta(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : e.__k[a] = o, c = a + f, o.__ = e, o.__b = e.__b + 1, s = null, (l = o.__i = pa(o, n, c, d)) != -1 && (d--, (s = n[l]) && (s.__u |= 2)), s == null || s.__v == null ? (l == -1 && (i > u ? f-- : i < u && f++), typeof o.type != "function" && (o.__u |= 4)) : l != c && (l == c - 1 ? f-- : l == c + 1 ? f++ : (l > c ? f-- : f++, o.__u |= 4))) : e.__k[a] = null;
	if (d) for (a = 0; a < u; a++) (s = n[a]) != null && !(2 & s.__u) && (s.__e == r && (r = aa(s)), Ca(s, s));
	return r;
}
function fa(e, t, n, r) {
	var i, a;
	if (typeof e.type == "function") {
		for (i = e.__k, a = 0; i && a < i.length; a++) i[a] && (i[a].__ = e, t = fa(i[a], t, n, r));
		return t;
	}
	e.__e != t && (r && (t && e.type && !t.parentNode && (t = aa(e)), n.insertBefore(e.__e, t || null)), t = e.__e);
	do
		t &&= t.nextSibling;
	while (t != null && t.nodeType == 8);
	return t;
}
function pa(e, t, n, r) {
	var i, a, o, s = e.key, c = e.type, l = t[n], u = l != null && (2 & l.__u) == 0;
	if (l === null && s == null || u && s == l.key && c == l.type) return n;
	if (r > +!!u) {
		for (i = n - 1, a = n + 1; i >= 0 || a < t.length;) if ((l = t[o = i >= 0 ? i-- : a++]) != null && !(2 & l.__u) && s == l.key && c == l.type) return o;
	}
	return -1;
}
function ma(e, t, n) {
	t[0] == "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || Zi.test(t) ? n : n + "px";
}
function ha(e, t, n, r, i) {
	var a, o;
	n: if (t == "style") if (typeof n == "string") e.style.cssText = n;
	else {
		if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || ma(e.style, t, "");
		if (n) for (t in n) r && n[t] == r[t] || ma(e.style, t, n[t]);
	}
	else if (t[0] == "o" && t[1] == "n") a = t != (t = t.replace(Gi, "$1")), o = t.toLowerCase(), t = o in e || t == "onFocusOut" || t == "onFocusIn" ? o.slice(2) : t.slice(2), e.l ||= {}, e.l[t + a] = n, n ? r ? n[Wi] = r[Wi] : (n[Wi] = Ki, e.addEventListener(t, a ? Ji : qi, a)) : e.removeEventListener(t, a ? Ji : qi, a);
	else {
		if (i == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
		else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
			e[t] = n ?? "";
			break n;
		} catch {}
		typeof n == "function" || (n == null || !1 === n && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
	}
}
function ga(e) {
	return function(t) {
		if (this.l) {
			var n = this.l[t.type + e];
			if (t[Ui] == null) t[Ui] = Ki++;
			else if (t[Ui] < n[Wi]) return;
			return n(L.event ? L.event(t) : t);
		}
	};
}
function _a(e, t, n, r, i, a, o, s, c, l) {
	var u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E = t.type;
	if (t.constructor !== void 0) return null;
	128 & n.__u && (c = !!(32 & n.__u), a = [s = t.__e = n.__e]), (u = L.__b) && u(t);
	n: if (typeof E == "function") {
		d = o.length;
		try {
			if (v = t.props, y = E.prototype && E.prototype.render, b = (u = E.contextType) && r[u.__c], x = u ? b ? b.props.value : u.__ : r, n.__c ? _ = (f = t.__c = n.__c).__ = f.__E : (y ? t.__c = f = new E(v, x) : (t.__c = f = new ia(v, x), f.constructor = E, f.render = wa), b && b.sub(f), f.state ||= {}, f.__n = r, p = f.__d = !0, f.__h = [], f._sb = []), y && f.__s == null && (f.__s = f.state), y && E.getDerivedStateFromProps != null && (f.__s == f.state && (f.__s = $i({}, f.__s)), $i(f.__s, E.getDerivedStateFromProps(v, f.__s))), m = f.props, h = f.state, f.__v = t, p) y && E.getDerivedStateFromProps == null && f.componentWillMount != null && f.componentWillMount(), y && f.componentDidMount != null && f.__h.push(f.componentDidMount);
			else {
				if (y && E.getDerivedStateFromProps == null && v !== m && f.componentWillReceiveProps != null && f.componentWillReceiveProps(v, x), t.__v == n.__v || !f.__e && f.shouldComponentUpdate != null && !1 === f.shouldComponentUpdate(v, f.__s, x)) {
					t.__v != n.__v && (f.props = v, f.state = f.__s, f.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.some(function(e) {
						e && (e.__ = t);
					}), Xi.push.apply(f.__h, f._sb), f._sb = [], f.__h.length && o.push(f);
					break n;
				}
				f.componentWillUpdate != null && f.componentWillUpdate(v, f.__s, x), y && f.componentDidUpdate != null && f.__h.push(function() {
					f.componentDidUpdate(m, h, g);
				});
			}
			if (f.context = x, f.props = v, f.__P = e, f.__e = !1, S = L.__r, C = 0, y) f.state = f.__s, f.__d = !1, S && S(t), u = f.render(f.props, f.state, f.context), Xi.push.apply(f.__h, f._sb), f._sb = [];
			else do
				f.__d = !1, S && S(t), u = f.render(f.props, f.state, f.context), f.state = f.__s;
			while (f.__d && ++C < 25);
			f.state = f.__s, f.getChildContext != null && (r = $i($i({}, r), f.getChildContext())), y && !p && f.getSnapshotBeforeUpdate != null && (g = f.getSnapshotBeforeUpdate(m, h)), w = u != null && u.type === ra && u.key == null ? ba(u.props.children) : u, s = ua(e, Qi(w) ? w : [w], t, n, r, i, a, o, s, c, l), f.base = t.__e, t.__u &= -161, f.__h.length && o.push(f), _ && (f.__E = f.__ = null);
		} catch (e) {
			if (o.length = d, t.__v = null, c || a != null) {
				if (e.then) {
					for (t.__u |= c ? 160 : 128; s && s.nodeType == 8 && s.nextSibling;) s = s.nextSibling;
					a != null && (a[a.indexOf(s)] = null), t.__e = s;
				} else if (a != null) for (T = a.length; T--;) ea(a[T]);
			} else t.__e = n.__e;
			t.__k ??= n.__k || [], e.then || va(t), L.__e(e, t, n);
		}
	} else a == null && t.__v == n.__v ? (t.__k = n.__k, t.__e = n.__e) : s = t.__e = xa(n.__e, t, n, r, i, a, o, c, l);
	return (u = L.diffed) && u(t), 128 & t.__u ? void 0 : s;
}
function va(e) {
	e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(va));
}
function ya(e, t, n) {
	for (var r = 0; r < n.length; r++) Sa(n[r], n[++r], n[++r]);
	L.__c && L.__c(t, e), e.some(function(t) {
		try {
			e = t.__h, t.__h = [], e.some(function(e) {
				e.call(t);
			});
		} catch (e) {
			L.__e(e, t.__v);
		}
	});
}
function ba(e) {
	return typeof e != "object" || !e || e.__b > 0 ? e : Qi(e) ? e.map(ba) : e.constructor === void 0 ? $i({}, e) : null;
}
function xa(e, t, n, r, i, a, o, s, c) {
	var l, u, d, f, p, m, h, g = n.props || Yi, _ = t.props, v = t.type;
	if (v == "svg" ? i = "http://www.w3.org/2000/svg" : v == "math" ? i = "http://www.w3.org/1998/Math/MathML" : i ||= "http://www.w3.org/1999/xhtml", a != null) {
		for (l = 0; l < a.length; l++) if ((p = a[l]) && "setAttribute" in p == !!v && (v ? p.localName == v : p.nodeType == 3)) {
			e = p, a[l] = null;
			break;
		}
	}
	if (e == null) {
		if (v == null) return document.createTextNode(_);
		e = document.createElementNS(i, v, _.is && _), s &&= (L.__m && L.__m(t, a), !1), a = null;
	}
	if (v == null) g === _ || s && e.data == _ || (e.data = _);
	else {
		if (a = v == "textarea" && _.defaultValue != null ? null : a && Ii.call(e.childNodes), !s && a != null) for (g = {}, l = 0; l < e.attributes.length; l++) g[(p = e.attributes[l]).name] = p.value;
		for (l in g) p = g[l], l == "dangerouslySetInnerHTML" ? d = p : l == "children" || l in _ || l == "value" && "defaultValue" in _ || l == "checked" && "defaultChecked" in _ || ha(e, l, null, p, i);
		for (l in _) p = _[l], l == "children" ? f = p : l == "dangerouslySetInnerHTML" ? u = p : l == "value" ? m = p : l == "checked" ? h = p : s && typeof p != "function" || g[l] === p || ha(e, l, p, g[l], i);
		if (u) s || d && (u.__html == d.__html || u.__html == e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
		else if (d && (e.innerHTML = ""), ua(t.type == "template" ? e.content : e, Qi(f) ? f : [f], t, n, r, v == "foreignObject" ? "http://www.w3.org/1999/xhtml" : i, a, o, a ? a[0] : n.__k && aa(n, 0), s, c), a != null) for (l = a.length; l--;) ea(a[l]);
		s && v != "textarea" || (l = "value", v == "progress" && m == null ? e.removeAttribute("value") : m != null && (m !== e[l] || v == "progress" && !m || v == "option" && m != g[l]) && ha(e, l, m, g[l], i), l = "checked", h != null && h != e[l] && ha(e, l, h, g[l], i));
	}
	return e;
}
function Sa(e, t, n) {
	try {
		if (typeof e == "function") {
			var r = typeof e.__u == "function";
			r && e.__u(), r && t == null || (e.__u = e(t));
		} else e.current = t;
	} catch (e) {
		L.__e(e, n);
	}
}
function Ca(e, t, n) {
	var r, i;
	if (L.unmount && L.unmount(e), (r = e.ref) && (r.current && r.current != e.__e || Sa(r, null, t)), (r = e.__c) != null) {
		if (r.componentWillUnmount) try {
			r.componentWillUnmount();
		} catch (e) {
			L.__e(e, t);
		}
		r.base = r.__P = r.__n = null;
	}
	if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && Ca(r[i], t, n || typeof e.type != "function");
	n || ea(e.__e), e.__c = e.__ = e.__e = void 0;
}
function wa(e, t, n) {
	return this.constructor(e, n);
}
function z(e, t, n) {
	var r, i, a, o;
	t == document && (t = document.documentElement), L.__ && L.__(e, t), i = (r = typeof n == "function") ? null : n && n.__k || t.__k, a = [], o = [], _a(t, e = (!r && n || t).__k = R(ra, null, [e]), i || Yi, Yi, t.namespaceURI, !r && n ? [n] : i ? null : t.firstChild ? Ii.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r, o), ya(a, e, o), e.props.children = null;
}
Ii = Xi.slice, L = { __e: function(e, t, n, r) {
	for (var i, a, o; t = t.__;) if ((i = t.__c) && !i.__) try {
		if ((a = i.constructor) && a.getDerivedStateFromError != null && (i.setState(a.getDerivedStateFromError(e)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), o = i.__d), o) return i.__E = i;
	} catch (t) {
		e = t;
	}
	throw e;
} }, Li = 0, ia.prototype.setState = function(e, t) {
	var n = this.__s != null && this.__s != this.state ? this.__s : this.__s = $i({}, this.state);
	typeof e == "function" && (e = e($i({}, n), this.props)), e && $i(n, e), e != null && this.__v && (t && this._sb.push(t), ca(this));
}, ia.prototype.forceUpdate = function(e) {
	this.__v && (this.__e = !0, e && this.__h.push(e), ca(this));
}, ia.prototype.render = ra, Ri = [], Bi = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Vi = function(e, t) {
	return e.__v.__b - t.__v.__b;
}, la.__r = 0, Hi = Math.random().toString(8), Ui = "__d" + Hi, Wi = "__a" + Hi, Gi = /(PointerCapture)$|Capture$/i, Ki = 0, qi = ga(!1), Ji = ga(!0);
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/constants/index.js
var Ta = "__aa-highlight__", Ea = "__/aa-highlight__";
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAttribute.js
function Da() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
	return {
		get: function() {
			return e;
		},
		add: function(t) {
			var n = e[e.length - 1];
			n?.isHighlighted === t.isHighlighted ? e[e.length - 1] = {
				value: n.value + t.value,
				isHighlighted: n.isHighlighted
			} : e.push(t);
		}
	};
}
function Oa(e) {
	var t = e.highlightedValue.split(Ta), n = t.shift(), r = Da(n ? [{
		value: n,
		isHighlighted: !1
	}] : []);
	return t.forEach(function(e) {
		var t = e.split(Ea);
		r.add({
			value: t[0],
			isHighlighted: !0
		}), t[1] !== "" && r.add({
			value: t[1],
			isHighlighted: !1
		});
	}), r.get();
}
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitHighlight.js
function ka(e) {
	return Na(e) || Ma(e) || ja(e) || Aa();
}
function Aa() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ja(e, t) {
	if (e) {
		if (typeof e == "string") return Pa(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Pa(e, t) : void 0;
	}
}
function Ma(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Na(e) {
	if (Array.isArray(e)) return Pa(e);
}
function Pa(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Fa(e) {
	var t = e.hit, n = e.attribute, r = Array.isArray(n) ? n : [n], i = C(t, ["_highlightResult"].concat(ka(r), ["value"]));
	return typeof i != "string" && (i = C(t, r) || ""), Oa({ highlightedValue: i });
}
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/isPartHighlighted.js
var Ia = {
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": "\"",
	"&#39;": "'"
}, La = function() {
	try {
		return /* @__PURE__ */ RegExp("[\\p{L}\\p{N}_]", "u");
	} catch {
		return /* @__PURE__ */ new RegExp(/\w/i);
	}
}(), Ra = /&(amp|quot|lt|gt|#39);/g, za = RegExp(Ra.source);
function Ba(e) {
	return e && za.test(e) ? e.replace(Ra, function(e) {
		return Ia[e];
	}) : e;
}
function Va(e, t) {
	var n = e[t], r = e[t + 1]?.isHighlighted ?? !0, i = e[t - 1]?.isHighlighted ?? !0;
	return !La.test(Ba(n.value)) && i === r ? i : n.isHighlighted;
}
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/reverseHighlightedParts.js
function Ha(e) {
	"@babel/helpers - typeof";
	return Ha = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Ha(e);
}
function Ua(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Wa(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Ua(Object(n), !0).forEach(function(t) {
			Ga(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ua(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Ga(e, t, n) {
	return (t = Ka(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Ka(e) {
	var t = qa(e, "string");
	return Ha(t) == "symbol" ? t : t + "";
}
function qa(e, t) {
	if (Ha(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Ha(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Ja(e) {
	return e.some(function(e) {
		return e.isHighlighted;
	}) ? e.map(function(t, n) {
		return Wa(Wa({}, t), {}, { isHighlighted: !Va(e, n) });
	}) : e.map(function(e) {
		return Wa(Wa({}, e), {}, { isHighlighted: !1 });
	});
}
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitReverseHighlight.js
function Ya(e) {
	return Ja(Fa(e));
}
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitSnippet.js
function Xa(e) {
	return eo(e) || $a(e) || Qa(e) || Za();
}
function Za() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Qa(e, t) {
	if (e) {
		if (typeof e == "string") return to(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? to(e, t) : void 0;
	}
}
function $a(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function eo(e) {
	if (Array.isArray(e)) return to(e);
}
function to(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function no(e) {
	var t = e.hit, n = e.attribute, r = Array.isArray(n) ? n : [n], i = C(t, ["_snippetResult"].concat(Xa(r), ["value"]));
	return typeof i != "string" && (i = C(t, r) || ""), Oa({ highlightedValue: i });
}
//#endregion
//#region node_modules/@algolia/autocomplete-preset-algolia/dist/esm/highlight/parseAlgoliaHitReverseSnippet.js
function ro(e) {
	return Ja(no(e));
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/components/Highlight.js
function io(e) {
	var t = e.createElement, n = e.Fragment;
	function r(e) {
		var r = e.hit, i = e.attribute, a = e.tagName, o = a === void 0 ? "mark" : a;
		return t(n, {}, Fa({
			hit: r,
			attribute: i
		}).map(function(e, n) {
			return e.isHighlighted ? t(o, { key: n }, e.value) : e.value;
		}));
	}
	return r.__autocomplete_componentName = "Highlight", r;
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/components/ReverseHighlight.js
function ao(e) {
	var t = e.createElement, n = e.Fragment;
	function r(e) {
		var r = e.hit, i = e.attribute, a = e.tagName, o = a === void 0 ? "mark" : a;
		return t(n, {}, Ya({
			hit: r,
			attribute: i
		}).map(function(e, n) {
			return e.isHighlighted ? t(o, { key: n }, e.value) : e.value;
		}));
	}
	return r.__autocomplete_componentName = "ReverseHighlight", r;
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/components/ReverseSnippet.js
function oo(e) {
	var t = e.createElement, n = e.Fragment;
	function r(e) {
		var r = e.hit, i = e.attribute, a = e.tagName, o = a === void 0 ? "mark" : a;
		return t(n, {}, ro({
			hit: r,
			attribute: i
		}).map(function(e, n) {
			return e.isHighlighted ? t(o, { key: n }, e.value) : e.value;
		}));
	}
	return r.__autocomplete_componentName = "ReverseSnippet", r;
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/components/Snippet.js
function so(e) {
	var t = e.createElement, n = e.Fragment;
	function r(e) {
		var r = e.hit, i = e.attribute, a = e.tagName, o = a === void 0 ? "mark" : a;
		return t(n, {}, no({
			hit: r,
			attribute: i
		}).map(function(e, n) {
			return e.isHighlighted ? t(o, { key: n }, e.value) : e.value;
		}));
	}
	return r.__autocomplete_componentName = "Snippet", r;
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/getDefaultOptions.js
function co(e) {
	"@babel/helpers - typeof";
	return co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, co(e);
}
var lo = [
	"classNames",
	"container",
	"getEnvironmentProps",
	"getFormProps",
	"getInputProps",
	"getItemProps",
	"getLabelProps",
	"getListProps",
	"getPanelProps",
	"getRootProps",
	"panelContainer",
	"panelPlacement",
	"render",
	"renderNoResults",
	"renderer",
	"detachedMediaQuery",
	"components",
	"translations"
];
function uo(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function fo(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? uo(Object(n), !0).forEach(function(t) {
			po(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : uo(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function po(e, t, n) {
	return (t = mo(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function mo(e) {
	var t = ho(e, "string");
	return co(t) == "symbol" ? t : t + "";
}
function ho(e, t) {
	if (co(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (co(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function go(e, t) {
	if (e == null) return {};
	var n, r, i = _o(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function _o(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
var vo = {
	clearButton: "aa-ClearButton",
	detachedCancelButton: "aa-DetachedCancelButton",
	detachedContainer: "aa-DetachedContainer",
	detachedFormContainer: "aa-DetachedFormContainer",
	detachedOverlay: "aa-DetachedOverlay",
	detachedSearchButton: "aa-DetachedSearchButton",
	detachedSearchButtonIcon: "aa-DetachedSearchButtonIcon",
	detachedSearchButtonPlaceholder: "aa-DetachedSearchButtonPlaceholder",
	detachedSearchButtonQuery: "aa-DetachedSearchButtonQuery",
	form: "aa-Form",
	input: "aa-Input",
	inputWrapper: "aa-InputWrapper",
	inputWrapperPrefix: "aa-InputWrapperPrefix",
	inputWrapperSuffix: "aa-InputWrapperSuffix",
	item: "aa-Item",
	label: "aa-Label",
	list: "aa-List",
	loadingIndicator: "aa-LoadingIndicator",
	panel: "aa-Panel",
	panelLayout: "aa-PanelLayout aa-Panel--scrollable",
	root: "aa-Autocomplete",
	source: "aa-Source",
	sourceFooter: "aa-SourceFooter",
	sourceHeader: "aa-SourceHeader",
	sourceNoResults: "aa-SourceNoResults",
	submitButton: "aa-SubmitButton"
}, yo = function(e, t) {
	var n = e.children, r = e.render;
	r(n, t);
}, bo = {
	createElement: R,
	Fragment: ra,
	render: z
};
function xo(e) {
	var t = e.classNames, n = e.container, r = e.getEnvironmentProps, i = e.getFormProps, a = e.getInputProps, o = e.getItemProps, s = e.getLabelProps, c = e.getListProps, l = e.getPanelProps, u = e.getRootProps, d = e.panelContainer, f = e.panelPlacement, p = e.render, m = e.renderNoResults, h = e.renderer, g = e.detachedMediaQuery, _ = e.components, v = e.translations, y = go(e, lo), b = typeof window < "u" ? window : {}, x = Or(b, n);
	x.tagName;
	var C = fo(fo({}, bo), h), w = {
		Highlight: io(C),
		ReverseHighlight: ao(C),
		ReverseSnippet: oo(C),
		Snippet: so(C)
	};
	return {
		renderer: {
			classNames: kr(vo, t ?? {}),
			container: x,
			getEnvironmentProps: r ?? function(e) {
				return e.props;
			},
			getFormProps: i ?? function(e) {
				return e.props;
			},
			getInputProps: a ?? function(e) {
				return e.props;
			},
			getItemProps: o ?? function(e) {
				return e.props;
			},
			getLabelProps: s ?? function(e) {
				return e.props;
			},
			getListProps: c ?? function(e) {
				return e.props;
			},
			getPanelProps: l ?? function(e) {
				return e.props;
			},
			getRootProps: u ?? function(e) {
				return e.props;
			},
			panelContainer: d ? Or(b, d) : b.document.body,
			panelPlacement: f ?? "input-wrapper-width",
			render: p ?? yo,
			renderNoResults: m,
			renderer: C,
			detachedMediaQuery: g ?? getComputedStyle(b.document.documentElement).getPropertyValue("--aa-detached-media-query"),
			components: fo(fo({}, w), _),
			translations: fo(fo({}, {
				clearButtonTitle: "Clear",
				detachedCancelButtonText: "Cancel",
				detachedSearchButtonTitle: "Search",
				submitButtonTitle: "Submit"
			}), v)
		},
		core: fo(fo({}, y), {}, {
			id: y.id ?? S(),
			environment: b
		})
	};
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/getPanelPlacementStyle.js
function So(e) {
	var t = e.panelPlacement, n = e.container, r = e.form, i = e.environment, a = n.getBoundingClientRect(), o = (i.pageYOffset || i.document.documentElement.scrollTop || i.document.body.scrollTop || 0) + a.top + a.height;
	switch (t) {
		case "start": return {
			top: o,
			left: a.left
		};
		case "end": return {
			top: o,
			right: i.document.documentElement.clientWidth - (a.left + a.width)
		};
		case "full-width": return {
			top: o,
			left: 0,
			right: 0,
			width: "unset",
			maxWidth: "unset"
		};
		case "input-wrapper-width":
			var s = r.getBoundingClientRect();
			return {
				top: o,
				left: s.left,
				right: i.document.documentElement.clientWidth - (s.left + s.width),
				width: "unset",
				maxWidth: "unset"
			};
		default: throw Error(`[Autocomplete] The \`panelPlacement\` value ${JSON.stringify(t)} is not valid.`);
	}
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/render.js
function Co(e) {
	"@babel/helpers - typeof";
	return Co = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Co(e);
}
function wo() {
	return wo = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, wo.apply(null, arguments);
}
function To(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Eo(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? To(Object(n), !0).forEach(function(t) {
			Do(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : To(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Do(e, t, n) {
	return (t = Oo(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Oo(e) {
	var t = ko(e, "string");
	return Co(t) == "symbol" ? t : t + "";
}
function ko(e, t) {
	if (Co(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Co(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function Ao(e) {
	var t = e.autocomplete, n = e.autocompleteScopeApi, r = e.dom, i = e.propGetters, a = e.state;
	ii(r.root, i.getRootProps(Eo({
		state: a,
		props: t.getRootProps({})
	}, n))), ii(r.input, i.getInputProps(Eo({
		state: a,
		props: t.getInputProps({ inputElement: r.input }),
		inputElement: r.input
	}, n))), ri(r.label, { hidden: a.status === "stalled" }), ri(r.loadingIndicator, { hidden: a.status !== "stalled" }), jo(r.loadingIndicator, a.status === "stalled"), ri(r.clearButton, { hidden: !a.query }), ri(r.detachedSearchButtonQuery, { textContent: a.query }), ri(r.detachedSearchButtonPlaceholder, { hidden: !!a.query });
}
function jo(e, t) {
	var n = e.firstChild?.nodeName === "svg" ? e.firstChild : null;
	!n || !n.pauseAnimations || !n.unpauseAnimations || (t ? n.unpauseAnimations() : n.pauseAnimations());
}
function Mo(e, t) {
	var n = t.autocomplete, r = t.autocompleteScopeApi, i = t.classNames, a = t.html, o = t.dom, s = t.panelContainer, c = t.propGetters, l = t.state, u = t.components, d = t.renderer;
	if (!l.isOpen) {
		s.contains(o.panel) && s.removeChild(o.panel);
		return;
	}
	!s.contains(o.panel) && l.status !== "loading" && s.appendChild(o.panel), o.panel.classList.toggle("aa-Panel--stalled", l.status === "stalled");
	var f = l.collections.filter(function(e) {
		var t = e.source, n = e.items;
		return t.templates.noResults || n.length > 0;
	}).map(function(e, t) {
		var o = e.source, s = e.items;
		return d.createElement("section", {
			key: t,
			className: i.source,
			"data-autocomplete-source-id": o.sourceId
		}, o.templates.header && d.createElement("div", { className: i.sourceHeader }, o.templates.header({
			components: u,
			createElement: d.createElement,
			Fragment: d.Fragment,
			items: s,
			source: o,
			state: l,
			html: a
		})), o.templates.noResults && s.length === 0 ? d.createElement("div", { className: i.sourceNoResults }, o.templates.noResults({
			components: u,
			createElement: d.createElement,
			Fragment: d.Fragment,
			source: o,
			state: l,
			html: a
		})) : d.createElement("ul", wo({ className: i.list }, c.getListProps(Eo({
			state: l,
			props: n.getListProps({ source: o })
		}, r))), s.map(function(e) {
			var t = n.getItemProps({
				item: e,
				source: o
			});
			return d.createElement("li", wo({
				key: t.id,
				className: i.item
			}, c.getItemProps(Eo({
				state: l,
				props: t
			}, r))), o.templates.item({
				components: u,
				createElement: d.createElement,
				Fragment: d.Fragment,
				item: e,
				state: l,
				html: a
			}));
		})), o.templates.footer && d.createElement("div", { className: i.sourceFooter }, o.templates.footer({
			components: u,
			createElement: d.createElement,
			Fragment: d.Fragment,
			items: s,
			source: o,
			state: l,
			html: a
		})));
	});
	e(Eo(Eo({
		children: d.createElement(d.Fragment, null, d.createElement("div", { className: i.panelLayout }, f), d.createElement("div", { className: "aa-GradientBottom" })),
		state: l,
		sections: f,
		elements: f.reduce(function(e, t) {
			return e[t.props["data-autocomplete-source-id"]] = t, e;
		}, {})
	}, d), {}, {
		components: u,
		html: a
	}, r), o.panel);
}
//#endregion
//#region node_modules/@algolia/autocomplete-js/dist/esm/userAgents.js
var No = [{
	segment: "autocomplete-js",
	version: O
}], Po = ["components"];
function Fo(e) {
	"@babel/helpers - typeof";
	return Fo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Fo(e);
}
function Io(e, t) {
	if (e == null) return {};
	var n, r, i = Lo(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function Lo(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
function Ro(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function zo(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Ro(Object(n), !0).forEach(function(t) {
			Bo(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ro(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Bo(e, t, n) {
	return (t = Vo(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Vo(e) {
	var t = Ho(e, "string");
	return Fo(t) == "symbol" ? t : t + "";
}
function Ho(e, t) {
	if (Fo(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Fo(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
var Uo = 0;
function Wo(e) {
	var t = Pi(), n = t.runEffect, r = t.cleanupEffects, i = t.runEffects, a = Fi(), o = a.reactive, s = a.runReactives, c = v(!1), l = v(e), u = v(void 0), d = o(function() {
		return xo(l.current);
	}), f = o(function() {
		return d.value.core.environment.matchMedia(d.value.renderer.detachedMediaQuery).matches;
	}), p = o(function() {
		return Cr(zo(zo({}, d.value.core), {}, {
			onStateChange: function(e) {
				var t, n, r;
				c.current = e.state.collections.some(function(e) {
					return e.source.templates.noResults;
				}), (t = u.current) == null || t.call(u, e), (n = (r = d.value.core).onStateChange) == null || n.call(r, e);
			},
			shouldPanelOpen: l.current.shouldPanelOpen || function(e) {
				var t = e.state;
				if (f.value) return !0;
				var n = w(t) > 0;
				if (!d.value.core.openOnFocus && !t.query) return n;
				var r = !!(c.current || d.value.renderer.renderNoResults);
				return !n && r || n;
			},
			__autocomplete_metadata: {
				userAgents: No,
				options: e
			}
		}));
	}), m = v(zo({
		collections: [],
		completion: null,
		context: {},
		isOpen: !1,
		query: "",
		activeItemId: null,
		status: "idle"
	}, d.value.core.initialState)), h = {
		getEnvironmentProps: d.value.renderer.getEnvironmentProps,
		getFormProps: d.value.renderer.getFormProps,
		getInputProps: d.value.renderer.getInputProps,
		getItemProps: d.value.renderer.getItemProps,
		getLabelProps: d.value.renderer.getLabelProps,
		getListProps: d.value.renderer.getListProps,
		getPanelProps: d.value.renderer.getPanelProps,
		getRootProps: d.value.renderer.getRootProps
	}, g = {
		setActiveItemId: p.value.setActiveItemId,
		setQuery: p.value.setQuery,
		setCollections: p.value.setCollections,
		setIsOpen: p.value.setIsOpen,
		setStatus: p.value.setStatus,
		setContext: p.value.setContext,
		refresh: p.value.refresh,
		navigator: p.value.navigator
	}, _ = o(function() {
		return Er.bind(d.value.renderer.renderer.createElement);
	}), b = o(function() {
		return Ni({
			autocomplete: p.value,
			autocompleteScopeApi: g,
			classNames: d.value.renderer.classNames,
			environment: d.value.core.environment,
			isDetached: f.value,
			placeholder: d.value.core.placeholder,
			propGetters: h,
			setIsModalOpen: E,
			state: m.current,
			translations: d.value.renderer.translations
		});
	});
	function x() {
		ri(b.value.panel, { style: f.value ? {} : So({
			panelPlacement: d.value.renderer.panelPlacement,
			container: b.value.root,
			form: b.value.form,
			environment: d.value.core.environment
		}) });
	}
	function S(e) {
		m.current = e;
		var t = {
			autocomplete: p.value,
			autocompleteScopeApi: g,
			classNames: d.value.renderer.classNames,
			components: d.value.renderer.components,
			container: d.value.renderer.container,
			html: _.value,
			dom: b.value,
			panelContainer: f.value ? b.value.detachedContainer : d.value.renderer.panelContainer,
			propGetters: h,
			state: m.current,
			renderer: d.value.renderer.renderer
		}, n = !w(e) && !c.current && d.value.renderer.renderNoResults || d.value.renderer.render;
		Ao(t), Mo(n, t);
	}
	n(function() {
		var e = p.value.getEnvironmentProps({
			formElement: b.value.form,
			panelElement: b.value.panel,
			inputElement: b.value.input
		});
		return ri(d.value.core.environment, e), function() {
			ri(d.value.core.environment, Object.keys(e).reduce(function(e, t) {
				return zo(zo({}, e), {}, Bo({}, t, void 0));
			}, {}));
		};
	}), n(function() {
		var e = f.value ? d.value.core.environment.document.body : d.value.renderer.panelContainer, t = f.value ? b.value.detachedOverlay : b.value.panel;
		return f.value && m.current.isOpen && E(!0), S(m.current), function() {
			e.contains(t) && (e.removeChild(t), e.classList.remove("aa-Detached"));
		};
	}), n(function() {
		var e = d.value.renderer.container;
		return e.appendChild(b.value.root), function() {
			e.removeChild(b.value.root);
		};
	}), n(function() {
		var e = y(function(e) {
			var t = e.state;
			S(t);
		}, 0);
		return u.current = function(t) {
			var n = t.state, r = t.prevState;
			f.value && r.isOpen !== n.isOpen && E(n.isOpen), !f.value && n.isOpen && !r.isOpen && x(), n.query !== r.query && d.value.core.environment.document.querySelectorAll(".aa-Panel--scrollable").forEach(function(e) {
				e.scrollTop !== 0 && (e.scrollTop = 0);
			}), e({ state: n });
		}, function() {
			u.current = void 0;
		};
	}), n(function() {
		var e = y(function() {
			var e = f.value;
			f.value = d.value.core.environment.matchMedia(d.value.renderer.detachedMediaQuery).matches, e === f.value ? requestAnimationFrame(x) : T({});
		}, 20);
		return d.value.core.environment.addEventListener("resize", e), function() {
			d.value.core.environment.removeEventListener("resize", e);
		};
	}), n(function() {
		if (!f.value) return function() {};
		function e(e) {
			b.value.detachedContainer.classList.toggle("aa-DetachedContainer--modal", e);
		}
		function t(t) {
			e(t.matches);
		}
		var n = d.value.core.environment.matchMedia(getComputedStyle(d.value.core.environment.document.documentElement).getPropertyValue("--aa-detached-modal-media-query"));
		e(n.matches);
		var r = !!n.addEventListener;
		return r ? n.addEventListener("change", t) : n.addListener(t), function() {
			r ? n.removeEventListener("change", t) : n.removeListener(t);
		};
	}), n(function() {
		return requestAnimationFrame(x), function() {};
	});
	function C() {
		Uo--, r();
	}
	function T() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		r();
		var t = d.value.renderer, n = t.components;
		l.current = Rr(Io(t, Po), d.value.core, {
			components: Zr(n, function(e) {
				return !e.value.hasOwnProperty("__autocomplete_componentName");
			}),
			initialState: m.current
		}, e), s(), i(), p.value.refresh().then(function() {
			S(m.current);
		});
	}
	function E(e) {
		e !== d.value.core.environment.document.body.contains(b.value.detachedOverlay) && (e ? (d.value.core.environment.document.body.appendChild(b.value.detachedOverlay), d.value.core.environment.document.body.classList.add("aa-Detached"), b.value.input.focus()) : (d.value.core.environment.document.body.removeChild(b.value.detachedOverlay), d.value.core.environment.document.body.classList.remove("aa-Detached")));
	}
	return Uo++, zo(zo({}, g), {}, {
		update: T,
		destroy: C
	});
}
var Go = {
	enabled: !1,
	host: "",
	port: 443,
	protocol: "https",
	apiKey: "",
	preset: "catalog-search",
	collectionsPreset: "collections-search",
	facets: "",
	badges: "",
	rootUrl: "/",
	searchUrl: "/search",
	moneyFormat: "{{amount_with_comma_separator}} €",
	currency: "EUR",
	translations: {},
	...globalThis.KKSearch ?? {}
}, Ko = !!(Go.enabled && Go.host && Go.apiKey);
function B(e, t = {}) {
	let n = Go.translations[e];
	return typeof n == "string" ? Object.entries(t).reduce((e, [t, n]) => e.replaceAll(`%${t}%`, String(n)), n) : "";
}
//#endregion
//#region documents.js
function qo(e) {
	return [
		e.display_title,
		e.werktitel,
		e.spielname,
		e.variant_title,
		e.sku
	].map((e) => typeof e == "string" ? e.trim() : "").find(Boolean) ?? "";
}
function Jo(e) {
	return [e.system, e.artikelart].filter(Boolean).join(" · ");
}
function Yo(e) {
	return typeof e != "number" || !Number.isFinite(e) ? "" : a(Math.round(e * 100), Go.moneyFormat, Go.currency);
}
function Xo(e, t) {
	return e ? `${e}${e.includes("?") ? "&" : "?"}width=${t}` : "";
}
function Zo(e) {
	return `${Go.rootUrl.replace(/\/$/, "")}/${e}`;
}
function Qo(e) {
	return Zo(`products/${e.handle}`);
}
function $o(e) {
	return Zo(`collections/${e.handle}`);
}
function es(e) {
	return e ? `${Go.searchUrl}?q=${encodeURIComponent(e)}` : Go.searchUrl;
}
//#endregion
//#region render/autocomplete-items.js
var ts = 120;
function ns(e) {
	return e.map(({ product: e, variantCount: t }) => ({
		product: e,
		variantCount: t
	}));
}
function rs(e) {
	return Qo(e.product);
}
function is(e, t) {
	let n = Xo(t.image, ts);
	return n ? e`<img class="kk-search__thumb" src="${n}" alt="" loading="lazy" decoding="async" />` : e`<span class="kk-search__thumb kk-search__thumb--empty" aria-hidden="true"></span>`;
}
function as(e, { product: t, variantCount: n }) {
	return e`
    <a class="kk-search__option kk-search__product" href="${Qo(t)}">
      ${is(e, t)}
      <span class="kk-search__text">
        <span class="kk-search__title">${qo(t)}</span>
        <span class="kk-search__subtitle">${Jo(t)}</span>
        <span class="kk-search__price">${B("price_from", { price: Yo(t.price_from) })}</span>
        ${n > 1 ? e`<span class="kk-search__variant-count">
              ${B(n === 1 ? "variant_count_one" : "variant_count_other", { count: n })}
            </span>` : ""}
      </span>
    </a>
  `;
}
function os(e, t) {
	return e`
    <a class="kk-search__option kk-search__collection" href="${$o(t)}">${qo(t)}</a>
  `;
}
function ss(e, t) {
	return e`<a class="kk-search__option kk-search__more" href="${es(t)}">${B("view_all")}</a>`;
}
//#endregion
//#region render/dropdown-skeleton.js
var cs = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, ls = (e) => String(e).replace(/[&<>"']/g, (e) => cs[e]), us = [
	"7rem",
	"5.5rem",
	"9rem",
	"6.5rem",
	"8rem"
];
function ds(e) {
	let t = us.slice(0, e.collections).map((e) => `<li><span class="kk-search__skel kk-search__skel--pill" style="width: ${e}"></span></li>`).join(""), n = Array.from({ length: e.products }, () => "\n      <li class=\"kk-search__skeleton-product\">\n        <span class=\"kk-search__skel kk-search__skel--thumb\"></span>\n        <span class=\"kk-search__skel kk-search__skel--title\"></span>\n        <span class=\"kk-search__skel kk-search__skel--subtitle\"></span>\n        <span class=\"kk-search__skel kk-search__skel--price\"></span>\n      </li>\n    ").join("");
	return `
    <div class="kk-search__panel kk-search__skeleton-panel" aria-hidden="true">
      <div class="kk-search__panel-layout">
        <section class="kk-search__section">
          <div class="kk-search__section-title-wrapper">
            <h3 class="kk-search__section-title">${ls(B("collections"))}</h3>
          </div>
          <ul class="kk-search__list kk-search__skeleton-list--collections">
            ${t}
          </ul>
        </section>

        <section class="kk-search__section">
          <div class="kk-search__section-title-wrapper">
            <h3 class="kk-search__section-title">${ls(B("products"))}</h3>
          </div>
          <ul class="kk-search__list kk-search__skeleton-list--products">
            ${n}
          </ul>
        </section>
      </div>
    </div>
  `;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function fs(e, t, n, r, i, a, o) {
	try {
		var s = e[a](o), c = s.value;
	} catch (e) {
		n(e);
		return;
	}
	s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function ps(e) {
	return function() {
		var t = this, n = arguments;
		return new Promise(function(r, i) {
			var a = e.apply(t, n);
			function o(e) {
				fs(a, r, i, o, s, "next", e);
			}
			function s(e) {
				fs(a, r, i, o, s, "throw", e);
			}
			o(void 0);
		});
	};
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function ms(e, t) {
	if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/typeof.js
function hs(e) {
	"@babel/helpers - typeof";
	return hs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, hs(e);
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function gs(e, t) {
	if (hs(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (hs(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function _s(e) {
	var t = gs(e, "string");
	return hs(t) == "symbol" ? t : t + "";
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/createClass.js
function vs(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _s(r.key), r);
	}
}
function ys(e, t, n) {
	return t && vs(e.prototype, t), n && vs(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/OverloadYield.js
var bs = /* @__PURE__ */ p(((e, t) => {
	function n(e, t) {
		this.v = e, this.k = t;
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), xs = /* @__PURE__ */ p(((e, t) => {
	function n(e, r, i, a) {
		var o = Object.defineProperty;
		try {
			o({}, "", {});
		} catch {
			o = 0;
		}
		t.exports = n = function(e, t, r, i) {
			function a(t, r) {
				n(e, t, function(e) {
					return this._invoke(t, r, e);
				});
			}
			t ? o ? o(e, t, {
				value: r,
				enumerable: !i,
				configurable: !i,
				writable: !i
			}) : e[t] = r : (a("next", 0), a("throw", 1), a("return", 2));
		}, t.exports.__esModule = !0, t.exports.default = t.exports, n(e, r, i, a);
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Ss = /* @__PURE__ */ p(((e, t) => {
	var n = xs();
	function r() {
		var e, i, a = typeof Symbol == "function" ? Symbol : {}, o = a.iterator || "@@iterator", s = a.toStringTag || "@@toStringTag";
		function c(t, r, a, o) {
			var s = r && r.prototype instanceof u ? r : u, c = Object.create(s.prototype);
			return n(c, "_invoke", function(t, n, r) {
				var a, o, s, c = 0, u = r || [], d = !1, f = {
					p: 0,
					n: 0,
					v: e,
					a: p,
					f: p.bind(e, 4),
					d: function(t, n) {
						return a = t, o = 0, s = e, f.n = n, l;
					}
				};
				function p(t, n) {
					for (o = t, s = n, i = 0; !d && c && !r && i < u.length; i++) {
						var r, a = u[i], p = f.p, m = a[2];
						t > 3 ? (r = m === n) && (s = a[(o = a[4]) ? 5 : (o = 3, 3)], a[4] = a[5] = e) : a[0] <= p && ((r = t < 2 && p < a[1]) ? (o = 0, f.v = n, f.n = a[1]) : p < m && (r = t < 3 || a[0] > n || n > m) && (a[4] = t, a[5] = n, f.n = m, o = 0));
					}
					if (r || t > 1) return l;
					throw d = !0, n;
				}
				return function(r, u, m) {
					if (c > 1) throw TypeError("Generator is already running");
					for (d && u === 1 && p(u, m), o = u, s = m; (i = o < 2 ? e : s) || !d;) {
						a || (o ? o < 3 ? (o > 1 && (f.n = -1), p(o, s)) : f.n = s : f.v = s);
						try {
							if (c = 2, a) {
								if (o || (r = "next"), i = a[r]) {
									if (!(i = i.call(a, s))) throw TypeError("iterator result is not an object");
									if (!i.done) return i;
									s = i.value, o < 2 && (o = 0);
								} else o === 1 && (i = a.return) && i.call(a), o < 2 && (s = TypeError("The iterator does not provide a '" + r + "' method"), o = 1);
								a = e;
							} else if ((i = (d = f.n < 0) ? s : t.call(n, f)) !== l) break;
						} catch (t) {
							a = e, o = 1, s = t;
						} finally {
							c = 1;
						}
					}
					return {
						value: i,
						done: d
					};
				};
			}(t, a, o), !0), c;
		}
		var l = {};
		function u() {}
		function d() {}
		function f() {}
		i = Object.getPrototypeOf;
		var p = [][o] ? i(i([][o]())) : (n(i = {}, o, function() {
			return this;
		}), i), m = f.prototype = u.prototype = Object.create(p);
		function h(e) {
			return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, n(e, s, "GeneratorFunction")), e.prototype = Object.create(m), e;
		}
		return d.prototype = f, n(m, "constructor", f), n(f, "constructor", d), d.displayName = "GeneratorFunction", n(f, s, "GeneratorFunction"), n(m), n(m, s, "Generator"), n(m, o, function() {
			return this;
		}), n(m, "toString", function() {
			return "[object Generator]";
		}), (t.exports = r = function() {
			return {
				w: c,
				m: h
			};
		}, t.exports.__esModule = !0, t.exports.default = t.exports)();
	}
	t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Cs = /* @__PURE__ */ p(((e, t) => {
	var n = bs(), r = xs();
	function i(e, t) {
		function a(r, i, o, s) {
			try {
				var c = e[r](i), l = c.value;
				return l instanceof n ? t.resolve(l.v).then(function(e) {
					a("next", e, o, s);
				}, function(e) {
					a("throw", e, o, s);
				}) : t.resolve(l).then(function(e) {
					c.value = e, o(c);
				}, function(e) {
					return a("throw", e, o, s);
				});
			} catch (e) {
				s(e);
			}
		}
		var o;
		this.next || (r(i.prototype), r(i.prototype, typeof Symbol == "function" && Symbol.asyncIterator || "@asyncIterator", function() {
			return this;
		})), r(this, "_invoke", function(e, n, r) {
			function i() {
				return new t(function(t, n) {
					a(e, r, t, n);
				});
			}
			return o = o ? o.then(i, i) : i();
		}, !0);
	}
	t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
})), ws = /* @__PURE__ */ p(((e, t) => {
	var n = Ss(), r = Cs();
	function i(e, t, i, a, o) {
		return new r(n().w(e, t, i, a), o || Promise);
	}
	t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Ts = /* @__PURE__ */ p(((e, t) => {
	var n = ws();
	function r(e, t, r, i, a) {
		var o = n(e, t, r, i, a);
		return o.next().then(function(e) {
			return e.done ? e.value : o.next();
		});
	}
	t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Es = /* @__PURE__ */ p(((e, t) => {
	function n(e) {
		var t = Object(e), n = [];
		for (var r in t) n.unshift(r);
		return function e() {
			for (; n.length;) if ((r = n.pop()) in t) return e.value = r, e.done = !1, e;
			return e.done = !0, e;
		};
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Ds = /* @__PURE__ */ p(((e, t) => {
	function n(e) {
		"@babel/helpers - typeof";
		return t.exports = n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, t.exports.__esModule = !0, t.exports.default = t.exports, n(e);
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Os = /* @__PURE__ */ p(((e, t) => {
	var n = Ds().default;
	function r(e) {
		if (e != null) {
			var t = e[typeof Symbol == "function" && Symbol.iterator || "@@iterator"], r = 0;
			if (t) return t.call(e);
			if (typeof e.next == "function") return e;
			if (!isNaN(e.length)) return { next: function() {
				return e && r >= e.length && (e = void 0), {
					value: e && e[r++],
					done: !e
				};
			} };
		}
		throw TypeError(n(e) + " is not iterable");
	}
	t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})), ks = /* @__PURE__ */ p(((e, t) => {
	var n = bs(), r = Ss(), i = Ts(), a = ws(), o = Cs(), s = Es(), c = Os();
	function l() {
		var e = r(), u = e.m(l), d = (Object.getPrototypeOf ? Object.getPrototypeOf(u) : u.__proto__).constructor;
		function f(e) {
			var t = typeof e == "function" && e.constructor;
			return !!t && (t === d || (t.displayName || t.name) === "GeneratorFunction");
		}
		var p = {
			throw: 1,
			return: 2,
			break: 3,
			continue: 3
		};
		function m(e) {
			var t, n;
			return function(r) {
				t || (t = {
					stop: function() {
						return n(r.a, 2);
					},
					catch: function() {
						return r.v;
					},
					abrupt: function(e, t) {
						return n(r.a, p[e], t);
					},
					delegateYield: function(e, i, a) {
						return t.resultName = i, n(r.d, c(e), a);
					},
					finish: function(e) {
						return n(r.f, e);
					}
				}, n = function(e, n, i) {
					r.p = t.prev, r.n = t.next;
					try {
						return e(n, i);
					} finally {
						t.next = r.n;
					}
				}), t.resultName && (t[t.resultName] = r.v, t.resultName = void 0), t.sent = r.v, t.next = r.n;
				try {
					return e.call(this, t);
				} finally {
					r.p = t.prev, r.n = t.next;
				}
			};
		}
		return (t.exports = l = function() {
			return {
				wrap: function(t, n, r, i) {
					return e.w(m(t), n, r, i && i.reverse());
				},
				isGeneratorFunction: f,
				mark: e.m,
				awrap: function(e, t) {
					return new n(e, t);
				},
				AsyncIterator: o,
				async: function(e, t, n, r, o) {
					return (f(t) ? a : i)(m(e), t, n, r, o);
				},
				keys: s,
				values: c
			};
		}, t.exports.__esModule = !0, t.exports.default = t.exports)();
	}
	t.exports = l, t.exports.__esModule = !0, t.exports.default = t.exports;
})), As = /* @__PURE__ */ g((/* @__PURE__ */ p(((e, t) => {
	var n = ks()();
	t.exports = n;
	try {
		regeneratorRuntime = n;
	} catch {
		typeof globalThis == "object" ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
	}
})))()), js = /*#__PURE__*/ function() {
	function e() {
		var t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		ms(this, e), this.server = n.server || { nodes: [{
			host: "localhost",
			port: "8108",
			path: "",
			protocol: "http"
		}] }, this.server.cacheSearchResultsForSeconds = this.server.cacheSearchResultsForSeconds ?? 120, this.additionalSearchParameters = n.additionalSearchParameters ?? {}, this.additionalSearchParameters.query_by = this.additionalSearchParameters.queryBy ?? this.additionalSearchParameters.query_by ?? "", this.additionalSearchParameters.preset = this.additionalSearchParameters.preset ?? this.additionalSearchParameters.preset ?? "", this.additionalSearchParameters.sort_by = this.additionalSearchParameters.sortBy ?? this.additionalSearchParameters.sort_by ?? "", this.additionalSearchParameters.highlight_full_fields = this.additionalSearchParameters.highlightFullFields ?? this.additionalSearchParameters.highlight_full_fields ?? this.additionalSearchParameters.query_by, this.geoLocationField = n.geoLocationField ?? "_geoloc", this.facetableFieldsWithSpecialCharacters = n.facetableFieldsWithSpecialCharacters ?? [], this.collectionSpecificSearchParameters = n.collectionSpecificSearchParameters ?? {}, Object.keys(this.collectionSpecificSearchParameters).forEach(function(e) {
			var n = t.collectionSpecificSearchParameters[e];
			n.query_by = n.queryBy ?? n.query_by, n.preset = n.preset ?? n.preset, n.sort_by = n.sortBy ?? n.sort_by, n.highlight_full_fields = n.highlightFullFields ?? n.highlight_full_fields ?? t.additionalSearchParameters.highlight_full_fields ?? n.query_by, Object.keys(n).forEach(function(e) {
				return n[e] === void 0 ? delete n[e] : {};
			});
		}), this.renderingContent = n.renderingContent, this.flattenGroupedHits = n.flattenGroupedHits ?? !0, this.facetByOptions = n.facetByOptions ?? {}, this.filterByOptions = n.filterByOptions ?? {}, this.sortByOptions = n.sortByOptions ?? {}, this.collectionSpecificFacetByOptions = n.collectionSpecificFacetByOptions ?? {}, this.collectionSpecificFilterByOptions = n.collectionSpecificFilterByOptions ?? {}, this.collectionSpecificSortByOptions = n.collectionSpecificSortByOptions ?? {}, this.union = n.union ?? !1, this.useOverrideTags = n.useOverrideTags ?? !1, this.flipNegativeRefinementOperator = n.flipNegativeRefinementOperator ?? !1;
	}
	return ys(e, [{
		key: "validate",
		value: function() {
			if ((this.additionalSearchParameters.queryBy || Object.values(this.collectionSpecificSearchParameters).some(function(e) {
				return e.queryBy;
			})) && console.warn("[typesense-instantsearch-adapter] Please use snake_cased versions of parameters in additionalSearchParameters instead of camelCased parameters. For example: Use query_by instead of queryBy. camelCased parameters will be deprecated in a future version. We're making this change so that parameter names are identical to the ones sent to Typesense (which are all snake_cased), and to also keep the types for these parameters in sync with the types defined in typesense-js."), this.additionalSearchParameters.query_by.length === 0 && this.additionalSearchParameters.preset.length === 0 && (Object.keys(this.collectionSpecificSearchParameters).length === 0 || Object.values(this.collectionSpecificSearchParameters).some(function(e) {
				return (e.query_by || "").length === 0 && (e.preset || "").length === 0;
			}))) throw Error("[typesense-instantsearch-adapter] Missing parameter: One of additionalSearchParameters.query_by or additionalSearchParameters.preset needs to be set, or all collectionSpecificSearchParameters need to have either .query_by or .preset set.");
		}
	}]);
}(), V = /* @__PURE__ */ m({
	__addDisposableResource: () => ac,
	__assign: () => lc,
	__asyncDelegator: () => Zs,
	__asyncGenerator: () => Xs,
	__asyncValues: () => Qs,
	__await: () => Ys,
	__awaiter: () => Vs,
	__classPrivateFieldGet: () => nc,
	__classPrivateFieldIn: () => ic,
	__classPrivateFieldSet: () => rc,
	__createBinding: () => uc,
	__decorate: () => Ps,
	__disposeResources: () => oc,
	__esDecorate: () => Is,
	__exportStar: () => Us,
	__extends: () => Ms,
	__generator: () => Hs,
	__importDefault: () => tc,
	__importStar: () => ec,
	__makeTemplateObject: () => $s,
	__metadata: () => Bs,
	__param: () => Fs,
	__propKey: () => Rs,
	__read: () => Gs,
	__rest: () => Ns,
	__rewriteRelativeImportExtension: () => sc,
	__runInitializers: () => Ls,
	__setFunctionName: () => zs,
	__spread: () => Ks,
	__spreadArray: () => Js,
	__spreadArrays: () => qs,
	__values: () => Ws,
	default: () => mc
});
function Ms(e, t) {
	if (typeof t != "function" && t !== null) throw TypeError("Class extends value " + String(t) + " is not a constructor or null");
	cc(e, t);
	function n() {
		this.constructor = e;
	}
	e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function Ns(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function Ps(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
function Fs(e, t) {
	return function(n, r) {
		t(n, r, e);
	};
}
function Is(e, t, n, r, i, a) {
	function o(e) {
		if (e !== void 0 && typeof e != "function") throw TypeError("Function expected");
		return e;
	}
	for (var s = r.kind, c = s === "getter" ? "get" : s === "setter" ? "set" : "value", l = !t && e ? r.static ? e : e.prototype : null, u = t || (l ? Object.getOwnPropertyDescriptor(l, r.name) : {}), d, f = !1, p = n.length - 1; p >= 0; p--) {
		var m = {};
		for (var h in r) m[h] = h === "access" ? {} : r[h];
		for (var h in r.access) m.access[h] = r.access[h];
		m.addInitializer = function(e) {
			if (f) throw TypeError("Cannot add initializers after decoration has completed");
			a.push(o(e || null));
		};
		var g = (0, n[p])(s === "accessor" ? {
			get: u.get,
			set: u.set
		} : u[c], m);
		if (s === "accessor") {
			if (g === void 0) continue;
			if (typeof g != "object" || !g) throw TypeError("Object expected");
			(d = o(g.get)) && (u.get = d), (d = o(g.set)) && (u.set = d), (d = o(g.init)) && i.unshift(d);
		} else (d = o(g)) && (s === "field" ? i.unshift(d) : u[c] = d);
	}
	l && Object.defineProperty(l, r.name, u), f = !0;
}
function Ls(e, t, n) {
	for (var r = arguments.length > 2, i = 0; i < t.length; i++) n = r ? t[i].call(e, n) : t[i].call(e);
	return r ? n : void 0;
}
function Rs(e) {
	return typeof e == "symbol" ? e : `${e}`;
}
function zs(e, t, n) {
	return typeof t == "symbol" && (t = t.description ? `[${t.description}]` : ""), Object.defineProperty(e, "name", {
		configurable: !0,
		value: n ? `${n} ${t}` : t
	});
}
function Bs(e, t) {
	if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function Vs(e, t, n, r) {
	function i(e) {
		return e instanceof n ? e : new n(function(t) {
			t(e);
		});
	}
	return new (n ||= Promise)(function(n, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			e.done ? n(e.value) : i(e.value).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	});
}
function Hs(e, t) {
	var n = {
		label: 0,
		sent: function() {
			if (a[0] & 1) throw a[1];
			return a[1];
		},
		trys: [],
		ops: []
	}, r, i, a, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
	return o.next = s(0), o.throw = s(1), o.return = s(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
		return this;
	}), o;
	function s(e) {
		return function(t) {
			return c([e, t]);
		};
	}
	function c(s) {
		if (r) throw TypeError("Generator is already executing.");
		for (; o && (o = 0, s[0] && (n = 0)), n;) try {
			if (r = 1, i && (a = s[0] & 2 ? i.return : s[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, s[1])).done) return a;
			switch (i = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
				case 0:
				case 1:
					a = s;
					break;
				case 4: return n.label++, {
					value: s[1],
					done: !1
				};
				case 5:
					n.label++, i = s[1], s = [0];
					continue;
				case 7:
					s = n.ops.pop(), n.trys.pop();
					continue;
				default:
					if ((a = n.trys, !(a = a.length > 0 && a[a.length - 1])) && (s[0] === 6 || s[0] === 2)) {
						n = 0;
						continue;
					}
					if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
						n.label = s[1];
						break;
					}
					if (s[0] === 6 && n.label < a[1]) {
						n.label = a[1], a = s;
						break;
					}
					if (a && n.label < a[2]) {
						n.label = a[2], n.ops.push(s);
						break;
					}
					a[2] && n.ops.pop(), n.trys.pop();
					continue;
			}
			s = t.call(e, n);
		} catch (e) {
			s = [6, e], i = 0;
		} finally {
			r = a = 0;
		}
		if (s[0] & 5) throw s[1];
		return {
			value: s[0] ? s[1] : void 0,
			done: !0
		};
	}
}
function Us(e, t) {
	for (var n in e) n !== "default" && !Object.prototype.hasOwnProperty.call(t, n) && uc(t, e, n);
}
function Ws(e) {
	var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
	if (n) return n.call(e);
	if (e && typeof e.length == "number") return { next: function() {
		return e && r >= e.length && (e = void 0), {
			value: e && e[r++],
			done: !e
		};
	} };
	throw TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Gs(e, t) {
	var n = typeof Symbol == "function" && e[Symbol.iterator];
	if (!n) return e;
	var r = n.call(e), i, a = [], o;
	try {
		for (; (t === void 0 || t-- > 0) && !(i = r.next()).done;) a.push(i.value);
	} catch (e) {
		o = { error: e };
	} finally {
		try {
			i && !i.done && (n = r.return) && n.call(r);
		} finally {
			if (o) throw o.error;
		}
	}
	return a;
}
function Ks() {
	for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(Gs(arguments[t]));
	return e;
}
function qs() {
	for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
	for (var r = Array(e), i = 0, t = 0; t < n; t++) for (var a = arguments[t], o = 0, s = a.length; o < s; o++, i++) r[i] = a[o];
	return r;
}
function Js(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
function Ys(e) {
	return this instanceof Ys ? (this.v = e, this) : new Ys(e);
}
function Xs(e, t, n) {
	if (!Symbol.asyncIterator) throw TypeError("Symbol.asyncIterator is not defined.");
	var r = n.apply(e, t || []), i, a = [];
	return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), s("next"), s("throw"), s("return", o), i[Symbol.asyncIterator] = function() {
		return this;
	}, i;
	function o(e) {
		return function(t) {
			return Promise.resolve(t).then(e, d);
		};
	}
	function s(e, t) {
		r[e] && (i[e] = function(t) {
			return new Promise(function(n, r) {
				a.push([
					e,
					t,
					n,
					r
				]) > 1 || c(e, t);
			});
		}, t && (i[e] = t(i[e])));
	}
	function c(e, t) {
		try {
			l(r[e](t));
		} catch (e) {
			f(a[0][3], e);
		}
	}
	function l(e) {
		e.value instanceof Ys ? Promise.resolve(e.value.v).then(u, d) : f(a[0][2], e);
	}
	function u(e) {
		c("next", e);
	}
	function d(e) {
		c("throw", e);
	}
	function f(e, t) {
		e(t), a.shift(), a.length && c(a[0][0], a[0][1]);
	}
}
function Zs(e) {
	var t, n;
	return t = {}, r("next"), r("throw", function(e) {
		throw e;
	}), r("return"), t[Symbol.iterator] = function() {
		return this;
	}, t;
	function r(r, i) {
		t[r] = e[r] ? function(t) {
			return (n = !n) ? {
				value: Ys(e[r](t)),
				done: !1
			} : i ? i(t) : t;
		} : i;
	}
}
function Qs(e) {
	if (!Symbol.asyncIterator) throw TypeError("Symbol.asyncIterator is not defined.");
	var t = e[Symbol.asyncIterator], n;
	return t ? t.call(e) : (e = typeof Ws == "function" ? Ws(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
		return this;
	}, n);
	function r(t) {
		n[t] = e[t] && function(n) {
			return new Promise(function(r, a) {
				n = e[t](n), i(r, a, n.done, n.value);
			});
		};
	}
	function i(e, t, n, r) {
		Promise.resolve(r).then(function(t) {
			e({
				value: t,
				done: n
			});
		}, t);
	}
}
function $s(e, t) {
	return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
function ec(e) {
	if (e && e.__esModule) return e;
	var t = {};
	if (e != null) for (var n = fc(e), r = 0; r < n.length; r++) n[r] !== "default" && uc(t, e, n[r]);
	return dc(t, e), t;
}
function tc(e) {
	return e && e.__esModule ? e : { default: e };
}
function nc(e, t, n, r) {
	if (n === "a" && !r) throw TypeError("Private accessor was defined without a getter");
	if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
	return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}
function rc(e, t, n, r, i) {
	if (r === "m") throw TypeError("Private method is not writable");
	if (r === "a" && !i) throw TypeError("Private accessor was defined without a setter");
	if (typeof t == "function" ? e !== t || !i : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
	return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}
function ic(e, t) {
	if (t === null || typeof t != "object" && typeof t != "function") throw TypeError("Cannot use 'in' operator on non-object");
	return typeof e == "function" ? t === e : e.has(t);
}
function ac(e, t, n) {
	if (t != null) {
		if (typeof t != "object" && typeof t != "function") throw TypeError("Object expected.");
		var r, i;
		if (n) {
			if (!Symbol.asyncDispose) throw TypeError("Symbol.asyncDispose is not defined.");
			r = t[Symbol.asyncDispose];
		}
		if (r === void 0) {
			if (!Symbol.dispose) throw TypeError("Symbol.dispose is not defined.");
			r = t[Symbol.dispose], n && (i = r);
		}
		if (typeof r != "function") throw TypeError("Object not disposable.");
		i && (r = function() {
			try {
				i.call(this);
			} catch (e) {
				return Promise.reject(e);
			}
		}), e.stack.push({
			value: t,
			dispose: r,
			async: n
		});
	} else n && e.stack.push({ async: !0 });
	return t;
}
function oc(e) {
	function t(t) {
		e.error = e.hasError ? new pc(t, e.error, "An error was suppressed during disposal.") : t, e.hasError = !0;
	}
	var n, r = 0;
	function i() {
		for (; n = e.stack.pop();) try {
			if (!n.async && r === 1) return r = 0, e.stack.push(n), Promise.resolve().then(i);
			if (n.dispose) {
				var a = n.dispose.call(n.value);
				if (n.async) return r |= 2, Promise.resolve(a).then(i, function(e) {
					return t(e), i();
				});
			} else r |= 1;
		} catch (e) {
			t(e);
		}
		if (r === 1) return e.hasError ? Promise.reject(e.error) : Promise.resolve();
		if (e.hasError) throw e.error;
	}
	return i();
}
function sc(e, t) {
	return typeof e == "string" && /^\.\.?\//.test(e) ? e.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(e, n, r, i, a) {
		return n ? t ? ".jsx" : ".js" : r && (!i || !a) ? e : r + i + "." + a.toLowerCase() + "js";
	}) : e;
}
var cc, lc, uc, dc, fc, pc, mc, H = f((() => {
	cc = function(e, t) {
		return cc = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
			e.__proto__ = t;
		} || function(e, t) {
			for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
		}, cc(e, t);
	}, lc = function() {
		return lc = Object.assign || function(e) {
			for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
			return e;
		}, lc.apply(this, arguments);
	}, uc = Object.create ? (function(e, t, n, r) {
		r === void 0 && (r = n);
		var i = Object.getOwnPropertyDescriptor(t, n);
		(!i || ("get" in i ? !t.__esModule : i.writable || i.configurable)) && (i = {
			enumerable: !0,
			get: function() {
				return t[n];
			}
		}), Object.defineProperty(e, r, i);
	}) : (function(e, t, n, r) {
		r === void 0 && (r = n), e[r] = t[n];
	}), dc = Object.create ? (function(e, t) {
		Object.defineProperty(e, "default", {
			enumerable: !0,
			value: t
		});
	}) : function(e, t) {
		e.default = t;
	}, fc = function(e) {
		return fc = Object.getOwnPropertyNames || function(e) {
			var t = [];
			for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[t.length] = n);
			return t;
		}, fc(e);
	}, pc = typeof SuppressedError == "function" ? SuppressedError : function(e, t, n) {
		var r = Error(n);
		return r.name = "SuppressedError", r.error = e, r.suppressed = t, r;
	}, mc = {
		__extends: Ms,
		__assign: lc,
		__rest: Ns,
		__decorate: Ps,
		__param: Fs,
		__esDecorate: Is,
		__runInitializers: Ls,
		__propKey: Rs,
		__setFunctionName: zs,
		__metadata: Bs,
		__awaiter: Vs,
		__generator: Hs,
		__createBinding: uc,
		__exportStar: Us,
		__values: Ws,
		__read: Gs,
		__spread: Ks,
		__spreadArrays: qs,
		__spreadArray: Js,
		__await: Ys,
		__asyncGenerator: Xs,
		__asyncDelegator: Zs,
		__asyncValues: Qs,
		__makeTemplateObject: $s,
		__importStar: ec,
		__importDefault: tc,
		__classPrivateFieldGet: nc,
		__classPrivateFieldSet: rc,
		__classPrivateFieldIn: ic,
		__addDisposableResource: ac,
		__disposeResources: oc,
		__rewriteRelativeImportExtension: sc
	};
})), hc = /* @__PURE__ */ p(((e, t) => {
	(function(e, n) {
		typeof define == "function" && define.amd ? define(n) : typeof t == "object" && t.exports ? t.exports = n() : e.log = n();
	})(e, function() {
		var e = function() {}, t = "undefined", n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent), r = [
			"trace",
			"debug",
			"info",
			"warn",
			"error"
		], i = {}, a = null;
		function o(e, t) {
			var n = e[t];
			if (typeof n.bind == "function") return n.bind(e);
			try {
				return Function.prototype.bind.call(n, e);
			} catch {
				return function() {
					return Function.prototype.apply.apply(n, [e, arguments]);
				};
			}
		}
		function s() {
			console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
		}
		function c(r) {
			return r === "debug" && (r = "log"), typeof console === t ? !1 : r === "trace" && n ? s : console[r] === void 0 ? console.log === void 0 ? e : o(console, "log") : o(console, r);
		}
		function l() {
			for (var n = this.getLevel(), i = 0; i < r.length; i++) {
				var a = r[i];
				this[a] = i < n ? e : this.methodFactory(a, n, this.name);
			}
			if (this.log = this.debug, typeof console === t && n < this.levels.SILENT) return "No console available for logging";
		}
		function u(e) {
			return function() {
				typeof console !== t && (l.call(this), this[e].apply(this, arguments));
			};
		}
		function d(e, t, n) {
			return c(e) || u.apply(this, arguments);
		}
		function f(e, n) {
			var o = this, s, c, u, f = "loglevel";
			typeof e == "string" ? f += ":" + e : typeof e == "symbol" && (f = void 0);
			function p(e) {
				var n = (r[e] || "silent").toUpperCase();
				if (!(typeof window === t || !f)) {
					try {
						window.localStorage[f] = n;
						return;
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(f) + "=" + n + ";";
					} catch {}
				}
			}
			function m() {
				var e;
				if (!(typeof window === t || !f)) {
					try {
						e = window.localStorage[f];
					} catch {}
					if (typeof e === t) try {
						var n = window.document.cookie, r = encodeURIComponent(f), i = n.indexOf(r + "=");
						i !== -1 && (e = /^([^;]+)/.exec(n.slice(i + r.length + 1))[1]);
					} catch {}
					return o.levels[e] === void 0 && (e = void 0), e;
				}
			}
			function h() {
				if (!(typeof window === t || !f)) {
					try {
						window.localStorage.removeItem(f);
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(f) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
					} catch {}
				}
			}
			function g(e) {
				var t = e;
				if (typeof t == "string" && o.levels[t.toUpperCase()] !== void 0 && (t = o.levels[t.toUpperCase()]), typeof t == "number" && t >= 0 && t <= o.levels.SILENT) return t;
				throw TypeError("log.setLevel() called with invalid level: " + e);
			}
			o.name = e, o.levels = {
				TRACE: 0,
				DEBUG: 1,
				INFO: 2,
				WARN: 3,
				ERROR: 4,
				SILENT: 5
			}, o.methodFactory = n || d, o.getLevel = function() {
				return u ?? c ?? s;
			}, o.setLevel = function(e, t) {
				return u = g(e), t !== !1 && p(u), l.call(o);
			}, o.setDefaultLevel = function(e) {
				c = g(e), m() || o.setLevel(e, !1);
			}, o.resetLevel = function() {
				u = null, h(), l.call(o);
			}, o.enableAll = function(e) {
				o.setLevel(o.levels.TRACE, e);
			}, o.disableAll = function(e) {
				o.setLevel(o.levels.SILENT, e);
			}, o.rebuild = function() {
				if (a !== o && (s = g(a.getLevel())), l.call(o), a === o) for (var e in i) i[e].rebuild();
			}, s = g(a ? a.getLevel() : "WARN");
			var _ = m();
			_ != null && (u = g(_)), l.call(o);
		}
		a = new f(), a.getLogger = function(e) {
			if (typeof e != "symbol" && typeof e != "string" || e === "") throw TypeError("You must supply a name when creating a logger.");
			var t = i[e];
			return t ||= i[e] = new f(e, a.methodFactory), t;
		};
		var p = typeof window === t ? void 0 : window.log;
		return a.noConflict = function() {
			return typeof window !== t && window.log === a && (window.log = p), a;
		}, a.getLoggers = function() {
			return i;
		}, a.default = a, a;
	});
})), gc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n(t, n, r) {
			var i = this.constructor, a = e.call(this, t) || this;
			return a.name = i.name, a.httpBody = n, a.httpStatus = r, Object.setPrototypeOf(a, i.prototype), a;
		}
		return n;
	}(Error);
})), _c = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), vc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), yc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), bc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), xc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), Sc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), Cc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), wc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n() {
			return e !== null && e.apply(this, arguments) || this;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), Tc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function(e) {
		t.__extends(n, e);
		function n(t, n, r) {
			var i = e.call(this, t) || this;
			return i.importResults = n, i.payload = r, i;
		}
		return n;
	}(t.__importDefault(gc()).default);
})), Ec = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.ImportError = e.TypesenseError = e.ServerError = e.RequestUnauthorized = e.RequestMalformed = e.ObjectUnprocessable = e.ObjectNotFound = e.ObjectAlreadyExists = e.MissingConfigurationError = e.HTTPError = void 0;
	var t = (H(), _(V));
	e.HTTPError = t.__importDefault(_c()).default, e.MissingConfigurationError = t.__importDefault(vc()).default, e.ObjectAlreadyExists = t.__importDefault(yc()).default, e.ObjectNotFound = t.__importDefault(bc()).default, e.ObjectUnprocessable = t.__importDefault(xc()).default, e.RequestMalformed = t.__importDefault(Sc()).default, e.RequestUnauthorized = t.__importDefault(Cc()).default, e.ServerError = t.__importDefault(wc()).default, e.ImportError = t.__importDefault(Tc()).default, e.TypesenseError = t.__importDefault(gc()).default;
})), Dc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importStar(hc()), r = Ec();
	e.default = function() {
		function e(e) {
			var r = this;
			this.nodes = e.nodes || [], this.nodes = this.nodes.map(function(e) {
				return r.setDefaultPathInNode(e);
			}).map(function(e) {
				return r.setDefaultPortInNode(e);
			}).map(function(e) {
				return t.__assign({}, e);
			}), e.randomizeNodes ??= !0, e.randomizeNodes === !0 && this.shuffleArray(this.nodes), this.nearestNode = e.nearestNode, this.nearestNode = this.setDefaultPathInNode(this.nearestNode), this.nearestNode = this.setDefaultPortInNode(this.nearestNode), this.connectionTimeoutSeconds = e.connectionTimeoutSeconds || e.timeoutSeconds || 5, this.healthcheckIntervalSeconds = e.healthcheckIntervalSeconds || 60, this.numRetries = (e.numRetries !== void 0 && e.numRetries >= 0 ? e.numRetries : this.nodes.length + (this.nearestNode == null ? 0 : 1)) || 3, this.retryIntervalSeconds = e.retryIntervalSeconds || .1, this.apiKey = e.apiKey, this.sendApiKeyAsQueryParam = e.sendApiKeyAsQueryParam, this.cacheSearchResultsForSeconds = e.cacheSearchResultsForSeconds || 0, this.useServerSideSearchCache = e.useServerSideSearchCache || !1, this.axiosAdapter = e.axiosAdapter, this.logger = e.logger || n, this.logLevel = e.logLevel || "warn", this.logger.setLevel(this.logLevel), this.additionalHeaders = e.additionalHeaders, this.httpAgent = e.httpAgent, this.httpsAgent = e.httpsAgent, this.paramsSerializer = e.paramsSerializer, this.showDeprecationWarnings(e), this.validate();
		}
		return e.prototype.validate = function() {
			if (this.nodes == null || this.nodes.length === 0 || this.validateNodes()) throw new r.MissingConfigurationError("Ensure that nodes[].protocol, nodes[].host and nodes[].port are set");
			if (this.nearestNode != null && this.isNodeMissingAnyParameters(this.nearestNode)) throw new r.MissingConfigurationError("Ensure that nearestNodes.protocol, nearestNodes.host and nearestNodes.port are set");
			if (this.apiKey == null) throw new r.MissingConfigurationError("Ensure that apiKey is set");
			return !0;
		}, e.prototype.validateNodes = function() {
			var e = this;
			return this.nodes.some(function(t) {
				return e.isNodeMissingAnyParameters(t);
			});
		}, e.prototype.isNodeMissingAnyParameters = function(e) {
			return ![
				"protocol",
				"host",
				"port",
				"path"
			].every(function(t) {
				return e.hasOwnProperty(t);
			}) && e.url == null;
		}, e.prototype.setDefaultPathInNode = function(e) {
			return e != null && !e.hasOwnProperty("path") && (e.path = ""), e;
		}, e.prototype.setDefaultPortInNode = function(e) {
			if (e != null && !e.hasOwnProperty("port") && e.hasOwnProperty("protocol")) switch (e.protocol) {
				case "https":
					e.port = 443;
					break;
				case "http":
					e.port = 80;
					break;
			}
			return e;
		}, e.prototype.showDeprecationWarnings = function(e) {
			e.timeoutSeconds && this.logger.warn("Deprecation warning: timeoutSeconds is now renamed to connectionTimeoutSeconds"), e.masterNode && this.logger.warn("Deprecation warning: masterNode is now consolidated to nodes, starting with Typesense Server v0.12"), e.readReplicaNodes && this.logger.warn("Deprecation warning: readReplicaNodes is now consolidated to nodes, starting with Typesense Server v0.12");
		}, e.prototype.shuffleArray = function(e) {
			for (var t, n = e.length - 1; n > 0; n--) {
				var r = Math.floor(Math.random() * (n + 1));
				t = [e[r], e[n]], e[n] = t[0], e[r] = t[1];
			}
		}, e;
	}();
})), Oc = /* @__PURE__ */ p(((e, t) => {
	function n(e, t) {
		return function() {
			return e.apply(t, arguments);
		};
	}
	var { toString: r } = Object.prototype, { getPrototypeOf: i } = Object, { iterator: a, toStringTag: o } = Symbol, s = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), c = (e, t) => {
		let n = e, r = [];
		for (; n != null && n !== Object.prototype;) {
			if (r.indexOf(n) !== -1) return !1;
			if (r.push(n), s(n, t)) return !0;
			n = i(n);
		}
		return !1;
	}, l = (e, t) => e != null && c(e, t) ? e[t] : void 0, u = ((e) => (t) => {
		let n = r.call(t);
		return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
	})(Object.create(null)), d = (e) => (e = e.toLowerCase(), (t) => u(t) === e), f = (e) => (t) => typeof t === e, { isArray: p } = Array, m = f("undefined");
	function h(e) {
		return e !== null && !m(e) && e.constructor !== null && !m(e.constructor) && y(e.constructor.isBuffer) && e.constructor.isBuffer(e);
	}
	var g = d("ArrayBuffer");
	function _(e) {
		let t;
		return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && g(e.buffer), t;
	}
	var v = f("string"), y = f("function"), b = f("number"), x = (e) => typeof e == "object" && !!e, S = (e) => e === !0 || e === !1, C = (e) => {
		if (!x(e)) return !1;
		let t = i(e);
		return (t === null || t === Object.prototype || i(t) === null) && !c(e, o) && !c(e, a);
	}, w = (e) => {
		if (!x(e) || h(e)) return !1;
		try {
			return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
		} catch {
			return !1;
		}
	}, T = d("Date"), E = d("File"), D = (e) => !!(e && e.uri !== void 0), ee = (e) => e && e.getParts !== void 0, O = d("Blob"), k = d("FileList"), A = (e) => x(e) && y(e.pipe);
	function j() {
		return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
	}
	var te = j(), ne = te.FormData === void 0 ? void 0 : te.FormData, M = (e) => {
		if (!e) return !1;
		if (ne && e instanceof ne) return !0;
		let t = i(e);
		if (!t || t === Object.prototype || !y(e.append)) return !1;
		let n = u(e);
		return n === "formdata" || n === "object" && y(e.toString) && e.toString() === "[object FormData]";
	}, re = d("URLSearchParams"), [ie, ae, oe, se] = [
		"ReadableStream",
		"Request",
		"Response",
		"Headers"
	].map(d), N = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
	function ce(e, t, { allOwnKeys: n = !1 } = {}) {
		if (e == null) return;
		let r, i;
		if (typeof e != "object" && (e = [e]), p(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
		else {
			if (h(e)) return;
			let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
			for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
		}
	}
	function le(e, t) {
		if (h(e)) return null;
		t = t.toLowerCase();
		let n = Object.keys(e), r = n.length, i;
		for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
		return null;
	}
	var ue = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, de = (e) => !m(e) && e !== ue;
	function fe(...e) {
		let { caseless: t, skipUndefined: n } = de(this) && this || {}, r = {}, i = (e, i) => {
			if (i === "__proto__" || i === "constructor" || i === "prototype") return;
			let a = t && typeof i == "string" && le(r, i) || i, o = s(r, a) ? r[a] : void 0;
			C(o) && C(e) ? r[a] = fe(o, e) : C(e) ? r[a] = fe({}, e) : p(e) ? r[a] = e.slice() : (!n || !m(e)) && (r[a] = e);
		};
		for (let t = 0, n = e.length; t < n; t++) {
			let n = e[t];
			if (!n || h(n) || (ce(n, i), typeof n != "object" || p(n))) continue;
			let r = Object.getOwnPropertySymbols(n);
			for (let e = 0; e < r.length; e++) {
				let t = r[e];
				we.call(n, t) && i(n[t], t);
			}
		}
		return r;
	}
	var pe = (e, t, r, { allOwnKeys: i } = {}) => (ce(t, (t, i) => {
		r && y(t) ? Object.defineProperty(e, i, {
			__proto__: null,
			value: n(t, r),
			writable: !0,
			enumerable: !0,
			configurable: !0
		}) : Object.defineProperty(e, i, {
			__proto__: null,
			value: t,
			writable: !0,
			enumerable: !0,
			configurable: !0
		});
	}, { allOwnKeys: i }), e), me = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), he = (e, t, n, r) => {
		e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
			__proto__: null,
			value: e,
			writable: !0,
			enumerable: !1,
			configurable: !0
		}), Object.defineProperty(e, "super", {
			__proto__: null,
			value: t.prototype
		}), n && Object.assign(e.prototype, n);
	}, ge = (e, t, n, r) => {
		let a, o, s, c = {};
		if (t ||= {}, e == null) return t;
		do {
			for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0;) s = a[o], (!r || r(s, e, t)) && !c[s] && (t[s] = e[s], c[s] = !0);
			e = n !== !1 && i(e);
		} while (e && (!n || n(e, t)) && e !== Object.prototype);
		return t;
	}, _e = (e, t, n) => {
		e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
		let r = e.indexOf(t, n);
		return r !== -1 && r === n;
	}, ve = (e) => {
		if (!e) return null;
		if (p(e)) return e;
		let t = e.length;
		if (!b(t)) return null;
		let n = Array(t);
		for (; t-- > 0;) n[t] = e[t];
		return n;
	}, ye = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && i(Uint8Array)), be = (e, t) => {
		let n = (e && e[a]).call(e), r;
		for (; (r = n.next()) && !r.done;) {
			let n = r.value;
			t.call(e, n[0], n[1]);
		}
	}, xe = (e, t) => {
		let n, r = [];
		for (; (n = e.exec(t)) !== null;) r.push(n);
		return r;
	}, Se = d("HTMLFormElement"), Ce = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
		return t.toUpperCase() + n;
	}), { propertyIsEnumerable: we } = Object.prototype, Te = d("RegExp"), Ee = (e, t) => {
		let n = Object.getOwnPropertyDescriptors(e), r = {};
		ce(n, (n, i) => {
			let a;
			(a = t(n, i, e)) !== !1 && (r[i] = a || n);
		}), Object.defineProperties(e, r);
	}, De = (e) => {
		Ee(e, (t, n) => {
			if (y(e) && [
				"arguments",
				"caller",
				"callee"
			].includes(n)) return !1;
			let r = e[n];
			if (y(r)) {
				if (t.enumerable = !1, "writable" in t) {
					t.writable = !1;
					return;
				}
				t.set ||= () => {
					throw Error("Can not rewrite read-only method '" + n + "'");
				};
			}
		});
	}, Oe = (e, t) => {
		let n = {}, r = (e) => {
			e.forEach((e) => {
				n[e] = !0;
			});
		};
		return p(e) ? r(e) : r(String(e).split(t)), n;
	}, ke = () => {}, Ae = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
	function je(e) {
		return !!(e && y(e.append) && e[o] === "FormData" && e[a]);
	}
	var Me = (e) => {
		let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
			if (x(e)) {
				if (t.has(e)) return;
				if (h(e)) return e;
				if (!("toJSON" in e)) {
					t.add(e);
					let r = p(e) ? [] : {};
					return ce(e, (e, t) => {
						let i = n(e);
						!m(i) && (r[t] = i);
					}), t.delete(e), r;
				}
			}
			return e;
		};
		return n(e);
	}, Ne = d("AsyncFunction"), Pe = (e) => e && (x(e) || y(e)) && y(e.then) && y(e.catch), Fe = ((e, t) => e ? setImmediate : t ? ((e, t) => (ue.addEventListener("message", ({ source: n, data: r }) => {
		n === ue && r === e && t.length && t.shift()();
	}, !1), (n) => {
		t.push(n), ue.postMessage(e, "*");
	}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", y(ue.postMessage)), Ie = typeof queueMicrotask < "u" ? queueMicrotask.bind(ue) : typeof process < "u" && process.nextTick || Fe, Le = (e) => e != null && y(e[a]), P = {
		isArray: p,
		isArrayBuffer: g,
		isBuffer: h,
		isFormData: M,
		isArrayBufferView: _,
		isString: v,
		isNumber: b,
		isBoolean: S,
		isObject: x,
		isPlainObject: C,
		isEmptyObject: w,
		isReadableStream: ie,
		isRequest: ae,
		isResponse: oe,
		isHeaders: se,
		isUndefined: m,
		isDate: T,
		isFile: E,
		isReactNativeBlob: D,
		isReactNative: ee,
		isBlob: O,
		isRegExp: Te,
		isFunction: y,
		isStream: A,
		isURLSearchParams: re,
		isTypedArray: ye,
		isFileList: k,
		forEach: ce,
		merge: fe,
		extend: pe,
		trim: N,
		stripBOM: me,
		inherits: he,
		toFlatObject: ge,
		kindOf: u,
		kindOfTest: d,
		endsWith: _e,
		toArray: ve,
		forEachEntry: be,
		matchAll: xe,
		isHTMLForm: Se,
		hasOwnProperty: s,
		hasOwnProp: s,
		hasOwnInPrototypeChain: c,
		getSafeProp: l,
		reduceDescriptors: Ee,
		freezeMethods: De,
		toObjectSet: Oe,
		toCamelCase: Ce,
		noop: ke,
		toFiniteNumber: Ae,
		findKey: le,
		global: ue,
		isContextDefined: de,
		isSpecCompliantForm: je,
		toJSONObject: Me,
		isAsyncFn: Ne,
		isThenable: Pe,
		setImmediate: Fe,
		asap: Ie,
		isIterable: Le,
		isSafeIterable: (e) => e != null && c(e, a) && Le(e)
	}, Re = P.toObjectSet([
		"age",
		"authorization",
		"content-length",
		"content-type",
		"etag",
		"expires",
		"from",
		"host",
		"if-modified-since",
		"if-unmodified-since",
		"last-modified",
		"location",
		"max-forwards",
		"proxy-authorization",
		"referer",
		"retry-after",
		"user-agent"
	]), ze = (e) => {
		let t = {}, n, r, i;
		return e && e.split("\n").forEach(function(e) {
			i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim(), !(!n || t[n] && Re[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
		}), t;
	};
	function Be(e) {
		let t = 0, n = e.length;
		for (; t < n;) {
			let n = e.charCodeAt(t);
			if (n !== 9 && n !== 32) break;
			t += 1;
		}
		for (; n > t;) {
			let t = e.charCodeAt(n - 1);
			if (t !== 9 && t !== 32) break;
			--n;
		}
		return t === 0 && n === e.length ? e : e.slice(t, n);
	}
	var Ve = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), He = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
	function Ue(e, t) {
		return P.isArray(e) ? e.map((e) => Ue(e, t)) : Be(String(e).replace(t, ""));
	}
	var We = (e) => Ue(e, Ve), Ge = (e) => Ue(e, He);
	function Ke(e) {
		let t = Object.create(null);
		return P.forEach(e.toJSON(), (e, n) => {
			t[n] = Ge(e);
		}), t;
	}
	var qe = Symbol("internals");
	function Je(e) {
		return e && String(e).trim().toLowerCase();
	}
	function Ye(e) {
		return e === !1 || e == null ? e : P.isArray(e) ? e.map(Ye) : We(String(e));
	}
	function Xe(e) {
		let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
		for (; r = n.exec(e);) t[r[1]] = r[2];
		return t;
	}
	var Ze = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
	function Qe(e, t, n, r, i) {
		if (P.isFunction(r)) return r.call(this, t, n);
		if (i && (t = n), P.isString(t)) {
			if (P.isString(r)) return t.indexOf(r) !== -1;
			if (P.isRegExp(r)) return r.test(t);
		}
	}
	function $e(e) {
		return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
	}
	function et(e, t) {
		let n = P.toCamelCase(" " + t);
		[
			"get",
			"set",
			"has"
		].forEach((r) => {
			Object.defineProperty(e, r + n, {
				__proto__: null,
				value: function(e, n, i) {
					return this[r].call(this, t, e, n, i);
				},
				configurable: !0
			});
		});
	}
	var tt = class {
		constructor(e) {
			e && this.set(e);
		}
		set(e, t, n) {
			let r = this;
			function i(e, t, n) {
				let i = Je(t);
				if (!i) return;
				let a = P.findKey(r, i);
				(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = Ye(e));
			}
			let a = (e, t) => P.forEach(e, (e, n) => i(e, n, t));
			if (P.isPlainObject(e) || e instanceof this.constructor) a(e, t);
			else if (P.isString(e) && (e = e.trim()) && !Ze(e)) a(ze(e), t);
			else if (P.isObject(e) && P.isSafeIterable(e)) {
				let n = Object.create(null), r, i;
				for (let t of e) {
					if (!P.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
					i = t[0], P.hasOwnProp(n, i) ? (r = n[i], n[i] = P.isArray(r) ? [...r, t[1]] : [r, t[1]]) : n[i] = t[1];
				}
				a(n, t);
			} else e != null && i(t, e, n);
			return this;
		}
		get(e, t) {
			if (e = Je(e), e) {
				let n = P.findKey(this, e);
				if (n) {
					let e = this[n];
					if (!t) return e;
					if (t === !0) return Xe(e);
					if (P.isFunction(t)) return t.call(this, e, n);
					if (P.isRegExp(t)) return t.exec(e);
					throw TypeError("parser must be boolean|regexp|function");
				}
			}
		}
		has(e, t) {
			if (e = Je(e), e) {
				let n = P.findKey(this, e);
				return !!(n && this[n] !== void 0 && (!t || Qe(this, this[n], n, t)));
			}
			return !1;
		}
		delete(e, t) {
			let n = this, r = !1;
			function i(e) {
				if (e = Je(e), e) {
					let i = P.findKey(n, e);
					i && (!t || Qe(n, n[i], i, t)) && (delete n[i], r = !0);
				}
			}
			return P.isArray(e) ? e.forEach(i) : i(e), r;
		}
		clear(e) {
			let t = Object.keys(this), n = t.length, r = !1;
			for (; n--;) {
				let i = t[n];
				(!e || Qe(this, this[i], i, e, !0)) && (delete this[i], r = !0);
			}
			return r;
		}
		normalize(e) {
			let t = this, n = {};
			return P.forEach(this, (r, i) => {
				let a = P.findKey(n, i);
				if (a) {
					t[a] = Ye(r), delete t[i];
					return;
				}
				let o = e ? $e(i) : String(i).trim();
				o !== i && delete t[i], t[o] = Ye(r), n[o] = !0;
			}), this;
		}
		concat(...e) {
			return this.constructor.concat(this, ...e);
		}
		toJSON(e) {
			let t = Object.create(null);
			return P.forEach(this, (n, r) => {
				n != null && n !== !1 && (t[r] = e && P.isArray(n) ? n.join(", ") : n);
			}), t;
		}
		[Symbol.iterator]() {
			return Object.entries(this.toJSON())[Symbol.iterator]();
		}
		toString() {
			return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
		}
		getSetCookie() {
			return this.get("set-cookie") || [];
		}
		get [Symbol.toStringTag]() {
			return "AxiosHeaders";
		}
		static from(e) {
			return e instanceof this ? e : new this(e);
		}
		static concat(e, ...t) {
			let n = new this(e);
			return t.forEach((e) => n.set(e)), n;
		}
		static accessor(e) {
			let t = (this[qe] = this[qe] = { accessors: {} }).accessors, n = this.prototype;
			function r(e) {
				let r = Je(e);
				t[r] || (et(n, e), t[r] = !0);
			}
			return P.isArray(e) ? e.forEach(r) : r(e), this;
		}
	};
	tt.accessor([
		"Content-Type",
		"Content-Length",
		"Accept",
		"Accept-Encoding",
		"User-Agent",
		"Authorization"
	]), P.reduceDescriptors(tt.prototype, ({ value: e }, t) => {
		let n = t[0].toUpperCase() + t.slice(1);
		return {
			get: () => e,
			set(e) {
				this[n] = e;
			}
		};
	}), P.freezeMethods(tt);
	var nt = "[REDACTED ****]";
	function rt(e) {
		if (P.hasOwnProp(e, "toJSON")) return !0;
		let t = Object.getPrototypeOf(e);
		for (; t && t !== Object.prototype;) {
			if (P.hasOwnProp(t, "toJSON")) return !0;
			t = Object.getPrototypeOf(t);
		}
		return !1;
	}
	function it(e, t) {
		let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
			if (typeof e != "object" || !e || P.isBuffer(e)) return e;
			if (r.indexOf(e) !== -1) return;
			e instanceof tt && (e = e.toJSON()), r.push(e);
			let t;
			if (P.isArray(e)) t = [], e.forEach((e, n) => {
				let r = i(e);
				P.isUndefined(r) || (t[n] = r);
			});
			else {
				if (!P.isPlainObject(e) && rt(e)) return r.pop(), e;
				t = Object.create(null);
				for (let [r, a] of Object.entries(e)) {
					let e = n.has(r.toLowerCase()) ? nt : i(a);
					P.isUndefined(e) || (t[r] = e);
				}
			}
			return r.pop(), t;
		};
		return i(e);
	}
	var F = class e extends Error {
		static from(t, n, r, i, a, o) {
			let s = new e(t.message, n || t.code, r, i, a);
			return Object.defineProperty(s, "cause", {
				__proto__: null,
				value: t,
				writable: !0,
				enumerable: !1,
				configurable: !0
			}), s.name = t.name, t.status != null && s.status == null && (s.status = t.status), o && Object.assign(s, o), s;
		}
		constructor(e, t, n, r, i) {
			super(e), Object.defineProperty(this, "message", {
				__proto__: null,
				value: e,
				enumerable: !0,
				writable: !0,
				configurable: !0
			}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
		}
		toJSON() {
			let e = this.config, t = e && P.hasOwnProp(e, "redact") ? e.redact : void 0, n = P.isArray(t) && t.length > 0 ? it(e, t) : P.toJSONObject(e);
			return {
				message: this.message,
				name: this.name,
				description: this.description,
				number: this.number,
				fileName: this.fileName,
				lineNumber: this.lineNumber,
				columnNumber: this.columnNumber,
				stack: this.stack,
				config: n,
				code: this.code,
				status: this.status
			};
		}
	};
	F.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", F.ERR_BAD_OPTION = "ERR_BAD_OPTION", F.ECONNABORTED = "ECONNABORTED", F.ETIMEDOUT = "ETIMEDOUT", F.ECONNREFUSED = "ECONNREFUSED", F.ERR_NETWORK = "ERR_NETWORK", F.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", F.ERR_DEPRECATED = "ERR_DEPRECATED", F.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", F.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", F.ERR_CANCELED = "ERR_CANCELED", F.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", F.ERR_INVALID_URL = "ERR_INVALID_URL", F.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
	var at = null, ot = 100;
	function st(e) {
		return P.isPlainObject(e) || P.isArray(e);
	}
	function ct(e) {
		return P.endsWith(e, "[]") ? e.slice(0, -2) : e;
	}
	function lt(e, t, n) {
		return e ? e.concat(t).map(function(e, t) {
			return e = ct(e), !n && t ? "[" + e + "]" : e;
		}).join(n ? "." : "") : t;
	}
	function ut(e) {
		return P.isArray(e) && !e.some(st);
	}
	var dt = P.toFlatObject(P, {}, null, function(e) {
		return /^is[A-Z]/.test(e);
	});
	function ft(e, t, n) {
		if (!P.isObject(e)) throw TypeError("target must be an object");
		t ||= new FormData(), n = P.toFlatObject(n, {
			metaTokens: !0,
			dots: !1,
			indexes: !1
		}, !1, function(e, t) {
			return !P.isUndefined(t[e]);
		});
		let r = n.metaTokens, i = n.visitor || m, a = n.dots, o = n.indexes, s = n.Blob || typeof Blob < "u" && Blob, c = n.maxDepth === void 0 ? ot : n.maxDepth, l = s && P.isSpecCompliantForm(t), u = [];
		if (!P.isFunction(i)) throw TypeError("visitor must be a function");
		function d(e) {
			if (e === null) return "";
			if (P.isDate(e)) return e.toISOString();
			if (P.isBoolean(e)) return e.toString();
			if (!l && P.isBlob(e)) throw new F("Blob is not supported. Use a Buffer instead.");
			if (P.isArrayBuffer(e) || P.isTypedArray(e)) {
				if (l && typeof s == "function") return new s([e]);
				if (typeof Buffer < "u") return Buffer.from(e);
				throw new F("Blob is not supported. Use a Buffer instead.", F.ERR_NOT_SUPPORT);
			}
			return e;
		}
		function f(e) {
			if (e > c) throw new F("Object is too deeply nested (" + e + " levels). Max depth: " + c, F.ERR_FORM_DATA_DEPTH_EXCEEDED);
		}
		function p(e, t) {
			if (c === Infinity) return JSON.stringify(e);
			let n = [];
			return JSON.stringify(e, function(e, r) {
				if (!P.isObject(r)) return r;
				for (; n.length && n[n.length - 1] !== this;) n.pop();
				return n.push(r), f(t + n.length - 1), r;
			});
		}
		function m(e, n, i) {
			let s = e;
			if (P.isReactNative(t) && P.isReactNativeBlob(e)) return t.append(lt(i, n, a), d(e)), !1;
			if (e && !i && typeof e == "object") {
				if (P.endsWith(n, "{}")) n = r ? n : n.slice(0, -2), e = p(e, 1);
				else if (P.isArray(e) && ut(e) || (P.isFileList(e) || P.endsWith(n, "[]")) && (s = P.toArray(e))) return n = ct(n), s.forEach(function(e, r) {
					!(P.isUndefined(e) || e === null) && t.append(o === !0 ? lt([n], r, a) : o === null ? n : n + "[]", d(e));
				}), !1;
			}
			return st(e) ? !0 : (t.append(lt(i, n, a), d(e)), !1);
		}
		let h = Object.assign(dt, {
			defaultVisitor: m,
			convertValue: d,
			isVisitable: st
		});
		function g(e, n, r = 0) {
			if (!P.isUndefined(e)) {
				if (f(r), u.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
				u.push(e), P.forEach(e, function(e, a) {
					(!(P.isUndefined(e) || e === null) && i.call(t, e, P.isString(a) ? a.trim() : a, n, h)) === !0 && g(e, n ? n.concat(a) : [a], r + 1);
				}), u.pop();
			}
		}
		if (!P.isObject(e)) throw TypeError("data must be an object");
		return g(e), t;
	}
	function pt(e) {
		let t = {
			"!": "%21",
			"'": "%27",
			"(": "%28",
			")": "%29",
			"~": "%7E",
			"%20": "+"
		};
		return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
			return t[e];
		});
	}
	function mt(e, t) {
		this._pairs = [], e && ft(e, this, t);
	}
	var ht = mt.prototype;
	ht.append = function(e, t) {
		this._pairs.push([e, t]);
	}, ht.toString = function(e) {
		let t = e ? (t) => e.call(this, t, pt) : pt;
		return this._pairs.map(function(e) {
			return t(e[0]) + "=" + t(e[1]);
		}, "").join("&");
	};
	function gt(e) {
		return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
	}
	function _t(e, t, n) {
		if (!t) return e;
		e ||= "";
		let r = P.isFunction(n) ? { serialize: n } : n, i = P.getSafeProp(r, "encode") || gt, a = P.getSafeProp(r, "serialize"), o;
		if (o = a ? a(t, r) : P.isURLSearchParams(t) ? t.toString() : new mt(t, r).toString(i), o) {
			let t = e.indexOf("#");
			t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
		}
		return e;
	}
	var vt = class {
		constructor() {
			this.handlers = [];
		}
		use(e, t, n) {
			return this.handlers.push({
				fulfilled: e,
				rejected: t,
				synchronous: n ? n.synchronous : !1,
				runWhen: n ? n.runWhen : null
			}), this.handlers.length - 1;
		}
		eject(e) {
			this.handlers[e] && (this.handlers[e] = null);
		}
		clear() {
			this.handlers &&= [];
		}
		forEach(e) {
			P.forEach(this.handlers, function(t) {
				t !== null && e(t);
			});
		}
	}, yt = {
		silentJSONParsing: !0,
		forcedJSONParsing: !0,
		clarifyTimeoutError: !1,
		legacyInterceptorReqResOrdering: !0,
		advertiseZstdAcceptEncoding: !1,
		validateStatusUndefinedResolves: !0
	}, bt = {
		isBrowser: !0,
		classes: {
			URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : mt,
			FormData: typeof FormData < "u" ? FormData : null,
			Blob: typeof Blob < "u" ? Blob : null
		},
		protocols: [
			"http",
			"https",
			"file",
			"blob",
			"url",
			"data"
		]
	}, xt = typeof window < "u" && typeof document < "u", St = typeof navigator == "object" && navigator || void 0, Ct = xt && (!St || [
		"ReactNative",
		"NativeScript",
		"NS"
	].indexOf(St.product) < 0), wt = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Tt = xt && window.location.href || "http://localhost", Et = {
		.../* @__PURE__ */ Object.freeze({
			__proto__: null,
			hasBrowserEnv: xt,
			hasStandardBrowserEnv: Ct,
			hasStandardBrowserWebWorkerEnv: wt,
			navigator: St,
			origin: Tt
		}),
		...bt
	};
	function Dt(e, t) {
		return ft(e, new Et.classes.URLSearchParams(), {
			visitor: function(e, t, n, r) {
				return Et.isNode && P.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
			},
			...t
		});
	}
	var Ot = ot;
	function kt(e) {
		if (e > Ot) throw new F("FormData field is too deeply nested (" + e + " levels). Max depth: 100", F.ERR_FORM_DATA_DEPTH_EXCEEDED);
	}
	function At(e) {
		let t = [], n = /\w+|\[(\w*)]/g, r;
		for (; (r = n.exec(e)) !== null;) kt(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
		return t;
	}
	function jt(e) {
		let t = {}, n = Object.keys(e), r, i = n.length, a;
		for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
		return t;
	}
	function Mt(e) {
		function t(e, n, r, i) {
			kt(i);
			let a = e[i++];
			if (a === "__proto__") return !0;
			let o = Number.isFinite(+a), s = i >= e.length;
			return a = !a && P.isArray(r) ? r.length : a, s ? (P.hasOwnProp(r, a) ? r[a] = P.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : ((!P.hasOwnProp(r, a) || !P.isObject(r[a])) && (r[a] = []), t(e, n, r[a], i) && P.isArray(r[a]) && (r[a] = jt(r[a])), !o);
		}
		if (P.isFormData(e) && P.isFunction(e.entries)) {
			let n = {};
			return P.forEachEntry(e, (e, r) => {
				t(At(e), r, n, 0);
			}), n;
		}
		return null;
	}
	var Nt = (e, t) => e != null && P.hasOwnProp(e, t) ? e[t] : void 0;
	function Pt(e, t, n) {
		if (P.isString(e)) try {
			return (t || JSON.parse)(e), P.trim(e);
		} catch (e) {
			if (e.name !== "SyntaxError") throw e;
		}
		return (n || JSON.stringify)(e);
	}
	var Ft = {
		transitional: yt,
		adapter: [
			"xhr",
			"http",
			"fetch"
		],
		transformRequest: [function(e, t) {
			let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = P.isObject(e);
			if (i && P.isHTMLForm(e) && (e = new FormData(e)), P.isFormData(e)) return r ? JSON.stringify(Mt(e)) : e;
			if (P.isArrayBuffer(e) || P.isBuffer(e) || P.isStream(e) || P.isFile(e) || P.isBlob(e) || P.isReadableStream(e)) return e;
			if (P.isArrayBufferView(e)) return e.buffer;
			if (P.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
			let a;
			if (i) {
				let t = Nt(this, "formSerializer");
				if (n.indexOf("application/x-www-form-urlencoded") > -1) return Dt(e, t).toString();
				if ((a = P.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
					let n = Nt(this, "env"), r = n && n.FormData;
					return ft(a ? { "files[]": e } : e, r && new r(), t);
				}
			}
			return i || r ? (t.setContentType("application/json", !1), Pt(e)) : e;
		}],
		transformResponse: [function(e) {
			let t = Nt(this, "transitional") || Ft.transitional, n = t && t.forcedJSONParsing, r = Nt(this, "responseType"), i = r === "json";
			if (P.isResponse(e) || P.isReadableStream(e)) return e;
			if (e && P.isString(e) && (n && !r || i)) {
				let n = !(t && t.silentJSONParsing) && i;
				try {
					return JSON.parse(e, Nt(this, "parseReviver"));
				} catch (e) {
					if (n) throw e.name === "SyntaxError" ? F.from(e, F.ERR_BAD_RESPONSE, this, null, Nt(this, "response")) : e;
				}
			}
			return e;
		}],
		timeout: 0,
		xsrfCookieName: "XSRF-TOKEN",
		xsrfHeaderName: "X-XSRF-TOKEN",
		maxContentLength: -1,
		maxBodyLength: -1,
		env: {
			FormData: Et.classes.FormData,
			Blob: Et.classes.Blob
		},
		validateStatus: function(e) {
			return e >= 200 && e < 300;
		},
		headers: { common: {
			Accept: "application/json, text/plain, */*",
			"Content-Type": void 0
		} }
	};
	P.forEach([
		"delete",
		"get",
		"head",
		"post",
		"put",
		"patch",
		"query"
	], (e) => {
		Ft.headers[e] = {};
	});
	function It(e, t) {
		let n = this || Ft, r = t || n, i = tt.from(r.headers), a = r.data;
		return P.forEach(e, function(e) {
			a = e.call(n, a, i.normalize(), t ? t.status : void 0);
		}), i.normalize(), a;
	}
	function Lt(e) {
		return !!(e && e.__CANCEL__);
	}
	var Rt = class extends F {
		constructor(e, t, n) {
			super(e ?? "canceled", F.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
		}
	};
	function zt(e, t, n) {
		let r = n.config.validateStatus;
		!n.status || !r || r(n.status) ? e(n) : t(new F("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? F.ERR_BAD_REQUEST : F.ERR_BAD_RESPONSE, n.config, n.request, n));
	}
	function Bt(e) {
		let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
		return t && t[1] || "";
	}
	function Vt(e, t) {
		e ||= 10;
		let n = Array(e), r = Array(e), i = 0, a = 0, o;
		return t = t === void 0 ? 1e3 : t, function(s) {
			let c = Date.now(), l = r[a];
			o ||= c, n[i] = s, r[i] = c;
			let u = a, d = 0;
			for (; u !== i;) d += n[u++], u %= e;
			if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
			let f = l && c - l;
			return f ? Math.round(d * 1e3 / f) : void 0;
		};
	}
	function Ht(e, t) {
		let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
			n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
		};
		return [(...e) => {
			let t = Date.now(), s = t - n;
			s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
				a = null, o(i);
			}, r - s));
		}, () => i && o(i)];
	}
	var Ut = (e, t, n = 3) => {
		let r = 0, i = Vt(50, 250);
		return Ht((n) => {
			if (!n || typeof n.loaded != "number") return;
			let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = o == null ? a : Math.min(a, o), c = Math.max(0, s - r), l = i(c);
			r = Math.max(r, s), e({
				loaded: s,
				total: o,
				progress: o ? s / o : void 0,
				bytes: c,
				rate: l || void 0,
				estimated: l && o ? (o - s) / l : void 0,
				event: n,
				lengthComputable: o != null,
				[t ? "download" : "upload"]: !0
			});
		}, n);
	}, Wt = (e, t) => {
		let n = e != null;
		return [(r) => t[0]({
			lengthComputable: n,
			total: e,
			loaded: r
		}), t[1]];
	}, Gt = (e) => (...t) => P.asap(() => e(...t)), Kt = Et.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Et.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Et.origin), Et.navigator && /(msie|trident)/i.test(Et.navigator.userAgent)) : () => !0, qt = Et.hasStandardBrowserEnv ? {
		write(e, t, n, r, i, a, o) {
			if (typeof document > "u") return;
			let s = [`${e}=${encodeURIComponent(t)}`];
			P.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), P.isString(r) && s.push(`path=${r}`), P.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), P.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
		},
		read(e) {
			if (typeof document > "u") return null;
			let t = document.cookie.split(";");
			for (let n = 0; n < t.length; n++) {
				let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
				if (i !== -1 && r.slice(0, i) === e) try {
					return decodeURIComponent(r.slice(i + 1));
				} catch {
					return r.slice(i + 1);
				}
			}
			return null;
		},
		remove(e) {
			this.write(e, "", Date.now() - 864e5, "/");
		}
	} : {
		write() {},
		read() {
			return null;
		},
		remove() {}
	};
	function Jt(e) {
		return typeof e == "string" && /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
	}
	function Yt(e, t) {
		return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
	}
	var Xt = /^https?:(?!\/\/)/i, Zt = /[\t\n\r]/g;
	function Qt(e) {
		let t = 0;
		for (; t < e.length && e.charCodeAt(t) <= 32;) t++;
		return e.slice(t);
	}
	function $t(e) {
		return Qt(e).replace(Zt, "");
	}
	function en(e, t) {
		if (typeof e == "string" && Xt.test($t(e))) throw new F("Invalid URL: missing \"//\" after protocol", F.ERR_INVALID_URL, t);
	}
	function tn(e, t, n, r) {
		en(t, r);
		let i = !Jt(t);
		return e && (i || n === !1) ? (en(e, r), Yt(e, t)) : t;
	}
	var nn = (e) => e instanceof tt ? { ...e } : e;
	function rn(e, t) {
		e ||= {}, t ||= {};
		let n = Object.create(null);
		Object.defineProperty(n, "hasOwnProperty", {
			__proto__: null,
			value: Object.prototype.hasOwnProperty,
			enumerable: !1,
			writable: !0,
			configurable: !0
		});
		function r(e, t, n, r) {
			return P.isPlainObject(e) && P.isPlainObject(t) ? P.merge.call({ caseless: r }, e, t) : P.isPlainObject(t) ? P.merge({}, t) : P.isArray(t) ? t.slice() : t;
		}
		function i(e, t, n, i) {
			if (!P.isUndefined(t)) return r(e, t, n, i);
			if (!P.isUndefined(e)) return r(void 0, e, n, i);
		}
		function a(e, t) {
			if (!P.isUndefined(t)) return r(void 0, t);
		}
		function o(e, t) {
			if (!P.isUndefined(t)) return r(void 0, t);
			if (!P.isUndefined(e)) return r(void 0, e);
		}
		function s(n) {
			let r = P.hasOwnProp(t, "transitional") ? t.transitional : void 0;
			if (!P.isUndefined(r)) if (P.isPlainObject(r)) {
				if (P.hasOwnProp(r, n)) return r[n];
			} else return;
			let i = P.hasOwnProp(e, "transitional") ? e.transitional : void 0;
			if (P.isPlainObject(i) && P.hasOwnProp(i, n)) return i[n];
		}
		function c(n, i, a) {
			if (P.hasOwnProp(t, a)) return r(n, i);
			if (P.hasOwnProp(e, a)) return r(void 0, n);
		}
		let l = {
			url: a,
			method: a,
			data: a,
			baseURL: o,
			transformRequest: o,
			transformResponse: o,
			paramsSerializer: o,
			timeout: o,
			timeoutMessage: o,
			withCredentials: o,
			withXSRFToken: o,
			adapter: o,
			responseType: o,
			xsrfCookieName: o,
			xsrfHeaderName: o,
			onUploadProgress: o,
			onDownloadProgress: o,
			decompress: o,
			maxContentLength: o,
			maxBodyLength: o,
			beforeRedirect: o,
			transport: o,
			httpAgent: o,
			httpsAgent: o,
			cancelToken: o,
			socketPath: o,
			allowedSocketPaths: o,
			responseEncoding: o,
			validateStatus: c,
			headers: (e, t, n) => i(nn(e), nn(t), n, !0)
		};
		return P.forEach(Object.keys({
			...e,
			...t
		}), function(r) {
			if (r === "__proto__" || r === "constructor" || r === "prototype") return;
			let a = P.hasOwnProp(l, r) ? l[r] : i, o = a(P.hasOwnProp(e, r) ? e[r] : void 0, P.hasOwnProp(t, r) ? t[r] : void 0, r);
			P.isUndefined(o) && a !== c || (n[r] = o);
		}), P.hasOwnProp(t, "validateStatus") && P.isUndefined(t.validateStatus) && s("validateStatusUndefinedResolves") === !1 && (P.hasOwnProp(e, "validateStatus") ? n.validateStatus = r(void 0, e.validateStatus) : delete n.validateStatus), n;
	}
	var an = ["content-type", "content-length"];
	function on(e, t, n) {
		if (n !== "content-only") {
			e.set(t);
			return;
		}
		Object.entries(t || {}).forEach(([t, n]) => {
			an.includes(t.toLowerCase()) && e.set(t, n);
		});
	}
	var sn = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16)));
	function cn(e) {
		let t = rn({}, e), n = (e) => P.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
		if (t.headers = s = tt.from(s), t.url = _t(tn(l, d, u, t), n("params"), n("paramsSerializer")), c) {
			let t = P.getSafeProp(c, "username") || "", n = P.getSafeProp(c, "password") || "";
			try {
				s.set("Authorization", "Basic " + btoa(t + ":" + (n ? sn(n) : "")));
			} catch (t) {
				throw F.from(t, F.ERR_BAD_OPTION_VALUE, e);
			}
		}
		if (P.isFormData(r) && (Et.hasStandardBrowserEnv || Et.hasStandardBrowserWebWorkerEnv || P.isReactNative(r) ? s.setContentType(void 0) : P.isFunction(r.getHeaders) && on(s, r.getHeaders(), n("formDataHeaderPolicy"))), Et.hasStandardBrowserEnv && (P.isFunction(i) && (i = i(t)), i === !0 || i == null && Kt(t.url))) {
			let e = a && o && qt.read(o);
			e && s.set(a, e);
		}
		return t;
	}
	var ln = typeof XMLHttpRequest < "u" && function(e) {
		return new Promise(function(t, n) {
			let r = cn(e), i = r.data, a = tt.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p;
			function m() {
				f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
			}
			let h = new XMLHttpRequest();
			h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout;
			function g() {
				if (!h) return;
				let r = tt.from("getAllResponseHeaders" in h && h.getAllResponseHeaders());
				zt(function(e) {
					t(e), m();
				}, function(e) {
					n(e), m();
				}, {
					data: !o || o === "text" || o === "json" ? h.responseText : h.response,
					status: h.status,
					statusText: h.statusText,
					headers: r,
					config: e,
					request: h
				}), h = null;
			}
			"onloadend" in h ? h.onloadend = g : h.onreadystatechange = function() {
				!h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.startsWith("file:")) || setTimeout(g);
			}, h.onabort = function() {
				h &&= (n(new F("Request aborted", F.ECONNABORTED, e, h)), m(), null);
			}, h.onerror = function(t) {
				let r = new F(t && t.message ? t.message : "Network Error", F.ERR_NETWORK, e, h);
				r.event = t || null, n(r), m(), h = null;
			}, h.ontimeout = function() {
				let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || yt;
				r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new F(t, i.clarifyTimeoutError ? F.ETIMEDOUT : F.ECONNABORTED, e, h)), m(), h = null;
			}, i === void 0 && a.setContentType(null), "setRequestHeader" in h && P.forEach(Ke(a), function(e, t) {
				h.setRequestHeader(t, e);
			}), P.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), o && o !== "json" && (h.responseType = r.responseType), c && ([d, p] = Ut(c, !0), h.addEventListener("progress", d)), s && h.upload && ([u, f] = Ut(s), h.upload.addEventListener("progress", u), h.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
				h &&= (n(!t || t.type ? new Rt(null, e, h) : t), h.abort(), m(), null);
			}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
			let _ = Bt(r.url);
			if (_ && !Et.protocols.includes(_)) {
				n(new F("Unsupported protocol " + _ + ":", F.ERR_BAD_REQUEST, e)), m();
				return;
			}
			h.send(i || null);
		});
	}, un = (e, t) => {
		if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
		let n = new AbortController(), r = !1, i = function(e) {
			if (!r) {
				r = !0, o();
				let t = e instanceof Error ? e : this.reason;
				n.abort(t instanceof F ? t : new Rt(t instanceof Error ? t.message : t));
			}
		}, a = t && setTimeout(() => {
			a = null, i(new F(`timeout of ${t}ms exceeded`, F.ETIMEDOUT));
		}, t), o = () => {
			e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
				e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
			}), null);
		};
		e.forEach((e) => e.addEventListener("abort", i, { once: !0 }));
		let { signal: s } = n;
		return s.unsubscribe = () => P.asap(o), s;
	}, dn = function* (e, t) {
		let n = e.byteLength;
		if (n < t) {
			yield e;
			return;
		}
		let r = 0, i;
		for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
	}, fn = async function* (e, t) {
		for await (let n of pn(e)) yield* dn(n, t);
	}, pn = async function* (e) {
		if (e[Symbol.asyncIterator]) {
			yield* e;
			return;
		}
		let t = e.getReader();
		try {
			for (;;) {
				let { done: e, value: n } = await t.read();
				if (e) break;
				yield n;
			}
		} finally {
			await t.cancel();
		}
	}, mn = (e, t, n, r) => {
		let i = fn(e, t), a = 0, o, s = (e) => {
			o || (o = !0, r && r(e));
		};
		return new ReadableStream({
			async pull(e) {
				try {
					let { done: t, value: r } = await i.next();
					if (t) {
						s(), e.close();
						return;
					}
					let o = r.byteLength;
					n && n(a += o), e.enqueue(new Uint8Array(r));
				} catch (e) {
					throw s(e), e;
				}
			},
			cancel(e) {
				return s(e), i.return();
			}
		}, { highWaterMark: 2 });
	}, hn = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, gn = (e, t, n) => t + 2 < n && hn(e.charCodeAt(t + 1)) && hn(e.charCodeAt(t + 2));
	function _n(e) {
		if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
		let t = e.indexOf(",");
		if (t < 0) return 0;
		let n = e.slice(5, t), r = e.slice(t + 1);
		if (/;base64/i.test(n)) {
			let e = r.length, t = r.length;
			for (let n = 0; n < t; n++) if (r.charCodeAt(n) === 37 && n + 2 < t) {
				let t = r.charCodeAt(n + 1), i = r.charCodeAt(n + 2);
				hn(t) && hn(i) && (e -= 2, n += 2);
			}
			let n = 0, i = t - 1, a = (e) => e >= 2 && r.charCodeAt(e - 2) === 37 && r.charCodeAt(e - 1) === 51 && (r.charCodeAt(e) === 68 || r.charCodeAt(e) === 100);
			i >= 0 && (r.charCodeAt(i) === 61 ? (n++, i--) : a(i) && (n++, i -= 3)), n === 1 && i >= 0 && (r.charCodeAt(i) === 61 || a(i)) && n++;
			let o = Math.floor(e / 4) * 3 - (n || 0);
			return o > 0 ? o : 0;
		}
		let i = 0;
		for (let e = 0, t = r.length; e < t; e++) {
			let n = r.charCodeAt(e);
			if (n === 37 && gn(r, e, t)) i += 1, e += 2;
			else if (n < 128) i += 1;
			else if (n < 2048) i += 2;
			else if (n >= 55296 && n <= 56319 && e + 1 < t) {
				let t = r.charCodeAt(e + 1);
				t >= 56320 && t <= 57343 ? (i += 4, e++) : i += 3;
			} else i += 3;
		}
		return i;
	}
	var vn = "1.18.1", yn = 64 * 1024, { isFunction: bn } = P, xn = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), Sn = (e) => {
		if (!P.isString(e)) return e;
		try {
			return decodeURIComponent(e);
		} catch {
			return e;
		}
	}, Cn = (e, ...t) => {
		try {
			return !!e(...t);
		} catch {
			return !1;
		}
	}, wn = (e) => {
		let t = e.indexOf("://"), n = e;
		return t !== -1 && (n = n.slice(t + 3)), n.includes("@") || n.includes(":");
	}, Tn = (e) => {
		let t = P.global !== void 0 && P.global !== null ? P.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
		e = P.merge.call({ skipUndefined: !0 }, {
			Request: t.Request,
			Response: t.Response
		}, e);
		let { fetch: i, Request: a, Response: o } = e, s = i ? bn(i) : typeof fetch == "function", c = bn(a), l = bn(o);
		if (!s) return !1;
		let u = s && bn(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && Cn(() => {
			let e = !1, t = new a(Et.origin, {
				body: new n(),
				method: "POST",
				get duplex() {
					return e = !0, "half";
				}
			}), r = t.headers.has("Content-Type");
			return t.body != null && t.body.cancel(), e && !r;
		}), p = l && u && Cn(() => P.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
		s && [
			"text",
			"arrayBuffer",
			"blob",
			"formData",
			"stream"
		].forEach((e) => {
			!m[e] && (m[e] = (t, n) => {
				let r = t && t[e];
				if (r) return r.call(t);
				throw new F(`Response type '${e}' is not supported`, F.ERR_NOT_SUPPORT, n);
			});
		});
		let h = async (e) => {
			if (e == null) return 0;
			if (P.isBlob(e)) return e.size;
			if (P.isSpecCompliantForm(e)) return (await new a(Et.origin, {
				method: "POST",
				body: e
			}).arrayBuffer()).byteLength;
			if (P.isArrayBufferView(e) || P.isArrayBuffer(e)) return e.byteLength;
			if (P.isURLSearchParams(e) && (e += ""), P.isString(e)) return (await d(e)).byteLength;
		}, g = async (e, t) => P.toFiniteNumber(e.getContentLength()) ?? h(t);
		return async (e) => {
			let { url: t, method: n, data: s, signal: l, cancelToken: d, timeout: _, onDownloadProgress: v, onUploadProgress: y, responseType: b, headers: x, withCredentials: S = "same-origin", fetchOptions: C, maxContentLength: w, maxBodyLength: T } = cn(e), E = P.isNumber(w) && w > -1, D = P.isNumber(T) && T > -1, ee = (t) => P.hasOwnProp(e, t) ? e[t] : void 0, O = i || fetch;
			b = b ? (b + "").toLowerCase() : "text";
			let k = un([l, d && d.toAbortSignal()], _), A = null, j = k && k.unsubscribe && (() => {
				k.unsubscribe();
			}), te, ne = null, M = () => new F("Request body larger than maxBodyLength limit", F.ERR_BAD_REQUEST, e, A);
			try {
				let i, l = ee("auth");
				if (l && (i = {
					username: P.getSafeProp(l, "username") || "",
					password: P.getSafeProp(l, "password") || ""
				}), wn(t)) {
					let e = new URL(t, Et.origin);
					!i && (e.username || e.password) && (i = {
						username: Sn(e.username),
						password: Sn(e.password)
					}), (e.username || e.password) && (e.username = "", e.password = "", t = e.href);
				}
				if (i && (x.delete("authorization"), x.set("Authorization", "Basic " + btoa(xn((i.username || "") + ":" + (i.password || ""))))), E && typeof t == "string" && t.startsWith("data:") && _n(t) > w) throw new F("maxContentLength size of " + w + " exceeded", F.ERR_BAD_RESPONSE, e, A);
				if (D && n !== "get" && n !== "head") {
					let e = await h(s);
					if (typeof e == "number" && isFinite(e) && (te = e, e > T)) throw M();
				}
				let d = D && (P.isReadableStream(s) || P.isStream(s)), _ = (e, t, n) => mn(e, yn, (e) => {
					if (D && e > T) throw ne = M();
					t && t(e);
				}, n);
				if (f && n !== "get" && n !== "head" && (y || d)) {
					if (te ??= await g(x, s), te !== 0 || d) {
						let e = new a(t, {
							method: "POST",
							body: s,
							duplex: "half"
						}), n;
						if (P.isFormData(s) && (n = e.headers.get("content-type")) && x.setContentType(n), e.body) {
							let [t, n] = y && Wt(te, Ut(Gt(y))) || [];
							s = _(e.body, t, n);
						}
					}
				} else if (d && !c && u && n !== "get" && n !== "head") s = _(s);
				else if (d && c && !f && n !== "get" && n !== "head") throw new F("Stream request bodies are not supported by the current fetch implementation", F.ERR_NOT_SUPPORT, e, A);
				P.isString(S) || (S = S ? "include" : "omit");
				let re = c && "credentials" in a.prototype;
				if (P.isFormData(s)) {
					let e = x.getContentType();
					e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && x.delete("content-type");
				}
				x.set("User-Agent", "axios/1.18.1", !1);
				let ie = {
					...C,
					signal: k,
					method: n.toUpperCase(),
					headers: Ke(x.normalize()),
					body: s,
					duplex: "half",
					credentials: re ? S : void 0
				};
				A = c && new a(t, ie);
				let ae = await (c ? O(A, C) : O(t, ie)), oe = tt.from(ae.headers);
				if (E) {
					let t = P.toFiniteNumber(oe.getContentLength());
					if (t != null && t > w) throw new F("maxContentLength size of " + w + " exceeded", F.ERR_BAD_RESPONSE, e, A);
				}
				let se = p && (b === "stream" || b === "response");
				if (p && ae.body && (v || E || se && j)) {
					let t = {};
					[
						"status",
						"statusText",
						"headers"
					].forEach((e) => {
						t[e] = ae[e];
					});
					let n = P.toFiniteNumber(oe.getContentLength()), [r, i] = v && Wt(n, Ut(Gt(v), !0)) || [], a = 0;
					ae = new o(mn(ae.body, yn, (t) => {
						if (E && (a = t, a > w)) throw new F("maxContentLength size of " + w + " exceeded", F.ERR_BAD_RESPONSE, e, A);
						r && r(t);
					}, () => {
						i && i(), j && j();
					}), t);
				}
				b ||= "text";
				let N = await m[P.findKey(m, b) || "text"](ae, e);
				if (E && !p && !se) {
					let t;
					if (N != null && (typeof N.byteLength == "number" ? t = N.byteLength : typeof N.size == "number" ? t = N.size : typeof N == "string" && (t = typeof r == "function" ? new r().encode(N).byteLength : N.length)), typeof t == "number" && t > w) throw new F("maxContentLength size of " + w + " exceeded", F.ERR_BAD_RESPONSE, e, A);
				}
				return !se && j && j(), await new Promise((t, n) => {
					zt(t, n, {
						data: N,
						headers: tt.from(ae.headers),
						status: ae.status,
						statusText: ae.statusText,
						config: e,
						request: A
					});
				});
			} catch (t) {
				if (j && j(), k && k.aborted && k.reason instanceof F) {
					let n = k.reason;
					throw n.config = e, A && (n.request = A), t !== n && Object.defineProperty(n, "cause", {
						__proto__: null,
						value: t,
						writable: !0,
						enumerable: !1,
						configurable: !0
					}), n;
				}
				if (ne) throw A && !ne.request && (ne.request = A), ne;
				if (t instanceof F) throw A && !t.request && (t.request = A), t;
				if (t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message)) {
					let n = new F("Network Error", F.ERR_NETWORK, e, A, t && t.response);
					throw Object.defineProperty(n, "cause", {
						__proto__: null,
						value: t.cause || t,
						writable: !0,
						enumerable: !1,
						configurable: !0
					}), n;
				}
				throw F.from(t, t && t.code, e, A, t && t.response);
			}
		};
	}, En = /* @__PURE__ */ new Map(), Dn = (e) => {
		let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
			r,
			i,
			n
		], o = a.length, s, c, l = En;
		for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : Tn(t)), l = c;
		return c;
	};
	Dn();
	var On = {
		http: at,
		xhr: ln,
		fetch: { get: Dn }
	};
	P.forEach(On, (e, t) => {
		if (e) {
			try {
				Object.defineProperty(e, "name", {
					__proto__: null,
					value: t
				});
			} catch {}
			Object.defineProperty(e, "adapterName", {
				__proto__: null,
				value: t
			});
		}
	});
	var kn = (e) => `- ${e}`, An = (e) => P.isFunction(e) || e === null || e === !1;
	function jn(e, t) {
		e = P.isArray(e) ? e : [e];
		let { length: n } = e, r, i, a = {};
		for (let o = 0; o < n; o++) {
			r = e[o];
			let n;
			if (i = r, !An(r) && (i = On[(n = String(r)).toLowerCase()], i === void 0)) throw new F(`Unknown adapter '${n}'`);
			if (i && (P.isFunction(i) || (i = i.get(t)))) break;
			a[n || "#" + o] = i;
		}
		if (!i) {
			let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
			throw new F("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(kn).join("\n") : " " + kn(e[0]) : "as no adapter specified"), F.ERR_NOT_SUPPORT);
		}
		return i;
	}
	var Mn = {
		getAdapter: jn,
		adapters: On
	};
	function Nn(e) {
		if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new Rt(null, e);
	}
	function Pn(e) {
		return Nn(e), e.headers = tt.from(e.headers), e.data = It.call(e, e.transformRequest), [
			"post",
			"put",
			"patch"
		].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Mn.getAdapter(e.adapter || Ft.adapter, e)(e).then(function(t) {
			Nn(e), e.response = t;
			try {
				t.data = It.call(e, e.transformResponse, t);
			} finally {
				delete e.response;
			}
			return t.headers = tt.from(t.headers), t;
		}, function(t) {
			if (!Lt(t) && (Nn(e), t && t.response)) {
				e.response = t.response;
				try {
					t.response.data = It.call(e, e.transformResponse, t.response);
				} finally {
					delete e.response;
				}
				t.response.headers = tt.from(t.response.headers);
			}
			return Promise.reject(t);
		});
	}
	var Fn = {};
	[
		"object",
		"boolean",
		"number",
		"function",
		"string",
		"symbol"
	].forEach((e, t) => {
		Fn[e] = function(n) {
			return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
		};
	});
	var In = {};
	Fn.transitional = function(e, t, n) {
		function r(e, t) {
			return "[Axios v1.18.1] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
		}
		return (n, i, a) => {
			if (e === !1) throw new F(r(i, " has been removed" + (t ? " in " + t : "")), F.ERR_DEPRECATED);
			return t && !In[i] && (In[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), !e || e(n, i, a);
		};
	}, Fn.spelling = function(e) {
		return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
	};
	function Ln(e, t, n) {
		if (typeof e != "object" || !e) throw new F("options must be an object", F.ERR_BAD_OPTION_VALUE);
		let r = Object.keys(e), i = r.length;
		for (; i-- > 0;) {
			let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
			if (o) {
				let t = e[a], n = t === void 0 || o(t, a, e);
				if (n !== !0) throw new F("option " + a + " must be " + n, F.ERR_BAD_OPTION_VALUE);
				continue;
			}
			if (n !== !0) throw new F("Unknown option " + a, F.ERR_BAD_OPTION);
		}
	}
	var Rn = {
		assertOptions: Ln,
		validators: Fn
	}, zn = Rn.validators, Bn = class {
		constructor(e) {
			this.defaults = e || {}, this.interceptors = {
				request: new vt(),
				response: new vt()
			};
		}
		async request(e, t) {
			try {
				return await this._request(e, t);
			} catch (e) {
				if (e instanceof Error) {
					let t = {};
					Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
					let n = (() => {
						if (!t.stack) return "";
						let e = t.stack.indexOf("\n");
						return e === -1 ? "" : t.stack.slice(e + 1);
					})();
					try {
						if (!e.stack) e.stack = n;
						else if (n) {
							let t = n.indexOf("\n"), r = t === -1 ? -1 : n.indexOf("\n", t + 1), i = r === -1 ? "" : n.slice(r + 1);
							String(e.stack).endsWith(i) || (e.stack += "\n" + n);
						}
					} catch {}
				}
				throw e;
			}
		}
		_request(e, t) {
			typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = rn(this.defaults, t);
			let { transitional: n, paramsSerializer: r, headers: i } = t;
			n !== void 0 && Rn.assertOptions(n, {
				silentJSONParsing: zn.transitional(zn.boolean),
				forcedJSONParsing: zn.transitional(zn.boolean),
				clarifyTimeoutError: zn.transitional(zn.boolean),
				legacyInterceptorReqResOrdering: zn.transitional(zn.boolean),
				advertiseZstdAcceptEncoding: zn.transitional(zn.boolean),
				validateStatusUndefinedResolves: zn.transitional(zn.boolean)
			}, !1), r != null && (P.isFunction(r) ? t.paramsSerializer = { serialize: r } : Rn.assertOptions(r, {
				encode: zn.function,
				serialize: zn.function
			}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), Rn.assertOptions(t, {
				baseUrl: zn.spelling("baseURL"),
				withXsrfToken: zn.spelling("withXSRFToken")
			}, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
			let a = i && P.merge(i.common, i[t.method]);
			i && P.forEach([
				"delete",
				"get",
				"head",
				"post",
				"put",
				"patch",
				"query",
				"common"
			], (e) => {
				delete i[e];
			}), t.headers = tt.concat(a, i);
			let o = [], s = !0;
			this.interceptors.request.forEach(function(e) {
				if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
				s &&= e.synchronous;
				let n = t.transitional || yt;
				n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
			});
			let c = [];
			this.interceptors.response.forEach(function(e) {
				c.push(e.fulfilled, e.rejected);
			});
			let l, u = 0, d;
			if (!s) {
				let e = [Pn.bind(this), void 0];
				for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
				return l;
			}
			d = o.length;
			let f = t;
			for (; u < d;) {
				let e = o[u++], t = o[u++];
				try {
					f = e(f);
				} catch (e) {
					t.call(this, e);
					break;
				}
			}
			try {
				l = Pn.call(this, f);
			} catch (e) {
				return Promise.reject(e);
			}
			for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
			return l;
		}
		getUri(e) {
			return e = rn(this.defaults, e), _t(tn(e.baseURL, e.url, e.allowAbsoluteUrls, e), e.params, e.paramsSerializer);
		}
	};
	P.forEach([
		"delete",
		"get",
		"head",
		"options"
	], function(e) {
		Bn.prototype[e] = function(t, n) {
			return this.request(rn(n || {}, {
				method: e,
				url: t,
				data: n && P.hasOwnProp(n, "data") ? n.data : void 0
			}));
		};
	}), P.forEach([
		"post",
		"put",
		"patch",
		"query"
	], function(e) {
		function t(t) {
			return function(n, r, i) {
				return this.request(rn(i || {}, {
					method: e,
					headers: t ? { "Content-Type": "multipart/form-data" } : {},
					url: n,
					data: r
				}));
			};
		}
		Bn.prototype[e] = t(), e !== "query" && (Bn.prototype[e + "Form"] = t(!0));
	});
	var Vn = class e {
		constructor(e) {
			if (typeof e != "function") throw TypeError("executor must be a function.");
			let t;
			this.promise = new Promise(function(e) {
				t = e;
			});
			let n = this;
			this.promise.then((e) => {
				if (!n._listeners) return;
				let t = n._listeners.length;
				for (; t-- > 0;) n._listeners[t](e);
				n._listeners = null;
			}), this.promise.then = (e) => {
				let t, r = new Promise((e) => {
					n.subscribe(e), t = e;
				}).then(e);
				return r.cancel = function() {
					n.unsubscribe(t);
				}, r;
			}, e(function(e, r, i) {
				n.reason || (n.reason = new Rt(e, r, i), t(n.reason));
			});
		}
		throwIfRequested() {
			if (this.reason) throw this.reason;
		}
		subscribe(e) {
			if (this.reason) {
				e(this.reason);
				return;
			}
			this._listeners ? this._listeners.push(e) : this._listeners = [e];
		}
		unsubscribe(e) {
			if (!this._listeners) return;
			let t = this._listeners.indexOf(e);
			t !== -1 && this._listeners.splice(t, 1);
		}
		toAbortSignal() {
			let e = new AbortController(), t = (t) => {
				e.abort(t);
			};
			return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
		}
		static source() {
			let t;
			return {
				token: new e(function(e) {
					t = e;
				}),
				cancel: t
			};
		}
	};
	function Hn(e) {
		return function(t) {
			return e.apply(null, t);
		};
	}
	function Un(e) {
		return P.isObject(e) && e.isAxiosError === !0;
	}
	var Wn = {
		Continue: 100,
		SwitchingProtocols: 101,
		Processing: 102,
		EarlyHints: 103,
		Ok: 200,
		Created: 201,
		Accepted: 202,
		NonAuthoritativeInformation: 203,
		NoContent: 204,
		ResetContent: 205,
		PartialContent: 206,
		MultiStatus: 207,
		AlreadyReported: 208,
		ImUsed: 226,
		MultipleChoices: 300,
		MovedPermanently: 301,
		Found: 302,
		SeeOther: 303,
		NotModified: 304,
		UseProxy: 305,
		Unused: 306,
		TemporaryRedirect: 307,
		PermanentRedirect: 308,
		BadRequest: 400,
		Unauthorized: 401,
		PaymentRequired: 402,
		Forbidden: 403,
		NotFound: 404,
		MethodNotAllowed: 405,
		NotAcceptable: 406,
		ProxyAuthenticationRequired: 407,
		RequestTimeout: 408,
		Conflict: 409,
		Gone: 410,
		LengthRequired: 411,
		PreconditionFailed: 412,
		PayloadTooLarge: 413,
		UriTooLong: 414,
		UnsupportedMediaType: 415,
		RangeNotSatisfiable: 416,
		ExpectationFailed: 417,
		ImATeapot: 418,
		MisdirectedRequest: 421,
		UnprocessableEntity: 422,
		Locked: 423,
		FailedDependency: 424,
		TooEarly: 425,
		UpgradeRequired: 426,
		PreconditionRequired: 428,
		TooManyRequests: 429,
		RequestHeaderFieldsTooLarge: 431,
		UnavailableForLegalReasons: 451,
		InternalServerError: 500,
		NotImplemented: 501,
		BadGateway: 502,
		ServiceUnavailable: 503,
		GatewayTimeout: 504,
		HttpVersionNotSupported: 505,
		VariantAlsoNegotiates: 506,
		InsufficientStorage: 507,
		LoopDetected: 508,
		NotExtended: 510,
		NetworkAuthenticationRequired: 511,
		WebServerIsDown: 521,
		ConnectionTimedOut: 522,
		OriginIsUnreachable: 523,
		TimeoutOccurred: 524,
		SslHandshakeFailed: 525,
		InvalidSslCertificate: 526
	};
	Object.entries(Wn).forEach(([e, t]) => {
		Wn[t] = e;
	});
	function Gn(e) {
		let t = new Bn(e), r = n(Bn.prototype.request, t);
		return P.extend(r, Bn.prototype, t, { allOwnKeys: !0 }), P.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(t) {
			return Gn(rn(e, t));
		}, r;
	}
	var Kn = Gn(Ft);
	Kn.Axios = Bn, Kn.CanceledError = Rt, Kn.CancelToken = Vn, Kn.isCancel = Lt, Kn.VERSION = vn, Kn.toFormData = ft, Kn.AxiosError = F, Kn.Cancel = Kn.CanceledError, Kn.all = function(e) {
		return Promise.all(e);
	}, Kn.spread = Hn, Kn.isAxiosError = Un, Kn.mergeConfig = rn, Kn.AxiosHeaders = tt, Kn.formToJSON = (e) => Mt(P.isHTMLForm(e) ? new FormData(e) : e), Kn.getAdapter = Mn.getAdapter, Kn.HttpStatusCode = Wn, Kn.default = Kn, t.exports = Kn;
})), kc = /* @__PURE__ */ p(((e, t) => {
	t.exports = {};
})), Ac = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.arrayableParams = void 0, e.arrayableParams = {
		query_by: "query_by",
		query_by_weights: "query_by_weights",
		facet_by: "facet_by",
		group_by: "group_by",
		include_fields: "include_fields",
		exclude_fields: "exclude_fields",
		highlight_fields: "highlight_fields",
		highlight_full_fields: "highlight_full_fields",
		pinned_hits: "pinned_hits",
		hidden_hits: "hidden_hits",
		infix: "infix",
		override_tags: "override_tags",
		num_typos: "num_typos",
		prefix: "prefix",
		synonym_sets: "synonym_sets",
		sort_by: "sort_by"
	};
})), jc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.normalizeArrayableParams = i, e.toErrorWithMessage = s;
	var t = (H(), _(V)), n = Ac();
	function r(e) {
		return Object.keys(n.arrayableParams).filter(function(t) {
			return e[t] !== void 0;
		}).every(function(t) {
			return a(e[t]);
		});
	}
	function i(e) {
		var i = t.__assign({}, e);
		if (!Object.keys(n.arrayableParams).filter(function(e) {
			return Array.isArray(i[e]);
		}).map(function(e) {
			return i[e] = i[e].join(","), e;
		}).length && r(i)) return i;
		if (!r(i)) throw Error(`Failed to normalize arrayable params: ${JSON.stringify(i)}`);
		return i;
	}
	function a(e) {
		return !Array.isArray(e);
	}
	function o(e) {
		return typeof e == "object" && !!e && "message" in e && typeof e.message == "string";
	}
	function s(e) {
		if (o(e)) return e;
		try {
			return Error(typeof e == "string" ? e : JSON.stringify(e));
		} catch {
			return Error(String(e));
		}
	}
})), Mc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Oc()), r = kc(), i = kc(), a = Ec(), o = t.__importDefault(gc()), s = jc(), c = "X-TYPESENSE-API-KEY", l = !0, u = !1, d = typeof process < "u" && process.versions != null && process.versions.node != null && typeof window > "u";
	e.default = function() {
		function e(e) {
			this.configuration = e, this.apiKey = this.configuration.apiKey, this.nodes = this.configuration.nodes == null ? this.configuration.nodes : JSON.parse(JSON.stringify(this.configuration.nodes)), this.nearestNode = this.configuration.nearestNode == null ? this.configuration.nearestNode : JSON.parse(JSON.stringify(this.configuration.nearestNode)), this.connectionTimeoutSeconds = this.configuration.connectionTimeoutSeconds, this.healthcheckIntervalSeconds = this.configuration.healthcheckIntervalSeconds, this.numRetriesPerRequest = this.configuration.numRetries, this.retryIntervalSeconds = this.configuration.retryIntervalSeconds, this.sendApiKeyAsQueryParam = this.configuration.sendApiKeyAsQueryParam, this.additionalUserHeaders = this.configuration.additionalHeaders, this.logger = this.configuration.logger, this.initializeMetadataForNodes(), this.currentNodeIndex = -1;
		}
		return e.prototype.get = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n, r) {
				n === void 0 && (n = {});
				var i = r === void 0 ? {} : r, a = i.abortSignal, o = a === void 0 ? null : a, s = i.responseType, c = s === void 0 ? void 0 : s, l = i.streamConfig, u = l === void 0 ? void 0 : l, d = i.isStreamingRequest;
				return t.__generator(this, function(t) {
					return [2, this.performRequest("get", e, {
						queryParameters: n,
						abortSignal: o,
						responseType: c,
						streamConfig: u,
						isStreamingRequest: d
					})];
				});
			});
		}, e.prototype.delete = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n) {
				return n === void 0 && (n = {}), t.__generator(this, function(t) {
					return [2, this.performRequest("delete", e, {
						queryParameters: n,
						isStreamingRequest: !1
					})];
				});
			});
		}, e.prototype.post = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n, r, i, a) {
				n === void 0 && (n = {}), r === void 0 && (r = {}), i === void 0 && (i = {});
				var o = a === void 0 ? {} : a, s = o.abortSignal, c = s === void 0 ? null : s, l = o.responseType, u = l === void 0 ? void 0 : l, d = o.streamConfig, f = d === void 0 ? void 0 : d, p = o.isStreamingRequest;
				return t.__generator(this, function(t) {
					return [2, this.performRequest("post", e, {
						queryParameters: r,
						bodyParameters: n,
						additionalHeaders: i,
						abortSignal: c,
						responseType: u,
						streamConfig: f,
						isStreamingRequest: p
					})];
				});
			});
		}, e.prototype.put = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n, r) {
				return n === void 0 && (n = {}), r === void 0 && (r = {}), t.__generator(this, function(t) {
					return [2, this.performRequest("put", e, {
						queryParameters: r,
						bodyParameters: n,
						isStreamingRequest: !1
					})];
				});
			});
		}, e.prototype.patch = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n, r) {
				return n === void 0 && (n = {}), r === void 0 && (r = {}), t.__generator(this, function(t) {
					return [2, this.performRequest("patch", e, {
						queryParameters: r,
						bodyParameters: n,
						isStreamingRequest: !1
					})];
				});
			});
		}, e.prototype.getAdapter = function() {
			if (this.configuration.axiosAdapter) return typeof this.configuration.axiosAdapter == "function" ? this.configuration.axiosAdapter : typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers" ? n.default.getAdapter(this.configuration.axiosAdapter).bind(globalThis) : n.default.getAdapter(this.configuration.axiosAdapter);
		}, e.prototype.performRequest = function(e, a, o) {
			return t.__awaiter(this, arguments, void 0, function(e, a, o) {
				var s, c, f, p, m, h, g, _ = o.queryParameters, v = _ === void 0 ? null : _, y = o.bodyParameters, b = y === void 0 ? null : y, x = o.additionalHeaders, S = x === void 0 ? {} : x, C = o.abortSignal, w = C === void 0 ? null : C, T = o.responseType, E = T === void 0 ? void 0 : T, D = o.skipConnectionTimeout, ee = D !== void 0 && D, O = o.enableKeepAlive, k = O === void 0 ? void 0 : O, A = o.streamConfig, j = A === void 0 ? void 0 : A, te = o.isStreamingRequest;
				return t.__generator(this, function(o) {
					switch (o.label) {
						case 0: this.configuration.validate(), te && (this.logger.debug(`Request: Performing streaming request to ${a}`), !d && typeof fetch < "u" && (this.logger.debug("Using fetch adapter for browser streaming"), E = "stream")), s = Date.now(), f = !1, this.logger.debug(`Request #${s}: Performing ${e.toUpperCase()} request: ${a}`), p = function(o) {
							var p, h, g, _, y, x, C;
							return t.__generator(this, function(T) {
								switch (T.label) {
									case 0:
										if (p = m.getNextNode(s), m.logger.debug(`Request #${s}: Attempting ${e.toUpperCase()} request Try #${o} to Node ${p.index}`), w && w.aborted) return [2, { value: Promise.reject(/* @__PURE__ */ Error("Request aborted by caller.")) }];
										h = void 0, T.label = 1;
									case 1: return T.trys.push([
										1,
										3,
										5,
										6
									]), g = {
										method: e,
										url: m.uriFor(a, p),
										headers: Object.assign({}, m.defaultHeaders(), S, m.additionalUserHeaders),
										maxContentLength: Infinity,
										maxBodyLength: Infinity,
										validateStatus: function(e) {
											return e > 0;
										},
										transformResponse: [function(e, t) {
											var n = e;
											return t !== void 0 && typeof e == "string" && t["content-type"] && t["content-type"].startsWith("application/json") && (n = JSON.parse(e)), n;
										}]
									}, g.adapter = te && !d ? "fetch" : m.getAdapter(), ee !== !0 && (g.timeout = m.connectionTimeoutSeconds * 1e3), v && Object.keys(v).length !== 0 && (g.params = v), m.sendApiKeyAsQueryParam && (g.params = g.params || {}, g.params["x-typesense-api-key"] = m.apiKey), m.configuration.httpAgent ? (m.logger.debug(`Request #${s}: Using custom httpAgent`), g.httpAgent = m.configuration.httpAgent) : k === !0 && (d ? (m.logger.debug(`Request #${s}: Enabling KeepAlive`), g.httpAgent = new r.Agent({ keepAlive: !0 })) : m.logger.warn(`Request #${s}: Cannot use custom httpAgent in a browser environment to enable keepAlive`)), m.configuration.httpsAgent ? (m.logger.debug(`Request #${s}: Using custom httpsAgent`), g.httpsAgent = m.configuration.httpsAgent) : k === !0 && (d ? (m.logger.debug(`Request #${s}: Enabling keepAlive`), g.httpsAgent = new i.Agent({ keepAlive: !0 })) : m.logger.warn(`Request #${s}: Cannot use custom httpAgent in a browser environment to enable keepAlive`)), m.configuration.paramsSerializer && (m.logger.debug(`Request #${s}: Using custom paramsSerializer`), g.paramsSerializer = m.configuration.paramsSerializer), b && (typeof b == "string" && b.length !== 0 || typeof b == "object" && Object.keys(b).length !== 0) && (g.data = b), w && (_ = n.default.CancelToken, y = _.source(), h = function() {
										f = !0, y.cancel();
									}, w.addEventListener("abort", h), g.cancelToken = y.token), te ? (g.responseType = "stream", d || (g.headers = t.__assign(t.__assign({}, g.headers), { Accept: "text/event-stream" }))) : E && (g.responseType = E), [4, (0, n.default)(g)];
									case 2:
										if (x = T.sent(), x.status >= 1 && x.status <= 499 && m.setNodeHealthcheck(p, l), m.logger.debug(`Request #${s}: Request to Node ${p.index} was made. Response Code was ${x.status}.`), x.status >= 200 && x.status < 300) return te ? [2, { value: m.handleStreamingResponse(x, j) }] : [2, { value: Promise.resolve(x.data) }];
										if (x.status < 500) return [2, { value: Promise.reject(m.customErrorForResponse(x, x.data?.message, g.data)) }];
										throw m.customErrorForResponse(x, x.data?.message, g.data);
									case 3:
										if (C = T.sent(), f || m.setNodeHealthcheck(p, u), c = C, m.logger.warn(`Request #${s}: Request to Node ${p.index} failed due to "${C?.code ?? ""} ${C.message}${C.response == null ? "" : " - " + JSON.stringify(C.response?.data)}"`), f) return [2, { value: Promise.reject(/* @__PURE__ */ Error("Request aborted by caller.")) }];
										if (te && m.invokeOnErrorCallback(C, j), o < m.numRetriesPerRequest + 1) m.logger.warn(`Request #${s}: Sleeping for ${m.retryIntervalSeconds}s and then retrying request...`);
										else return m.logger.debug(`Request #${s}: No retries left. Raising last error`), [2, { value: Promise.reject(c) }];
										return [4, m.timer(m.retryIntervalSeconds)];
									case 4: return T.sent(), [3, 6];
									case 5: return w && h && w.removeEventListener("abort", h), [7];
									case 6: return [2];
								}
							});
						}, m = this, h = 1, o.label = 1;
						case 1: return h <= this.numRetriesPerRequest + 1 ? [5, p(h)] : [3, 4];
						case 2:
							if (g = o.sent(), typeof g == "object") return [2, g.value];
							o.label = 3;
						case 3: return h++, [3, 1];
						case 4: return this.logger.debug(`Request #${s}: No retries left. Raising last error`), [2, Promise.reject(c)];
					}
				});
			});
		}, e.prototype.processStreamingLine = function(e) {
			if (!e.trim() || e === "data: [DONE]") return null;
			if (e.startsWith("data: ")) return this.processDataLine(e.slice(6).trim());
			if (e.trim().startsWith("{")) try {
				var t = JSON.parse(e.trim());
				return t && typeof t == "object" ? (t.conversation_id ||= "unknown", !t.message && t.message !== "" && (t.message = ""), t) : {
					conversation_id: "unknown",
					message: JSON.stringify(t)
				};
			} catch {
				return {
					conversation_id: "unknown",
					message: e.trim()
				};
			}
			return {
				conversation_id: "unknown",
				message: e.trim()
			};
		}, e.prototype.processDataLine = function(e) {
			if (!e) return null;
			if (e.startsWith("{")) try {
				var t = JSON.parse(e);
				return t && typeof t == "object" ? (t.conversation_id ||= "unknown", !t.message && t.message !== "" && (t.message = ""), t) : {
					conversation_id: "unknown",
					message: JSON.stringify(t)
				};
			} catch {
				return {
					conversation_id: "unknown",
					message: e
				};
			}
			return {
				conversation_id: "unknown",
				message: e
			};
		}, e.prototype.handleStreamingResponse = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return this.logger.debug(`Handling streaming response. Environment: ${d ? "Node.js" : "Browser"}`), d && e.data ? [2, this.handleNodeStreaming(e, n)] : d ? (this.logger.debug("Processing non-streaming response"), this.invokeOnCompleteCallback(e.data, n), [2, Promise.resolve(e.data)]) : [2, this.handleBrowserStreaming(e, n)];
				});
			});
		}, e.prototype.handleNodeStreaming = function(e, t) {
			var n = this;
			return this.logger.debug("Processing Node.js stream"), new Promise(function(r, i) {
				var a = e.data, o = [], s = "";
				a.on("data", function(e) {
					try {
						var r = e.toString();
						s += r;
						var a = s.split("\n");
						s = a.pop() ?? "", n.processStreamLines(a, o, t);
					} catch (e) {
						i(e);
					}
				}), a.on("end", function() {
					if (s.trim().length > 0) {
						var i = s.split("\n");
						n.processStreamLines(i, o, t);
					}
					n.finalizeStreamResult(o, r, e, t);
				}), a.on("error", function(e) {
					n.logger.error(`Stream error: ${e}`), n.invokeOnErrorCallback(e, t), i(e);
				});
			});
		}, e.prototype.handleBrowserStreaming = function(e, n) {
			var r = this;
			return this.logger.debug("Processing browser stream"), new Promise(function(i, a) {
				return t.__awaiter(r, void 0, void 0, function() {
					return t.__generator(this, function(t) {
						try {
							return e.data && typeof e.data.getReader == "function" ? [2, this.handleBrowserReadableStream(e.data, i, a, e, n)] : typeof e.data == "string" ? [2, this.handleBrowserStringResponse(e.data, i, e, n)] : typeof e.data == "object" && e.data !== null ? (this.logger.debug("No stream found, but data object is available"), this.invokeOnCompleteCallback(e.data, n), [2, i(e.data)]) : (this.logger.error("No usable data found in response"), [2, a(/* @__PURE__ */ Error("No usable data found in response"))]);
						} catch (e) {
							this.logger.error(`Error processing streaming response: ${e}`), this.invokeOnErrorCallback(e, n), a(e);
						}
						return [2];
					});
				});
			});
		}, e.prototype.handleBrowserReadableStream = function(e, n, r, i, a) {
			return t.__awaiter(this, void 0, void 0, function() {
				var o, s, c, l, u, d, f, p, m, h;
				return t.__generator(this, function(t) {
					switch (t.label) {
						case 0: this.logger.debug("Found ReadableStream in response.data"), o = e.getReader(), s = [], c = "", t.label = 1;
						case 1: t.trys.push([
							1,
							5,
							,
							6
						]), t.label = 2;
						case 2: return [4, o.read()];
						case 3: return l = t.sent(), u = l.done, d = l.value, u ? (this.logger.debug("Stream reading complete"), c.trim() && (f = c.split("\n"), this.processStreamLines(f, s, a)), [3, 4]) : (p = new TextDecoder().decode(d), this.logger.debug(`Received chunk: ${p.length} bytes`), c += p, m = c.split("\n"), c = m.pop() || "", this.processStreamLines(m, s, a), [3, 2]);
						case 4: return this.finalizeStreamResult(s, n, i, a), [3, 6];
						case 5: return h = t.sent(), this.logger.error(`Stream error: ${h}`), this.invokeOnErrorCallback(h, a), r(h), [3, 6];
						case 6: return [2];
					}
				});
			});
		}, e.prototype.handleBrowserStringResponse = function(e, t, n, r) {
			this.logger.debug("Processing text response as stream data");
			var i = [], a = e.split("\n");
			if (this.processStreamLines(a, i, r), i.length > 0) {
				var o = this.combineStreamingChunks(i);
				this.invokeOnCompleteCallback(o, r), t(o);
			} else this.logger.debug("No chunks processed, returning original API response"), this.invokeOnCompleteCallback(n.data, r), t(n.data);
		}, e.prototype.processStreamLines = function(e, t, n) {
			for (var r = 0, i = e; r < i.length; r++) {
				var a = i[r];
				if (a.trim() && a !== "data: [DONE]") {
					var o = this.processStreamingLine(a);
					o !== null && (this.invokeOnChunkCallback(o, n), t.push(o));
				}
			}
		}, e.prototype.finalizeStreamResult = function(e, t, n, r) {
			if (e.length > 0) {
				var i = this.combineStreamingChunks(e);
				this.logger.debug("Stream processing complete"), this.invokeOnCompleteCallback(i, r), t(i);
			} else this.logger.debug("No chunks processed, returning original API response"), this.invokeOnCompleteCallback(n.data, r), t(n.data);
		}, e.prototype.combineStreamingChunks = function(e) {
			if (e.length === 0) return {};
			if (e.length === 1) return e[0];
			var t = this.getMessageChunks(e);
			if (t.length > 0) return this.combineMessageChunks(e, t);
			var n = e[e.length - 1];
			if (!this.isCompleteSearchResponse(n)) throw Error("Last chunk is not a complete search response");
			return n;
		}, e.prototype.getMessageChunks = function(e) {
			return e.filter(this.isChunkMessage);
		}, e.prototype.isChunkMessage = function(e) {
			return typeof e == "object" && !!e && "message" in e && "conversation_id" in e;
		}, e.prototype.combineMessageChunks = function(e, t) {
			this.logger.debug(`Found ${t.length} message chunks to combine`);
			var n = e[e.length - 1];
			if (this.isCompleteSearchResponse(n)) return n;
			var r = e.find(this.isCompleteSearchResponse);
			if (!r) throw Error("No metadata chunk found");
			return r;
		}, e.prototype.isCompleteSearchResponse = function(e) {
			return typeof e == "object" && e && Object.keys(e).length > 0 ? "results" in e || "found" in e || "hits" in e || "page" in e || "search_time_ms" in e : !1;
		}, e.prototype.getNextNode = function(e) {
			if (e === void 0 && (e = 0), this.nearestNode != null) {
				if (this.logger.debug(`Request #${e}: Nodes Health: Node ${this.nearestNode.index} is ${this.nearestNode.isHealthy === !0 ? "Healthy" : "Unhealthy"}`), this.nearestNode.isHealthy === !0 || this.nodeDueForHealthcheck(this.nearestNode, e)) return this.logger.debug(`Request #${e}: Updated current node to Node ${this.nearestNode.index}`), this.nearestNode;
				this.logger.debug(`Request #${e}: Falling back to individual nodes`);
			}
			this.logger.debug(`Request #${e}: Nodes Health: ${this.nodes.map(function(e) {
				return `Node ${e.index} is ${e.isHealthy === !0 ? "Healthy" : "Unhealthy"}`;
			}).join(" || ")}`);
			for (var t = this.nodes[0], n = 0; n <= this.nodes.length; n++) if (this.currentNodeIndex = (this.currentNodeIndex + 1) % this.nodes.length, t = this.nodes[this.currentNodeIndex], t.isHealthy === !0 || this.nodeDueForHealthcheck(t, e)) return this.logger.debug(`Request #${e}: Updated current node to Node ${t.index}`), t;
			return this.logger.debug(`Request #${e}: No healthy nodes were found. Returning the next node, Node ${t.index}`), t;
		}, e.prototype.nodeDueForHealthcheck = function(e, t) {
			t === void 0 && (t = 0);
			var n = Date.now() - e.lastAccessTimestamp > this.healthcheckIntervalSeconds * 1e3;
			return n && this.logger.debug(`Request #${t}: Node ${e.index} has exceeded healtcheckIntervalSeconds of ${this.healthcheckIntervalSeconds}. Adding it back into rotation.`), n;
		}, e.prototype.initializeMetadataForNodes = function() {
			var e = this;
			this.nearestNode != null && (this.nearestNode.index = "nearestNode", this.setNodeHealthcheck(this.nearestNode, l)), this.nodes.forEach(function(t, n) {
				t.index = n, e.setNodeHealthcheck(t, l);
			});
		}, e.prototype.setNodeHealthcheck = function(e, t) {
			e.isHealthy = t, e.lastAccessTimestamp = Date.now();
		}, e.prototype.uriFor = function(e, t) {
			return t.url == null ? `${t.protocol}://${t.host}:${t.port}${t.path}${e}` : `${t.url}${e}`;
		}, e.prototype.defaultHeaders = function() {
			var e = {};
			return this.sendApiKeyAsQueryParam || (e[c] = this.apiKey), e["Content-Type"] = "application/json", e;
		}, e.prototype.timer = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, new Promise(function(t) {
						return setTimeout(t, e * 1e3);
					})];
				});
			});
		}, e.prototype.customErrorForResponse = function(e, t, n) {
			var r = `Request failed with HTTP code ${e.status}`;
			typeof t == "string" && t.trim() !== "" && (r += ` | Server said: ${t}`);
			var i = new o.default(r, n, e.status);
			return i = e.status === 400 ? new a.RequestMalformed(r, n, e.status) : e.status === 401 ? new a.RequestUnauthorized(r, n, e.status) : e.status === 404 ? new a.ObjectNotFound(r, n, e.status) : e.status === 409 ? new a.ObjectAlreadyExists(r, n, e.status) : e.status === 422 ? new a.ObjectUnprocessable(r, n, e.status) : e.status >= 500 && e.status <= 599 ? new a.ServerError(r, n, e.status) : new a.HTTPError(r, n, e.status), i;
		}, e.prototype.invokeOnChunkCallback = function(e, t) {
			if (t?.onChunk) try {
				t.onChunk(e);
			} catch (e) {
				this.logger.warn(`Error in onChunk callback: ${e}`);
			}
		}, e.prototype.invokeOnCompleteCallback = function(e, t) {
			if (t?.onComplete) try {
				t.onComplete(e);
			} catch (e) {
				this.logger.warn(`Error in onComplete callback: ${e}`);
			}
		}, e.prototype.invokeOnErrorCallback = function(e, t) {
			if (t?.onError) {
				var n = (0, s.toErrorWithMessage)(e);
				try {
					t.onError(n);
				} catch (e) {
					this.logger.warn(`Error in onError callback: ${e}`);
				}
			}
		}, e;
	}();
})), Nc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/collections";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.create = function(e, r) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.post(n, e, r)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, arguments, void 0, function(e) {
				return e === void 0 && (e = {}), t.__generator(this, function(t) {
					return [2, this.apiCall.get(n, e)];
				});
			});
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), Pc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = 120, r = 100;
	e.default = function() {
		function e() {
			this.responseCache = /* @__PURE__ */ new Map(), this.responsePromiseCache = /* @__PURE__ */ new Map();
		}
		return e.prototype.clearCache = function() {
			this.responseCache = /* @__PURE__ */ new Map(), this.responsePromiseCache = /* @__PURE__ */ new Map();
		}, e.prototype.perform = function(e, i, a, o) {
			return t.__awaiter(this, void 0, void 0, function() {
				var s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, w, E, D, ee, O, k, O;
				return t.__generator(this, function(t) {
					switch (t.label) {
						case 0:
							if (s = o || {}, c = s.cacheResponseForSeconds, l = c === void 0 ? n : c, u = s.maxSize, d = u === void 0 ? r : u, f = o === void 0 || l <= 0 || d <= 0, p = a.path, m = a.queryParams, h = a.body, g = a.headers, _ = a.streamConfig, v = a.abortSignal, y = a.responseType, b = a.isStreamingRequest, f) return [2, this.executeRequest(e, i, p, m, h, g, {
								abortSignal: v,
								responseType: y,
								streamConfig: _,
								isStreamingRequest: b
							})];
							if (x = JSON.stringify(a), S = this.responseCache.get(x), C = Date.now(), S) {
								if (w = C - S.requestTimestamp < l * 1e3, w) return this.responseCache.delete(x), this.responseCache.set(x, S), [2, S.response];
								this.responseCache.delete(x);
							}
							if (T = this.responsePromiseCache.get(x), T) {
								if (w = C - T.requestTimestamp < l * 1e3, w) return this.responsePromiseCache.delete(x), this.responsePromiseCache.set(x, T), [2, T.responsePromise];
								this.responsePromiseCache.delete(x);
							}
							return E = this.executeRequest(e, i, p, m, h, g, {
								abortSignal: v,
								responseType: y,
								streamConfig: _,
								isStreamingRequest: b
							}), this.responsePromiseCache.set(x, {
								requestTimestamp: C,
								responsePromise: E
							}), [4, E];
						case 1: return D = t.sent(), this.responseCache.set(x, {
							requestTimestamp: C,
							response: D
						}), ee = this.responseCache.size > d, ee && (O = this.responseCache.keys().next().value, O && this.responseCache.delete(O)), k = this.responsePromiseCache.size > d, k && (O = this.responsePromiseCache.keys().next().value, O && this.responsePromiseCache.delete(O)), [2, D];
					}
				});
			});
		}, e.prototype.executeRequest = function(e, t, n, r, i, a, o) {
			r === void 0 && (r = {});
			var s = e[t];
			switch (t) {
				case "get": return s.call(e, n, r, {
					abortSignal: o?.abortSignal,
					responseType: o?.responseType,
					streamConfig: o?.streamConfig,
					isStreamingRequest: o?.isStreamingRequest
				});
				case "delete": return s.call(e, n, r);
				case "post": return s.call(e, n, i, r, a || {}, {
					abortSignal: o?.abortSignal,
					responseType: o?.responseType,
					streamConfig: o?.streamConfig,
					isStreamingRequest: o?.isStreamingRequest
				});
				case "put":
				case "patch": return s.call(e, n, i, r);
				default: throw Error(`Unsupported method: ${String(t)}`);
			}
		}, e;
	}();
})), Fc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.SearchOnlyDocuments = void 0;
	var t = (H(), _(V)), n = t.__importDefault(Pc()), r = t.__importDefault(Nc()), i = jc(), a = "/documents";
	e.SearchOnlyDocuments = function() {
		function e(e, t, r) {
			this.collectionName = e, this.apiCall = t, this.configuration = r, this.requestWithCache = new n.default();
		}
		return e.prototype.clearCache = function() {
			this.requestWithCache.clearCache();
		}, e.prototype.search = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n) {
				var r, a, o, s, c, l, u = n === void 0 ? {} : n, d = u.cacheSearchResultsForSeconds, f = d === void 0 ? this.configuration.cacheSearchResultsForSeconds : d, p = u.abortSignal, m = p === void 0 ? null : p;
				return t.__generator(this, function(n) {
					return r = {}, this.configuration.useServerSideSearchCache === !0 && (r.use_cache = !0), a = (0, i.normalizeArrayableParams)(e), o = a.streamConfig, s = t.__rest(a, ["streamConfig"]), c = t.__assign(t.__assign({}, r), s), l = c.conversation_stream === !0, [2, this.requestWithCache.perform(this.apiCall, "get", {
						path: this.endpointPath("search"),
						queryParams: c,
						streamConfig: o,
						abortSignal: m,
						isStreamingRequest: l
					}, { cacheResponseForSeconds: f })];
				});
			});
		}, e.prototype.endpointPath = function(e) {
			return `${r.default.RESOURCEPATH}/${encodeURIComponent(this.collectionName)}${a}${e === void 0 ? "" : "/" + e}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return a;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), Ic = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = Ec(), r = Fc(), i = typeof process < "u" && process.versions != null && process.versions.node != null;
	e.default = function(e) {
		t.__extends(r, e);
		function r(t, n, r) {
			return e.call(this, t, n, r) || this;
		}
		return r.prototype.create = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n) {
				return n === void 0 && (n = {}), t.__generator(this, function(t) {
					if (!e) throw Error("No document provided");
					return [2, this.apiCall.post(this.endpointPath(), e, n)];
				});
			});
		}, r.prototype.upsert = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n) {
				return n === void 0 && (n = {}), t.__generator(this, function(t) {
					if (!e) throw Error("No document provided");
					return [2, this.apiCall.post(this.endpointPath(), e, Object.assign({}, n, { action: "upsert" }))];
				});
			});
		}, r.prototype.update = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n) {
				return n === void 0 && (n = {}), t.__generator(this, function(t) {
					if (!e) throw Error("No document provided");
					return n.filter_by == null ? [2, this.apiCall.post(this.endpointPath(), e, Object.assign({}, n, { action: "update" }))] : [2, this.apiCall.patch(this.endpointPath(), e, Object.assign({}, n))];
				});
			});
		}, r.prototype.delete = function() {
			return t.__awaiter(this, arguments, void 0, function(e) {
				return e === void 0 && (e = {}), t.__generator(this, function(t) {
					return [2, this.apiCall.delete(this.endpointPath(), e)];
				});
			});
		}, r.prototype.createMany = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n) {
				return n === void 0 && (n = {}), t.__generator(this, function(t) {
					return this.configuration.logger.warn("createMany is deprecated and will be removed in a future version. Use import instead, which now takes both an array of documents or a JSONL string of documents"), [2, this.import(e, n)];
				});
			});
		}, r.prototype.import = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, r) {
				var o, s, c, l, u;
				return r === void 0 && (r = {}), t.__generator(this, function(d) {
					switch (d.label) {
						case 0:
							if (o = t.__assign({ throwOnFail: !0 }, r), Array.isArray(e)) {
								if (e.length === 0) throw new n.RequestMalformed("No documents provided");
								try {
									s = e.map(function(e) {
										return JSON.stringify(e);
									}).join("\n");
								} catch (e) {
									throw e instanceof RangeError && e.message.includes("Too many properties to enumerate") ? Error(`${e}
          It looks like you have reached a Node.js limit that restricts the number of keys in an Object: https://stackoverflow.com/questions/9282869/are-there-limits-to-the-number-of-properties-in-a-javascript-object

         Please try reducing the number of keys in your document, or using CURL to import your data.
          `) : Error(e);
								}
							} else if (s = e, a(s)) throw new n.RequestMalformed("No documents provided");
							return [4, this.apiCall.performRequest("post", this.endpointPath("import"), {
								queryParameters: o,
								bodyParameters: s,
								additionalHeaders: { "Content-Type": "text/plain" },
								skipConnectionTimeout: !0,
								enableKeepAlive: !!i
							})];
						case 1:
							if (c = d.sent(), Array.isArray(e)) {
								if (l = c.split("\n").map(function(e) {
									return JSON.parse(e);
								}), u = l.filter(function(e) {
									return e.success === !1;
								}), u.length > 0 && o.throwOnFail) throw new n.ImportError(`${l.length - u.length} documents imported successfully, ${u.length} documents failed during import. Use \`error.importResults\` from the raised exception to get a detailed error reason for each document.`, l, {
									documentsInJSONLFormat: s,
									options: o,
									failedItems: u,
									successCount: l.length - u.length
								});
								return [2, l];
							} else return [2, c];
							return [2];
					}
				});
			});
		}, r.prototype.importStream = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, r) {
				var a, o, s, c;
				return r === void 0 && (r = {}), t.__generator(this, function(l) {
					switch (l.label) {
						case 0: return a = t.__assign({ throwOnFail: !0 }, r), [4, this.apiCall.performRequest("post", this.endpointPath("import"), {
							queryParameters: a,
							bodyParameters: e,
							additionalHeaders: { "Content-Type": "text/plain" },
							skipConnectionTimeout: !0,
							enableKeepAlive: !!i
						})];
						case 1:
							if (o = l.sent(), s = o.split("\n").map(function(e) {
								return JSON.parse(e);
							}), c = s.filter(function(e) {
								return e.success === !1;
							}), c.length > 0 && a.throwOnFail) throw new n.ImportError(`${s.length - c.length} documents imported successfully, ${c.length} documents failed during import. Use \`error.importResults\` from the raised exception to get a detailed error reason for each document.`, s, {
								documentsInJSONLFormat: e,
								options: a,
								failedItems: c,
								successCount: s.length - c.length
							});
							return [2, s];
					}
				});
			});
		}, r.prototype.export = function() {
			return t.__awaiter(this, arguments, void 0, function(e) {
				return e === void 0 && (e = {}), t.__generator(this, function(t) {
					return [2, this.apiCall.get(this.endpointPath("export"), e)];
				});
			});
		}, r.prototype.exportStream = function() {
			return t.__awaiter(this, arguments, void 0, function(e) {
				return e === void 0 && (e = {}), t.__generator(this, function(t) {
					return [2, this.apiCall.get(this.endpointPath("export"), e, { responseType: "stream" })];
				});
			});
		}, r;
	}(r.SearchOnlyDocuments);
	function a(e) {
		return e == null || e === "" || e.length === 0;
	}
})), Lc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Nc()), r = "/overrides";
	e.default = function() {
		function e(e, t) {
			this.collectionName = e, this.apiCall = t;
		}
		return e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(e), n)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${n.default.RESOURCEPATH}/${this.collectionName}${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return r;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), Rc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Nc()), r = t.__importDefault(Lc());
	e.default = function() {
		function e(e, t, n) {
			this.collectionName = e, this.overrideId = t, this.apiCall = n;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.collectionName)}${r.default.RESOURCEPATH}/${encodeURIComponent(this.overrideId)}`;
		}, e;
	}();
})), zc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Nc()), r = "/synonyms";
	e.default = function() {
		function e(e, t) {
			this.collectionName = e, this.apiCall = t;
		}
		return e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(e), n)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return e.hasWarnedDeprecation ||= (console.warn("[typesense] 'synonyms' APIs are deprecated starting with Typesense Server v30. Please migrate to synonym sets ('synonym_sets')."), !0), `${n.default.RESOURCEPATH}/${encodeURIComponent(this.collectionName)}${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return r;
			},
			enumerable: !1,
			configurable: !0
		}), e.hasWarnedDeprecation = !1, e;
	}();
})), Bc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Nc()), r = t.__importDefault(zc());
	e.default = function() {
		function e(e, t, n) {
			this.collectionName = e, this.synonymId = t, this.apiCall = n;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return e.hasWarnedDeprecation ||= (console.warn("[typesense] 'synonym' APIs are deprecated starting with Typesense Server v30. Please migrate to synonym sets 'synonym_sets'."), !0), `${n.default.RESOURCEPATH}/${encodeURIComponent(this.collectionName)}${r.default.RESOURCEPATH}/${encodeURIComponent(this.synonymId)}`;
		}, e.hasWarnedDeprecation = !1, e;
	}();
})), Vc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Document = void 0;
	var t = (H(), _(V)), n = t.__importDefault(Nc()), r = t.__importDefault(Ic());
	e.Document = function() {
		function e(e, t, n) {
			this.collectionName = e, this.documentId = t, this.apiCall = n;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.delete(this.endpointPath(), e)];
				});
			});
		}, e.prototype.update = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, n) {
				return n === void 0 && (n = {}), t.__generator(this, function(t) {
					return [2, this.apiCall.patch(this.endpointPath(), e, n)];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.collectionName)}${r.default.RESOURCEPATH}/${encodeURIComponent(this.documentId)}`;
		}, e;
	}();
})), Hc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Nc()), r = t.__importDefault(Ic()), i = Ec(), a = t.__importDefault(Lc()), o = t.__importDefault(Rc()), s = t.__importDefault(zc()), c = t.__importDefault(Bc()), l = Vc();
	e.default = function() {
		function e(e, t, n) {
			this.name = e, this.apiCall = t, this.configuration = n, this.individualDocuments = {}, this.individualOverrides = {}, this.individualSynonyms = {}, this.name = e, this.apiCall = t, this.configuration = n, this._documents = new r.default(this.name, this.apiCall, this.configuration), this._overrides = new a.default(this.name, this.apiCall), this._synonyms = new s.default(this.name, this.apiCall);
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.update = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.patch(this.endpointPath(), e)];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, arguments, void 0, function(e) {
				return e === void 0 && (e = {}), t.__generator(this, function(t) {
					return [2, this.apiCall.delete(this.endpointPath(), e)];
				});
			});
		}, e.prototype.exists = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				var e;
				return t.__generator(this, function(t) {
					switch (t.label) {
						case 0: return t.trys.push([
							0,
							2,
							,
							3
						]), [4, this.retrieve()];
						case 1: return t.sent(), [2, !0];
						case 2:
							if (e = t.sent(), e instanceof i.ObjectNotFound) return [2, !1];
							throw e;
						case 3: return [2];
					}
				});
			});
		}, e.prototype.documents = function(e) {
			return e ? (this.individualDocuments[e] === void 0 && (this.individualDocuments[e] = new l.Document(this.name, e, this.apiCall)), this.individualDocuments[e]) : this._documents;
		}, e.prototype.overrides = function(e) {
			return e === void 0 ? this._overrides : (this.individualOverrides[e] === void 0 && (this.individualOverrides[e] = new o.default(this.name, e, this.apiCall)), this.individualOverrides[e]);
		}, e.prototype.synonyms = function(e) {
			return e === void 0 ? this._synonyms : (this.individualSynonyms[e] === void 0 && (this.individualSynonyms[e] = new c.default(this.name, e, this.apiCall)), this.individualSynonyms[e]);
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.name)}`;
		}, e;
	}();
})), Uc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/aliases";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(e), n)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(n)];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${e.RESOURCEPATH}/${encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), Wc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Uc());
	e.default = function() {
		function e(e, t) {
			this.name = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.name)}`;
		}, e;
	}();
})), Gc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = kc(), r = jc(), i = "/keys";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.apiCall = e;
		}
		return e.prototype.create = function(n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.post(e.RESOURCEPATH, n)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(i)];
				});
			});
		}, e.prototype.generateScopedSearchKey = function(e, t) {
			var i = (0, r.normalizeArrayableParams)(t), a = JSON.stringify(i), o = `${Buffer.from((0, n.createHmac)("sha256", e).update(a).digest("base64"))}${e.substr(0, 4)}${a}`;
			return Buffer.from(o).toString("base64");
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return i;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), Kc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Gc());
	e.default = function() {
		function e(e, t) {
			this.id = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.id)}`;
		}, e;
	}();
})), qc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/debug";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(n)];
				});
			});
		}, e;
	}();
})), Jc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/metrics.json";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(n)];
				});
			});
		}, e;
	}();
})), Yc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/stats.json";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(n)];
				});
			});
		}, e;
	}();
})), Xc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/health";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(n)];
				});
			});
		}, e;
	}();
})), Zc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/operations";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.perform = function(e) {
			return t.__awaiter(this, arguments, void 0, function(e, r) {
				return r === void 0 && (r = {}), t.__generator(this, function(t) {
					return [2, this.apiCall.post(`${n}/${e}`, {}, r)];
				});
			});
		}, e.prototype.getSchemaChanges = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(`${n}/schema_changes`)];
				});
			});
		}, e;
	}();
})), Qc = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Pc()), r = jc(), i = "/multi_search";
	e.default = function() {
		function e(e, t, r) {
			r === void 0 && (r = !1), this.apiCall = e, this.configuration = t, this.useTextContentType = r, this.requestWithCache = new n.default(), this.logger = this.apiCall.logger;
		}
		return e.prototype.clearCache = function() {
			this.requestWithCache.clearCache();
		}, e.prototype.perform = function(e, n, a) {
			return t.__awaiter(this, void 0, void 0, function() {
				var o, s, c, l, u, d;
				return t.__generator(this, function(f) {
					return o = n ? t.__assign({}, n) : {}, s = a?.cacheSearchResultsForSeconds ?? this.configuration.cacheSearchResultsForSeconds, this.configuration.useServerSideSearchCache === !0 && (o.use_cache = !0), e.union === !0 && this.hasAnySearchObjectPagination(e) && this.logger.warn("Individual `searches` pagination parameters are ignored when `union: true` is set. Use a top-level pagination parameter instead. See https://typesense.org/docs/29.0/api/federated-multi-search.html#union-search"), c = {
						union: e.union,
						searches: e.searches.map(r.normalizeArrayableParams)
					}, l = o.streamConfig, u = t.__rest(o, ["streamConfig"]), d = (0, r.normalizeArrayableParams)(u), [2, this.requestWithCache.perform(this.apiCall, "post", {
						path: i,
						body: c,
						queryParams: d,
						headers: this.useTextContentType ? { "content-type": "text/plain" } : {},
						streamConfig: l,
						abortSignal: a?.abortSignal,
						isStreamingRequest: this.isStreamingRequest(o)
					}, s === void 0 ? void 0 : { cacheResponseForSeconds: s })];
				});
			});
		}, e.prototype.isStreamingRequest = function(e) {
			return e.streamConfig !== void 0;
		}, e.prototype.hasAnySearchObjectPagination = function(e) {
			return e.searches.some(function(e) {
				return e.page !== void 0 || e.per_page !== void 0 || e.offset !== void 0 || e.limit !== void 0 || e.limit_hits !== void 0;
			});
		}, e;
	}();
})), $c = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = jc(), r = "/presets";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.upsert = function(e, r) {
			return t.__awaiter(this, void 0, void 0, function() {
				var i, a;
				return t.__generator(this, function(t) {
					return typeof r.value == "object" && "searches" in r.value ? (i = r.value.searches.map(function(e) {
						return (0, n.normalizeArrayableParams)(e);
					}), [2, this.apiCall.put(this.endpointPath(e), { value: { searches: i } })]) : (a = (0, n.normalizeArrayableParams)(r.value), [2, this.apiCall.put(this.endpointPath(e), { value: a })]);
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return r;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), el = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault($c());
	e.default = function() {
		function e(e, t) {
			this.presetId = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.presetId)}`;
		}, e;
	}();
})), tl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/analytics/rules";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.apiCall = e;
		}
		return e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(e), n)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), nl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(tl());
	e.default = function() {
		function e(e, t) {
			this.name = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.name)}`;
		}, e;
	}();
})), rl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/analytics/events";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.apiCall = e;
		}
		return e.prototype.create = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.post(this.endpointPath(), e)];
				});
			});
		}, e.prototype.retrieve = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.get(this.endpointPath(), e)];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), il = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(tl()), r = t.__importDefault(nl()), i = t.__importDefault(rl()), a = "/analytics";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.individualAnalyticsRules = {}, this.apiCall = e, this._analyticsRules = new n.default(this.apiCall), this._analyticsEvents = new i.default(this.apiCall);
		}
		return e.prototype.rules = function(t) {
			return e.hasWarnedDeprecation ||= (console.warn("[typesense] 'analyticsV1' is deprecated starting with Typesense Server v30 and will be removed in a future release. Please use 'analytics' instead."), !0), t === void 0 ? this._analyticsRules : (this.individualAnalyticsRules[t] === void 0 && (this.individualAnalyticsRules[t] = new r.default(t, this.apiCall)), this.individualAnalyticsRules[t]);
		}, e.prototype.events = function() {
			return this._analyticsEvents;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return a;
			},
			enumerable: !1,
			configurable: !0
		}), e.hasWarnedDeprecation = !1, e;
	}();
})), al = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/analytics/rules";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.apiCall = e;
		}
		return e.prototype.create = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.post(this.endpointPath(), e, {}, {})];
				});
			});
		}, e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(e), n)];
				});
			});
		}, e.prototype.retrieve = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				var n;
				return t.__generator(this, function(t) {
					return n = {}, e && (n.rule_tag = e), [2, this.apiCall.get(this.endpointPath(), n)];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), ol = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(al());
	e.default = function() {
		function e(e, t) {
			this.name = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.name)}`;
		}, e;
	}();
})), sl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(al()), r = t.__importDefault(ol()), i = t.__importDefault(rl()), a = "/analytics";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.individualAnalyticsRules = {}, this.apiCall = e, this._analyticsRules = new n.default(this.apiCall), this._analyticsEvents = new i.default(this.apiCall);
		}
		return e.prototype.rules = function(e) {
			return e === void 0 ? this._analyticsRules : (this.individualAnalyticsRules[e] === void 0 && (this.individualAnalyticsRules[e] = new r.default(e, this.apiCall)), this.individualAnalyticsRules[e]);
		}, e.prototype.events = function() {
			return this._analyticsEvents;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return a;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), cl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/stopwords";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(e), n)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), ll = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(cl());
	e.default = function() {
		function e(e, t) {
			this.stopwordId = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.stopwordId)}`;
		}, e;
	}();
})), ul = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/conversations/models";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.apiCall = e;
		}
		return e.prototype.create = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.post(this.endpointPath(), e)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return `${e.RESOURCEPATH}${t === void 0 ? "" : "/" + encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), dl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(ul());
	e.default = function() {
		function e(e, t) {
			this.id = e, this.apiCall = t;
		}
		return e.prototype.update = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(), e)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.id)}`;
		}, e;
	}();
})), fl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(ul()), r = t.__importDefault(dl()), i = "/conversations";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.individualConversationModels = {}, this.apiCall = e, this._conversationsModels = new n.default(this.apiCall);
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(i)];
				});
			});
		}, e.prototype.models = function(e) {
			return e === void 0 ? this._conversationsModels : (this.individualConversationModels[e] === void 0 && (this.individualConversationModels[e] = new r.default(e, this.apiCall)), this.individualConversationModels[e]);
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return i;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), pl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(fl());
	e.default = function() {
		function e(e, t) {
			this.id = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.update = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(), e)];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.id)}`;
		}, e;
	}();
})), ml = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/stemming/dictionaries";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.apiCall = e;
		}
		return e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				var r, i;
				return t.__generator(this, function(t) {
					switch (t.label) {
						case 0: return r = Array.isArray(n) ? n.map(function(e) {
							return JSON.stringify(e);
						}).join("\n") : n, [4, this.apiCall.performRequest("post", this.endpointPath("import"), {
							queryParameters: { id: e },
							bodyParameters: r,
							additionalHeaders: { "Content-Type": "text/plain" },
							skipConnectionTimeout: !0
						})];
						case 1: return i = t.sent(), [2, Array.isArray(n) ? i.split("\n").map(function(e) {
							return JSON.parse(e);
						}) : i];
					}
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(t) {
			return t === void 0 ? `${e.RESOURCEPATH}` : `${e.RESOURCEPATH}/${encodeURIComponent(t)}`;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), hl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(ml());
	e.default = function() {
		function e(e, t) {
			this.id = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.id)}`;
		}, e;
	}();
})), gl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(ml()), r = t.__importDefault(hl()), i = "/stemming";
	e.default = function() {
		function e(e) {
			this.apiCall = e, this.individualStemmingDictionaries = {}, this.apiCall = e, this._stemmingDictionaries = new n.default(this.apiCall);
		}
		return e.prototype.dictionaries = function(e) {
			return e === void 0 ? this._stemmingDictionaries : (this.individualStemmingDictionaries[e] === void 0 && (this.individualStemmingDictionaries[e] = new r.default(e, this.apiCall)), this.individualStemmingDictionaries[e]);
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return i;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), _l = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = "/nl_search_models";
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.create = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.post(this.endpointPath(), e)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return e.RESOURCEPATH;
		}, Object.defineProperty(e, "RESOURCEPATH", {
			get: function() {
				return n;
			},
			enumerable: !1,
			configurable: !0
		}), e;
	}();
})), vl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(_l());
	e.default = function() {
		function e(e, t) {
			this.id = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.update = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(), e)];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.id)}`;
		}, e;
	}();
})), yl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.get(e.RESOURCEPATH)];
				});
			});
		}, e.RESOURCEPATH = "/synonym_sets", e;
	}();
})), bl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(yl());
	e.default = function() {
		function e(e, t) {
			this.synonymSetName = e, this.apiCall = t;
		}
		return e.prototype.upsert = function(e, n) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(e), n)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(e) {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.synonymSetName)}/items${e === void 0 ? "" : "/" + encodeURIComponent(e)}`;
		}, e;
	}();
})), xl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(yl());
	e.default = function() {
		function e(e, t, n) {
			this.synonymSetName = e, this.itemId = t, this.apiCall = n;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.synonymSetName)}/items/${encodeURIComponent(this.itemId)}`;
		}, e;
	}();
})), Sl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(yl()), r = t.__importDefault(bl()), i = t.__importDefault(xl());
	e.default = function() {
		function e(e, t) {
			this.synonymSetName = e, this.apiCall = t, this.individualItems = {}, this._items = new r.default(this.synonymSetName, t);
		}
		return e.prototype.upsert = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(), e)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.items = function(e) {
			return e === void 0 ? this._items : (this.individualItems[e] === void 0 && (this.individualItems[e] = new i.default(this.synonymSetName, e, this.apiCall)), this.individualItems[e]);
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.synonymSetName)}`;
		}, e;
	}();
})), Cl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V));
	e.default = function() {
		function e(e) {
			this.apiCall = e;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.get(e.RESOURCEPATH)];
				});
			});
		}, e.RESOURCEPATH = "/curation_sets", e;
	}();
})), wl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Cl());
	e.default = function() {
		function e(e, t) {
			this.name = e, this.apiCall = t;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function(e) {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.name)}/items${e === void 0 ? "" : "/" + encodeURIComponent(e)}`;
		}, e;
	}();
})), Tl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Cl());
	e.default = function() {
		function e(e, t, n) {
			this.name = e, this.itemId = t, this.apiCall = n;
		}
		return e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.upsert = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(), e)];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.name)}/items/${encodeURIComponent(this.itemId)}`;
		}, e;
	}();
})), El = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Cl()), r = t.__importDefault(wl()), i = t.__importDefault(Tl());
	e.default = function() {
		function e(e, t) {
			this.name = e, this.apiCall = t, this.individualItems = {}, this._items = new r.default(this.name, t);
		}
		return e.prototype.upsert = function(e) {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(t) {
					return [2, this.apiCall.put(this.endpointPath(), e)];
				});
			});
		}, e.prototype.retrieve = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.get(this.endpointPath())];
				});
			});
		}, e.prototype.delete = function() {
			return t.__awaiter(this, void 0, void 0, function() {
				return t.__generator(this, function(e) {
					return [2, this.apiCall.delete(this.endpointPath())];
				});
			});
		}, e.prototype.items = function(e) {
			return e === void 0 ? this._items : (this.individualItems[e] === void 0 && (this.individualItems[e] = new i.default(this.name, e, this.apiCall)), this.individualItems[e]);
		}, e.prototype.endpointPath = function() {
			return `${n.default.RESOURCEPATH}/${encodeURIComponent(this.name)}`;
		}, e;
	}();
})), Dl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Dc()), r = t.__importDefault(Mc()), i = t.__importDefault(Nc()), a = t.__importDefault(Hc()), o = t.__importDefault(Uc()), s = t.__importDefault(Wc()), c = t.__importDefault(Gc()), l = t.__importDefault(Kc()), u = t.__importDefault(qc()), d = t.__importDefault(Jc()), f = t.__importDefault(Yc()), p = t.__importDefault(Xc()), m = t.__importDefault(Zc()), h = t.__importDefault(Qc()), g = t.__importDefault($c()), v = t.__importDefault(el()), y = t.__importDefault(il()), b = t.__importDefault(sl()), x = t.__importDefault(cl()), S = t.__importDefault(ll()), C = t.__importDefault(fl()), w = t.__importDefault(pl()), T = t.__importDefault(gl()), E = t.__importDefault(_l()), D = t.__importDefault(vl()), ee = t.__importDefault(yl()), O = t.__importDefault(Sl()), k = t.__importDefault(Cl()), A = t.__importDefault(El());
	e.default = function() {
		function e(e) {
			e.sendApiKeyAsQueryParam = e.sendApiKeyAsQueryParam ?? !1, this.configuration = new n.default(e), this.apiCall = new r.default(this.configuration), this.debug = new u.default(this.apiCall), this.metrics = new d.default(this.apiCall), this.stats = new f.default(this.apiCall), this.health = new p.default(this.apiCall), this.operations = new m.default(this.apiCall), this.multiSearch = new h.default(this.apiCall, this.configuration), this._collections = new i.default(this.apiCall), this.individualCollections = {}, this._aliases = new o.default(this.apiCall), this.individualAliases = {}, this._keys = new c.default(this.apiCall), this.individualKeys = {}, this._presets = new g.default(this.apiCall), this.individualPresets = {}, this._stopwords = new x.default(this.apiCall), this.individualStopwords = {}, this.analytics = new b.default(this.apiCall), this.analyticsV1 = new y.default(this.apiCall), this.stemming = new T.default(this.apiCall), this._conversations = new C.default(this.apiCall), this.individualConversations = {}, this._nlSearchModels = new E.default(this.apiCall), this.individualNLSearchModels = {}, this._synonymSets = new ee.default(this.apiCall), this.individualSynonymSets = {}, this._curationSets = new k.default(this.apiCall), this.individualCurationSets = {};
		}
		return e.prototype.collections = function(e) {
			return e === void 0 ? this._collections : (this.individualCollections[e] === void 0 && (this.individualCollections[e] = new a.default(e, this.apiCall, this.configuration)), this.individualCollections[e]);
		}, e.prototype.aliases = function(e) {
			return e === void 0 ? this._aliases : (this.individualAliases[e] === void 0 && (this.individualAliases[e] = new s.default(e, this.apiCall)), this.individualAliases[e]);
		}, e.prototype.keys = function(e) {
			return e === void 0 ? this._keys : (this.individualKeys[e] === void 0 && (this.individualKeys[e] = new l.default(e, this.apiCall)), this.individualKeys[e]);
		}, e.prototype.presets = function(e) {
			return e === void 0 ? this._presets : (this.individualPresets[e] === void 0 && (this.individualPresets[e] = new v.default(e, this.apiCall)), this.individualPresets[e]);
		}, e.prototype.stopwords = function(e) {
			return e === void 0 ? this._stopwords : (this.individualStopwords[e] === void 0 && (this.individualStopwords[e] = new S.default(e, this.apiCall)), this.individualStopwords[e]);
		}, e.prototype.conversations = function(e) {
			return e === void 0 ? this._conversations : (this.individualConversations[e] === void 0 && (this.individualConversations[e] = new w.default(e, this.apiCall)), this.individualConversations[e]);
		}, e.prototype.nlSearchModels = function(e) {
			return e === void 0 ? this._nlSearchModels : (this.individualNLSearchModels[e] === void 0 && (this.individualNLSearchModels[e] = new D.default(e, this.apiCall)), this.individualNLSearchModels[e]);
		}, e.prototype.synonymSets = function(e) {
			return e === void 0 ? this._synonymSets : (this.individualSynonymSets[e] === void 0 && (this.individualSynonymSets[e] = new O.default(e, this.apiCall)), this.individualSynonymSets[e]);
		}, e.prototype.curationSets = function(e) {
			return e === void 0 ? this._curationSets : (this.individualCurationSets[e] === void 0 && (this.individualCurationSets[e] = new A.default(e, this.apiCall)), this.individualCurationSets[e]);
		}, e;
	}();
})), Ol = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.SearchOnlyCollection = void 0;
	var t = Fc();
	e.SearchOnlyCollection = function() {
		function e(e, n, r) {
			this.name = e, this.apiCall = n, this.configuration = r, this._documents = new t.SearchOnlyDocuments(this.name, this.apiCall, this.configuration);
		}
		return e.prototype.documents = function() {
			return this._documents;
		}, e;
	}();
})), kl = /* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	var t = (H(), _(V)), n = t.__importDefault(Dc()), r = t.__importDefault(Mc()), i = t.__importDefault(Qc()), a = Ol();
	e.default = function() {
		function e(e) {
			e.sendApiKeyAsQueryParam = e.sendApiKeyAsQueryParam ?? !0, e.sendApiKeyAsQueryParam === !0 && (e.apiKey || "").length > 2e3 && (console.warn("[typesense] API Key is longer than 2000 characters which is over the allowed limit, so disabling sending it as a query parameter."), e.sendApiKeyAsQueryParam = !1), this.configuration = new n.default(e), this.apiCall = new r.default(this.configuration), this.multiSearch = new i.default(this.apiCall, this.configuration, !0), this.individualCollections = {};
		}
		return e.prototype.clearCache = function() {
			this.multiSearch.clearCache(), Object.entries(this.individualCollections).forEach(function(e) {
				e[0], e[1].documents().clearCache();
			});
		}, e.prototype.collections = function(e) {
			if (e) return this.individualCollections[e] === void 0 && (this.individualCollections[e] = new a.SearchOnlyCollection(e, this.apiCall, this.configuration)), this.individualCollections[e];
			throw Error("Typesense.SearchClient only supports search operations, so the collectionName that needs to be searched must be specified. Use Typesense.Client if you need to access the collection object.");
		}, e;
	}();
})), Al = (/* @__PURE__ */ p(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.Errors = e.SearchClient = e.Client = void 0;
	var t = (H(), _(V)), n = t.__importDefault(Dl());
	e.Client = n.default;
	var r = t.__importDefault(kl());
	e.SearchClient = r.default;
	var i = t.__importStar(Ec());
	e.Errors = i, e.default = {
		Client: n.default,
		SearchClient: r.default,
		Errors: i
	};
})))();
function jl(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function Ml(e, t) {
	if (e == null) return {};
	var n, r, i = jl(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function Nl(e) {
	if (Array.isArray(e)) return e;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function Pl(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t === 0) {
				if (Object(n) !== n) return;
				c = !1;
			} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function Fl(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function Il(e, t) {
	if (e) {
		if (typeof e == "string") return Fl(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Fl(e, t) : void 0;
	}
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function Ll() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function Rl(e, t) {
	return Nl(e) || Pl(e, t) || Il(e, t) || Ll();
}
//#endregion
//#region node_modules/typesense-instantsearch-adapter/lib/SearchRequestAdapter.js
var zl = [
	"q",
	"conversation",
	"conversation_id",
	"conversation_model_id"
], Bl = /*#__PURE__*/ function() {
	function e(t, n, r) {
		ms(this, e), this.instantsearchRequests = t, this.typesenseClient = n, this.configuration = r, this.additionalSearchParameters = r.additionalSearchParameters, this.collectionSpecificSearchParameters = r.collectionSpecificSearchParameters;
	}
	return ys(e, [
		{
			key: "_shouldUseExactMatchForField",
			value: function(e, t) {
				var n, r;
				return !(((n = this.configuration.collectionSpecificFilterByOptions) == null || (n = n[t]) == null || (n = n[e]) == null ? void 0 : n.exactMatch) === !1 || ((r = this.configuration.filterByOptions) == null || (r = r[e]) == null ? void 0 : r.exactMatch) === !1);
			}
		},
		{
			key: "_adaptFacetFilters",
			value: function(e, t) {
				var n = this, r = "";
				return e && (r = e.map(function(e) {
					if (Array.isArray(e)) {
						var r = {};
						e.forEach(function(e) {
							var t = n._parseFacetFilter(e), i = t.fieldName, a = t.fieldValue;
							r[i] = r[i] || [], r[i].push(a);
						}), Object.keys(r).length > 1 && console.error(`[Typesense-Instantsearch-Adapter] Typesense does not support cross-field ORs at the moment. The adapter could not OR values between these fields: ${Object.keys(r).join(",")}`);
						var i = Object.keys(r)[0], a = Rl(r[i].reduce(function(e, t) {
							return t.startsWith("-") && !n._isNumber(t) ? e[0].push(t.substring(1)) : e[1].push(t), e;
						}, [[], []]), 2), o = a[0], s = a[1], c = [];
						if (s.length > 0) {
							var l = n._shouldUseExactMatchForField(i, t) ? ":=" : ":";
							c.push(`${i}${l}[${s.map(function(e) {
								return n._escapeFacetValue(e);
							}).join(",")}]`);
						}
						if (o.length > 0) {
							var u = n._shouldUseExactMatchForField(i, t) ? ":!=" : ":!";
							n.configuration.flipNegativeRefinementOperator ? c.push(`(${o.map(function(e) {
								return `${i}${u}${n._escapeFacetValue(e)}`;
							}).join(" || ")})`) : c.push(`${i}${u}[${o.map(function(e) {
								return n._escapeFacetValue(e);
							}).join(",")}]`);
						}
						return c.filter(function(e) {
							return e;
						}).join(" && ");
					} else {
						var d = n._parseFacetFilter(e), f = d.fieldName, p = d.fieldValue;
						return p.startsWith("-") && !n._isNumber(p) ? `${f}${n._shouldUseExactMatchForField(f, t) ? ":!=" : ":!"}[${n._escapeFacetValue(p.substring(1))}]` : `${f}${n._shouldUseExactMatchForField(f, t) ? ":=" : ":"}[${n._escapeFacetValue(p)}]`;
					}
				}).join(" && ")), r;
			}
		},
		{
			key: "_parseFacetFilter",
			value: function(e) {
				var t, n, r, i;
				if (this.configuration.facetableFieldsWithSpecialCharacters?.length > 0) {
					var a = this.configuration.facetableFieldsWithSpecialCharacters.flat().map(function(e) {
						return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
					});
					if (t = RegExp(`^(${a.join("|")}):(.*)\$`), n = e.match(t), n != null) return r = `${n[1]}`, i = `${n[2]}`, {
						fieldName: r,
						fieldValue: i
					};
				}
				return t = this.constructor.DEFAULT_FACET_FILTER_STRING_MATCHING_REGEX, n = e.match(t), n == null ? console.error(`[Typesense-Instantsearch-Adapter] Parsing failed for a facet filter \`${e}\` with the Regex \`${t}\`. If you have field names with special characters, be sure to add them to a parameter called \`facetableFieldsWithSpecialCharacters\` when instantiating the adapter.`) : (r = `${n[1]}${n[2]}`, i = `${n[3]}`), {
					fieldName: r,
					fieldValue: i
				};
			}
		},
		{
			key: "_escapeFacetValue",
			value: function(e) {
				return typeof e == "boolean" || e === "true" || e === "false" || this._isNumber(e) ? e : `\`${e}\``;
			}
		},
		{
			key: "_isNumber",
			value: function(e) {
				return Number.isInteger(e % 1) || !!(e % 1);
			}
		},
		{
			key: "_adaptNumericFilters",
			value: function(e) {
				var t = this, n = "";
				if (!e) return n;
				var r = {};
				e.forEach(function(e) {
					var n = t._parseNumericFilter(e), i = n.fieldName, a = n.operator, o = n.fieldValue;
					r[i] = r[i] || {}, r[i][a] = o;
				});
				var i = [];
				return Object.keys(r).forEach(function(e) {
					r[e]["<="] != null && r[e][">="] != null ? i.push(`${e}:=[${r[e][">="]}..${r[e]["<="]}]`) : r[e]["<="] == null ? r[e][">="] == null ? r[e]["="] == null ? console.warn(`[Typesense-Instantsearch-Adapter] Unsupported operator found ${JSON.stringify(r[e])}`) : i.push(`${e}:=${r[e]["="]}`) : i.push(`${e}:>=${r[e][">="]}`) : i.push(`${e}:<=${r[e]["<="]}`);
				}), n = i.join(" && "), n;
			}
		},
		{
			key: "_parseNumericFilter",
			value: function(e) {
				var t, n, r, i, a;
				if (this.configuration.facetableFieldsWithSpecialCharacters?.length > 0) {
					var o = this.configuration.facetableFieldsWithSpecialCharacters.map(function(e) {
						return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
					});
					if (t = RegExp(`^(${o.join("|")})(<=|>=|>|<|=)(.*)\$`), n = e.match(t), n != null) {
						var s = Rl(n, 4);
						return r = s[1], i = s[2], a = s[3], {
							fieldName: r,
							operator: i,
							fieldValue: a
						};
					}
				}
				if (t = this.constructor.DEFAULT_NUMERIC_FILTER_STRING_MATCHING_REGEX, n = e.match(t), n == null) console.error(`[Typesense-Instantsearch-Adapter] Parsing failed for a numeric filter \`${e}\` with the Regex \`${t}\`. If you have field names with special characters, be sure to add them to a parameter called \`facetableFieldsWithSpecialCharacters\` when instantiating the adapter.`);
				else {
					var c = Rl(n, 4);
					r = c[1], i = c[2], a = c[3];
				}
				return {
					fieldName: r,
					operator: i,
					fieldValue: a
				};
			}
		},
		{
			key: "_adaptGeoFilter",
			value: function(e) {
				var t = e.insideBoundingBox, n = e.aroundRadius, r = e.aroundLatLng, i = e.insidePolygon;
				if (t) {
					var a, o, s, c;
					if (Array.isArray(t)) {
						var l = Rl(t.flat(), 4);
						a = l[0], o = l[1], s = l[2], c = l[3];
					} else {
						var u = Rl(t.split(","), 4);
						a = u[0], o = u[1], s = u[2], c = u[3];
					}
					return `${this.configuration.geoLocationField}:(${a}, ${o}, ${a}, ${c}, ${s}, ${c}, ${s}, ${o})`;
				}
				if (r || n) {
					if (!n || n === "all") throw Error("[Typesense-Instantsearch-Adapter] In Typesense, geo-filtering around a lat/lng also requires a numerical radius. So the `aroundRadius` parameter is required when `aroundLatLng` is used. If you intend to just geo-sort around a lat/long, you want to use the sortBy InstantSearch widget (or a virtual sortBy custom widget).");
					var d = `${parseFloat(n) / 1e3} km`;
					return `${this.configuration.geoLocationField}:(${r}, ${d})`;
				}
				if (i) {
					var f = i;
					return Array.isArray(i) && (f = i.flat().join(",")), `${this.configuration.geoLocationField}:(${f})`;
				}
			}
		},
		{
			key: "_splitByTopLevelAnd",
			value: function(e) {
				for (var t = [], n = "", r = !1, i = 0; i < e.length; i += 1) {
					var a = e[i], o = e[i + 1];
					if (a === "`" && (r = !r), !r && a === "&" && o === "&") {
						n.trim() !== "" && t.push(n.trim()), n = "", i += 1;
						continue;
					}
					n += a;
				}
				return n.trim() !== "" && t.push(n.trim()), t;
			}
		},
		{
			key: "_splitListValues",
			value: function(e) {
				for (var t = [], n = "", r = !1, i = 0; i < e.length; i += 1) {
					var a = e[i];
					if (a === "`" && (r = !r), !r && a === ",") {
						n.trim() !== "" && t.push(n.trim()), n = "";
						continue;
					}
					n += a;
				}
				return n.trim() !== "" && t.push(n.trim()), t;
			}
		},
		{
			key: "_parseListClause",
			value: function(e) {
				var t = e.trim(), n = t.indexOf("["), r = t.lastIndexOf("]");
				if (n === -1 || r === -1 || r !== t.length - 1) return null;
				var i = t.slice(0, n).trim(), a = t.slice(n + 1, r), o = [
					":!=",
					":=",
					":!",
					":"
				].find(function(e) {
					return i.endsWith(e);
				});
				if (!o) return null;
				var s = i.slice(0, i.length - o.length).trim();
				return s ? {
					fieldName: s,
					operator: o,
					values: this._splitListValues(a)
				} : null;
			}
		},
		{
			key: "_mergeSameFieldExclusionListClauses",
			value: function(e) {
				var t = this;
				if (!e) return e;
				var n = this._splitByTopLevelAnd(e), r = {}, i = [];
				return n.forEach(function(e, n) {
					var a = t._parseListClause(e);
					if (!a) {
						i.push({
							clauseIndex: n,
							clause: e
						});
						return;
					}
					var o = a.operator === ":!" || a.operator === ":!=" ? "exclude" : null;
					if (o == null) {
						i.push({
							clauseIndex: n,
							clause: e
						});
						return;
					}
					var s = `${a.fieldName}|${o}`;
					r[s] || (r[s] = {
						clauseIndex: n,
						fieldName: a.fieldName,
						operator: a.operator,
						normalizedOperator: o,
						values: []
					}), a.values.forEach(function(e) {
						r[s].values.includes(e) || r[s].values.push(e);
					});
				}), Object.values(r).forEach(function(e) {
					i.push({
						clauseIndex: e.clauseIndex,
						clause: `${e.fieldName}${e.operator}[${e.values.join(",")}]`
					});
				}), i.sort(function(e, t) {
					return e.clauseIndex - t.clauseIndex;
				}).map(function(e) {
					return e.clause;
				}).join(" && ");
			}
		},
		{
			key: "_adaptFilters",
			value: function(e, t) {
				var n = [];
				e.filters && n.push(e.filters), n.push(this._adaptFacetFilters(e.facetFilters, t)), n.push(this._adaptNumericFilters(e.numericFilters)), n.push(this._adaptGeoFilter(e));
				var r = n.filter(function(e) {
					return e && e !== "";
				}).join(" && ");
				return this.configuration.flipNegativeRefinementOperator ? this._mergeSameFieldExclusionListClauses(r) : r;
			}
		},
		{
			key: "_adaptIndexName",
			value: function(e) {
				return e.match(this.constructor.INDEX_NAME_MATCHING_REGEX)[1];
			}
		},
		{
			key: "_adaptSortBy",
			value: function(e) {
				return e.match(this.constructor.INDEX_NAME_MATCHING_REGEX)[3];
			}
		},
		{
			key: "_adaptFacetBy",
			value: function(e, t) {
				var n = this;
				return [e].flat().map(function(e) {
					var r;
					return (r = n.configuration.collectionSpecificFacetByOptions) != null && (r = r[t]) != null && r[e] ? `${e}${n.configuration.collectionSpecificFacetByOptions[t][e]}` : n.configuration.facetByOptions[e] ? `${e}${n.configuration.facetByOptions[e]}` : e;
				}).join(",");
			}
		},
		{
			key: "_adaptRulesContextsToOverrideTags",
			value: function(e) {
				return e.join(",");
			}
		},
		{
			key: "_buildSearchParameters",
			value: function(e) {
				for (var t, n = e.params, r = e.indexName, i = this._adaptIndexName(r), a = {}, o = 0, s = Object.entries(this.additionalSearchParameters); o < s.length; o++) {
					var c = Rl(s[o], 2), l = c[0], u = c[1];
					a[this._camelToSnakeCase(l)] = u;
				}
				if (this.collectionSpecificSearchParameters[i]) for (var d = 0, f = Object.entries(this.collectionSpecificSearchParameters[i]); d < f.length; d++) {
					var p = Rl(f[d], 2), m = p[0], h = p[1];
					a[this._camelToSnakeCase(m)] = h;
				}
				var g = Object.assign({}, a), _ = this._adaptSortBy(r);
				if (Object.assign(g, {
					collection: i,
					q: n.query === "" || n.query === void 0 ? "*" : n.query,
					facet_by: a.facet_by || this._adaptFacetBy(n.facets, i),
					filter_by: this._adaptFilters(n, i) || a.filter_by,
					sort_by: _ || a.sort_by,
					max_facet_values: n.maxValuesPerFacet,
					page: (n.page || 0) + 1
				}), n.hitsPerPage != null && (g.per_page = n.hitsPerPage), n.facetQuery && (g.facet_query = `${n.facetName}:${n.facetQuery}`, g.per_page = 0), n.ruleContexts && n.ruleContexts.length > 0) {
					var v = this.configuration.useOverrideTags ? "override_tags" : "curation_tags";
					g[v] = this._adaptRulesContextsToOverrideTags(n.ruleContexts);
				}
				n.typesenseVectorQuery && (g.vector_query = n.typesenseVectorQuery);
				var y = ((t = this.configuration.collectionSpecificSortByOptions) == null || (t = t[i]) == null ? void 0 : t[g.sort_by]) || this.configuration.sortByOptions?.[g.sort_by];
				return y?.enable_overrides != null && (g.enable_overrides = y.enable_overrides), Object.fromEntries(Object.entries(g).filter(function(e) {
					var t = Rl(e, 2);
					t[0];
					var n = t[1];
					return n != null && n !== "";
				}));
			}
		},
		{
			key: "_camelToSnakeCase",
			value: function(e) {
				return e.split(/(?=[A-Z])/).join("_").toLowerCase();
			}
		},
		{
			key: "request",
			value: function() {
				var e = ps(/*#__PURE__*/ As.default.mark(function e() {
					var t = this, n, r, i, a, o, s, c, l;
					return As.default.wrap(function(e) {
						for (;;) switch (e.prev = e.next) {
							case 0: return n = this.instantsearchRequests.map(function(e) {
								return t._buildSearchParameters(e);
							}), r = {}, (n[0]?.conversation === !0 || n[0]?.conversation === "true") && (i = n[0], a = i.q, o = i.conversation, s = i.conversation_id, c = i.conversation_model_id, r = {
								q: a,
								conversation: o,
								conversation_id: s,
								conversation_model_id: c
							}, n = n.map(function(e) {
								return e.q, e.conversation, e.conversation_id, e.conversation_model_id, Ml(e, zl);
							})), l = { searches: n }, this.configuration.union && (l.union = this.configuration.union, [
								"page",
								"per_page",
								"offset",
								"limit",
								"limit_hits"
							].forEach(function(e) {
								n[0][e] != null && (r[e] = n[0][e]);
							})), e.abrupt("return", this.typesenseClient.multiSearch.perform(l, r));
							case 6:
							case "end": return e.stop();
						}
					}, e, this);
				}));
				function t() {
					return e.apply(this, arguments);
				}
				return t;
			}()
		}
	], [
		{
			key: "INDEX_NAME_MATCHING_REGEX",
			get: function() {
				return /* @__PURE__ */ RegExp("^(.+?)(?=(/sort/(.*))|$)");
			}
		},
		{
			key: "DEFAULT_FACET_FILTER_STRING_MATCHING_REGEX",
			get: function() {
				return /* @__PURE__ */ RegExp("(.*)((?!:).):(?!:)(.*)");
			}
		},
		{
			key: "DEFAULT_NUMERIC_FILTER_STRING_MATCHING_REGEX",
			get: function() {
				return /* @__PURE__ */ RegExp("(.*?)(<=|>=|>|<|=)(.*)");
			}
		}
	]);
}();
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function Vl(e) {
	if (Array.isArray(e)) return Fl(e);
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function Hl(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function Ul() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
function Wl(e) {
	return Vl(e) || Hl(e) || Il(e) || Ul();
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/defineProperty.js
function Gl(e, t, n) {
	return (t = _s(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region node_modules/typesense-instantsearch-adapter/lib/support/utils.js
var Kl = {
	_adaptHighlightTag: function(e, t, n) {
		return e.replace(/* @__PURE__ */ RegExp("<mark>", "g"), t || "<mark>").replace(/* @__PURE__ */ RegExp("</mark>", "g"), n || "</mark>");
	},
	_adaptNumberOfPages: function() {
		var e = (this.typesenseResponse.union_request_params ? this.typesenseResponse.union_request_params[0] : this.typesenseResponse.request_params)?.per_page || 10, t = this.typesenseResponse.found / e;
		return Number.isFinite(t) ? Math.ceil(t) : 1;
	}
};
//#endregion
//#region node_modules/typesense-instantsearch-adapter/lib/SearchResponseAdapter.js
function ql(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Jl(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ql(Object(n), !0).forEach(function(t) {
			Gl(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ql(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var Yl = /*#__PURE__*/ function() {
	function e(t, n, r) {
		var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
		ms(this, e), this.typesenseResponse = t, this.instantsearchRequest = n, this.configuration = r, this.allTypesenseResults = i, this.fullTypesenseResponse = a;
	}
	return ys(e, [
		{
			key: "_adaptGroupedHits",
			value: function(e) {
				var t = this, n = [];
				return n = e.map(function(e) {
					var n = t._adaptHits(e.hits);
					return n.forEach(function(t) {
						t.group_key = t._group_key = e.group_key, e.found && (t._group_found = e.found);
					}), n;
				}), n = this.configuration.flattenGroupedHits ? n.flat() : n.map(function(e) {
					return Jl(Jl({}, e[0]), {}, { _grouped_hits: e });
				}), n;
			}
		},
		{
			key: "_adaptHits",
			value: function(e) {
				var t = this, n = [];
				return n = e.map(function(e) {
					var n = Jl({}, e.document);
					n.objectID = e.document.id, n._snippetResult = t._adaptHighlightResult(e, "snippet"), n._highlightResult = t._adaptHighlightResult(e, "value"), n._rawTypesenseHit = e, t.fullTypesenseResponse.conversation && (n._rawTypesenseConversation = t.fullTypesenseResponse.conversation), [
						"text_match",
						"geo_distance_meters",
						"curated",
						"text_match_info",
						"hybrid_search_info",
						"vector_distance",
						"collection",
						"search_index"
					].forEach(function(t) {
						Object.keys(e).includes(t) && !Object.keys(n).includes(t) && (n[t] = e[t]);
					});
					var r = n[t.configuration.geoLocationField];
					return r && (n._geoloc = {
						lat: r[0],
						lng: r[1]
					}), n;
				}), n;
			}
		},
		{
			key: "_adaptHighlightResult",
			value: function(e, t) {
				var n = {};
				return e.highlight != null && this.isHighlightPost0240RCN32Format(e.highlight) ? this.adaptHighlightObject(e, n, t) : this.adaptHighlightsArray(e, n, t), n;
			}
		},
		{
			key: "isHighlightPost0240RCN32Format",
			value: function(e) {
				return e.full == null && e.snippet == null;
			}
		},
		{
			key: "adaptHighlightsArray",
			value: function(e, t, n) {
				var r = this;
				Object.assign.apply(Object, [t].concat(Wl(Object.entries(e.document).map(function(e) {
					var t = Rl(e, 2), n = t[0], r = t[1];
					return Gl({}, n, {
						value: r,
						matchLevel: "none",
						matchedWords: []
					});
				})))), e.highlights.forEach(function(e) {
					t[e.field] = {
						value: e[n] || e[`${n}s`],
						matchLevel: "full",
						matchedWords: e.matched_tokens
					}, e.indices && (t[e.field].matchedIndices = e.indices);
				}), Object.entries(t).forEach(function(i) {
					var a = Rl(i, 2), o = a[0], s = a[1], c = o, l = s.value, u = s.matchLevel, d = s.matchedWords, f = s.matchedIndices;
					l == null ? t[c] = r._adaptHighlightNullValue() : Array.isArray(l) ? (t[c] = [], e.document[c].forEach(function(e, i) {
						f && f.includes(i) ? t[c].push({
							value: r._adaptHighlightTag(`${l[f.indexOf(i)]}`, r.instantsearchRequest.params.highlightPreTag, r.instantsearchRequest.params.highlightPostTag),
							matchLevel: u,
							matchedWords: d[i]
						}) : hs(e) === "object" ? t[c].push(r._adaptHighlightInObjectValue(e, {}, n)) : t[c].push({
							value: `${e}`,
							matchLevel: "none",
							matchedWords: []
						});
					})) : hs(l) === "object" ? t[c] = r._adaptHighlightInObjectValue(l, {}, n) : t[c].value = r._adaptHighlightTag(`${l}`, r.instantsearchRequest.params.highlightPreTag, r.instantsearchRequest.params.highlightPostTag);
				});
			}
		},
		{
			key: "adaptHighlightObject",
			value: function(e, t, n) {
				Object.assign(t, this._adaptHighlightInObjectValue(e.document, e.highlight, n));
			}
		},
		{
			key: "_adaptHighlightInObjectValue",
			value: function(e, t, n) {
				var r = this;
				return Object.assign.apply(Object, [{}].concat(Wl(Object.entries(e).map(function(e) {
					var i = Rl(e, 2), a = i[0], o = i[1];
					return Gl({}, a, o == null ? r._adaptHighlightNullValue() : Array.isArray(o) ? r._adaptHighlightInArrayValue(o, t?.[a] ?? [], n) : hs(o) === "object" ? r._adaptHighlightInObjectValue(o, t?.[a] ?? {}, n) : r._adaptHighlightInPrimitiveValue(o, t?.[a], n));
				}))));
			}
		},
		{
			key: "_adaptHighlightInArrayValue",
			value: function(e, t, n) {
				var r = this;
				return e.map(function(e, i) {
					return e == null ? r._adaptHighlightNullValue() : Array.isArray(e) ? r._adaptHighlightInArrayValue(e, t?.[i] ?? [], n) : hs(e) === "object" ? r._adaptHighlightInObjectValue(e, t?.[i] ?? {}, n) : r._adaptHighlightInPrimitiveValue(e, t?.[i], n);
				});
			}
		},
		{
			key: "_adaptHighlightInPrimitiveValue",
			value: function(e, t, n) {
				if (t != null) {
					var r = t[n] ?? t.highlight ?? t.snippet ?? e;
					return {
						value: this._adaptHighlightTag(`${r}`, this.instantsearchRequest.params.highlightPreTag, this.instantsearchRequest.params.highlightPostTag),
						matchLevel: (t.matched_tokens || []).length > 0 ? "full" : "none",
						matchedWords: t.matched_tokens || []
					};
				} else return {
					value: this._adaptHighlightTag(`${e}`, this.instantsearchRequest.params.highlightPreTag, this.instantsearchRequest.params.highlightPostTag),
					matchLevel: "none",
					matchedWords: []
				};
			}
		},
		{
			key: "_adaptHighlightNullValue",
			value: function() {
				return {
					value: "",
					matchLevel: "none",
					matchedWords: []
				};
			}
		},
		{
			key: "_adaptFacets",
			value: function(e) {
				var t = {};
				return Array.isArray(e) && e.forEach(function(e) {
					Object.assign(t, Gl({}, e.field_name, Object.assign.apply(Object, [{}].concat(Wl(e.counts.map(function(e) {
						return Gl({}, e.value, e.count);
					}))))));
				}), t;
			}
		},
		{
			key: "_adaptFacetStats",
			value: function(e) {
				var t = {};
				return Array.isArray(e) && e.forEach(function(e) {
					e.stats && Object.keys(e.stats).length > 0 && Object.assign(t, Gl({}, e.field_name, e.stats));
				}), t;
			}
		},
		{
			key: "_adaptRenderingContent",
			value: function(e) {
				var t, n = Object.assign({}, this.configuration.renderingContent);
				return ((t = n.facetOrdering) == null || (t = t.facets) == null ? void 0 : t.order) ?? (n.facetOrdering = n.facetOrdering || {}, n.facetOrdering.facets = n.facetOrdering.facets || {}, n.facetOrdering.facets.order = Wl(new Set((Array.isArray(e) ? e : []).map(function(e) {
					return e.field_name;
				}).concat(this.allTypesenseResults.map(function(e) {
					return e.facet_counts || [];
				}).flat().map(function(e) {
					return e.field_name;
				}).filter(function(e) {
					return e;
				}))))), n;
			}
		},
		{
			key: "_adaptUserData",
			value: function(e) {
				return e ? Array.isArray(e) ? e : [e] : [];
			}
		},
		{
			key: "adapt",
			value: function() {
				var e = this._adaptRenderingContent(this.typesenseResponse.facet_counts || []), t = this.typesenseResponse.union_request_params ? this.typesenseResponse.union_request_params[0] : this.typesenseResponse.request_params, n = Jl({
					hits: this.typesenseResponse.grouped_hits ? this._adaptGroupedHits(this.typesenseResponse.grouped_hits) : this._adaptHits(this.typesenseResponse.hits),
					nbHits: this.typesenseResponse.found,
					page: this.typesenseResponse.union_request_params ? this.typesenseResponse.page : this.typesenseResponse.page - 1,
					nbPages: this._adaptNumberOfPages(),
					hitsPerPage: t?.per_page || 10,
					facets: this._adaptFacets(this.typesenseResponse.facet_counts || []),
					facets_stats: this._adaptFacetStats(this.typesenseResponse.facet_counts || []),
					query: t?.q || "",
					processingTimeMS: this.typesenseResponse.search_time_ms
				}, Object.keys(e).length > 0 ? { renderingContent: e } : null);
				return this.typesenseResponse.metadata && (n.appliedRules = ["typesense-override"], n.userData = this._adaptUserData(this.typesenseResponse.metadata)), this.typesenseResponse.parsed_nl_query && (n.parsed_nl_query = this.typesenseResponse.parsed_nl_query), this.fullTypesenseResponse.conversation && n.hits.length === 0 && (n.hits = [{ _rawTypesenseConversation: this.fullTypesenseResponse.conversation }]), n;
			}
		}
	]);
}();
Object.assign(Yl.prototype, Kl);
//#endregion
//#region node_modules/typesense-instantsearch-adapter/lib/FacetSearchResponseAdapter.js
var Xl = /*#__PURE__*/ function() {
	function e(t, n) {
		ms(this, e), this.typesenseResponse = t, this.instantsearchRequest = n;
	}
	return ys(e, [{
		key: "_adaptFacetHits",
		value: function(e) {
			var t = this, n = [], r = e.find(function(e) {
				return e.field_name === t.instantsearchRequest.params.facetName;
			});
			return r !== void 0 && (n = r.counts.map(function(e) {
				return {
					value: e.value,
					highlighted: t._adaptHighlightTag(e.highlighted, t.instantsearchRequest.params.highlightPreTag, t.instantsearchRequest.params.highlightPostTag),
					count: e.count
				};
			})), n;
		}
	}, {
		key: "adapt",
		value: function() {
			return {
				facetHits: this._adaptFacetHits(this.typesenseResponse.facet_counts),
				exhaustiveFacetsCount: !0,
				processingTimeMS: this.typesenseResponse.search_time_ms
			};
		}
	}]);
}();
Object.assign(Xl.prototype, Kl);
//#endregion
//#region node_modules/typesense-instantsearch-adapter/lib/TypesenseInstantsearchAdapter.js
var Zl = /*#__PURE__*/ function() {
	function e(t) {
		var n = this;
		ms(this, e), this.updateConfiguration(t), this.searchClient = {
			clearCache: function() {
				return n.clearCache();
			},
			search: function(e) {
				return n.searchTypesenseAndAdapt(e);
			},
			searchForFacetValues: function(e) {
				return n.searchTypesenseForFacetValuesAndAdapt(e);
			}
		};
	}
	return ys(e, [
		{
			key: "searchTypesenseAndAdapt",
			value: function() {
				var e = ps(/*#__PURE__*/ As.default.mark(function e(t) {
					var n = this, r, i, a, o, s;
					return As.default.wrap(function(e) {
						for (;;) switch (e.prev = e.next) {
							case 0: return e.prev = 0, e.next = 3, this._adaptAndPerformTypesenseRequest(t);
							case 3:
								if (r = e.sent, !r.union_request_params) {
									e.next = 12;
									break;
								}
								return this._validateTypesenseResult(r), i = new Yl(r, t[0], this.configuration, [r], r), a = i.adapt(), o = t.map(function() {
									return a;
								}), e.abrupt("return", { results: o });
							case 12: return s = r.results.map(function(e, i) {
								return n._validateTypesenseResult(e), new Yl(e, t[i], n.configuration, r.results, r).adapt();
							}), e.abrupt("return", { results: s });
							case 14:
								e.next = 20;
								break;
							case 16: throw e.prev = 16, e.t0 = e.catch(0), console.error(e.t0), e.t0;
							case 20:
							case "end": return e.stop();
						}
					}, e, this, [[0, 16]]);
				}));
				function t(t) {
					return e.apply(this, arguments);
				}
				return t;
			}()
		},
		{
			key: "searchTypesenseForFacetValuesAndAdapt",
			value: function() {
				var e = ps(/*#__PURE__*/ As.default.mark(function e(t) {
					var n = this, r, i;
					return As.default.wrap(function(e) {
						for (;;) switch (e.prev = e.next) {
							case 0: return e.prev = 0, e.next = 3, this._adaptAndPerformTypesenseRequest(t);
							case 3: return r = e.sent, i = r.results.map(function(e, r) {
								return n._validateTypesenseResult(e), new Xl(e, t[r], n.configuration).adapt();
							}), e.abrupt("return", i);
							case 8: throw e.prev = 8, e.t0 = e.catch(0), console.error(e.t0), e.t0;
							case 12:
							case "end": return e.stop();
						}
					}, e, this, [[0, 8]]);
				}));
				function t(t) {
					return e.apply(this, arguments);
				}
				return t;
			}()
		},
		{
			key: "_adaptAndPerformTypesenseRequest",
			value: function() {
				var e = ps(/*#__PURE__*/ As.default.mark(function e(t) {
					var n, r;
					return As.default.wrap(function(e) {
						for (;;) switch (e.prev = e.next) {
							case 0: return n = new Bl(t, this.typesenseClient, this.configuration), e.next = 3, n.request();
							case 3: return r = e.sent, e.abrupt("return", r);
							case 5:
							case "end": return e.stop();
						}
					}, e, this);
				}));
				function t(t) {
					return e.apply(this, arguments);
				}
				return t;
			}()
		},
		{
			key: "clearCache",
			value: function() {
				return this.typesenseClient = new Al.SearchClient(this.configuration.server), this.searchClient;
			}
		},
		{
			key: "updateConfiguration",
			value: function(e) {
				return this.configuration = new js(e), this.configuration.validate(), this.typesenseClient = new Al.SearchClient(this.configuration.server), !0;
			}
		},
		{
			key: "_validateTypesenseResult",
			value: function(e) {
				if (e.error) throw Error(`${e.code} - ${e.error}`);
				if (!e.hits && !e.grouped_hits) throw Error(`Did not find any hits. ${e.code} - ${e.error}`);
			}
		}
	]);
}(), Ql = "catalog", $l = "collections", eu = /^_preset:(.+)$/, tu = null;
function nu() {
	let e = new Zl({
		server: {
			apiKey: Go.apiKey,
			nodes: [{
				host: Go.host,
				port: Number(Go.port),
				protocol: Go.protocol
			}]
		},
		collectionSpecificSearchParameters: {
			[Ql]: { preset: Go.preset },
			[$l]: { preset: Go.collectionsPreset }
		},
		flattenGroupedHits: !1
	}), { typesenseClient: t } = e, n = t.multiSearch.perform.bind(t.multiSearch);
	return t.multiSearch.perform = (e, t, r) => {
		let i = {
			...e,
			searches: (e.searches || []).map((e) => {
				if (typeof e.sort_by == "string" && eu.test(e.sort_by)) {
					let [, t] = e.sort_by.match(eu), { sort_by: n, ...r } = e;
					return {
						...r,
						preset: t
					};
				}
				return e;
			})
		};
		return n(i, t, r);
	}, e;
}
function ru() {
	return tu ??= nu(), tu;
}
function iu() {
	return ru().typesenseClient;
}
//#endregion
//#region search.js
async function au(e, { limits: t, signal: n }) {
	let r = e || "*", [i, a] = (await iu().multiSearch.perform({ searches: [{
		preset: Go.preset,
		q: r,
		per_page: t.products,
		group_limit: 1
	}, {
		collection: "collections",
		preset: Go.collectionsPreset,
		q: r,
		per_page: t.collections
	}] }, {}, { abortSignal: n })).results ?? [];
	return {
		products: (i?.grouped_hits ?? []).map((e) => {
			let t = e.hits[0]?.document;
			return t ? {
				product: t,
				variantCount: t.variant_count ?? 1
			} : null;
		}).filter(Boolean),
		productCount: i?.found ?? 0,
		collections: (a?.hits ?? []).map((e) => e.document),
		collectionCount: a?.found ?? 0
	};
}
//#endregion
//#region components/search-component.js
var ou = 200, su = {
	desktop: {
		products: 8,
		collections: 5
	},
	mobile: {
		products: 6,
		collections: 5
	}
};
function cu(e, t) {
	let n;
	return (...r) => new Promise((i) => {
		clearTimeout(n), n = setTimeout(() => i(e(...r)), t);
	});
}
var lu = cu(au, ou), uu = class extends e {
	requiredRefs = [
		"autocompleteContainer",
		"panelContainer",
		"status"
	];
	#e = null;
	#t = !1;
	connectedCallback() {
		super.connectedCallback(), this.#e = Wo({
			container: this.refs.autocompleteContainer,
			panelContainer: this.refs.panelContainer,
			detachedMediaQuery: "none",
			openOnFocus: !0,
			placeholder: B("placeholder"),
			translations: {
				clearButtonTitle: B("clear"),
				submitButtonTitle: B("input_label")
			},
			classNames: {
				root: "kk-search__autocomplete",
				form: "kk-search__form",
				label: "kk-search__label",
				inputWrapperPrefix: "kk-search__input-prefix",
				inputWrapperSuffix: "kk-search__input-suffix",
				inputWrapper: "kk-search__input-wrapper",
				input: "kk-search__input",
				submitButton: "kk-search__submit",
				clearButton: "kk-search__reset",
				loadingIndicator: "kk-search__loading",
				panel: "kk-search__panel",
				panelLayout: "kk-search__panel-layout",
				list: "kk-search__list",
				source: "kk-search__section",
				sourceHeader: "kk-search__section-title-wrapper"
			},
			getSources: async ({ query: e }) => {
				let t = lu(e, { limits: r() ? su.mobile : su.desktop }).then((t) => (this.#o(), this.#t = !1, this.refs.status.textContent = e ? t.productCount > 0 ? B("results_count", {
					count: t.productCount,
					query: e
				}) : B("no_results", { terms: e }) : "", t)).catch((t) => (this.#o(), console.error("[kk-search] search failed", t), this.#t = !0, this.refs.status.textContent = e ? B("error") : "", null));
				return [
					{
						sourceId: "collections",
						getItemUrl: ({ item: e }) => $o(e),
						getItems: async () => {
							let e = await t;
							return e ? e.collections : [];
						},
						templates: {
							item: ({ item: e, html: t }) => os(t, e),
							header: ({ html: e }) => e`<h3 class="kk-search__section-title">${B("collections")}</h3>`
						}
					},
					{
						sourceId: "products",
						getItemUrl: ({ item: e }) => rs(e),
						getItems: async () => {
							let e = await t;
							return e ? ns(e.products) : [];
						},
						templates: {
							item: ({ item: e, html: t }) => as(t, e),
							header: ({ html: e }) => e`<h3 class="kk-search__section-title">${B("products")}</h3>`
						}
					},
					{
						sourceId: "more",
						getItemUrl: () => es(e),
						getItems: async () => {
							let n = await t;
							return n && (n.products.length > 0 || n.collections.length > 0) ? [{ query: e }] : [];
						},
						templates: { item: ({ html: t }) => ss(t, e) }
					}
				];
			},
			renderNoResults: ({ state: e, render: t, html: n }, r) => {
				t(n`<p class="kk-search__message">${this.#t ? B("error") : B("no_results", { terms: e.query })}</p>`, r);
			},
			onStateChange: ({ state: e }) => {
				e.query || (this.refs.status.textContent = "");
			},
			onSubmit: ({ state: e }) => {
				window.location.href = es(e.query);
			}
		});
		let { signal: e } = this.#n, i = this.closest("dialog-component");
		i?.addEventListener(t.eventName, this.#r, { signal: e }), i?.addEventListener(n.eventName, this.#s, { signal: e });
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this.#n.abort(), this.#e?.destroy();
	}
	#n = new AbortController();
	#r = () => {
		this.#o(), this.#e?.setQuery(""), this.#e?.setIsOpen(!1), this.#e?.refresh();
	};
	#i = null;
	#a = () => {
		if (this.#i) return;
		let e = r() ? su.mobile : su.desktop, t = document.createElement("div");
		t.innerHTML = ds(e), this.#i = t.firstElementChild, this.#i && this.refs.panelContainer.append(this.#i);
	};
	#o = () => {
		this.#i?.remove(), this.#i = null;
	};
	#s = () => {
		this.#a(), this.refs.autocompleteContainer.querySelector("input")?.focus();
	};
};
function du() {
	customElements.get("kk-search-component") || customElements.define("kk-search-component", uu);
}
//#endregion
//#region header-shortcut.js
function fu() {
	let e = navigator.userAgentData?.platform ?? navigator.platform ?? navigator.userAgent ?? "";
	return /mac|iphone|ipad|ipod/i.test(e);
}
function pu(e) {
	return (e.metaKey || e.ctrlKey) && !e.altKey && e.key.toLowerCase() === "k";
}
function mu(e) {
	return e.offsetParent !== null;
}
function hu() {
	if (fu()) {
		let e = B("shortcut_command");
		if (e) for (let t of document.querySelectorAll("[data-kk-shortcut]")) t.textContent = e;
	}
	document.addEventListener("keydown", (e) => {
		if (!pu(e)) return;
		let t = [...document.querySelectorAll("[data-kk-header-search], .search-page-input")].find((e) => e instanceof HTMLElement && mu(e));
		if (t) {
			e.preventDefault(), t.scrollIntoView({
				behavior: i() ? "instant" : "smooth",
				block: "center"
			}), t.focus(), t.select?.();
			return;
		}
		let n = document.getElementById("search-modal");
		n instanceof HTMLElement && (customElements.upgrade(n), typeof n.showDialog == "function" && (e.preventDefault(), n.showDialog()));
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index26.js
var gu = "ais", _u = function(e) {
	return function() {
		var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.descendantName, r = t.modifierName;
		return `${gu}-${e}${n ? `-${n}` : ""}${r ? `--${r}` : ""}`;
	};
};
//#endregion
//#region node_modules/@swc/helpers/esm/_array_with_holes.js
function vu(e) {
	if (Array.isArray(e)) return e;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_iterable_to_array_limit.js
function yu(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
//#endregion
//#region node_modules/@swc/helpers/esm/_non_iterable_rest.js
function bu() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
//#endregion
//#region node_modules/@swc/helpers/esm/_array_like_to_array.js
function xu(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_unsupported_iterable_to_array.js
function Su(e, t) {
	if (e) {
		if (typeof e == "string") return xu(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(n);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return xu(e, t);
	}
}
//#endregion
//#region node_modules/@swc/helpers/esm/_sliced_to_array.js
function U(e, t) {
	return vu(e) || yu(e, t) || Su(e, t) || bu();
}
//#endregion
//#region node_modules/@swc/helpers/esm/_array_without_holes.js
function Cu(e) {
	if (Array.isArray(e)) return xu(e);
}
//#endregion
//#region node_modules/@swc/helpers/esm/_iterable_to_array.js
function wu(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
//#endregion
//#region node_modules/@swc/helpers/esm/_non_iterable_spread.js
function Tu() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
//#endregion
//#region node_modules/@swc/helpers/esm/_to_consumable_array.js
function W(e) {
	return Cu(e) || wu(e) || Su(e) || Tu();
}
//#endregion
//#region node_modules/@swc/helpers/esm/_define_property.js
function G(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_extends.js
function Eu() {
	return Eu = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Eu.apply(this, arguments);
}
//#endregion
//#region node_modules/@swc/helpers/esm/_object_destructuring_empty.js
function Du(e) {
	if (e == null) throw TypeError("Cannot destructure " + e);
	return e;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_object_spread.js
function K(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t], r = Object.keys(n);
		typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
			return Object.getOwnPropertyDescriptor(n, e).enumerable;
		}))), r.forEach(function(t) {
			G(e, t, n[t]);
		});
	}
	return e;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_object_spread_props.js
function Ou(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function q(e, t) {
	return t ??= {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ou(Object(t)).forEach(function(n) {
		Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
	}), e;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_type_of.js
function ku(e) {
	"@swc/helpers - typeof";
	return e && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e;
}
//#endregion
//#region node_modules/instantsearch.js/es/index27.js
var Au = {
	highlightPreTag: "<mark>",
	highlightPostTag: "</mark>"
}, ju = Promise.resolve();
function Mu(e) {
	var t = null, n = !1, r = function() {
		var r = [...arguments];
		t === null && (t = ju.then(function() {
			if (t = null, n) {
				n = !1;
				return;
			}
			e.apply(void 0, W(r));
		}));
	};
	return r.wait = function() {
		if (t === null) throw Error("The deferred function should be called before calling `wait()`");
		return t;
	}, r.cancel = function() {
		t !== null && (n = !0);
	}, r;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_instanceof.js
function Nu(e, t) {
	return t != null && typeof Symbol < "u" && t[Symbol.hasInstance] ? !!t[Symbol.hasInstance](e) : e instanceof t;
}
//#endregion
//#region node_modules/instantsearch.js/es/index28.js
function Pu(e, t) {
	return (Array.isArray(t) ? t : t.split(".")).reduce(function(e, t) {
		return e && e[t];
	}, e);
}
//#endregion
//#region node_modules/@swc/helpers/esm/_object_without_properties_loose.js
function Fu(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.getOwnPropertyNames(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (n[i] = e[i]);
	return n;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_object_without_properties.js
function J(e, t) {
	if (e == null) return {};
	var n = {}, r, i, a;
	if (typeof Reflect < "u" && Reflect.ownKeys) {
		for (r = Reflect.ownKeys(e), a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (n[i] = e[i]);
		return n;
	}
	if (n = Fu(e, t), Object.getOwnPropertySymbols) for (r = Object.getOwnPropertySymbols(e), a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (n[i] = e[i]);
	return n;
}
//#endregion
//#region node_modules/instantsearch.js/es/index2.js
var Iu = _u("Highlight");
function Lu(e) {
	var t = e.attribute, n = e.highlightedTagName, r = n === void 0 ? "mark" : n, i = e.hit, a = e.cssClasses, o = a === void 0 ? {} : a, s = (Pu(i._highlightResult, t) || {}).value, c = s === void 0 ? "" : s, l = Iu({ descendantName: "highlighted" }) + (o.highlighted ? ` ${o.highlighted}` : "");
	return c.replace(new RegExp(Au.highlightPreTag, "g"), `<${r} class="${l}">`).replace(new RegExp(Au.highlightPostTag, "g"), `</${r}>`);
}
//#endregion
//#region node_modules/instantsearch.js/es/index29.js
function Ru(e) {
	var t = Au.highlightPreTag, n = Au.highlightPostTag;
	return e.map(function(e) {
		return e.isHighlighted ? t + e.value + n : e.value;
	}).join("");
}
//#endregion
//#region node_modules/instantsearch.js/es/index30.js
function zu(e) {
	var t = Au.highlightPostTag, n = Au.highlightPreTag, r = e.split(n), i = r.shift(), a = i ? [{
		value: i,
		isHighlighted: !1
	}] : [];
	return r.forEach(function(e) {
		var n = e.split(t);
		a.push({
			value: n[0],
			isHighlighted: !0
		}), n[1] !== "" && a.push({
			value: n[1],
			isHighlighted: !1
		});
	}), a;
}
//#endregion
//#region node_modules/instantsearch.js/es/index37.js
var Bu = {
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": "\"",
	"&#39;": "'"
}, Vu = /&(amp|quot|lt|gt|#39);/g, Hu = RegExp(Vu.source);
function Uu(e) {
	return e && Hu.test(e) ? e.replace(Vu, function(e) {
		return Bu[e];
	}) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/index42.js
var Wu = /* @__PURE__ */ new RegExp(/\w/i);
function Gu(e, t) {
	var n = e[t], r = e[t + 1]?.isHighlighted ?? !0, i = e[t - 1]?.isHighlighted ?? !0;
	return !Wu.test(Uu(n.value)) && i === r ? i : n.isHighlighted;
}
//#endregion
//#region node_modules/instantsearch.js/es/index31.js
function Ku(e) {
	return e.some(function(e) {
		return e.isHighlighted;
	}) ? e.map(function(t, n) {
		return q(K({}, t), { isHighlighted: !Gu(e, n) });
	}) : e.map(function(e) {
		return q(K({}, e), { isHighlighted: !1 });
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index3.js
var qu = _u("ReverseHighlight");
function Ju(e) {
	var t = e.attribute, n = e.highlightedTagName, r = n === void 0 ? "mark" : n, i = e.hit, a = e.cssClasses, o = a === void 0 ? {} : a, s = (Pu(i._highlightResult, t) || {}).value, c = s === void 0 ? "" : s, l = qu({ descendantName: "highlighted" }) + (o.highlighted ? ` ${o.highlighted}` : "");
	return Ru(Ku(zu(c))).replace(new RegExp(Au.highlightPreTag, "g"), `<${r} class="${l}">`).replace(new RegExp(Au.highlightPostTag, "g"), `</${r}>`);
}
//#endregion
//#region node_modules/instantsearch.js/es/index4.js
var Yu = _u("Snippet");
function Xu(e) {
	var t = e.attribute, n = e.highlightedTagName, r = n === void 0 ? "mark" : n, i = e.hit, a = e.cssClasses, o = a === void 0 ? {} : a, s = (Pu(i._snippetResult, t) || {}).value, c = s === void 0 ? "" : s, l = Yu({ descendantName: "highlighted" }) + (o.highlighted ? ` ${o.highlighted}` : "");
	return c.replace(new RegExp(Au.highlightPreTag, "g"), `<${r} class="${l}">`).replace(new RegExp(Au.highlightPostTag, "g"), `</${r}>`);
}
//#endregion
//#region node_modules/instantsearch.js/es/index5.js
var Zu = _u("ReverseSnippet");
function Qu(e) {
	var t = e.attribute, n = e.highlightedTagName, r = n === void 0 ? "mark" : n, i = e.hit, a = e.cssClasses, o = a === void 0 ? {} : a, s = (Pu(i._snippetResult, t) || {}).value, c = s === void 0 ? "" : s, l = Zu({ descendantName: "highlighted" }) + (o.highlighted ? ` ${o.highlighted}` : "");
	return Ru(Ku(zu(c))).replace(new RegExp(Au.highlightPreTag, "g"), `<${r} class="${l}">`).replace(new RegExp(Au.highlightPostTag, "g"), `</${r}>`);
}
//#endregion
//#region node_modules/instantsearch.js/es/index32.js
function $u(e) {
	return btoa(encodeURIComponent(JSON.stringify(e)));
}
//#endregion
//#region node_modules/instantsearch.js/es/index33.js
function ed() {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
		var t = Math.random() * 16 | 0;
		return (e === "x" ? t : t & 3 | 8).toString(16);
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index6.js
var td = "ais.usage.sessionId", nd = null;
function rd() {
	if (nd) return nd;
	try {
		var e = sessionStorage.getItem(td);
		return e ? (nd = e, nd) : (nd = ed(), sessionStorage.setItem(td, nd), nd);
	} catch {
		return nd = ed(), nd;
	}
}
function id(e) {
	var t = e.method, n = e.payload;
	if ((n === void 0 ? "undefined" : ku(n)) !== "object") throw Error("The insights helper expects the payload to be an object.");
	var r;
	try {
		r = $u(n);
	} catch {
		throw Error("Could not JSON serialize the payload object.");
	}
	return `data-insights-method="${t}" data-insights-payload="${r}"`;
}
function ad(e, t) {
	return id({
		method: e,
		payload: t
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index7.js
var od = "_ALGOLIA";
function sd(e) {
	if (!((typeof document > "u" ? "undefined" : ku(document)) !== "object" || typeof document.cookie != "string")) for (var t = `${e}=`, n = document.cookie.split(";"), r = 0; r < n.length; r++) {
		for (var i = n[r]; i.charAt(0) === " ";) i = i.substring(1);
		if (i.indexOf(t) === 0) return i.substring(t.length, i.length);
	}
}
function cd() {
	return sd(od);
}
function ld() {
	return cd();
}
//#endregion
//#region node_modules/instantsearch.js/es/index34.js
function ud(e) {
	return e !== Object(e);
}
function dd(e, t) {
	if (e === t) return !0;
	if (ud(e) || ud(t) || typeof e == "function" || typeof t == "function") return e === t;
	if (Object.keys(e).length !== Object.keys(t).length) return !1;
	var n = !0, r = !1, i = void 0;
	try {
		for (var a = Object.keys(e)[Symbol.iterator](), o; !(n = (o = a.next()).done); n = !0) {
			var s = o.value;
			if (!(s in t) || !dd(e[s], t[s])) return !1;
		}
	} catch (e) {
		r = !0, i = e;
	} finally {
		try {
			!n && a.return != null && a.return();
		} finally {
			if (r) throw i;
		}
	}
	return !0;
}
//#endregion
//#region node_modules/instantsearch.js/es/index35.js
function fd(e) {
	var t = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { fallback: function() {} }).fallback;
	return typeof window > "u" ? t() : e({ window });
}
//#endregion
//#region node_modules/instantsearch.js/es/index8.js
function pd(e) {
	var t = e || {};
	return t.page, J(t, ["page"]);
}
function md() {
	var e = ["ais.infiniteHits", (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).key].filter(Boolean).join(":");
	return {
		read: function(t) {
			var n = t.state, r = fd(function(e) {
				return e.window.sessionStorage;
			});
			if (!r) return null;
			try {
				var i = JSON.parse(r.getItem(e));
				return i && dd(i.state, pd(n)) ? i.hits : null;
			} catch (t) {
				if (Nu(t, SyntaxError)) try {
					r.removeItem(e);
				} catch {}
				return null;
			}
		},
		write: function(t) {
			var n = t.state, r = t.hits, i = fd(function(e) {
				return e.window.sessionStorage;
			});
			if (i) try {
				i.setItem(e, JSON.stringify({
					state: pd(n),
					hits: r
				}));
			} catch {}
		}
	};
}
//#endregion
//#region node_modules/@swc/helpers/esm/_get_prototype_of.js
function hd(e) {
	return hd = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
		return e.__proto__ || Object.getPrototypeOf(e);
	}, hd(e);
}
//#endregion
//#region node_modules/@swc/helpers/esm/_is_native_reflect_construct.js
function gd() {
	try {
		var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch {}
	return (gd = function() {
		return !!e;
	})();
}
//#endregion
//#region node_modules/@swc/helpers/esm/_assert_this_initialized.js
function _d(e) {
	if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
	return e;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_possible_constructor_return.js
function vd(e, t) {
	return t && (ku(t) === "object" || typeof t == "function") ? t : _d(e);
}
//#endregion
//#region node_modules/@swc/helpers/esm/_call_super.js
function yd(e, t, n) {
	return t = hd(t), vd(e, gd() ? Reflect.construct(t, n || [], hd(e).constructor) : t.apply(e, n));
}
//#endregion
//#region node_modules/@swc/helpers/esm/_class_call_check.js
function bd(e, t) {
	if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
//#endregion
//#region node_modules/@swc/helpers/esm/_create_class.js
function xd(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
	}
}
function Sd(e, t, n) {
	return t && xd(e.prototype, t), n && xd(e, n), e;
}
//#endregion
//#region node_modules/@swc/helpers/esm/_set_prototype_of.js
function Cd(e, t) {
	return Cd = Object.setPrototypeOf || function(e, t) {
		return e.__proto__ = t, e;
	}, Cd(e, t);
}
//#endregion
//#region node_modules/@swc/helpers/esm/_inherits.js
function wd(e, t) {
	if (typeof t != "function" && t !== null) throw TypeError("Super expression must either be null or a function");
	e.prototype = Object.create(t && t.prototype, { constructor: {
		value: e,
		writable: !0,
		configurable: !0
	} }), t && Cd(e, t);
}
//#endregion
//#region node_modules/@algolia/events/events.js
var Td = /* @__PURE__ */ p(((e, t) => {
	function n() {
		this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
	}
	t.exports = n, n.prototype._events = void 0, n.prototype._maxListeners = void 0, n.defaultMaxListeners = 10, n.prototype.setMaxListeners = function(e) {
		if (!i(e) || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
		return this._maxListeners = e, this;
	}, n.prototype.emit = function(e) {
		var t, n, i, s, c, l;
		if (this._events ||= {}, e === "error" && (!this._events.error || a(this._events.error) && !this._events.error.length)) {
			if (t = arguments[1], t instanceof Error) throw t;
			var u = /* @__PURE__ */ Error("Uncaught, unspecified \"error\" event. (" + t + ")");
			throw u.context = t, u;
		}
		if (n = this._events[e], o(n)) return !1;
		if (r(n)) switch (arguments.length) {
			case 1:
				n.call(this);
				break;
			case 2:
				n.call(this, arguments[1]);
				break;
			case 3:
				n.call(this, arguments[1], arguments[2]);
				break;
			default: s = Array.prototype.slice.call(arguments, 1), n.apply(this, s);
		}
		else if (a(n)) for (s = Array.prototype.slice.call(arguments, 1), l = n.slice(), i = l.length, c = 0; c < i; c++) l[c].apply(this, s);
		return !0;
	}, n.prototype.addListener = function(e, t) {
		var i;
		if (!r(t)) throw TypeError("listener must be a function");
		return this._events ||= {}, this._events.newListener && this.emit("newListener", e, r(t.listener) ? t.listener : t), this._events[e] ? a(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, a(this._events[e]) && !this._events[e].warned && (i = o(this._maxListeners) ? n.defaultMaxListeners : this._maxListeners, i && i > 0 && this._events[e].length > i && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), typeof console.trace == "function" && console.trace())), this;
	}, n.prototype.on = n.prototype.addListener, n.prototype.once = function(e, t) {
		if (!r(t)) throw TypeError("listener must be a function");
		var n = !1;
		function i() {
			this.removeListener(e, i), n || (n = !0, t.apply(this, arguments));
		}
		return i.listener = t, this.on(e, i), this;
	}, n.prototype.removeListener = function(e, t) {
		var n, i, o, s;
		if (!r(t)) throw TypeError("listener must be a function");
		if (!this._events || !this._events[e]) return this;
		if (n = this._events[e], o = n.length, i = -1, n === t || r(n.listener) && n.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);
		else if (a(n)) {
			for (s = o; s-- > 0;) if (n[s] === t || n[s].listener && n[s].listener === t) {
				i = s;
				break;
			}
			if (i < 0) return this;
			n.length === 1 ? (n.length = 0, delete this._events[e]) : n.splice(i, 1), this._events.removeListener && this.emit("removeListener", e, t);
		}
		return this;
	}, n.prototype.removeAllListeners = function(e) {
		var t, n;
		if (!this._events) return this;
		if (!this._events.removeListener) return arguments.length === 0 ? this._events = {} : this._events[e] && delete this._events[e], this;
		if (arguments.length === 0) {
			for (t in this._events) t !== "removeListener" && this.removeAllListeners(t);
			return this.removeAllListeners("removeListener"), this._events = {}, this;
		}
		if (n = this._events[e], r(n)) this.removeListener(e, n);
		else if (n) for (; n.length;) this.removeListener(e, n[n.length - 1]);
		return delete this._events[e], this;
	}, n.prototype.listeners = function(e) {
		return !this._events || !this._events[e] ? [] : r(this._events[e]) ? [this._events[e]] : this._events[e].slice();
	}, n.prototype.listenerCount = function(e) {
		if (this._events) {
			var t = this._events[e];
			if (r(t)) return 1;
			if (t) return t.length;
		}
		return 0;
	}, n.listenerCount = function(e, t) {
		return e.listenerCount(t);
	};
	function r(e) {
		return typeof e == "function";
	}
	function i(e) {
		return typeof e == "number";
	}
	function a(e) {
		return typeof e == "object" && !!e;
	}
	function o(e) {
		return e === void 0;
	}
})), Ed = /* @__PURE__ */ p(((e, t) => {
	function n(e, t) {
		e.prototype = Object.create(t.prototype, { constructor: {
			value: e,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} });
	}
	t.exports = n;
})), Dd = /* @__PURE__ */ p(((e, t) => {
	var n = Td(), r = Ed();
	function i(e, t, n) {
		this.main = e, this.fn = t, this.recommendFn = n, this.lastResults = null, this.lastRecommendResults = null;
	}
	r(i, n), i.prototype.detach = function() {
		this.removeAllListeners(), this.main.detachDerivedHelper(this);
	}, i.prototype.getModifiedState = function(e) {
		return this.fn(e);
	}, i.prototype.getModifiedRecommendState = function(e) {
		return this.recommendFn(e);
	}, t.exports = i;
})), Od = /* @__PURE__ */ p(((e, t) => {
	function n(e) {
		return typeof e == "string" ? String(e).replace(/^-/, "\\-") : e;
	}
	function r(e) {
		return typeof e == "string" ? e.replace(/^\\-/, "-") : e;
	}
	t.exports = {
		escapeFacetValue: n,
		unescapeFacetValue: r
	};
})), kd = /* @__PURE__ */ p(((e, t) => {
	function n(e) {
		return typeof e == "object" && e ? i(Array.isArray(e) ? [] : {}, e) : e;
	}
	function r(e) {
		return typeof e == "function" || Array.isArray(e) || Object.prototype.toString.call(e) === "[object Object]";
	}
	function i(e, t) {
		if (e === t) return e;
		for (var a in t) if (!(!Object.prototype.hasOwnProperty.call(t, a) || a === "__proto__" || a === "constructor")) {
			var o = t[a], s = e[a];
			s !== void 0 && o === void 0 || (r(s) && r(o) ? e[a] = i(s, o) : e[a] = n(o));
		}
		return e;
	}
	function a(e) {
		r(e) || (e = {});
		for (var t = 1, n = arguments.length; t < n; t++) {
			var a = arguments[t];
			r(a) && i(e, a);
		}
		return e;
	}
	t.exports = a;
})), Ad = /* @__PURE__ */ p(((e, t) => {
	function n(e) {
		return e && Object.keys(e).length > 0;
	}
	t.exports = n;
})), jd = /* @__PURE__ */ p(((e, t) => {
	function n(e, t) {
		if (e === null) return {};
		var n = {}, r = Object.keys(e), i, a;
		for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
		return n;
	}
	t.exports = n;
})), Md = /* @__PURE__ */ p(((e, t) => {
	function n(e) {
		e ||= {}, this.params = e.params || [];
	}
	n.prototype = {
		constructor: n,
		addParams: function(e) {
			var t = this.params.slice();
			return t.push(e), new n({ params: t });
		},
		removeParams: function(e) {
			return new n({ params: this.params.filter(function(t) {
				return t.$$id !== e;
			}) });
		},
		addFrequentlyBoughtTogether: function(e) {
			return this.addParams(Object.assign({}, e, { model: "bought-together" }));
		},
		addRelatedProducts: function(e) {
			return this.addParams(Object.assign({}, e, { model: "related-products" }));
		},
		addTrendingItems: function(e) {
			return this.addParams(Object.assign({}, e, { model: "trending-items" }));
		},
		addTrendingFacets: function(e) {
			return this.addParams(Object.assign({}, e, { model: "trending-facets" }));
		},
		addLookingSimilar: function(e) {
			return this.addParams(Object.assign({}, e, { model: "looking-similar" }));
		},
		_buildQueries: function(e, t) {
			return this.params.filter(function(e) {
				return t[e.$$id] === void 0;
			}).map(function(t) {
				var n = Object.assign({}, t, {
					indexName: e,
					threshold: t.threshold || 0
				});
				return delete n.$$id, n;
			});
		}
	}, t.exports = n;
})), Nd = /* @__PURE__ */ p(((e, t) => {
	function n(e, t) {
		this._state = e, this._rawResults = {};
		var n = this;
		e.params.forEach(function(e) {
			var r = e.$$id;
			n[r] = t[r], n._rawResults[r] = t[r];
		});
	}
	n.prototype = { constructor: n }, t.exports = n;
})), Pd = /* @__PURE__ */ p(((e, t) => {
	var n = kd();
	function r(e) {
		return Object.keys(e).sort().reduce(function(t, n) {
			return t[n] = e[n], t;
		}, {});
	}
	var i = {
		_getQueries: function(e, t) {
			var n = [];
			return n.push({
				indexName: e,
				params: i._getHitsSearchParams(t)
			}), t.getRefinedDisjunctiveFacets().forEach(function(r) {
				n.push({
					indexName: e,
					params: i._getDisjunctiveFacetSearchParams(t, r)
				});
			}), t.getRefinedHierarchicalFacets().forEach(function(r) {
				var a = t.getHierarchicalFacetByName(r), o = t.getHierarchicalRefinement(r), s = t._getHierarchicalFacetSeparator(a);
				if (o.length > 0 && o[0].split(s).length > 1) {
					var c = o[0].split(s).slice(0, -1).reduce(function(e, t, n) {
						return e.concat({
							attribute: a.attributes[n],
							value: n === 0 ? t : [e[e.length - 1].value, t].join(s)
						});
					}, []);
					c.forEach(function(r, o) {
						var s = i._getDisjunctiveFacetSearchParams(t, r.attribute, o === 0);
						function l(e) {
							return a.attributes.some(function(t) {
								return t === e.split(":")[0];
							});
						}
						var u = (s.facetFilters || []).reduce(function(e, t) {
							if (Array.isArray(t)) {
								var n = t.filter(function(e) {
									return !l(e);
								});
								n.length > 0 && e.push(n);
							}
							return typeof t == "string" && !l(t) && e.push(t), e;
						}, []), d = c[o - 1];
						o > 0 ? s.facetFilters = u.concat(d.attribute + ":" + d.value) : u.length > 0 ? s.facetFilters = u : delete s.facetFilters, n.push({
							indexName: e,
							params: s
						});
					});
				}
			}), n;
		},
		_getCompositionQueries: function(e) {
			return [{
				compositionID: e.index,
				requestBody: { params: i._getCompositionHitsSearchParams(e) }
			}];
		},
		_getHitsSearchParams: function(e) {
			var t = e.facets.concat(e.disjunctiveFacets).concat(i._getHitsHierarchicalFacetsAttributes(e)).sort(), a = i._getFacetFilters(e), o = i._getNumericFilters(e), s = i._getTagFilters(e), c = {};
			return t.length > 0 && (c.facets = t.indexOf("*") > -1 ? ["*"] : t), s.length > 0 && (c.tagFilters = s), a.length > 0 && (c.facetFilters = a), o.length > 0 && (c.numericFilters = o), r(n({}, e.getQueryParams(), c));
		},
		_getCompositionHitsSearchParams: function(e) {
			var t = e.facets.concat(e.disjunctiveFacets.map(function(t) {
				return e.disjunctiveFacetsRefinements && e.disjunctiveFacetsRefinements[t] && e.disjunctiveFacetsRefinements[t].length > 0 ? "disjunctive(" + t + ")" : t;
			})).concat(i._getHitsHierarchicalFacetsAttributes(e)).sort(), a = i._getFacetFilters(e), o = i._getNumericFilters(e), s = i._getTagFilters(e), c = {};
			t.length > 0 && (c.facets = t.indexOf("*") > -1 ? ["*"] : t), s.length > 0 && (c.tagFilters = s), a.length > 0 && (c.facetFilters = a), o.length > 0 && (c.numericFilters = o);
			var l = e.getQueryParams();
			return delete l.highlightPreTag, delete l.highlightPostTag, delete l.index, r(n({}, l, c));
		},
		_getDisjunctiveFacetSearchParams: function(e, t, a) {
			var o = i._getFacetFilters(e, t, a), s = i._getNumericFilters(e, t), c = i._getTagFilters(e), l = {
				hitsPerPage: 0,
				page: 0,
				analytics: !1,
				clickAnalytics: !1
			};
			c.length > 0 && (l.tagFilters = c);
			var u = e.getHierarchicalFacetByName(t);
			return u ? l.facets = i._getDisjunctiveHierarchicalFacetAttribute(e, u, a) : l.facets = t, s.length > 0 && (l.numericFilters = s), o.length > 0 && (l.facetFilters = o), r(n({}, e.getQueryParams(), l));
		},
		_getNumericFilters: function(e, t) {
			if (e.numericFilters) return e.numericFilters;
			var n = [];
			return Object.keys(e.numericRefinements).forEach(function(r) {
				var i = e.numericRefinements[r] || {};
				Object.keys(i).forEach(function(e) {
					var a = i[e] || [];
					t !== r && a.forEach(function(t) {
						if (Array.isArray(t)) {
							var i = t.map(function(t) {
								return r + e + t;
							});
							n.push(i);
						} else n.push(r + e + t);
					});
				});
			}), n;
		},
		_getTagFilters: function(e) {
			return e.tagFilters ? e.tagFilters : e.tagRefinements.join(",");
		},
		_getFacetFilters: function(e, t, n) {
			var r = [], i = e.facetsRefinements || {};
			Object.keys(i).sort().forEach(function(e) {
				(i[e] || []).slice().sort().forEach(function(t) {
					r.push(e + ":" + t);
				});
			});
			var a = e.facetsExcludes || {};
			Object.keys(a).sort().forEach(function(e) {
				(a[e] || []).sort().forEach(function(t) {
					r.push(e + ":-" + t);
				});
			});
			var o = e.disjunctiveFacetsRefinements || {};
			Object.keys(o).sort().forEach(function(e) {
				var n = o[e] || [];
				if (!(e === t || !n || n.length === 0)) {
					var i = [];
					n.slice().sort().forEach(function(t) {
						i.push(e + ":" + t);
					}), r.push(i);
				}
			});
			var s = e.hierarchicalFacetsRefinements || {};
			return Object.keys(s).sort().forEach(function(i) {
				var a = (s[i] || [])[0];
				if (a !== void 0) {
					var o = e.getHierarchicalFacetByName(i), c = e._getHierarchicalFacetSeparator(o), l = e._getHierarchicalRootPath(o), u, d;
					if (t === i) {
						if (a.indexOf(c) === -1 || !l && n === !0 || l && l.split(c).length === a.split(c).length) return;
						l ? (d = l.split(c).length - 1, a = l) : (d = a.split(c).length - 2, a = a.slice(0, a.lastIndexOf(c))), u = o.attributes[d];
					} else d = a.split(c).length - 1, u = o.attributes[d];
					u && r.push([u + ":" + a]);
				}
			}), r;
		},
		_getHitsHierarchicalFacetsAttributes: function(e) {
			return e.hierarchicalFacets.reduce(function(t, n) {
				var r = e.getHierarchicalRefinement(n.name)[0];
				if (!r) return t.push(n.attributes[0]), t;
				var i = e._getHierarchicalFacetSeparator(n), a = r.split(i).length, o = n.attributes.slice(0, a + 1);
				return t.concat(o);
			}, []);
		},
		_getDisjunctiveHierarchicalFacetAttribute: function(e, t, n) {
			var r = e._getHierarchicalFacetSeparator(t);
			if (n === !0) {
				var i = e._getHierarchicalRootPath(t), a = 0;
				return i && (a = i.split(r).length), [t.attributes[a]];
			}
			var o = (e.getHierarchicalRefinement(t.name)[0] || "").split(r).length - 1;
			return t.attributes.slice(0, o + 1);
		},
		getSearchForFacetQuery: function(e, t, a, o) {
			var s = o.isDisjunctiveFacet(e) ? o.clearRefinements(e) : o, c = {
				facetQuery: t,
				facetName: e
			};
			return typeof a == "number" && (c.maxFacetHits = a), r(n({}, i._getHitsSearchParams(s), c));
		}
	};
	t.exports = i;
})), Fd = /* @__PURE__ */ p(((e, t) => {
	t.exports = function() {
		return Array.prototype.slice.call(arguments).reduceRight(function(e, t) {
			return Object.keys(Object(t)).forEach(function(n) {
				t[n] !== void 0 && (e[n] !== void 0 && delete e[n], e[n] = t[n]);
			}), e;
		}, {});
	};
})), Id = /* @__PURE__ */ p(((e, t) => {
	t.exports = function(e, t) {
		if (Array.isArray(e)) {
			for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
		}
	};
})), Ld = /* @__PURE__ */ p(((e, t) => {
	function n(e, t) {
		return e.filter(function(n, r) {
			return t.indexOf(n) > -1 && e.indexOf(n) === r;
		});
	}
	t.exports = n;
})), Rd = /* @__PURE__ */ p(((e, t) => {
	function n(e) {
		if (typeof e == "number") return e;
		if (typeof e == "string") return parseFloat(e);
		if (Array.isArray(e)) return e.map(n);
		throw Error("The value should be a number, a parsable string or an array of those.");
	}
	t.exports = n;
})), zd = /* @__PURE__ */ p(((e, t) => {
	t.exports = function(e) {
		return e !== null && /^[a-zA-Z0-9_-]{1,64}$/.test(e);
	};
})), Bd = /* @__PURE__ */ p(((e, t) => {
	var n = Fd(), r = Ad(), i = jd(), a = {
		addRefinement: function(e, t, r) {
			if (a.isRefined(e, t, r)) return e;
			var i = "" + r, o = e[t] ? e[t].concat(i) : [i], s = {};
			return s[t] = o, n(s, e);
		},
		removeRefinement: function(e, t, n) {
			if (n === void 0) return a.clearRefinement(e, function(e, n) {
				return t === n;
			});
			var r = "" + n;
			return a.clearRefinement(e, function(e, n) {
				return t === n && r === e;
			});
		},
		toggleRefinement: function(e, t, n) {
			if (n === void 0) throw Error("toggleRefinement should be used with a value");
			return a.isRefined(e, t, n) ? a.removeRefinement(e, t, n) : a.addRefinement(e, t, n);
		},
		clearRefinement: function(e, t, n) {
			if (t === void 0) return r(e) ? {} : e;
			if (typeof t == "string") return i(e, [t]);
			if (typeof t == "function") {
				var a = !1, o = Object.keys(e).reduce(function(r, i) {
					var o = e[i] || [], s = o.filter(function(e) {
						return !t(e, i, n);
					});
					return s.length !== o.length && (a = !0), r[i] = s, r;
				}, {});
				return a ? o : e;
			}
		},
		isRefined: function(e, t, n) {
			var r = !!e[t] && e[t].length > 0;
			if (n === void 0 || !r) return r;
			var i = "" + n;
			return e[t].indexOf(i) !== -1;
		}
	};
	t.exports = a;
})), Vd = /* @__PURE__ */ p(((e, t) => {
	var n = Fd(), r = Id(), i = Ld(), a = kd(), o = Ad(), s = jd(), c = Rd(), l = zd(), u = Bd();
	function d(e, t) {
		return Array.isArray(e) && Array.isArray(t) ? e.length === t.length && e.every(function(e, n) {
			return d(t[n], e);
		}) : e === t;
	}
	function f(e, t) {
		return r(e, function(e) {
			return d(e, t);
		});
	}
	function p(e) {
		var t = e ? p._parseNumbers(e) : {};
		t.userToken !== void 0 && !l(t.userToken) && console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}"), this.facets = t.facets || [], this.disjunctiveFacets = t.disjunctiveFacets || [], this.hierarchicalFacets = t.hierarchicalFacets || [], this.facetsRefinements = t.facetsRefinements || {}, this.facetsExcludes = t.facetsExcludes || {}, this.disjunctiveFacetsRefinements = t.disjunctiveFacetsRefinements || {}, this.numericRefinements = t.numericRefinements || {}, this.tagRefinements = t.tagRefinements || [], this.hierarchicalFacetsRefinements = t.hierarchicalFacetsRefinements || {};
		var n = this;
		Object.keys(t).forEach(function(e) {
			var r = p.PARAMETERS.indexOf(e) !== -1, i = t[e] !== void 0;
			!r && i && (n[e] = t[e]);
		});
	}
	p.PARAMETERS = Object.keys(new p());
	function m(e) {
		var t = parseFloat(e);
		return isFinite(t) ? t : null;
	}
	p._parseNumbers = function(e) {
		if (e instanceof p) return e;
		var t = {};
		if ([
			"aroundPrecision",
			"aroundRadius",
			"getRankingInfo",
			"minWordSizefor2Typos",
			"minWordSizefor1Typo",
			"page",
			"maxValuesPerFacet",
			"distinct",
			"minimumAroundRadius",
			"hitsPerPage",
			"minProximity"
		].forEach(function(n) {
			var r = e[n];
			if (typeof r == "string") {
				var i = parseFloat(r);
				isNaN(i) ? t[n] = r : isFinite(i) ? t[n] = i : t[n] = null;
			} else typeof r == "number" && !isFinite(r) && (t[n] = null);
		}), Array.isArray(e.insideBoundingBox) && (t.insideBoundingBox = e.insideBoundingBox.map(function(e) {
			return Array.isArray(e) ? e.map(function(e) {
				return typeof e == "string" ? m(e) : typeof e == "number" && !isFinite(e) ? null : e;
			}) : e;
		})), e.numericRefinements) {
			var n = {};
			Object.keys(e.numericRefinements).forEach(function(t) {
				var r = e.numericRefinements[t] || {};
				n[t] = {}, Object.keys(r).forEach(function(e) {
					var i = r[e].map(function(e) {
						return Array.isArray(e) ? e.map(function(e) {
							return typeof e == "string" ? m(e) : typeof e == "number" && !isFinite(e) ? null : e;
						}) : typeof e == "string" ? m(e) : typeof e == "number" && !isFinite(e) ? null : e;
					});
					n[t][e] = i;
				});
			}), t.numericRefinements = n;
		}
		return a(e, t);
	}, p.make = function(e) {
		var t = new p(e);
		return (e.hierarchicalFacets || []).forEach(function(e) {
			if (e.rootPath) {
				var n = t.getHierarchicalRefinement(e.name);
				n.length > 0 && n[0].indexOf(e.rootPath) !== 0 && (t = t.clearRefinements(e.name)), n = t.getHierarchicalRefinement(e.name), n.length === 0 && (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath));
			}
		}), t;
	}, p.validate = function(e, t) {
		var n = t || {};
		return e.tagFilters && n.tagRefinements && n.tagRefinements.length > 0 ? /* @__PURE__ */ Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.") : e.tagRefinements.length > 0 && n.tagFilters ? /* @__PURE__ */ Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.") : e.numericFilters && n.numericRefinements && o(n.numericRefinements) ? /* @__PURE__ */ Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : o(e.numericRefinements) && n.numericFilters ? /* @__PURE__ */ Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.") : null;
	}, p.prototype = {
		constructor: p,
		clearRefinements: function(e) {
			var t = {
				numericRefinements: this._clearNumericRefinements(e),
				facetsRefinements: u.clearRefinement(this.facetsRefinements, e, "conjunctiveFacet"),
				facetsExcludes: u.clearRefinement(this.facetsExcludes, e, "exclude"),
				disjunctiveFacetsRefinements: u.clearRefinement(this.disjunctiveFacetsRefinements, e, "disjunctiveFacet"),
				hierarchicalFacetsRefinements: u.clearRefinement(this.hierarchicalFacetsRefinements, e, "hierarchicalFacet")
			};
			return t.numericRefinements === this.numericRefinements && t.facetsRefinements === this.facetsRefinements && t.facetsExcludes === this.facetsExcludes && t.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && t.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements ? this : this.setQueryParameters(t);
		},
		clearTags: function() {
			return this.tagFilters === void 0 && this.tagRefinements.length === 0 ? this : this.setQueryParameters({
				tagFilters: void 0,
				tagRefinements: []
			});
		},
		setIndex: function(e) {
			return e === this.index ? this : this.setQueryParameters({ index: e });
		},
		setQuery: function(e) {
			return e === this.query ? this : this.setQueryParameters({ query: e });
		},
		setPage: function(e) {
			return e === this.page ? this : this.setQueryParameters({ page: e });
		},
		setFacets: function(e) {
			return this.setQueryParameters({ facets: e });
		},
		setDisjunctiveFacets: function(e) {
			return this.setQueryParameters({ disjunctiveFacets: e });
		},
		setHitsPerPage: function(e) {
			return this.hitsPerPage === e ? this : this.setQueryParameters({ hitsPerPage: e });
		},
		setTypoTolerance: function(e) {
			return this.typoTolerance === e ? this : this.setQueryParameters({ typoTolerance: e });
		},
		addNumericRefinement: function(e, t, n) {
			var r = c(n);
			if (this.isNumericRefined(e, t, r)) return this;
			var i = a({}, this.numericRefinements);
			return i[e] = a({}, i[e]), i[e][t] ? (i[e][t] = i[e][t].slice(), i[e][t].push(r)) : i[e][t] = [r], this.setQueryParameters({ numericRefinements: i });
		},
		getConjunctiveRefinements: function(e) {
			return this.isConjunctiveFacet(e) && this.facetsRefinements[e] || [];
		},
		getDisjunctiveRefinements: function(e) {
			return this.isDisjunctiveFacet(e) && this.disjunctiveFacetsRefinements[e] || [];
		},
		getHierarchicalRefinement: function(e) {
			return this.hierarchicalFacetsRefinements[e] || [];
		},
		getExcludeRefinements: function(e) {
			return this.isConjunctiveFacet(e) && this.facetsExcludes[e] || [];
		},
		removeNumericRefinement: function(e, t, n) {
			var r = n;
			return r === void 0 ? t === void 0 ? this.isNumericRefined(e) ? this.setQueryParameters({ numericRefinements: this._clearNumericRefinements(function(t, n) {
				return n === e;
			}) }) : this : this.isNumericRefined(e, t) ? this.setQueryParameters({ numericRefinements: this._clearNumericRefinements(function(n, r) {
				return r === e && n.op === t;
			}) }) : this : this.isNumericRefined(e, t, r) ? this.setQueryParameters({ numericRefinements: this._clearNumericRefinements(function(n, i) {
				return i === e && n.op === t && d(n.val, c(r));
			}) }) : this;
		},
		getNumericRefinements: function(e) {
			return this.numericRefinements[e] || {};
		},
		getNumericRefinement: function(e, t) {
			return this.numericRefinements[e] && this.numericRefinements[e][t];
		},
		_clearNumericRefinements: function(e) {
			if (e === void 0) return o(this.numericRefinements) ? {} : this.numericRefinements;
			if (typeof e == "string") return s(this.numericRefinements, [e]);
			if (typeof e == "function") {
				var t = !1, n = this.numericRefinements, r = Object.keys(n).reduce(function(r, i) {
					var a = n[i], o = {};
					return a ||= {}, Object.keys(a).forEach(function(n) {
						var r = a[n] || [], s = [];
						r.forEach(function(t) {
							e({
								val: t,
								op: n
							}, i, "numeric") || s.push(t);
						}), s.length !== r.length && (t = !0), o[n] = s;
					}), r[i] = o, r;
				}, {});
				return t ? r : this.numericRefinements;
			}
		},
		addFacet: function(e) {
			return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({ facets: this.facets.concat([e]) });
		},
		addDisjunctiveFacet: function(e) {
			return this.isDisjunctiveFacet(e) ? this : this.setQueryParameters({ disjunctiveFacets: this.disjunctiveFacets.concat([e]) });
		},
		addHierarchicalFacet: function(e) {
			if (this.isHierarchicalFacet(e.name)) throw Error("Cannot declare two hierarchical facets with the same name: `" + e.name + "`");
			return this.setQueryParameters({ hierarchicalFacets: this.hierarchicalFacets.concat([e]) });
		},
		addFacetRefinement: function(e, t) {
			if (!this.isConjunctiveFacet(e)) throw Error(e + " is not defined in the facets attribute of the helper configuration");
			return u.isRefined(this.facetsRefinements, e, t) ? this : this.setQueryParameters({ facetsRefinements: u.addRefinement(this.facetsRefinements, e, t) });
		},
		addExcludeRefinement: function(e, t) {
			if (!this.isConjunctiveFacet(e)) throw Error(e + " is not defined in the facets attribute of the helper configuration");
			return u.isRefined(this.facetsExcludes, e, t) ? this : this.setQueryParameters({ facetsExcludes: u.addRefinement(this.facetsExcludes, e, t) });
		},
		addDisjunctiveFacetRefinement: function(e, t) {
			if (!this.isDisjunctiveFacet(e)) throw Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
			return u.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this : this.setQueryParameters({ disjunctiveFacetsRefinements: u.addRefinement(this.disjunctiveFacetsRefinements, e, t) });
		},
		addTagRefinement: function(e) {
			if (this.isTagRefined(e)) return this;
			var t = { tagRefinements: this.tagRefinements.concat(e) };
			return this.setQueryParameters(t);
		},
		removeFacet: function(e) {
			return this.isConjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({ facets: this.facets.filter(function(t) {
				return t !== e;
			}) }) : this;
		},
		removeDisjunctiveFacet: function(e) {
			return this.isDisjunctiveFacet(e) ? this.clearRefinements(e).setQueryParameters({ disjunctiveFacets: this.disjunctiveFacets.filter(function(t) {
				return t !== e;
			}) }) : this;
		},
		removeHierarchicalFacet: function(e) {
			return this.isHierarchicalFacet(e) ? this.clearRefinements(e).setQueryParameters({ hierarchicalFacets: this.hierarchicalFacets.filter(function(t) {
				return t.name !== e;
			}) }) : this;
		},
		removeFacetRefinement: function(e, t) {
			if (!this.isConjunctiveFacet(e)) throw Error(e + " is not defined in the facets attribute of the helper configuration");
			return u.isRefined(this.facetsRefinements, e, t) ? this.setQueryParameters({ facetsRefinements: u.removeRefinement(this.facetsRefinements, e, t) }) : this;
		},
		removeExcludeRefinement: function(e, t) {
			if (!this.isConjunctiveFacet(e)) throw Error(e + " is not defined in the facets attribute of the helper configuration");
			return u.isRefined(this.facetsExcludes, e, t) ? this.setQueryParameters({ facetsExcludes: u.removeRefinement(this.facetsExcludes, e, t) }) : this;
		},
		removeDisjunctiveFacetRefinement: function(e, t) {
			if (!this.isDisjunctiveFacet(e)) throw Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
			return u.isRefined(this.disjunctiveFacetsRefinements, e, t) ? this.setQueryParameters({ disjunctiveFacetsRefinements: u.removeRefinement(this.disjunctiveFacetsRefinements, e, t) }) : this;
		},
		removeTagRefinement: function(e) {
			if (!this.isTagRefined(e)) return this;
			var t = { tagRefinements: this.tagRefinements.filter(function(t) {
				return t !== e;
			}) };
			return this.setQueryParameters(t);
		},
		toggleRefinement: function(e, t) {
			return this.toggleFacetRefinement(e, t);
		},
		toggleFacetRefinement: function(e, t) {
			if (this.isHierarchicalFacet(e)) return this.toggleHierarchicalFacetRefinement(e, t);
			if (this.isConjunctiveFacet(e)) return this.toggleConjunctiveFacetRefinement(e, t);
			if (this.isDisjunctiveFacet(e)) return this.toggleDisjunctiveFacetRefinement(e, t);
			throw Error("Cannot refine the undeclared facet " + e + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
		},
		toggleConjunctiveFacetRefinement: function(e, t) {
			if (!this.isConjunctiveFacet(e)) throw Error(e + " is not defined in the facets attribute of the helper configuration");
			return this.setQueryParameters({ facetsRefinements: u.toggleRefinement(this.facetsRefinements, e, t) });
		},
		toggleExcludeFacetRefinement: function(e, t) {
			if (!this.isConjunctiveFacet(e)) throw Error(e + " is not defined in the facets attribute of the helper configuration");
			return this.setQueryParameters({ facetsExcludes: u.toggleRefinement(this.facetsExcludes, e, t) });
		},
		toggleDisjunctiveFacetRefinement: function(e, t) {
			if (!this.isDisjunctiveFacet(e)) throw Error(e + " is not defined in the disjunctiveFacets attribute of the helper configuration");
			return this.setQueryParameters({ disjunctiveFacetsRefinements: u.toggleRefinement(this.disjunctiveFacetsRefinements, e, t) });
		},
		toggleHierarchicalFacetRefinement: function(e, t) {
			if (!this.isHierarchicalFacet(e)) throw Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration");
			var r = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)), i = {};
			return this.hierarchicalFacetsRefinements[e] !== void 0 && this.hierarchicalFacetsRefinements[e].length > 0 && (this.hierarchicalFacetsRefinements[e][0] === t || this.hierarchicalFacetsRefinements[e][0].indexOf(t + r) === 0) ? t.indexOf(r) === -1 ? i[e] = [] : i[e] = [t.slice(0, t.lastIndexOf(r))] : i[e] = [t], this.setQueryParameters({ hierarchicalFacetsRefinements: n(i, this.hierarchicalFacetsRefinements) });
		},
		addHierarchicalFacetRefinement: function(e, t) {
			if (this.isHierarchicalFacetRefined(e)) throw Error(e + " is already refined.");
			if (!this.isHierarchicalFacet(e)) throw Error(e + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
			var r = {};
			return r[e] = [t], this.setQueryParameters({ hierarchicalFacetsRefinements: n(r, this.hierarchicalFacetsRefinements) });
		},
		removeHierarchicalFacetRefinement: function(e) {
			if (!this.isHierarchicalFacetRefined(e)) return this;
			var t = {};
			return t[e] = [], this.setQueryParameters({ hierarchicalFacetsRefinements: n(t, this.hierarchicalFacetsRefinements) });
		},
		toggleTagRefinement: function(e) {
			return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e);
		},
		isDisjunctiveFacet: function(e) {
			return this.disjunctiveFacets.indexOf(e) > -1;
		},
		isHierarchicalFacet: function(e) {
			return this.getHierarchicalFacetByName(e) !== void 0;
		},
		isConjunctiveFacet: function(e) {
			return this.facets.indexOf(e) > -1;
		},
		isFacetRefined: function(e, t) {
			return this.isConjunctiveFacet(e) ? u.isRefined(this.facetsRefinements, e, t) : !1;
		},
		isExcludeRefined: function(e, t) {
			return this.isConjunctiveFacet(e) ? u.isRefined(this.facetsExcludes, e, t) : !1;
		},
		isDisjunctiveFacetRefined: function(e, t) {
			return this.isDisjunctiveFacet(e) ? u.isRefined(this.disjunctiveFacetsRefinements, e, t) : !1;
		},
		isHierarchicalFacetRefined: function(e, t) {
			if (!this.isHierarchicalFacet(e)) return !1;
			var n = this.getHierarchicalRefinement(e);
			return t ? n.indexOf(t) !== -1 : n.length > 0;
		},
		isNumericRefined: function(e, t, n) {
			if (n === void 0 && t === void 0) return !!this.numericRefinements[e];
			var r = this.numericRefinements[e] && this.numericRefinements[e][t] !== void 0;
			if (n === void 0 || !r) return r;
			var i = c(n), a = f(this.numericRefinements[e][t], i) !== void 0;
			return r && a;
		},
		isTagRefined: function(e) {
			return this.tagRefinements.indexOf(e) !== -1;
		},
		getRefinedDisjunctiveFacets: function() {
			var e = this, t = i(Object.keys(this.numericRefinements).filter(function(t) {
				return Object.keys(e.numericRefinements[t]).length > 0;
			}), this.disjunctiveFacets);
			return Object.keys(this.disjunctiveFacetsRefinements).filter(function(t) {
				return e.disjunctiveFacetsRefinements[t].length > 0;
			}).concat(t).concat(this.getRefinedHierarchicalFacets()).sort();
		},
		getRefinedHierarchicalFacets: function() {
			var e = this;
			return i(this.hierarchicalFacets.map(function(e) {
				return e.name;
			}), Object.keys(this.hierarchicalFacetsRefinements).filter(function(t) {
				return e.hierarchicalFacetsRefinements[t].length > 0;
			})).sort();
		},
		getUnrefinedDisjunctiveFacets: function() {
			var e = this.getRefinedDisjunctiveFacets();
			return this.disjunctiveFacets.filter(function(t) {
				return e.indexOf(t) === -1;
			});
		},
		managedParameters: [
			"index",
			"facets",
			"disjunctiveFacets",
			"facetsRefinements",
			"hierarchicalFacets",
			"facetsExcludes",
			"disjunctiveFacetsRefinements",
			"numericRefinements",
			"tagRefinements",
			"hierarchicalFacetsRefinements"
		],
		getQueryParams: function() {
			var e = this.managedParameters, t = {}, n = this;
			return Object.keys(this).forEach(function(r) {
				var i = n[r];
				e.indexOf(r) === -1 && i !== void 0 && (t[r] = i);
			}), t;
		},
		setQueryParameter: function(e, t) {
			if (this[e] === t) return this;
			var n = {};
			return n[e] = t, this.setQueryParameters(n);
		},
		setQueryParameters: function(e) {
			if (!e) return this;
			var t = p.validate(this, e);
			if (t) throw t;
			var n = this, r = p._parseNumbers(e), i = Object.keys(this).reduce(function(e, t) {
				return e[t] = n[t], e;
			}, {}), a = Object.keys(r).reduce(function(e, t) {
				var n = e[t] !== void 0, i = r[t] !== void 0;
				return n && !i ? s(e, [t]) : (i && (e[t] = r[t]), e);
			}, i);
			return new this.constructor(a);
		},
		resetPage: function() {
			return this.page === void 0 ? this : this.setPage(0);
		},
		_getHierarchicalFacetSortBy: function(e) {
			return e.sortBy || ["isRefined:desc", "name:asc"];
		},
		_getHierarchicalFacetSeparator: function(e) {
			return e.separator || " > ";
		},
		_getHierarchicalRootPath: function(e) {
			return e.rootPath || null;
		},
		_getHierarchicalShowParentLevel: function(e) {
			return typeof e.showParentLevel != "boolean" || e.showParentLevel;
		},
		getHierarchicalFacetByName: function(e) {
			return r(this.hierarchicalFacets, function(t) {
				return t.name === e;
			});
		},
		getHierarchicalFacetBreadcrumb: function(e) {
			if (!this.isHierarchicalFacet(e)) return [];
			var t = this.getHierarchicalRefinement(e)[0];
			if (!t) return [];
			var n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e));
			return t.split(n).map(function(e) {
				return e.trim();
			});
		},
		toString: function() {
			return JSON.stringify(this, null, 2);
		}
	}, t.exports = p;
})), Hd = /* @__PURE__ */ p(((e, t) => {
	t.exports = function(e) {
		return Array.isArray(e) ? e.filter(Boolean) : [];
	};
})), Ud = /* @__PURE__ */ p(((e, t) => {
	t.exports = function(e, t) {
		if (!Array.isArray(e)) return -1;
		for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
		return -1;
	};
})), Wd = /* @__PURE__ */ p(((e, t) => {
	var n = Id();
	t.exports = function(e, t) {
		var r = (t || []).map(function(e) {
			return e.split(":");
		});
		return e.reduce(function(e, t) {
			var i = t.split(":"), a = n(r, function(e) {
				return e[0] === i[0];
			});
			return i.length > 1 || !a ? (e[0].push(i[0]), e[1].push(i[1]), e) : (e[0].push(a[0]), e[1].push(a[1]), e);
		}, [[], []]);
	};
})), Gd = /* @__PURE__ */ p(((e, t) => {
	function n() {
		return Array.prototype.slice.call(arguments).reduceRight(function(e, t) {
			return Object.keys(Object(t)).forEach(function(n) {
				var r = typeof e[n] == "number" ? e[n] : 0, i = t[n];
				i !== void 0 && i >= r && (e[n] !== void 0 && delete e[n], e[n] = i);
			}), e;
		}, {});
	}
	t.exports = n;
})), Kd = /* @__PURE__ */ p(((e, t) => {
	function n(e, t) {
		if (e !== t) {
			var n = e !== void 0, r = e === null, i = t !== void 0, a = t === null;
			if (!a && e > t || r && i || !n) return 1;
			if (!r && e < t || a && n || !i) return -1;
		}
		return 0;
	}
	function r(e, t, r) {
		if (!Array.isArray(e)) return [];
		Array.isArray(r) || (r = []);
		var i = e.map(function(e, n) {
			return {
				criteria: t.map(function(t) {
					return e[t];
				}),
				index: n,
				value: e
			};
		});
		return i.sort(function(e, t) {
			for (var i = -1; ++i < e.criteria.length;) {
				var a = n(e.criteria[i], t.criteria[i]);
				if (a) return i >= r.length ? a : r[i] === "desc" ? -a : a;
			}
			return e.index - t.index;
		}), i.map(function(e) {
			return e.value;
		});
	}
	t.exports = r;
})), qd = /* @__PURE__ */ p(((e, t) => {
	t.exports = c;
	var n = Od(), r = Id(), i = Wd(), a = Kd(), o = n.escapeFacetValue, s = n.unescapeFacetValue;
	function c(e) {
		return function(t, n) {
			var r = e.hierarchicalFacets[n], a = e.hierarchicalFacetsRefinements[r.name] && e.hierarchicalFacetsRefinements[r.name][0] || "", o = e._getHierarchicalFacetSeparator(r), s = e._getHierarchicalRootPath(r), c = e._getHierarchicalShowParentLevel(r), u = i(e._getHierarchicalFacetSortBy(r)), d = t.every(function(e) {
				return e.exhaustive;
			}), f = l(u, o, s, c, a), p = t;
			return s && (p = t.slice(s.split(o).length)), p.reduce(f, {
				name: e.hierarchicalFacets[n].name,
				count: null,
				isRefined: !0,
				path: null,
				escapedValue: null,
				exhaustive: d,
				data: null
			});
		};
	}
	function l(e, t, n, i, o) {
		return function(c, l, f) {
			var p = c;
			if (f > 0) {
				var m = 0;
				for (p = c; m < f;) p = r(p && Array.isArray(p.data) ? p.data : [], function(e) {
					return e.isRefined;
				}), m++;
			}
			if (p) {
				var h = Object.keys(l.data).map(function(e) {
					return [e, l.data[e]];
				}).filter(function(e) {
					var r = e[0];
					return u(r, p.path || n, o, t, n, i);
				});
				p.data = a(h.map(function(e) {
					var n = e[0], r = e[1];
					return d(r, n, t, s(o), l.exhaustive);
				}), e[0], e[1]);
			}
			return c;
		};
	}
	function u(e, t, n, r, i, a) {
		return i && (e.indexOf(i) !== 0 || i === e) ? !1 : !i && e.indexOf(r) === -1 || i && e.split(r).length - i.split(r).length === 1 || e.indexOf(r) === -1 && n.indexOf(r) === -1 || n.indexOf(e) === 0 || e.indexOf(t + r) === 0 && (a || e.indexOf(n) === 0);
	}
	function d(e, t, n, r, i) {
		var a = t.split(n);
		return {
			name: a[a.length - 1].trim(),
			path: t,
			escapedValue: o(t),
			count: e,
			isRefined: r === t || r.indexOf(t + n) === 0,
			exhaustive: i,
			data: null
		};
	}
})), Jd = /* @__PURE__ */ p(((e, t) => {
	var n = Hd(), r = Fd(), i = Od(), a = Id(), o = Ud(), s = Wd(), c = Gd(), l = Kd(), u = i.escapeFacetValue, d = i.unescapeFacetValue, f = qd();
	function p(e) {
		var t = {};
		return e.forEach(function(e, n) {
			t[e] = n;
		}), t;
	}
	function m(e, t, n) {
		t && t[n] && (e.stats = t[n]);
	}
	function h(e, t) {
		return a(e, function(e) {
			return (e.attributes || []).indexOf(t) > -1;
		});
	}
	function g(e, t, i) {
		var a = t[0] || {};
		this._rawResults = t;
		var s = this;
		Object.keys(a).forEach(function(e) {
			s[e] = a[e];
		});
		var l = r(i, { persistHierarchicalRootCount: !1 });
		Object.keys(l).forEach(function(e) {
			s[e] = l[e];
		}), this.processingTimeMS = t.reduce(function(e, t) {
			return t.processingTimeMS === void 0 ? e : e + t.processingTimeMS;
		}, 0), this.disjunctiveFacets = [], this.hierarchicalFacets = e.hierarchicalFacets.map(function() {
			return [];
		}), this.facets = [];
		var u = e.getRefinedDisjunctiveFacets(), g = p(e.facets), _ = p(e.disjunctiveFacets), v = 1, y = a.facets || {};
		Object.keys(y).forEach(function(t) {
			var n = y[t], r = h(e.hierarchicalFacets, t);
			if (r) {
				var i = r.attributes.indexOf(t), c = o(e.hierarchicalFacets, function(e) {
					return e.name === r.name;
				});
				s.hierarchicalFacets[c][i] = {
					attribute: t,
					data: n,
					exhaustive: a.exhaustiveFacetsCount
				};
			} else {
				var l = e.disjunctiveFacets.indexOf(t) !== -1, u = e.facets.indexOf(t) !== -1, d;
				l && (d = _[t], s.disjunctiveFacets[d] = {
					name: t,
					data: n,
					exhaustive: a.exhaustiveFacetsCount
				}, m(s.disjunctiveFacets[d], a.facets_stats, t)), u && (d = g[t], s.facets[d] = {
					name: t,
					data: n,
					exhaustive: a.exhaustiveFacetsCount
				}, m(s.facets[d], a.facets_stats, t));
			}
		}), this.hierarchicalFacets = n(this.hierarchicalFacets), u.forEach(function(n) {
			var i = t[v], l = i && i.facets ? i.facets : {}, u = e.getHierarchicalFacetByName(n);
			Object.keys(l).forEach(function(t) {
				var n = l[t], f;
				if (u) {
					f = o(e.hierarchicalFacets, function(e) {
						return e.name === u.name;
					});
					var p = o(s.hierarchicalFacets[f], function(e) {
						return e.attribute === t;
					});
					if (p === -1) return;
					s.hierarchicalFacets[f][p].data = s.persistHierarchicalRootCount ? c(s.hierarchicalFacets[f][p].data, n) : r(n, s.hierarchicalFacets[f][p].data);
				} else {
					f = _[t];
					var h = a.facets && a.facets[t] || {};
					s.disjunctiveFacets[f] = {
						name: t,
						data: c(h, n),
						exhaustive: i.exhaustiveFacetsCount
					}, m(s.disjunctiveFacets[f], i.facets_stats, t), e.disjunctiveFacetsRefinements[t] && e.disjunctiveFacetsRefinements[t].forEach(function(n) {
						!s.disjunctiveFacets[f].data[n] && e.disjunctiveFacetsRefinements[t].indexOf(d(n)) > -1 && (s.disjunctiveFacets[f].data[n] = 0);
					});
				}
			}), v++;
		}), e.getRefinedHierarchicalFacets().forEach(function(n) {
			var i = e.getHierarchicalFacetByName(n), a = e._getHierarchicalFacetSeparator(i), c = e.getHierarchicalRefinement(n);
			c.length === 0 || c[0].split(a).length < 2 || t.slice(v).forEach(function(t) {
				var n = t && t.facets ? t.facets : {};
				Object.keys(n).forEach(function(t) {
					var l = n[t], u = o(e.hierarchicalFacets, function(e) {
						return e.name === i.name;
					}), d = o(s.hierarchicalFacets[u], function(e) {
						return e.attribute === t;
					});
					if (d !== -1) {
						var f = {};
						if (c.length > 0 && !s.persistHierarchicalRootCount) {
							var p = c[0].split(a)[0];
							f[p] = s.hierarchicalFacets[u][d].data[p];
						}
						s.hierarchicalFacets[u][d].data = r(f, l, s.hierarchicalFacets[u][d].data);
					}
				}), v++;
			});
		}), Object.keys(e.facetsExcludes).forEach(function(t) {
			var n = e.facetsExcludes[t], r = g[t];
			s.facets[r] = {
				name: t,
				data: y[t],
				exhaustive: a.exhaustiveFacetsCount
			}, n.forEach(function(e) {
				s.facets[r] = s.facets[r] || { name: t }, s.facets[r].data = s.facets[r].data || {}, s.facets[r].data[e] = 0;
			});
		}), this.hierarchicalFacets = this.hierarchicalFacets.map(f(e)), this.facets = n(this.facets), this.disjunctiveFacets = n(this.disjunctiveFacets), this._state = e;
	}
	g.prototype.getFacetByName = function(e) {
		function t(t) {
			return t.name === e;
		}
		return a(this.facets, t) || a(this.disjunctiveFacets, t) || a(this.hierarchicalFacets, t);
	};
	function _(e, t) {
		function n(e) {
			return e.name === t;
		}
		if (e._state.isConjunctiveFacet(t)) {
			var r = a(e.facets, n);
			return r ? Object.keys(r.data).map(function(n) {
				var i = u(n);
				return {
					name: n,
					escapedValue: i,
					count: r.data[n],
					isRefined: e._state.isFacetRefined(t, i),
					isExcluded: e._state.isExcludeRefined(t, n)
				};
			}) : [];
		} else if (e._state.isDisjunctiveFacet(t)) {
			var i = a(e.disjunctiveFacets, n);
			return i ? Object.keys(i.data).map(function(n) {
				var r = u(n);
				return {
					name: n,
					escapedValue: r,
					count: i.data[n],
					isRefined: e._state.isDisjunctiveFacetRefined(t, r)
				};
			}) : [];
		} else if (e._state.isHierarchicalFacet(t)) {
			var o = a(e.hierarchicalFacets, n);
			if (!o) return o;
			var s = e._state.getHierarchicalFacetByName(t), c = e._state._getHierarchicalFacetSeparator(s), l = d(e._state.getHierarchicalRefinement(t)[0] || "");
			l.indexOf(s.rootPath) === 0 && (l = l.replace(s.rootPath + c, ""));
			var f = l.split(c);
			return f.unshift(t), v(o, f, 0), o;
		}
	}
	function v(e, t, n) {
		e.isRefined = e.name === (t[n] && t[n].trim()), e.data && e.data.forEach(function(e) {
			v(e, t, n + 1);
		});
	}
	function y(e, t, n, i) {
		return i ||= 0, Array.isArray(t) ? e(t, n[i]) : !t.data || t.data.length === 0 ? t : r({ data: e(t.data.map(function(t) {
			return y(e, t, n, i + 1);
		}), n[i]) }, t);
	}
	g.DEFAULT_SORT = [
		"isRefined:desc",
		"count:desc",
		"name:asc"
	];
	function b(e, t) {
		return t.sort(e);
	}
	function x(e, t) {
		var n = [], r = [], i = t.hide || [], a = (t.order || []).reduce(function(e, t, n) {
			return e[t] = n, e;
		}, {});
		e.forEach(function(e) {
			var t = e.path || e.name, o = i.indexOf(t) > -1;
			!o && a[t] !== void 0 ? n[a[t]] = e : o || r.push(e);
		}), n = n.filter(function(e) {
			return e;
		});
		var o = t.sortRemainingBy, s;
		return o === "hidden" ? n : (s = o === "alpha" ? [["path", "name"], ["asc", "asc"]] : [["count"], ["desc"]], n.concat(l(r, s[0], s[1])));
	}
	function S(e, t) {
		return e.renderingContent && e.renderingContent.facetOrdering && e.renderingContent.facetOrdering.values && e.renderingContent.facetOrdering.values[t];
	}
	g.prototype.getFacetValues = function(e, t) {
		var n = _(this, e);
		if (n) {
			var i = r(t, {
				sortBy: g.DEFAULT_SORT,
				facetOrdering: !(t && t.sortBy)
			}), a = this;
			return y(function(e, t) {
				var n = S(a, t);
				if (i.facetOrdering && n) return x(e, n);
				if (Array.isArray(i.sortBy)) {
					var r = s(i.sortBy, g.DEFAULT_SORT), o = l(e, r[0], r[1]), c = n && n.hide ? n.hide : [];
					if (c.length > 0) {
						var u = [];
						return o.forEach(function(e) {
							var t = e.path || e.name;
							c.indexOf(t) === -1 && u.push(e);
						}), u;
					}
					return o;
				} else if (typeof i.sortBy == "function") return b(i.sortBy, e);
				throw Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
			}, n, Array.isArray(n) ? [e] : a._state.getHierarchicalFacetByName(n.name).attributes);
		}
	}, g.prototype.getFacetStats = function(e) {
		if (this._state.isConjunctiveFacet(e)) return C(this.facets, e);
		if (this._state.isDisjunctiveFacet(e)) return C(this.disjunctiveFacets, e);
	};
	function C(e, t) {
		var n = a(e, function(e) {
			return e.name === t;
		});
		return n && n.stats;
	}
	g.prototype.getRefinements = function() {
		var e = this._state, t = this, n = [];
		return Object.keys(e.facetsRefinements).forEach(function(r) {
			e.facetsRefinements[r].forEach(function(i) {
				n.push(w(e, "facet", r, i, t.facets));
			});
		}), Object.keys(e.facetsExcludes).forEach(function(r) {
			e.facetsExcludes[r].forEach(function(i) {
				n.push(w(e, "exclude", r, i, t.facets));
			});
		}), Object.keys(e.disjunctiveFacetsRefinements).forEach(function(r) {
			e.disjunctiveFacetsRefinements[r].forEach(function(i) {
				n.push(w(e, "disjunctive", r, i, t.disjunctiveFacets));
			});
		}), Object.keys(e.hierarchicalFacetsRefinements).forEach(function(r) {
			e.hierarchicalFacetsRefinements[r].forEach(function(i) {
				n.push(T(e, r, i, t.hierarchicalFacets));
			});
		}), Object.keys(e.numericRefinements).forEach(function(t) {
			var r = e.numericRefinements[t];
			Object.keys(r).forEach(function(e) {
				r[e].forEach(function(r) {
					n.push({
						type: "numeric",
						attributeName: t,
						name: r,
						numericValue: r,
						operator: e
					});
				});
			});
		}), e.tagRefinements.forEach(function(e) {
			n.push({
				type: "tag",
				attributeName: "_tags",
				name: e
			});
		}), n;
	};
	function w(e, t, n, r, i) {
		var o = a(i, function(e) {
			return e.name === n;
		});
		return {
			type: t,
			attributeName: n,
			name: r,
			count: o && o.data && o.data[r] ? o.data[r] : 0,
			exhaustive: o && o.exhaustive || !1
		};
	}
	function T(e, t, n, r) {
		var i = e.getHierarchicalFacetByName(t), o = e._getHierarchicalFacetSeparator(i), s = n.split(o), c = a(r, function(e) {
			return e.name === t;
		}), l = s.reduce(function(e, t) {
			var n = e && a(e.data, function(e) {
				return e.name === t;
			});
			return n === void 0 ? e : n;
		}, c), u = l && l.count || 0, d = l && l.exhaustive || !1;
		return {
			type: "hierarchical",
			attributeName: t,
			name: l && l.path || "",
			count: u,
			exhaustive: d
		};
	}
	t.exports = g;
})), Yd = /* @__PURE__ */ p(((e, t) => {
	t.exports = function(e) {
		return e.reduce(function(e, t) {
			return e.concat(t);
		}, []);
	};
})), Xd = /* @__PURE__ */ p(((e, t) => {
	var n = Id(), r = Yd();
	function i(e, t) {
		var n = [];
		return Object.keys(e).forEach(function(r) {
			e[r].count < 2 && (e[r].indexSum += 100), n.push({
				objectID: r,
				avgOfIndices: e[r].indexSum / t
			});
		}), n.sort(function(e, t) {
			return e.avgOfIndices > t.avgOfIndices ? 1 : -1;
		});
	}
	function a(e, t) {
		var a = {};
		return t.forEach(function(t) {
			t.forEach(function(t, n) {
				e.includes(t.objectID) || (a[t.objectID] ? a[t.objectID] = {
					indexSum: a[t.objectID].indexSum + n,
					count: a[t.objectID].count + 1
				} : a[t.objectID] = {
					indexSum: n,
					count: 1
				});
			});
		}), i(a, t.length).reduce(function(e, i) {
			var a = n(r(t), function(e) {
				return e.objectID === i.objectID;
			});
			return a ? e.concat(a) : e;
		}, []);
	}
	t.exports = a;
})), Zd = /* @__PURE__ */ p(((e, t) => {
	t.exports = "3.29.2";
})), Qd = /* @__PURE__ */ p(((e, t) => {
	var n = Td(), r = Dd(), i = Od().escapeFacetValue, a = Ed(), o = kd(), s = Ad(), c = jd(), l = Md(), u = Nd(), d = Pd(), f = Vd(), p = Jd(), m = Xd(), h = Zd();
	function g(e, t, n, r) {
		typeof e.addAlgoliaAgent == "function" && e.addAlgoliaAgent("JS Helper (" + h + ")"), this.setClient(e);
		var i = n || {};
		i.index = t, this.state = f.make(i), this.recommendState = new l({ params: i.recommendState }), this.lastResults = null, this.lastRecommendResults = null, this._queryId = 0, this._recommendQueryId = 0, this._lastQueryIdReceived = -1, this._lastRecommendQueryIdReceived = -1, this.derivedHelpers = [], this._currentNbQueries = 0, this._currentNbRecommendQueries = 0, this._searchResultsOptions = r, this._recommendCache = {};
	}
	a(g, n), g.prototype.search = function() {
		return this._search({ onlyWithDerivedHelpers: !1 }), this;
	}, g.prototype.searchOnlyWithDerivedHelpers = function() {
		return this._search({ onlyWithDerivedHelpers: !0 }), this;
	}, g.prototype.searchWithComposition = function() {
		return this._runComposition({ onlyWithDerivedHelpers: !0 }), this;
	}, g.prototype.recommend = function() {
		return this._recommend(), this;
	}, g.prototype.getQuery = function() {
		var e = this.state;
		return d._getHitsSearchParams(e);
	}, g.prototype.searchOnce = function(e, t) {
		var n = e ? this.state.setQueryParameters(e) : this.state, r = d._getQueries(n.index, n), i = this;
		if (this._currentNbQueries++, this.emit("searchOnce", { state: n }), t) {
			this.client.search(r).then(function(e) {
				i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), t(null, new p(n, e.results), n);
			}).catch(function(e) {
				i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), t(e, null, n);
			});
			return;
		}
		return this.client.search(r).then(function(e) {
			return i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), {
				content: new p(n, e.results),
				state: n,
				_originalResponse: e
			};
		}, function(e) {
			throw i._currentNbQueries--, i._currentNbQueries === 0 && i.emit("searchQueueEmpty"), e;
		});
	}, g.prototype.findAnswers = function(e) {
		console.warn("[algoliasearch-helper] answers is no longer supported");
		var t = this.state, n = this.derivedHelpers[0];
		if (!n) return Promise.resolve([]);
		var r = n.getModifiedState(t), i = o({
			attributesForPrediction: e.attributesForPrediction,
			nbHits: e.nbHits
		}, { params: c(d._getHitsSearchParams(r), [
			"attributesToSnippet",
			"hitsPerPage",
			"restrictSearchableAttributes",
			"snippetEllipsisText"
		]) }), a = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
		if (typeof this.client.initIndex != "function") throw Error(a);
		var s = this.client.initIndex(r.index);
		if (typeof s.findAnswers != "function") throw Error(a);
		return s.findAnswers(r.query, e.queryLanguages, i);
	}, g.prototype.searchForFacetValues = function(e, t, n, r) {
		var a = typeof this.client.searchForFacetValues == "function" && typeof this.client.searchForFacets != "function", o = typeof this.client.initIndex == "function";
		if (!a && !o && typeof this.client.search != "function") throw Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
		var s = this.state.setQueryParameters(r || {}), c = s.isDisjunctiveFacet(e), l = d.getSearchForFacetQuery(e, t, n, s);
		this._currentNbQueries++;
		var u = this, f;
		a ? f = this.client.searchForFacetValues([{
			indexName: s.index,
			params: l
		}]) : o ? f = this.client.initIndex(s.index).searchForFacetValues(l) : (delete l.facetName, f = this.client.search([{
			type: "facet",
			facet: e,
			indexName: s.index,
			params: l
		}]).then(function(e) {
			return e.results[0];
		})), this.emit("searchForFacetValues", {
			state: s,
			facet: e,
			query: t
		});
		var p = this.lastResults && this.lastResults.index === s.index && this.lastResults.renderingContent && this.lastResults.renderingContent.facetOrdering && this.lastResults.renderingContent.facetOrdering.values && this.lastResults.renderingContent.facetOrdering.values[e] && this.lastResults.renderingContent.facetOrdering.values[e].hide || [];
		return f.then(function(t) {
			return u._currentNbQueries--, u._currentNbQueries === 0 && u.emit("searchQueueEmpty"), t = Array.isArray(t) ? t[0] : t, t.facetHits = t.facetHits.reduce(function(t, n) {
				return p.indexOf(n.value) > -1 ? t : (n.escapedValue = i(n.value), n.isRefined = c ? s.isDisjunctiveFacetRefined(e, n.escapedValue) : s.isFacetRefined(e, n.escapedValue), t.push(n), t);
			}, []), t;
		}, function(e) {
			throw u._currentNbQueries--, u._currentNbQueries === 0 && u.emit("searchQueueEmpty"), e;
		});
	}, g.prototype.searchForCompositionFacetValues = function(e, t, n, r) {
		if (typeof this.client.searchForFacetValues != "function") throw Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues");
		var a = this.state.setQueryParameters(r || {}), o = a.isDisjunctiveFacet(e);
		this._currentNbQueries++;
		var s = this, c = this.client.searchForFacetValues({
			compositionID: a.index,
			facetName: e,
			searchForFacetValuesRequest: { params: {
				query: t,
				maxFacetHits: n,
				searchQuery: d._getCompositionHitsSearchParams(a)
			} }
		});
		return this.emit("searchForFacetValues", {
			state: a,
			facet: e,
			query: t
		}), c.then(function(t) {
			return s._currentNbQueries--, s._currentNbQueries === 0 && s.emit("searchQueueEmpty"), t = t.results[0], t.facetHits.forEach(function(t) {
				t.escapedValue = i(t.value), t.isRefined = o ? a.isDisjunctiveFacetRefined(e, t.escapedValue) : a.isFacetRefined(e, t.escapedValue);
			}), t;
		}, function(e) {
			throw s._currentNbQueries--, s._currentNbQueries === 0 && s.emit("searchQueueEmpty"), e;
		});
	}, g.prototype.setQuery = function(e) {
		return this._change({
			state: this.state.resetPage().setQuery(e),
			isPageReset: !0
		}), this;
	}, g.prototype.clearRefinements = function(e) {
		return this._change({
			state: this.state.resetPage().clearRefinements(e),
			isPageReset: !0
		}), this;
	}, g.prototype.clearTags = function() {
		return this._change({
			state: this.state.resetPage().clearTags(),
			isPageReset: !0
		}), this;
	}, g.prototype.addDisjunctiveFacetRefinement = function(e, t) {
		return this._change({
			state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.addDisjunctiveRefine = function() {
		return this.addDisjunctiveFacetRefinement.apply(this, arguments);
	}, g.prototype.addHierarchicalFacetRefinement = function(e, t) {
		return this._change({
			state: this.state.resetPage().addHierarchicalFacetRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.addNumericRefinement = function(e, t, n) {
		return this._change({
			state: this.state.resetPage().addNumericRefinement(e, t, n),
			isPageReset: !0
		}), this;
	}, g.prototype.addFacetRefinement = function(e, t) {
		return this._change({
			state: this.state.resetPage().addFacetRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.addRefine = function() {
		return this.addFacetRefinement.apply(this, arguments);
	}, g.prototype.addFacetExclusion = function(e, t) {
		return this._change({
			state: this.state.resetPage().addExcludeRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.addExclude = function() {
		return this.addFacetExclusion.apply(this, arguments);
	}, g.prototype.addTag = function(e) {
		return this._change({
			state: this.state.resetPage().addTagRefinement(e),
			isPageReset: !0
		}), this;
	}, g.prototype.addFrequentlyBoughtTogether = function(e) {
		return this._recommendChange({ state: this.recommendState.addFrequentlyBoughtTogether(e) }), this;
	}, g.prototype.addRelatedProducts = function(e) {
		return this._recommendChange({ state: this.recommendState.addRelatedProducts(e) }), this;
	}, g.prototype.addTrendingItems = function(e) {
		return this._recommendChange({ state: this.recommendState.addTrendingItems(e) }), this;
	}, g.prototype.addTrendingFacets = function(e) {
		return this._recommendChange({ state: this.recommendState.addTrendingFacets(e) }), this;
	}, g.prototype.addLookingSimilar = function(e) {
		return this._recommendChange({ state: this.recommendState.addLookingSimilar(e) }), this;
	}, g.prototype.removeNumericRefinement = function(e, t, n) {
		return this._change({
			state: this.state.resetPage().removeNumericRefinement(e, t, n),
			isPageReset: !0
		}), this;
	}, g.prototype.removeDisjunctiveFacetRefinement = function(e, t) {
		return this._change({
			state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.removeDisjunctiveRefine = function() {
		return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
	}, g.prototype.removeHierarchicalFacetRefinement = function(e) {
		return this._change({
			state: this.state.resetPage().removeHierarchicalFacetRefinement(e),
			isPageReset: !0
		}), this;
	}, g.prototype.removeFacetRefinement = function(e, t) {
		return this._change({
			state: this.state.resetPage().removeFacetRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.removeRefine = function() {
		return this.removeFacetRefinement.apply(this, arguments);
	}, g.prototype.removeFacetExclusion = function(e, t) {
		return this._change({
			state: this.state.resetPage().removeExcludeRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.removeExclude = function() {
		return this.removeFacetExclusion.apply(this, arguments);
	}, g.prototype.removeTag = function(e) {
		return this._change({
			state: this.state.resetPage().removeTagRefinement(e),
			isPageReset: !0
		}), this;
	}, g.prototype.removeFrequentlyBoughtTogether = function(e) {
		return this._recommendChange({ state: this.recommendState.removeParams(e) }), this;
	}, g.prototype.removeRelatedProducts = function(e) {
		return this._recommendChange({ state: this.recommendState.removeParams(e) }), this;
	}, g.prototype.removeTrendingItems = function(e) {
		return this._recommendChange({ state: this.recommendState.removeParams(e) }), this;
	}, g.prototype.removeTrendingFacets = function(e) {
		return this._recommendChange({ state: this.recommendState.removeParams(e) }), this;
	}, g.prototype.removeLookingSimilar = function(e) {
		return this._recommendChange({ state: this.recommendState.removeParams(e) }), this;
	}, g.prototype.toggleFacetExclusion = function(e, t) {
		return this._change({
			state: this.state.resetPage().toggleExcludeFacetRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.toggleExclude = function() {
		return this.toggleFacetExclusion.apply(this, arguments);
	}, g.prototype.toggleRefinement = function(e, t) {
		return this.toggleFacetRefinement(e, t);
	}, g.prototype.toggleFacetRefinement = function(e, t) {
		return this._change({
			state: this.state.resetPage().toggleFacetRefinement(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.toggleRefine = function() {
		return this.toggleFacetRefinement.apply(this, arguments);
	}, g.prototype.toggleTag = function(e) {
		return this._change({
			state: this.state.resetPage().toggleTagRefinement(e),
			isPageReset: !0
		}), this;
	}, g.prototype.nextPage = function() {
		var e = this.state.page || 0;
		return this.setPage(e + 1);
	}, g.prototype.previousPage = function() {
		var e = this.state.page || 0;
		return this.setPage(e - 1);
	};
	function _(e) {
		if (e < 0) throw Error("Page requested below 0.");
		return this._change({
			state: this.state.setPage(e),
			isPageReset: !1
		}), this;
	}
	g.prototype.setCurrentPage = _, g.prototype.setPage = _, g.prototype.setIndex = function(e) {
		return this._change({
			state: this.state.resetPage().setIndex(e),
			isPageReset: !0
		}), this;
	}, g.prototype.setQueryParameter = function(e, t) {
		return this._change({
			state: this.state.resetPage().setQueryParameter(e, t),
			isPageReset: !0
		}), this;
	}, g.prototype.setState = function(e) {
		return this._change({
			state: f.make(e),
			isPageReset: !1
		}), this;
	}, g.prototype.overrideStateWithoutTriggeringChangeEvent = function(e) {
		return this.state = new f(e), this;
	}, g.prototype.hasRefinements = function(e) {
		return s(this.state.getNumericRefinements(e)) ? !0 : this.state.isConjunctiveFacet(e) ? this.state.isFacetRefined(e) : this.state.isDisjunctiveFacet(e) ? this.state.isDisjunctiveFacetRefined(e) : this.state.isHierarchicalFacet(e) ? this.state.isHierarchicalFacetRefined(e) : !1;
	}, g.prototype.isExcluded = function(e, t) {
		return this.state.isExcludeRefined(e, t);
	}, g.prototype.isDisjunctiveRefined = function(e, t) {
		return this.state.isDisjunctiveFacetRefined(e, t);
	}, g.prototype.hasTag = function(e) {
		return this.state.isTagRefined(e);
	}, g.prototype.isTagRefined = function() {
		return this.hasTagRefinements.apply(this, arguments);
	}, g.prototype.getIndex = function() {
		return this.state.index;
	};
	function v() {
		return this.state.page;
	}
	g.prototype.getCurrentPage = v, g.prototype.getPage = v, g.prototype.getTags = function() {
		return this.state.tagRefinements;
	}, g.prototype.getRefinements = function(e) {
		var t = [];
		this.state.isConjunctiveFacet(e) ? (this.state.getConjunctiveRefinements(e).forEach(function(e) {
			t.push({
				value: e,
				type: "conjunctive"
			});
		}), this.state.getExcludeRefinements(e).forEach(function(e) {
			t.push({
				value: e,
				type: "exclude"
			});
		})) : this.state.isDisjunctiveFacet(e) && this.state.getDisjunctiveRefinements(e).forEach(function(e) {
			t.push({
				value: e,
				type: "disjunctive"
			});
		});
		var n = this.state.getNumericRefinements(e);
		return Object.keys(n).forEach(function(e) {
			var r = n[e];
			t.push({
				value: r,
				operator: e,
				type: "numeric"
			});
		}), t;
	}, g.prototype.getNumericRefinement = function(e, t) {
		return this.state.getNumericRefinement(e, t);
	}, g.prototype.getHierarchicalFacetBreadcrumb = function(e) {
		return this.state.getHierarchicalFacetBreadcrumb(e);
	}, g.prototype._search = function(e) {
		var t = this.state, n = [], r = [];
		e.onlyWithDerivedHelpers || (r = d._getQueries(t.index, t), n.push({
			state: t,
			queriesCount: r.length,
			helper: this
		}), this.emit("search", {
			state: t,
			results: this.lastResults
		}));
		var i = this.derivedHelpers.map(function(e) {
			var r = e.getModifiedState(t), i = r.index ? d._getQueries(r.index, r) : [];
			return n.push({
				state: r,
				queriesCount: i.length,
				helper: e
			}), e.emit("search", {
				state: r,
				results: e.lastResults
			}), i;
		}), a = Array.prototype.concat.apply(r, i), o = this._queryId++;
		if (this._currentNbQueries++, !a.length) return Promise.resolve({ results: [] }).then(this._dispatchAlgoliaResponse.bind(this, n, o));
		try {
			this.client.search(a).then(this._dispatchAlgoliaResponse.bind(this, n, o)).catch(this._dispatchAlgoliaError.bind(this, o));
		} catch (e) {
			this.emit("error", { error: e });
		}
	}, g.prototype._runComposition = function() {
		var e = this.state, t = [], n = [], r = this.derivedHelpers.map(function(n) {
			var r = n.getModifiedState(e), i = d._getCompositionQueries(r);
			return t.push({
				state: r,
				helper: n
			}), n.emit("search", {
				state: r,
				results: n.lastResults
			}), i;
		}), i = Array.prototype.concat.apply(n, r), a = this._queryId++;
		if (this._currentNbQueries++, !i.length) return Promise.resolve({ results: [] }).then(this._dispatchAlgoliaResponse.bind(this, t, a));
		if (i.length > 1) throw Error("Only one query is allowed when using a composition.");
		var o = i[0];
		try {
			this.client.search(o).then(this._dispatchAlgoliaResponse.bind(this, t, a)).catch(this._dispatchAlgoliaError.bind(this, a));
		} catch (e) {
			this.emit("error", { error: e });
		}
	}, g.prototype._recommend = function() {
		var e = this.state, t = this.recommendState, n = this.getIndex(), r = [{
			state: t,
			index: n,
			helper: this
		}], i = t.params.map(function(e) {
			return e.$$id;
		});
		this.emit("fetch", { recommend: {
			state: t,
			results: this.lastRecommendResults
		} });
		var a = this._recommendCache, o = this.derivedHelpers.map(function(t) {
			var n = t.getModifiedState(e).index;
			if (!n) return [];
			var o = t.getModifiedRecommendState(new l());
			return r.push({
				state: o,
				index: n,
				helper: t
			}), i = Array.prototype.concat.apply(i, o.params.map(function(e) {
				return e.$$id;
			})), t.emit("fetch", { recommend: {
				state: o,
				results: t.lastRecommendResults
			} }), o._buildQueries(n, a);
		}), s = Array.prototype.concat.apply(this.recommendState._buildQueries(n, a), o);
		if (s.length !== 0) {
			if (s.length > 0 && this.client.getRecommendations === void 0) {
				console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
				return;
			}
			var c = this._recommendQueryId++;
			this._currentNbRecommendQueries++;
			try {
				this.client.getRecommendations(s).then(this._dispatchRecommendResponse.bind(this, c, r, i)).catch(this._dispatchRecommendError.bind(this, c));
			} catch (e) {
				this.emit("error", { error: e });
			}
		}
	}, g.prototype._dispatchAlgoliaResponse = function(e, t, n) {
		var r = this;
		if (!(t < this._lastQueryIdReceived)) {
			this._currentNbQueries -= t - this._lastQueryIdReceived, this._lastQueryIdReceived = t, this._currentNbQueries === 0 && this.emit("searchQueueEmpty");
			var i = n.results.slice(), a = Object.keys(n).reduce(function(e, t) {
				return t !== "results" && (e[t] = n[t]), e;
			}, {});
			Object.keys(a).length <= 0 && (a = void 0), e.forEach(function(e) {
				var t = e.state, n = e.queriesCount, o = e.helper, s = n === void 0 ? i : i.splice(0, n);
				if (!t.index) {
					o.emit("result", {
						results: null,
						state: t
					});
					return;
				}
				if (s.length > 0 && s[0].feedID) {
					var c = s.map(function(e) {
						var n = new p(t, [e], r._searchResultsOptions);
						return a !== void 0 && (n._rawContent = a), n;
					});
					o.lastResults = new p(t, [s[0]], r._searchResultsOptions), o.lastResults.feeds = c, a !== void 0 && (o.lastResults._rawContent = a);
				} else o.lastResults = new p(t, s, r._searchResultsOptions), a !== void 0 && (o.lastResults._rawContent = a);
				o.emit("result", {
					results: o.lastResults,
					state: t
				});
			});
		}
	}, g.prototype._dispatchRecommendResponse = function(e, t, n, r) {
		if (!(e < this._lastRecommendQueryIdReceived)) {
			this._currentNbRecommendQueries -= e - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = e, this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty");
			var i = this._recommendCache, a = {};
			n.filter(function(e) {
				return i[e] === void 0;
			}).forEach(function(e, t) {
				a[e] || (a[e] = []), a[e].push(t);
			}), Object.keys(a).forEach(function(e) {
				var t = a[e], o = r.results[t[0]];
				if (t.length === 1) {
					i[e] = o;
					return;
				}
				i[e] = Object.assign({}, o, { hits: m(n, t.map(function(e) {
					return r.results[e].hits;
				})) });
			});
			var o = {};
			n.forEach(function(e) {
				o[e] = i[e];
			}), t.forEach(function(e) {
				var t = e.state, n = e.helper;
				if (!e.index) {
					n.emit("recommend:result", {
						results: null,
						state: t
					});
					return;
				}
				n.lastRecommendResults = new u(t, o), n.emit("recommend:result", { recommend: {
					results: n.lastRecommendResults,
					state: t
				} });
			});
		}
	}, g.prototype._dispatchAlgoliaError = function(e, t) {
		e < this._lastQueryIdReceived || (this._currentNbQueries -= e - this._lastQueryIdReceived, this._lastQueryIdReceived = e, this.emit("error", { error: t }), this._currentNbQueries === 0 && this.emit("searchQueueEmpty"));
	}, g.prototype._dispatchRecommendError = function(e, t) {
		e < this._lastRecommendQueryIdReceived || (this._currentNbRecommendQueries -= e - this._lastRecommendQueryIdReceived, this._lastRecommendQueryIdReceived = e, this.emit("error", { error: t }), this._currentNbRecommendQueries === 0 && this.emit("recommendQueueEmpty"));
	}, g.prototype.containsRefinement = function(e, t, n, r) {
		return e || t.length !== 0 || n.length !== 0 || r.length !== 0;
	}, g.prototype._hasDisjunctiveRefinements = function(e) {
		return this.state.disjunctiveRefinements[e] && this.state.disjunctiveRefinements[e].length > 0;
	}, g.prototype._change = function(e) {
		var t = e.state, n = e.isPageReset;
		t !== this.state && (this.state = t, this.emit("change", {
			state: this.state,
			results: this.lastResults,
			isPageReset: n
		}));
	}, g.prototype._recommendChange = function(e) {
		var t = e.state;
		t !== this.recommendState && (this.recommendState = t, this.emit("recommend:change", {
			search: {
				results: this.lastResults,
				state: this.state
			},
			recommend: {
				results: this.lastRecommendResults,
				state: this.recommendState
			}
		}));
	}, g.prototype.clearCache = function() {
		return this.client.clearCache && this.client.clearCache(), this;
	}, g.prototype.setClient = function(e) {
		return this.client === e ? this : (typeof e.addAlgoliaAgent == "function" && e.addAlgoliaAgent("JS Helper (" + h + ")"), this.client = e, this);
	}, g.prototype.getClient = function() {
		return this.client;
	}, g.prototype.derive = function(e, t) {
		var n = new r(this, e, t);
		return this.derivedHelpers.push(n), n;
	}, g.prototype.detachDerivedHelper = function(e) {
		var t = this.derivedHelpers.indexOf(e);
		if (t === -1) throw Error("Derived helper already detached");
		this.derivedHelpers.splice(t, 1);
	}, g.prototype.hasPendingRequests = function() {
		return this._currentNbQueries > 0;
	}, t.exports = g;
})), $d = /* @__PURE__ */ p(((e, t) => {
	var n = Qd(), r = Md(), i = Nd(), a = Vd(), o = Jd();
	function s(e, t, r, i) {
		return new n(e, t, r, i);
	}
	s.version = Zd(), s.AlgoliaSearchHelper = n, s.SearchParameters = a, s.RecommendParameters = r, s.SearchResults = o, s.RecommendResults = i, t.exports = s;
})), ef = /* @__PURE__ */ g(Td()), Y = /* @__PURE__ */ g($d());
function tf() {}
//#endregion
//#region node_modules/instantsearch.js/es/index38.js
function nf(e, t) {
	for (var n, r = 0; r < e.length; r++) if (n = e[r], t(n, r, e)) return n;
}
//#endregion
//#region node_modules/instantsearch.js/es/index40.js
function rf(e) {
	var t = e;
	return t.transporter && t.transporter.userAgent ? t.transporter.userAgent.value : t._ua;
}
//#endregion
//#region node_modules/instantsearch.js/es/index41.js
function af(e) {
	if (e.appId && e.apiKey) return [e.appId, e.apiKey];
	if (e.transporter) {
		var t = e.transporter, n = t.headers || t.baseHeaders, r = t.queryParameters || t.baseQueryParameters, i = "x-algolia-application-id", a = "x-algolia-api-key";
		return [n[i] || r[i], n[a] || r[a]];
	} else return [e.applicationID, e.apiKey];
}
//#endregion
//#region node_modules/instantsearch.js/es/index45.js
function of(e, t) {
	return e == null ? e : Object.keys(e).reduce(function(n, r) {
		if (t.indexOf(r) >= 0) return n;
		var i = r;
		return n[i] = e[i], n;
	}, {});
}
//#endregion
//#region node_modules/instantsearch.js/es/index11.js
var sf = ["ais.index", "ais.feedContainer"];
//#endregion
//#region node_modules/instantsearch.js/es/index21.js
function cf(e) {
	return sf.includes(e.$$type);
}
//#endregion
//#region node_modules/instantsearch.js/es/index47.js
function lf(e, t, n) {
	var r = t.getHelper();
	return {
		uiState: n,
		helper: r,
		parent: t,
		instantSearchInstance: e,
		state: r.state,
		renderState: e.renderState,
		templatesConfig: e.templatesConfig,
		createURL: t.createURL,
		scopedResults: [],
		searchMetadata: { isSearchStalled: e.status === "stalled" },
		status: e.status,
		error: e.error
	};
}
function uf(e, t, n) {
	var r = t.getResultsForWidget(n), i = t.getHelper();
	return {
		helper: i,
		parent: t,
		instantSearchInstance: e,
		results: r,
		scopedResults: t.getScopedResults(),
		state: r && "_state" in r ? r._state : i.state,
		renderState: e.renderState,
		templatesConfig: e.templatesConfig,
		createURL: t.createURL,
		searchMetadata: { isSearchStalled: e.status === "stalled" },
		status: e.status,
		error: e.error
	};
}
function df(e) {
	var t = e.renderState, n = e.instantSearchInstance, r = e.parent, i = r ? r.getIndexId() : n.mainIndex.getIndexId();
	n.renderState = q(K({}, n.renderState), G({}, i, K({}, n.renderState[i], t)));
}
//#endregion
//#region node_modules/instantsearch.js/es/index46.js
function ff(e) {
	if (e == null) return null;
	var t = e === void 0 ? "undefined" : ku(e);
	if (t === "string" || t === "number" || t === "boolean") return {
		value: String(e),
		type: t
	};
	if (Array.isArray(e) || t === "object") {
		var n = Array.isArray(e) ? "array" : "object";
		try {
			return {
				value: JSON.stringify(e),
				type: n
			};
		} catch {
			return { type: n };
		}
	}
	return t === "function" ? {
		value: e.name,
		type: "function"
	} : null;
}
function pf(e) {
	var t = [];
	return Object.keys(e).forEach(function(n) {
		var r = e[n];
		if (r !== void 0) {
			var i = ff(r);
			i ? t.push(K({ name: n }, i)) : t.push({ name: n });
		}
	}), t;
}
function mf(e, t) {
	var n = lf(t, arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.mainIndex, t._initialUiState);
	return e.map(function(e) {
		var r = {};
		if (e.getWidgetRenderState) {
			var i = e.getWidgetRenderState(n);
			i && i.widgetParams && (r = i.widgetParams);
		}
		var a = pf(r), o = cf(e) ? mf(e.getWidgets(), t, e) : [];
		return {
			type: e.$$widgetType || e.$$type || "unknown",
			params: a,
			children: o
		};
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index25.js
var hf = typeof performance < "u" ? function() {
	return performance.now();
} : function() {
	return Date.now();
}, gf = "4.107.0", _f = "2.17.2", vf = `https://cdn.jsdelivr.net/npm/search-insights@${_f}/dist/search-insights.min.js`, yf = [
	"searchClient",
	"insightsClient",
	"initialUiState"
];
function bf() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.insightsClient, n = e.insightsInitParams, r = e.onEvent, i = e.$$internal, a = i !== void 0 && i, o = e.$$automatic, s = o !== void 0 && o, c = t;
	!t && t !== null && fd(function(e) {
		var t = e.window, n = t.AlgoliaAnalyticsObject || "aa";
		typeof n == "string" && (c = t[n]), c ||= (t.AlgoliaAnalyticsObject = n, t[n] || (t[n] = function() {
			var e = [...arguments];
			t[n].queue || (t[n].queue = []), t[n].queue.push(e);
		}, t[n].version = _f, t[n].shouldAddScript = !0), t[n]);
	});
	var l = c || tf;
	return function(e) {
		var t = e.instantSearchInstance, i, o = t.middleware.filter(function(e) {
			return e.instance.$$type === "ais.insights" && e.instance.$$internal;
		}).map(function(e) {
			return e.creator;
		});
		(i = t).unuse.apply(i, W(o));
		var c = U(af(t.client), 2), u = c[0], d = c[1], f = void 0, p = void 0, m = void 0, h = l.queue;
		if (Array.isArray(h)) {
			var g = U(["setUserToken", "init"].map(function(e) {
				return U(nf(h.slice().reverse(), function(t) {
					return U(t, 1)[0] === e;
				}) || [], 2)[1];
			}), 2);
			p = g[0], f = g[1];
		}
		l("getUserToken", null, function(e, t) {
			m = wf(t);
		}), (n || !Cf(l)) && l("init", K({
			appId: u,
			apiKey: d,
			partial: !0
		}, n));
		var _, v, y = null;
		return {
			$$type: "ais.insights",
			$$internal: a,
			$$automatic: s,
			onStateChange: function() {},
			subscribe: function() {
				if (l.shouldAddScript) {
					var e = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
					try {
						var n = document.createElement("script");
						n.async = !0, n.src = vf, n.onerror = function() {
							t.emit("error", Error(e));
						}, document.body.appendChild(n), l.shouldAddScript = !1;
					} catch {
						l.shouldAddScript = !1, t.emit("error", Error(e));
					}
				}
			},
			started: function() {
				l("addAlgoliaAgent", "insights-middleware"), v = t.mainHelper;
				var e = l.queue;
				if (Array.isArray(e)) {
					var i = U(["setUserToken", "init"].map(function(t) {
						return U(nf(e.slice().reverse(), function(e) {
							return U(e, 1)[0] === t;
						}) || [], 2)[1];
					}), 2);
					p = i[0], f = i[1];
				}
				_ = xf(t), s || v.overrideStateWithoutTriggeringChangeEvent(q(K({}, v.state), { clickAnalytics: !0 })), a || t.scheduleSearch();
				var o = function(e) {
					var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], r = wf(e);
					if (!r) return;
					var i = v.state.userToken;
					function a() {
						v.overrideStateWithoutTriggeringChangeEvent(q(K({}, v.state), { userToken: r })), i && i !== e && t.scheduleSearch();
					}
					n ? a() : setTimeout(a, 0);
				};
				function c(e) {
					o(e, !0), l("setUserToken", e);
				}
				var d = void 0;
				d = cd() || `anonymous-${ed()}`;
				var h, g = _.userToken;
				n?.userToken && (h = n.userToken), h ? c(h) : g ? c(g) : m ? c(m) : p ? c(p) : d && (c(d), (n?.useCookie || f?.useCookie) && Sf(d, n?.cookieDuration || f?.cookieDuration)), l("onUserTokenChange", function(e) {
					return o(e, !0);
				}, { immediate: !0 });
				var b = l;
				Cf(l) && (b = function(e, n) {
					var r = U(af(t.client), 2);
					return l(e, n, { headers: {
						"X-Algolia-Application-Id": r[0],
						"X-Algolia-API-Key": r[1]
					} });
				});
				var x = /* @__PURE__ */ new Set(), S;
				t.mainHelper.derivedHelpers[0].on("result", function(e) {
					var t = e.results;
					t && (!t.queryID || t.queryID !== S) && (S = t.queryID, x.clear());
				}), t.sendEventToInsights = function(e) {
					if (r) r(e, b);
					else if (e.insightsMethod) {
						if (e.insightsMethod === "viewedObjectIDs") {
							var t = e.payload, n = t.objectIDs.filter(function(e) {
								return !x.has(e);
							});
							if (n.length === 0) return;
							n.forEach(function(e) {
								return x.add(e);
							}), t.objectIDs = n;
						}
						e.payload.algoliaSource = ["instantsearch"], s && e.payload.algoliaSource.push("instantsearch-automatic"), e.eventModifier === "internal" && e.payload.algoliaSource.push("instantsearch-internal"), b(e.insightsMethod, e.payload);
					}
				}, fd(function() {
					var e = rd();
					function n(t) {
						var n = v.state?.userToken;
						b("sendEvents", [K({
							eventType: "instantsearch",
							timestamp: Date.now(),
							sessionID: e,
							userToken: n ? String(n) : void 0
						}, t)]);
					}
					var r = function() {
						try {
							var e = Math.round(hf() - t._createdAt);
							n({
								eventName: "__start__",
								algoliaAgent: rf(t.client),
								version: gf,
								applicationId: u,
								performance: { bootstrapMs: e },
								widgets: [{
									type: "ais.instantSearch",
									params: t._initialOptions ? pf(of(t._initialOptions, W(yf))) : [],
									children: mf(t.mainIndex.getWidgets(), t)
								}]
							});
						} catch {}
					};
					t.once("render", r), y = function() {
						return t.removeListener("render", r);
					};
				});
			},
			unsubscribe: function() {
				y && y(), l("onUserTokenChange", void 0), t.sendEventToInsights = tf, v && _ && (v.overrideStateWithoutTriggeringChangeEvent(K({}, v.state, _)), t.scheduleSearch());
			}
		};
	};
}
function xf(e) {
	var t = e._initialResults?.[e.indexName]?.state || {}, n = e.mainHelper.state;
	return {
		userToken: t.userToken || n.userToken,
		clickAnalytics: t.clickAnalytics || n.clickAnalytics
	};
}
function Sf(e, t) {
	var n = 720 * 60 * 60 * 1e3, r = /* @__PURE__ */ new Date();
	r.setTime(r.getTime() + (t || n * 6));
	var i = `expires=${r.toUTCString()}`;
	document.cookie = `_ALGOLIA=${e};${i};path=/`;
}
function Cf(e) {
	var t = U((e.version || "").split(".").map(Number), 2), n = t[0], r = t[1];
	return n >= 3 || n === 2 && r >= 6 || n === 1 && r >= 10;
}
function wf(e) {
	if (e) return typeof e == "number" ? e.toString() : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/index48.js
function Tf(e, t, n) {
	var r = lf(t, arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t.mainIndex, t._initialUiState);
	e.forEach(function(e) {
		var i = {};
		if (e.getWidgetRenderState) {
			var a = e.getWidgetRenderState(r);
			a && a.widgetParams && (i = a.widgetParams);
		}
		var o = Object.keys(i).filter(function(e) {
			return i[e] !== void 0;
		});
		n.widgets.push({
			type: e.$$type,
			widgetType: e.$$widgetType,
			params: o
		}), cf(e) && Tf(e.getWidgets(), t, n, e);
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index15.js
function Ef() {
	return fd(function(e) {
		return e.window.navigator?.userAgent?.indexOf("Algolia Crawler") > -1;
	}, { fallback: function() {
		return !1;
	} });
}
function Df() {
	var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).$$internal, t = e !== void 0 && e;
	return function(e) {
		var n = e.instantSearchInstance, r = { widgets: [] }, i = document.createElement("meta"), a = document.querySelector("head");
		return i.name = "instantsearch:widgets", {
			$$type: "ais.metadata",
			$$internal: t,
			onStateChange: function() {},
			subscribe: function() {
				setTimeout(function() {
					r.ua = rf(n.client), Tf(n.mainIndex.getWidgets(), n, r), n.middleware.forEach(function(e) {
						return r.widgets.push({
							middleware: !0,
							type: e.instance.$$type,
							internal: e.instance.$$internal
						});
					}), i.content = JSON.stringify(r), a.appendChild(i);
				}, 0);
			},
			started: function() {},
			unsubscribe: function() {
				i.remove();
			}
		};
	};
}
//#endregion
//#region node_modules/es-errors/type.js
var Of = /* @__PURE__ */ p(((e, t) => {
	t.exports = TypeError;
})), kf = /* @__PURE__ */ p(((e, t) => {
	var n = typeof Map == "function" && Map.prototype, r = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, i = n && r && typeof r.get == "function" ? r.get : null, a = n && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, s = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, c = o && s && typeof s.get == "function" ? s.get : null, l = o && Set.prototype.forEach, u = typeof WeakMap == "function" && WeakMap.prototype ? WeakMap.prototype.has : null, d = typeof WeakSet == "function" && WeakSet.prototype ? WeakSet.prototype.has : null, f = typeof WeakRef == "function" && WeakRef.prototype ? WeakRef.prototype.deref : null, p = Boolean.prototype.valueOf, m = Object.prototype.toString, h = Function.prototype.toString, g = String.prototype.match, _ = String.prototype.slice, v = String.prototype.replace, y = String.prototype.toUpperCase, b = String.prototype.toLowerCase, x = RegExp.prototype.test, S = Array.prototype.concat, C = Array.prototype.join, w = Array.prototype.slice, T = Math.floor, E = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, D = Object.getOwnPropertySymbols, ee = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, O = typeof Symbol == "function" && typeof Symbol.iterator == "object", k = typeof Symbol == "function" && Symbol.toStringTag ? Symbol.toStringTag : null, A = Object.prototype.propertyIsEnumerable, j = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
		return e.__proto__;
	} : null);
	function te(e, t) {
		if (e === Infinity || e === -Infinity || e !== e || e && e > -1e3 && e < 1e3 || x.call(/e/, t)) return t;
		var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
		if (typeof e == "number") {
			var r = e < 0 ? -T(-e) : T(e);
			if (r !== e) {
				var i = String(r), a = _.call(t, i.length + 1);
				return v.call(i, n, "$&_") + "." + v.call(v.call(a, /([0-9]{3})/g, "$&_"), /_$/, "");
			}
		}
		return v.call(t, n, "$&_");
	}
	var ne = kc(), M = ne.custom, re = he(M) ? M : null, ie = {
		__proto__: null,
		double: "\"",
		single: "'"
	}, ae = {
		__proto__: null,
		double: /(["\\])/g,
		single: /(['\\])/g
	};
	t.exports = function e(t, n, r, o) {
		var s = n || {};
		if (ve(s, "quoteStyle") && !ve(ie, s.quoteStyle)) throw TypeError("option \"quoteStyle\" must be \"single\" or \"double\"");
		if (ve(s, "maxStringLength") && (typeof s.maxStringLength == "number" ? s.maxStringLength < 0 && s.maxStringLength !== Infinity : s.maxStringLength !== null)) throw TypeError("option \"maxStringLength\", if provided, must be a positive integer, Infinity, or `null`");
		var u = !ve(s, "customInspect") || s.customInspect;
		if (typeof u != "boolean" && u !== "symbol") throw TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
		if (ve(s, "indent") && s.indent !== null && s.indent !== "	" && !(parseInt(s.indent, 10) === s.indent && s.indent > 0)) throw TypeError("option \"indent\" must be \"\\t\", an integer > 0, or `null`");
		if (ve(s, "numericSeparator") && typeof s.numericSeparator != "boolean") throw TypeError("option \"numericSeparator\", if provided, must be `true` or `false`");
		var d = s.numericSeparator;
		if (t === void 0) return "undefined";
		if (t === null) return "null";
		if (typeof t == "boolean") return t ? "true" : "false";
		if (typeof t == "string") return Oe(t, s);
		if (typeof t == "number") {
			if (t === 0) return Infinity / t > 0 ? "0" : "-0";
			var f = String(t);
			return d ? te(t, f) : f;
		}
		if (typeof t == "bigint") {
			var m = String(t) + "n";
			return d ? te(t, m) : m;
		}
		var h = s.depth === void 0 ? 5 : s.depth;
		if (r === void 0 && (r = 0), r >= h && h > 0 && typeof t == "object") return ce(t) ? "[Array]" : "[Object]";
		var g = Pe(s, r);
		if (o === void 0) o = [];
		else if (xe(o, t) >= 0) return "[Circular]";
		function y(t, n, i) {
			if (n && (o = w.call(o), o.push(n)), i) {
				var a = { depth: s.depth };
				return ve(s, "quoteStyle") && (a.quoteStyle = s.quoteStyle), e(t, a, r + 1, o);
			}
			return e(t, s, r + 1, o);
		}
		if (typeof t == "function" && !ue(t)) {
			var x = be(t), T = Ie(t, y);
			return "[Function" + (x ? ": " + x : " (anonymous)") + "]" + (T.length > 0 ? " { " + C.call(T, ", ") + " }" : "");
		}
		if (he(t)) {
			var D = O ? v.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : ee.call(t);
			return typeof t == "object" && !O ? Ae(D) : D;
		}
		if (De(t)) {
			for (var M = "<" + b.call(String(t.nodeName)), ae = t.attributes || [], N = 0; N < ae.length; N++) M += " " + ae[N].name + "=" + oe(se(ae[N].value), "double", s);
			return M += ">", t.childNodes && t.childNodes.length && (M += "..."), M += "</" + b.call(String(t.nodeName)) + ">", M;
		}
		if (ce(t)) {
			if (t.length === 0) return "[]";
			var _e = Ie(t, y);
			return g && !Ne(_e) ? "[" + Fe(_e, g) + "]" : "[ " + C.call(_e, ", ") + " ]";
		}
		if (de(t)) {
			var ke = Ie(t, y);
			return !("cause" in Error.prototype) && "cause" in t && !A.call(t, "cause") ? "{ [" + String(t) + "] " + C.call(S.call("[cause]: " + y(t.cause), ke), ", ") + " }" : ke.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + C.call(ke, ", ") + " }";
		}
		if (typeof t == "object" && u) {
			if (re && typeof t[re] == "function" && ne) return ne(t, { depth: h - r });
			if (u !== "symbol" && typeof t.inspect == "function") return t.inspect();
		}
		if (Se(t)) {
			var Le = [];
			return a && a.call(t, function(e, n) {
				Le.push(y(n, t, !0) + " => " + y(e, t));
			}), Me("Map", i.call(t), Le, g);
		}
		if (Te(t)) {
			var P = [];
			return l && l.call(t, function(e) {
				P.push(y(e, t));
			}), Me("Set", c.call(t), P, g);
		}
		if (Ce(t)) return je("WeakMap");
		if (Ee(t)) return je("WeakSet");
		if (we(t)) return je("WeakRef");
		if (pe(t)) return Ae(y(Number(t)));
		if (ge(t)) return Ae(y(E.call(t)));
		if (me(t)) return Ae(p.call(t));
		if (fe(t)) return Ae(y(String(t)));
		if (typeof window < "u" && t === window) return "{ [object Window] }";
		if (typeof globalThis < "u" && t === globalThis || typeof global < "u" && t === global) return "{ [object globalThis] }";
		if (!le(t) && !ue(t)) {
			var Re = Ie(t, y), ze = j ? j(t) === Object.prototype : t instanceof Object || t.constructor === Object, Be = t instanceof Object ? "" : "null prototype", Ve = !ze && k && Object(t) === t && k in t ? _.call(ye(t), 8, -1) : Be ? "Object" : "", He = (ze || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "") + (Ve || Be ? "[" + C.call(S.call([], Ve || [], Be || []), ": ") + "] " : "");
			return Re.length === 0 ? He + "{}" : g ? He + "{" + Fe(Re, g) + "}" : He + "{ " + C.call(Re, ", ") + " }";
		}
		return String(t);
	};
	function oe(e, t, n) {
		var r = ie[n.quoteStyle || t];
		return r + e + r;
	}
	function se(e) {
		return v.call(String(e), /"/g, "&quot;");
	}
	function N(e) {
		return !k || !(typeof e == "object" && (k in e || e[k] !== void 0));
	}
	function ce(e) {
		return ye(e) === "[object Array]" && N(e);
	}
	function le(e) {
		return ye(e) === "[object Date]" && N(e);
	}
	function ue(e) {
		return ye(e) === "[object RegExp]" && N(e);
	}
	function de(e) {
		return ye(e) === "[object Error]" && N(e);
	}
	function fe(e) {
		return ye(e) === "[object String]" && N(e);
	}
	function pe(e) {
		return ye(e) === "[object Number]" && N(e);
	}
	function me(e) {
		return ye(e) === "[object Boolean]" && N(e);
	}
	function he(e) {
		if (O) return e && typeof e == "object" && e instanceof Symbol;
		if (typeof e == "symbol") return !0;
		if (!e || typeof e != "object" || !ee) return !1;
		try {
			return ee.call(e), !0;
		} catch {}
		return !1;
	}
	function ge(e) {
		if (!e || typeof e != "object" || !E) return !1;
		try {
			return E.call(e), !0;
		} catch {}
		return !1;
	}
	var _e = Object.prototype.hasOwnProperty || function(e) {
		return e in this;
	};
	function ve(e, t) {
		return _e.call(e, t);
	}
	function ye(e) {
		return m.call(e);
	}
	function be(e) {
		if (e.name) return e.name;
		var t = g.call(h.call(e), /^function\s*([\w$]+)/);
		return t ? t[1] : null;
	}
	function xe(e, t) {
		if (e.indexOf) return e.indexOf(t);
		for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
		return -1;
	}
	function Se(e) {
		if (!i || !e || typeof e != "object") return !1;
		try {
			i.call(e);
			try {
				c.call(e);
			} catch {
				return !0;
			}
			return e instanceof Map;
		} catch {}
		return !1;
	}
	function Ce(e) {
		if (!u || !e || typeof e != "object") return !1;
		try {
			u.call(e, u);
			try {
				d.call(e, d);
			} catch {
				return !0;
			}
			return e instanceof WeakMap;
		} catch {}
		return !1;
	}
	function we(e) {
		if (!f || !e || typeof e != "object") return !1;
		try {
			return f.call(e), !0;
		} catch {}
		return !1;
	}
	function Te(e) {
		if (!c || !e || typeof e != "object") return !1;
		try {
			c.call(e);
			try {
				i.call(e);
			} catch {
				return !0;
			}
			return e instanceof Set;
		} catch {}
		return !1;
	}
	function Ee(e) {
		if (!d || !e || typeof e != "object") return !1;
		try {
			d.call(e, d);
			try {
				u.call(e, u);
			} catch {
				return !0;
			}
			return e instanceof WeakSet;
		} catch {}
		return !1;
	}
	function De(e) {
		return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement || typeof e.nodeName == "string" && typeof e.getAttribute == "function";
	}
	function Oe(e, t) {
		if (e.length > t.maxStringLength) {
			var n = e.length - t.maxStringLength, r = "... " + n + " more character" + (n > 1 ? "s" : "");
			return Oe(_.call(e, 0, t.maxStringLength), t) + r;
		}
		var i = ae[t.quoteStyle || "single"];
		return i.lastIndex = 0, oe(v.call(v.call(e, i, "\\$1"), /[\x00-\x1f]/g, ke), "single", t);
	}
	function ke(e) {
		var t = e.charCodeAt(0), n = {
			8: "b",
			9: "t",
			10: "n",
			12: "f",
			13: "r"
		}[t];
		return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + y.call(t.toString(16));
	}
	function Ae(e) {
		return "Object(" + e + ")";
	}
	function je(e) {
		return e + " { ? }";
	}
	function Me(e, t, n, r) {
		var i = r ? Fe(n, r) : C.call(n, ", ");
		return e + " (" + t + ") {" + i + "}";
	}
	function Ne(e) {
		for (var t = 0; t < e.length; t++) if (xe(e[t], "\n") >= 0) return !1;
		return !0;
	}
	function Pe(e, t) {
		var n;
		if (e.indent === "	") n = "	";
		else if (typeof e.indent == "number" && e.indent > 0) n = C.call(Array(e.indent + 1), " ");
		else return null;
		return {
			base: n,
			prev: C.call(Array(t + 1), n)
		};
	}
	function Fe(e, t) {
		if (e.length === 0) return "";
		var n = "\n" + t.prev + t.base;
		return n + C.call(e, "," + n) + "\n" + t.prev;
	}
	function Ie(e, t) {
		var n = ce(e), r = [];
		if (n) {
			r.length = e.length;
			for (var i = 0; i < e.length; i++) r[i] = ve(e, i) ? t(e[i], e) : "";
		}
		var a = typeof D == "function" ? D(e) : [], o;
		if (O) {
			o = {};
			for (var s = 0; s < a.length; s++) o["$" + a[s]] = a[s];
		}
		for (var c in e) ve(e, c) && (n && String(Number(c)) === c && c < e.length || O && o["$" + c] instanceof Symbol || (x.call(/[^\w$]/, c) ? r.push(t(c, e) + ": " + t(e[c], e)) : r.push(c + ": " + t(e[c], e))));
		if (typeof D == "function") for (var l = 0; l < a.length; l++) A.call(e, a[l]) && r.push("[" + t(a[l]) + "]: " + t(e[a[l]], e));
		return r;
	}
})), Af = /* @__PURE__ */ p(((e, t) => {
	var n = kf(), r = Of(), i = function(e, t, n) {
		for (var r = e, i; (i = r.next) != null; r = i) if (i.key === t) return r.next = i.next, n || (i.next = e.next, e.next = i), i;
	}, a = function(e, t) {
		if (e) {
			var n = i(e, t);
			return n && n.value;
		}
	}, o = function(e, t, n) {
		var r = i(e, t);
		r ? r.value = n : e.next = {
			key: t,
			next: e.next,
			value: n
		};
	}, s = function(e, t) {
		return e ? !!i(e, t) : !1;
	}, c = function(e, t) {
		if (e) return i(e, t, !0);
	};
	t.exports = function() {
		var e, t = {
			assert: function(e) {
				if (!t.has(e)) throw new r("Side channel does not contain " + n(e));
			},
			delete: function(t) {
				var n = c(e, t);
				return n && e && !e.next && (e = void 0), !!n;
			},
			get: function(t) {
				return a(e, t);
			},
			has: function(t) {
				return s(e, t);
			},
			set: function(t, n) {
				e ||= { next: void 0 }, o(e, t, n);
			}
		};
		return t;
	};
})), jf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Object;
})), Mf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Error;
})), Nf = /* @__PURE__ */ p(((e, t) => {
	t.exports = EvalError;
})), Pf = /* @__PURE__ */ p(((e, t) => {
	t.exports = RangeError;
})), Ff = /* @__PURE__ */ p(((e, t) => {
	t.exports = ReferenceError;
})), If = /* @__PURE__ */ p(((e, t) => {
	t.exports = SyntaxError;
})), Lf = /* @__PURE__ */ p(((e, t) => {
	t.exports = URIError;
})), Rf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Math.abs;
})), zf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Math.floor;
})), Bf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Math.max;
})), Vf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Math.min;
})), Hf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Math.pow;
})), Uf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Math.round;
})), Wf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Number.isNaN || function(e) {
		return e !== e;
	};
})), Gf = /* @__PURE__ */ p(((e, t) => {
	var n = Wf();
	t.exports = function(e) {
		return n(e) || e === 0 ? e : e < 0 ? -1 : 1;
	};
})), Kf = /* @__PURE__ */ p(((e, t) => {
	t.exports = Object.getOwnPropertyDescriptor;
})), qf = /* @__PURE__ */ p(((e, t) => {
	var n = Kf();
	if (n) try {
		n([], "length");
	} catch {
		n = null;
	}
	t.exports = n;
})), Jf = /* @__PURE__ */ p(((e, t) => {
	var n = Object.defineProperty || !1;
	if (n) try {
		n({}, "a", { value: 1 });
	} catch {
		n = !1;
	}
	t.exports = n;
})), Yf = /* @__PURE__ */ p(((e, t) => {
	t.exports = function() {
		if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
		if (typeof Symbol.iterator == "symbol") return !0;
		var e = {}, t = Symbol("test"), n = Object(t);
		if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]") return !1;
		var r = 42;
		for (var i in e[t] = r, e) return !1;
		if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0) return !1;
		var a = Object.getOwnPropertySymbols(e);
		if (a.length !== 1 || a[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
		if (typeof Object.getOwnPropertyDescriptor == "function") {
			var o = Object.getOwnPropertyDescriptor(e, t);
			if (o.value !== r || o.enumerable !== !0) return !1;
		}
		return !0;
	};
})), Xf = /* @__PURE__ */ p(((e, t) => {
	var n = typeof Symbol < "u" && Symbol, r = Yf();
	t.exports = function() {
		return typeof n != "function" || typeof Symbol != "function" || typeof n("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : r();
	};
})), Zf = /* @__PURE__ */ p(((e, t) => {
	t.exports = typeof Reflect < "u" && Reflect.getPrototypeOf || null;
})), Qf = /* @__PURE__ */ p(((e, t) => {
	t.exports = jf().getPrototypeOf || null;
})), $f = /* @__PURE__ */ p(((e, t) => {
	var n = Object.prototype.toString, r = Math.max, i = "[object Function]", a = function(e, t) {
		for (var n = [], r = 0; r < e.length; r += 1) n[r] = e[r];
		for (var i = 0; i < t.length; i += 1) n[i + e.length] = t[i];
		return n;
	}, o = function(e, t) {
		for (var n = [], r = t || 0, i = 0; r < e.length; r += 1, i += 1) n[i] = e[r];
		return n;
	}, s = function(e, t) {
		for (var n = "", r = 0; r < e.length; r += 1) n += e[r], r + 1 < e.length && (n += t);
		return n;
	};
	t.exports = function(e) {
		var t = this;
		if (typeof t != "function" || n.apply(t) !== i) throw TypeError("Function.prototype.bind called on incompatible " + t);
		for (var c = o(arguments, 1), l, u = function() {
			if (this instanceof l) {
				var n = t.apply(this, a(c, arguments));
				return Object(n) === n ? n : this;
			}
			return t.apply(e, a(c, arguments));
		}, d = r(0, t.length - c.length), f = [], p = 0; p < d; p++) f[p] = "$" + p;
		if (l = Function("binder", "return function (" + s(f, ",") + "){ return binder.apply(this,arguments); }")(u), t.prototype) {
			var m = function() {};
			m.prototype = t.prototype, l.prototype = new m(), m.prototype = null;
		}
		return l;
	};
})), ep = /* @__PURE__ */ p(((e, t) => {
	var n = $f();
	t.exports = Function.prototype.bind || n;
})), tp = /* @__PURE__ */ p(((e, t) => {
	t.exports = Function.prototype.call;
})), np = /* @__PURE__ */ p(((e, t) => {
	t.exports = Function.prototype.apply;
})), rp = /* @__PURE__ */ p(((e, t) => {
	t.exports = typeof Reflect < "u" && Reflect && Reflect.apply;
})), ip = /* @__PURE__ */ p(((e, t) => {
	var n = ep(), r = np(), i = tp();
	t.exports = rp() || n.call(i, r);
})), ap = /* @__PURE__ */ p(((e, t) => {
	var n = ep(), r = Of(), i = tp(), a = ip();
	t.exports = function(e) {
		if (e.length < 1 || typeof e[0] != "function") throw new r("a function is required");
		return a(n, i, e);
	};
})), op = /* @__PURE__ */ p(((e, t) => {
	var n = ap(), r = qf(), i;
	try {
		i = [].__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e != "object" || !("code" in e) || e.code !== "ERR_PROTO_ACCESS") throw e;
	}
	var a = !!i && r && r(Object.prototype, "__proto__"), o = Object, s = o.getPrototypeOf;
	t.exports = a && typeof a.get == "function" ? n([a.get]) : typeof s == "function" && function(e) {
		return s(e == null ? e : o(e));
	};
})), sp = /* @__PURE__ */ p(((e, t) => {
	var n = Zf(), r = Qf(), i = op();
	t.exports = n ? function(e) {
		return n(e);
	} : r ? function(e) {
		if (!e || typeof e != "object" && typeof e != "function") throw TypeError("getProto: not an object");
		return r(e);
	} : i ? function(e) {
		return i(e);
	} : null;
})), cp = /* @__PURE__ */ p(((e, t) => {
	var n = Function.prototype.call, r = Object.prototype.hasOwnProperty;
	t.exports = ep().call(n, r);
})), lp = /* @__PURE__ */ p(((e, t) => {
	var n, r = jf(), i = Mf(), a = Nf(), o = Pf(), s = Ff(), c = If(), l = Of(), u = Lf(), d = Rf(), f = zf(), p = Bf(), m = Vf(), h = Hf(), g = Uf(), _ = Gf(), v = Function, y = function(e) {
		try {
			return v("\"use strict\"; return (" + e + ").constructor;")();
		} catch {}
	}, b = qf(), x = Jf(), S = function() {
		throw new l();
	}, C = b ? function() {
		try {
			return arguments.callee, S;
		} catch {
			try {
				return b(arguments, "callee").get;
			} catch {
				return S;
			}
		}
	}() : S, w = Xf()(), T = sp(), E = Qf(), D = Zf(), ee = np(), O = tp(), k = {}, A = typeof Uint8Array > "u" || !T ? n : T(Uint8Array), j = {
		__proto__: null,
		"%AggregateError%": typeof AggregateError > "u" ? n : AggregateError,
		"%Array%": Array,
		"%ArrayBuffer%": typeof ArrayBuffer > "u" ? n : ArrayBuffer,
		"%ArrayIteratorPrototype%": w && T ? T([][Symbol.iterator]()) : n,
		"%AsyncFromSyncIteratorPrototype%": n,
		"%AsyncFunction%": k,
		"%AsyncGenerator%": k,
		"%AsyncGeneratorFunction%": k,
		"%AsyncIteratorPrototype%": k,
		"%Atomics%": typeof Atomics > "u" ? n : Atomics,
		"%BigInt%": typeof BigInt > "u" ? n : BigInt,
		"%BigInt64Array%": typeof BigInt64Array > "u" ? n : BigInt64Array,
		"%BigUint64Array%": typeof BigUint64Array > "u" ? n : BigUint64Array,
		"%Boolean%": Boolean,
		"%DataView%": typeof DataView > "u" ? n : DataView,
		"%Date%": Date,
		"%decodeURI%": decodeURI,
		"%decodeURIComponent%": decodeURIComponent,
		"%encodeURI%": encodeURI,
		"%encodeURIComponent%": encodeURIComponent,
		"%Error%": i,
		"%eval%": eval,
		"%EvalError%": a,
		"%Float16Array%": typeof Float16Array > "u" ? n : Float16Array,
		"%Float32Array%": typeof Float32Array > "u" ? n : Float32Array,
		"%Float64Array%": typeof Float64Array > "u" ? n : Float64Array,
		"%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? n : FinalizationRegistry,
		"%Function%": v,
		"%GeneratorFunction%": k,
		"%Int8Array%": typeof Int8Array > "u" ? n : Int8Array,
		"%Int16Array%": typeof Int16Array > "u" ? n : Int16Array,
		"%Int32Array%": typeof Int32Array > "u" ? n : Int32Array,
		"%isFinite%": isFinite,
		"%isNaN%": isNaN,
		"%IteratorPrototype%": w && T ? T(T([][Symbol.iterator]())) : n,
		"%JSON%": typeof JSON == "object" ? JSON : n,
		"%Map%": typeof Map > "u" ? n : Map,
		"%MapIteratorPrototype%": typeof Map > "u" || !w || !T ? n : T((/* @__PURE__ */ new Map())[Symbol.iterator]()),
		"%Math%": Math,
		"%Number%": Number,
		"%Object%": r,
		"%Object.getOwnPropertyDescriptor%": b,
		"%parseFloat%": parseFloat,
		"%parseInt%": parseInt,
		"%Promise%": typeof Promise > "u" ? n : Promise,
		"%Proxy%": typeof Proxy > "u" ? n : Proxy,
		"%RangeError%": o,
		"%ReferenceError%": s,
		"%Reflect%": typeof Reflect > "u" ? n : Reflect,
		"%RegExp%": RegExp,
		"%Set%": typeof Set > "u" ? n : Set,
		"%SetIteratorPrototype%": typeof Set > "u" || !w || !T ? n : T((/* @__PURE__ */ new Set())[Symbol.iterator]()),
		"%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? n : SharedArrayBuffer,
		"%String%": String,
		"%StringIteratorPrototype%": w && T ? T(""[Symbol.iterator]()) : n,
		"%Symbol%": w ? Symbol : n,
		"%SyntaxError%": c,
		"%ThrowTypeError%": C,
		"%TypedArray%": A,
		"%TypeError%": l,
		"%Uint8Array%": typeof Uint8Array > "u" ? n : Uint8Array,
		"%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? n : Uint8ClampedArray,
		"%Uint16Array%": typeof Uint16Array > "u" ? n : Uint16Array,
		"%Uint32Array%": typeof Uint32Array > "u" ? n : Uint32Array,
		"%URIError%": u,
		"%WeakMap%": typeof WeakMap > "u" ? n : WeakMap,
		"%WeakRef%": typeof WeakRef > "u" ? n : WeakRef,
		"%WeakSet%": typeof WeakSet > "u" ? n : WeakSet,
		"%Function.prototype.call%": O,
		"%Function.prototype.apply%": ee,
		"%Object.defineProperty%": x,
		"%Object.getPrototypeOf%": E,
		"%Math.abs%": d,
		"%Math.floor%": f,
		"%Math.max%": p,
		"%Math.min%": m,
		"%Math.pow%": h,
		"%Math.round%": g,
		"%Math.sign%": _,
		"%Reflect.getPrototypeOf%": D
	};
	if (T) try {
		null.error;
	} catch (e) {
		j["%Error.prototype%"] = T(T(e));
	}
	var te = function e(t) {
		var n;
		if (t === "%AsyncFunction%") n = y("async function () {}");
		else if (t === "%GeneratorFunction%") n = y("function* () {}");
		else if (t === "%AsyncGeneratorFunction%") n = y("async function* () {}");
		else if (t === "%AsyncGenerator%") {
			var r = e("%AsyncGeneratorFunction%");
			r && (n = r.prototype);
		} else if (t === "%AsyncIteratorPrototype%") {
			var i = e("%AsyncGenerator%");
			i && T && (n = T(i.prototype));
		}
		return j[t] = n, n;
	}, ne = {
		__proto__: null,
		"%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
		"%ArrayPrototype%": ["Array", "prototype"],
		"%ArrayProto_entries%": [
			"Array",
			"prototype",
			"entries"
		],
		"%ArrayProto_forEach%": [
			"Array",
			"prototype",
			"forEach"
		],
		"%ArrayProto_keys%": [
			"Array",
			"prototype",
			"keys"
		],
		"%ArrayProto_values%": [
			"Array",
			"prototype",
			"values"
		],
		"%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
		"%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
		"%AsyncGeneratorPrototype%": [
			"AsyncGeneratorFunction",
			"prototype",
			"prototype"
		],
		"%BooleanPrototype%": ["Boolean", "prototype"],
		"%DataViewPrototype%": ["DataView", "prototype"],
		"%DatePrototype%": ["Date", "prototype"],
		"%ErrorPrototype%": ["Error", "prototype"],
		"%EvalErrorPrototype%": ["EvalError", "prototype"],
		"%Float32ArrayPrototype%": ["Float32Array", "prototype"],
		"%Float64ArrayPrototype%": ["Float64Array", "prototype"],
		"%FunctionPrototype%": ["Function", "prototype"],
		"%Generator%": ["GeneratorFunction", "prototype"],
		"%GeneratorPrototype%": [
			"GeneratorFunction",
			"prototype",
			"prototype"
		],
		"%Int8ArrayPrototype%": ["Int8Array", "prototype"],
		"%Int16ArrayPrototype%": ["Int16Array", "prototype"],
		"%Int32ArrayPrototype%": ["Int32Array", "prototype"],
		"%JSONParse%": ["JSON", "parse"],
		"%JSONStringify%": ["JSON", "stringify"],
		"%MapPrototype%": ["Map", "prototype"],
		"%NumberPrototype%": ["Number", "prototype"],
		"%ObjectPrototype%": ["Object", "prototype"],
		"%ObjProto_toString%": [
			"Object",
			"prototype",
			"toString"
		],
		"%ObjProto_valueOf%": [
			"Object",
			"prototype",
			"valueOf"
		],
		"%PromisePrototype%": ["Promise", "prototype"],
		"%PromiseProto_then%": [
			"Promise",
			"prototype",
			"then"
		],
		"%Promise_all%": ["Promise", "all"],
		"%Promise_reject%": ["Promise", "reject"],
		"%Promise_resolve%": ["Promise", "resolve"],
		"%RangeErrorPrototype%": ["RangeError", "prototype"],
		"%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
		"%RegExpPrototype%": ["RegExp", "prototype"],
		"%SetPrototype%": ["Set", "prototype"],
		"%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
		"%StringPrototype%": ["String", "prototype"],
		"%SymbolPrototype%": ["Symbol", "prototype"],
		"%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
		"%TypedArrayPrototype%": ["TypedArray", "prototype"],
		"%TypeErrorPrototype%": ["TypeError", "prototype"],
		"%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
		"%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
		"%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
		"%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
		"%URIErrorPrototype%": ["URIError", "prototype"],
		"%WeakMapPrototype%": ["WeakMap", "prototype"],
		"%WeakSetPrototype%": ["WeakSet", "prototype"]
	}, M = ep(), re = cp(), ie = M.call(O, Array.prototype.concat), ae = M.call(ee, Array.prototype.splice), oe = M.call(O, String.prototype.replace), se = M.call(O, String.prototype.slice), N = M.call(O, RegExp.prototype.exec), ce = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, le = /\\(\\)?/g, ue = function(e) {
		var t = se(e, 0, 1), n = se(e, -1);
		if (t === "%" && n !== "%") throw new c("invalid intrinsic syntax, expected closing `%`");
		if (n === "%" && t !== "%") throw new c("invalid intrinsic syntax, expected opening `%`");
		var r = [];
		return oe(e, ce, function(e, t, n, i) {
			r[r.length] = n ? oe(i, le, "$1") : t || e;
		}), r;
	}, de = function(e, t) {
		var n = e, r;
		if (re(ne, n) && (r = ne[n], n = "%" + r[0] + "%"), re(j, n)) {
			var i = j[n];
			if (i === k && (i = te(n)), i === void 0 && !t) throw new l("intrinsic " + e + " exists, but is not available. Please file an issue!");
			return {
				alias: r,
				name: n,
				value: i
			};
		}
		throw new c("intrinsic " + e + " does not exist!");
	};
	t.exports = function(e, t) {
		if (typeof e != "string" || e.length === 0) throw new l("intrinsic name must be a non-empty string");
		if (arguments.length > 1 && typeof t != "boolean") throw new l("\"allowMissing\" argument must be a boolean");
		if (N(/^%?[^%]*%?$/, e) === null) throw new c("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
		var n = ue(e), r = n.length > 0 ? n[0] : "", i = de("%" + r + "%", t), a = i.name, o = i.value, s = !1, u = i.alias;
		u && (r = u[0], ae(n, ie([0, 1], u)));
		for (var d = 1, f = !0; d < n.length; d += 1) {
			var p = n[d], m = se(p, 0, 1), h = se(p, -1);
			if ((m === "\"" || m === "'" || m === "`" || h === "\"" || h === "'" || h === "`") && m !== h) throw new c("property names with quotes must have matching quotes");
			if ((p === "constructor" || !f) && (s = !0), r += "." + p, a = "%" + r + "%", re(j, a)) o = j[a];
			else if (o != null) {
				if (!(p in o)) {
					if (!t) throw new l("base intrinsic for " + e + " exists, but the property is not available.");
					return;
				}
				if (b && d + 1 >= n.length) {
					var g = b(o, p);
					f = !!g, o = f && "get" in g && !("originalValue" in g.get) ? g.get : o[p];
				} else f = re(o, p), o = o[p];
				f && !s && (j[a] = o);
			}
		}
		return o;
	};
})), up = /* @__PURE__ */ p(((e, t) => {
	var n = lp(), r = ap(), i = r([n("%String.prototype.indexOf%")]);
	t.exports = function(e, t) {
		var a = n(e, !!t);
		return typeof a == "function" && i(e, ".prototype.") > -1 ? r([a]) : a;
	};
})), dp = /* @__PURE__ */ p(((e, t) => {
	var n = lp(), r = up(), i = kf(), a = Of(), o = n("%Map%", !0), s = r("Map.prototype.get", !0), c = r("Map.prototype.set", !0), l = r("Map.prototype.has", !0), u = r("Map.prototype.delete", !0), d = r("Map.prototype.size", !0);
	t.exports = !!o && function() {
		var e, t = {
			assert: function(e) {
				if (!t.has(e)) throw new a("Side channel does not contain " + i(e));
			},
			delete: function(t) {
				if (e) {
					var n = u(e, t);
					return d(e) === 0 && (e = void 0), n;
				}
				return !1;
			},
			get: function(t) {
				if (e) return s(e, t);
			},
			has: function(t) {
				return e ? l(e, t) : !1;
			},
			set: function(t, n) {
				e ||= new o(), c(e, t, n);
			}
		};
		return t;
	};
})), fp = /* @__PURE__ */ p(((e, t) => {
	var n = lp(), r = up(), i = kf(), a = dp(), o = Of(), s = n("%WeakMap%", !0), c = r("WeakMap.prototype.get", !0), l = r("WeakMap.prototype.set", !0), u = r("WeakMap.prototype.has", !0), d = r("WeakMap.prototype.delete", !0);
	t.exports = s ? function() {
		var e, t, n = {
			assert: function(e) {
				if (!n.has(e)) throw new o("Side channel does not contain " + i(e));
			},
			delete: function(n) {
				if (s && n && (typeof n == "object" || typeof n == "function")) {
					if (e) return d(e, n);
				} else if (a && t) return t.delete(n);
				return !1;
			},
			get: function(n) {
				return s && n && (typeof n == "object" || typeof n == "function") && e ? c(e, n) : t && t.get(n);
			},
			has: function(n) {
				return s && n && (typeof n == "object" || typeof n == "function") && e ? u(e, n) : !!t && t.has(n);
			},
			set: function(n, r) {
				s && n && (typeof n == "object" || typeof n == "function") ? (e ||= new s(), l(e, n, r)) : a && (t ||= a(), t.set(n, r));
			}
		};
		return n;
	} : a;
})), pp = /* @__PURE__ */ p(((e, t) => {
	var n = Of(), r = kf(), i = Af(), a = dp(), o = fp() || a || i;
	t.exports = function() {
		var e, t = {
			assert: function(e) {
				if (!t.has(e)) throw new n("Side channel does not contain " + (e && Object(e) === e ? "the given object key" : r(e)));
			},
			delete: function(t) {
				return !!e && e.delete(t);
			},
			get: function(t) {
				return e && e.get(t);
			},
			has: function(t) {
				return !!e && e.has(t);
			},
			set: function(t, n) {
				e ||= o(), e.set(t, n);
			}
		};
		return t;
	};
})), mp = /* @__PURE__ */ p(((e, t) => {
	var n = String.prototype.replace, r = /%20/g, i = {
		RFC1738: "RFC1738",
		RFC3986: "RFC3986"
	};
	t.exports = {
		default: i.RFC3986,
		formatters: {
			RFC1738: function(e) {
				return n.call(e, r, "+");
			},
			RFC3986: function(e) {
				return String(e);
			}
		},
		RFC1738: i.RFC1738,
		RFC3986: i.RFC3986
	};
})), hp = /* @__PURE__ */ p(((e, t) => {
	var n = mp(), r = pp(), i = Jf(), a = Object.prototype.hasOwnProperty, o = Array.isArray, s = r(), c = function(e, t) {
		return s.set(e, t), e;
	}, l = function(e) {
		return s.has(e);
	}, u = function(e) {
		return s.get(e);
	}, d = function(e, t) {
		s.set(e, t);
	}, f = function() {
		for (var e = [], t = 0; t < 256; ++t) e[e.length] = "%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase();
		return e;
	}(), p = function(e) {
		for (; e.length > 1;) {
			var t = e.pop(), n = t.obj[t.prop];
			if (o(n)) {
				for (var r = [], i = 0; i < n.length; ++i) n[i] !== void 0 && (r[r.length] = n[i]);
				t.obj[t.prop] = r;
			}
		}
	}, m = function(e, t) {
		for (var n = t && t.plainObjects ? { __proto__: null } : {}, r = 0; r < e.length; ++r) e[r] !== void 0 && (n[r] = e[r]);
		return n;
	}, h = function(e, t, n) {
		t === "__proto__" && i ? i(e, t, {
			configurable: !0,
			enumerable: !0,
			value: n,
			writable: !0
		}) : e[t] = n;
	}, g = function e(t, n, r) {
		if (!n) return t;
		if (typeof n != "object" && typeof n != "function") {
			if (o(t)) {
				var i = t.length;
				if (r && typeof r.arrayLimit == "number" && i >= r.arrayLimit) {
					if (r.throwOnLimitExceeded) throw RangeError("Array limit exceeded. Only " + r.arrayLimit + " element" + (r.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
					return c(m(t.concat(n), r), i);
				}
				t[i] = n;
			} else if (t && typeof t == "object") if (l(t)) {
				var s = u(t) + 1;
				t[s] = n, d(t, s);
			} else if (r && r.strictMerge) return [t, n];
			else (r && (r.plainObjects || r.allowPrototypes) || !a.call(Object.prototype, n)) && (t[n] = !0);
			else return [t, n];
			return t;
		}
		if (!t || typeof t != "object") {
			if (l(n)) {
				for (var f = Object.keys(n), p = r && r.plainObjects ? {
					__proto__: null,
					0: t
				} : { 0: t }, g = 0; g < f.length; g++) {
					var _ = parseInt(f[g], 10);
					p[_ + 1] = n[f[g]];
				}
				return c(p, u(n) + 1);
			}
			var v = [t].concat(n);
			if (r && typeof r.arrayLimit == "number" && v.length > r.arrayLimit) {
				if (r.throwOnLimitExceeded) throw RangeError("Array limit exceeded. Only " + r.arrayLimit + " element" + (r.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				return c(m(v, r), v.length - 1);
			}
			return v;
		}
		var y = t;
		if (o(t) && !o(n) && (y = m(t, r)), o(t) && o(n)) {
			if (n.forEach(function(n, i) {
				if (a.call(t, i)) {
					var o = t[i];
					o && typeof o == "object" && n && typeof n == "object" ? t[i] = e(o, n, r) : t[t.length] = n;
				} else t[i] = n;
			}), r && typeof r.arrayLimit == "number" && t.length > r.arrayLimit) {
				if (r.throwOnLimitExceeded) throw RangeError("Array limit exceeded. Only " + r.arrayLimit + " element" + (r.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				return c(m(t, r), t.length - 1);
			}
			return t;
		}
		return Object.keys(n).reduce(function(t, i) {
			var o = n[i];
			if (a.call(t, i) ? h(t, i, e(t[i], o, r)) : h(t, i, o), l(n) && !l(t) && c(t, u(n)), l(t)) {
				var s = parseInt(i, 10);
				String(s) === i && s >= 0 && s > u(t) && d(t, s);
			}
			return t;
		}, y);
	}, _ = function(e, t) {
		return Object.keys(t).reduce(function(e, n) {
			return h(e, n, t[n]), e;
		}, e);
	}, v = function(e, t, n) {
		var r = e.replace(/\+/g, " ");
		if (n === "iso-8859-1") return r.replace(/%[0-9a-f]{2}/gi, unescape);
		try {
			return decodeURIComponent(r);
		} catch {
			return r;
		}
	}, y = 1024;
	t.exports = {
		arrayToObject: m,
		assign: _,
		combine: function(e, t, n, r, i) {
			if (l(e)) {
				if (i) throw RangeError("Array limit exceeded. Only " + n + " element" + (n === 1 ? "" : "s") + " allowed in an array.");
				var a = u(e) + 1;
				return e[a] = t, d(e, a), e;
			}
			var o = [].concat(e, t);
			if (o.length > n) {
				if (i) throw RangeError("Array limit exceeded. Only " + n + " element" + (n === 1 ? "" : "s") + " allowed in an array.");
				return c(m(o, { plainObjects: r }), o.length - 1);
			}
			return o;
		},
		compact: function(e) {
			for (var t = [{
				obj: { o: e },
				prop: "o"
			}], n = r(), i = 0; i < t.length; ++i) for (var a = t[i], o = a.obj[a.prop], s = Object.keys(o), c = 0; c < s.length; ++c) {
				var l = s[c], u = o[l];
				typeof u == "object" && u && !n.has(u) && (t[t.length] = {
					obj: o,
					prop: l
				}, n.set(u, !0));
			}
			return p(t), e;
		},
		decode: v,
		encode: function(e, t, r, i, a) {
			if (e.length === 0) return e;
			var o = e;
			if (typeof e == "symbol" ? o = Symbol.prototype.toString.call(e) : typeof e != "string" && (o = String(e)), r === "iso-8859-1") return escape(o).replace(/%u[0-9a-f]{4}/gi, function(e) {
				return "%26%23" + parseInt(e.slice(2), 16) + "%3B";
			});
			for (var s = "", c = 0; c < o.length; c += y) {
				var l = o.length >= y ? o.slice(c, c + y) : o;
				if (c + y < o.length) {
					var u = l.charCodeAt(l.length - 1);
					u >= 55296 && u <= 56319 && (l = l.slice(0, -1), --c);
				}
				for (var d = [], p = 0; p < l.length; ++p) {
					var m = l.charCodeAt(p);
					if (m === 45 || m === 46 || m === 95 || m === 126 || m >= 48 && m <= 57 || m >= 65 && m <= 90 || m >= 97 && m <= 122 || a === n.RFC1738 && (m === 40 || m === 41)) {
						d[d.length] = l.charAt(p);
						continue;
					}
					if (m < 128) {
						d[d.length] = f[m];
						continue;
					}
					if (m < 2048) {
						d[d.length] = f[192 | m >> 6] + f[128 | m & 63];
						continue;
					}
					if (m < 55296 || m >= 57344) {
						d[d.length] = f[224 | m >> 12] + f[128 | m >> 6 & 63] + f[128 | m & 63];
						continue;
					}
					p += 1, m = 65536 + ((m & 1023) << 10 | l.charCodeAt(p) & 1023), d[d.length] = f[240 | m >> 18] + f[128 | m >> 12 & 63] + f[128 | m >> 6 & 63] + f[128 | m & 63];
				}
				s += d.join("");
			}
			return s;
		},
		isBuffer: function(e) {
			return !e || typeof e != "object" ? !1 : !!(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e));
		},
		isOverflow: l,
		isRegExp: function(e) {
			return Object.prototype.toString.call(e) === "[object RegExp]";
		},
		markOverflow: c,
		maybeMap: function(e, t) {
			if (o(e)) {
				for (var n = [], r = 0; r < e.length; r += 1) n[n.length] = t(e[r]);
				return n;
			}
			return t(e);
		},
		merge: g
	};
})), gp = /* @__PURE__ */ p(((e, t) => {
	var n = pp(), r = hp(), i = mp(), a = Object.prototype.hasOwnProperty, o = {
		brackets: function(e) {
			return e + "[]";
		},
		comma: "comma",
		indices: function(e, t) {
			return e + "[" + t + "]";
		},
		repeat: function(e) {
			return e;
		}
	}, s = Array.isArray, c = Array.prototype.push, l = function(e, t) {
		c.apply(e, s(t) ? t : [t]);
	}, u = Date.prototype.toISOString, d = i.default, f = {
		addQueryPrefix: !1,
		allowDots: !1,
		allowEmptyArrays: !1,
		arrayFormat: "indices",
		charset: "utf-8",
		charsetSentinel: !1,
		commaRoundTrip: !1,
		delimiter: "&",
		encode: !0,
		encodeDotInKeys: !1,
		encoder: r.encode,
		encodeValuesOnly: !1,
		filter: void 0,
		format: d,
		formatter: i.formatters[d],
		indices: !1,
		serializeDate: function(e) {
			return u.call(e);
		},
		skipNulls: !1,
		strictNullHandling: !1
	}, p = function(e) {
		return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
	}, m = {}, h = function e(t, i, a, o, c, u, d, h, g, _, v, y, b, x, S, C, w, T) {
		for (var E = t, D = T, ee = 0, O = !1; (D = D.get(m)) !== void 0 && !O;) {
			var k = D.get(t);
			if (ee += 1, k !== void 0) {
				if (k === ee) throw RangeError("Cyclic object value");
				O = !0;
			}
			D.get(m) === void 0 && (ee = 0);
		}
		if (typeof _ == "function" ? E = _(i, E) : E instanceof Date ? E = b(E) : a === "comma" && s(E) && (E = r.maybeMap(E, function(e) {
			return e instanceof Date ? b(e) : e;
		})), E === null) {
			if (u) return S(g && !C ? g(i, f.encoder, w, "key", x) : i);
			E = "";
		}
		if (p(E) || r.isBuffer(E)) return g ? [S(C ? i : g(i, f.encoder, w, "key", x)) + "=" + S(g(E, f.encoder, w, "value", x))] : [S(i) + "=" + S(String(E))];
		var A = [];
		if (E === void 0) return A;
		var j;
		if (a === "comma" && s(E)) C && g && (E = r.maybeMap(E, function(e) {
			return e == null ? e : g(e);
		})), j = [{ value: E.length > 0 ? E.join(",") || null : void 0 }];
		else if (s(_)) j = _;
		else {
			var te = Object.keys(E);
			j = v ? te.sort(v) : te;
		}
		var ne = h ? String(i).replace(/\./g, "%2E") : String(i), M = o && s(E) && E.length === 1 ? ne + "[]" : ne;
		if (c && s(E) && E.length === 0) return M + "[]";
		for (var re = 0; re < j.length; ++re) {
			var ie = j[re], ae = typeof ie == "object" && ie && ie.value !== void 0 ? ie.value : E[ie];
			if (!(d && ae === null)) {
				var oe = y && h ? String(ie).replace(/\./g, "%2E") : String(ie), se = s(E) ? typeof a == "function" ? a(M, oe) : M : M + (y ? "." + oe : "[" + oe + "]");
				T.set(t, ee);
				var N = n();
				N.set(m, T), l(A, e(ae, se, a, o, c, u, d, h, a === "comma" && C && s(E) ? null : g, _, v, y, b, x, S, C, w, N));
			}
		}
		return A;
	}, g = function(e) {
		if (!e) return f;
		if (e.allowEmptyArrays !== void 0 && typeof e.allowEmptyArrays != "boolean") throw TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
		if (e.encodeDotInKeys !== void 0 && typeof e.encodeDotInKeys != "boolean") throw TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
		if (e.encoder !== null && e.encoder !== void 0 && typeof e.encoder != "function") throw TypeError("Encoder has to be a function.");
		var t = e.charset || f.charset;
		if (e.charset !== void 0 && e.charset !== "utf-8" && e.charset !== "iso-8859-1") throw TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
		var n = i.default;
		if (e.format !== void 0) {
			if (!a.call(i.formatters, e.format)) throw TypeError("Unknown format option provided.");
			n = e.format;
		}
		var r = i.formatters[n], c = f.filter;
		(typeof e.filter == "function" || s(e.filter)) && (c = e.filter);
		var l = e.arrayFormat in o ? e.arrayFormat : "indices" in e ? e.indices ? "indices" : "repeat" : f.arrayFormat;
		if ("commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean") throw TypeError("`commaRoundTrip` must be a boolean, or absent");
		var u = e.allowDots === void 0 ? e.encodeDotInKeys === !0 || f.allowDots : !!e.allowDots;
		return {
			addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : f.addQueryPrefix,
			allowDots: u,
			allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : f.allowEmptyArrays,
			arrayFormat: l,
			charset: t,
			charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : f.charsetSentinel,
			commaRoundTrip: !!e.commaRoundTrip,
			delimiter: e.delimiter === void 0 ? f.delimiter : e.delimiter,
			encode: typeof e.encode == "boolean" ? e.encode : f.encode,
			encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : f.encodeDotInKeys,
			encoder: typeof e.encoder == "function" ? e.encoder : f.encoder,
			encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : f.encodeValuesOnly,
			filter: c,
			format: n,
			formatter: r,
			serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : f.serializeDate,
			skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : f.skipNulls,
			sort: typeof e.sort == "function" ? e.sort : null,
			strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : f.strictNullHandling
		};
	};
	t.exports = function(e, t) {
		var r = e, i = g(t), a, c;
		typeof i.filter == "function" ? (c = i.filter, r = c("", r)) : s(i.filter) && (c = i.filter, a = c);
		var u = [];
		if (typeof r != "object" || !r) return "";
		var d = o[i.arrayFormat], f = d === "comma" && i.commaRoundTrip;
		a ||= Object.keys(r), i.sort && a.sort(i.sort);
		for (var p = n(), m = 0; m < a.length; ++m) {
			var _ = a[m];
			if (_ != null) {
				var v = r[_];
				i.skipNulls && v === null || l(u, h(v, _, d, f, i.allowEmptyArrays, i.strictNullHandling, i.skipNulls, i.encodeDotInKeys, i.encode ? i.encoder : null, i.filter, i.sort, i.allowDots, i.serializeDate, i.format, i.formatter, i.encodeValuesOnly, i.charset, p));
			}
		}
		var y = u.join(i.delimiter), b = i.addQueryPrefix === !0 ? "?" : "";
		return i.charsetSentinel && (i.charset === "iso-8859-1" ? b += "utf8=%26%2310003%3B" + i.delimiter : b += "utf8=%E2%9C%93" + i.delimiter), y.length > 0 ? b + y : "";
	};
})), _p = /* @__PURE__ */ p(((e, t) => {
	var n = hp(), r = Object.prototype.hasOwnProperty, i = Array.isArray, a = {
		allowDots: !1,
		allowEmptyArrays: !1,
		allowPrototypes: !1,
		allowSparse: !1,
		arrayLimit: 20,
		charset: "utf-8",
		charsetSentinel: !1,
		comma: !1,
		decodeDotInKeys: !1,
		decoder: n.decode,
		delimiter: "&",
		depth: 5,
		duplicates: "combine",
		ignoreQueryPrefix: !1,
		interpretNumericEntities: !1,
		parameterLimit: 1e3,
		parseArrays: !0,
		plainObjects: !1,
		strictDepth: !1,
		strictMerge: !0,
		strictNullHandling: !1,
		throwOnLimitExceeded: !1
	}, o = function(e) {
		return e.replace(/&#(\d+);/g, function(e, t) {
			return String.fromCharCode(parseInt(t, 10));
		});
	}, s = function(e, t, n, r) {
		if (e && typeof e == "string" && t.comma && e.indexOf(",") > -1) {
			if (r && t.throwOnLimitExceeded) for (var i = 0, a = e.indexOf(","); a > -1;) {
				if (i += 1, i >= t.arrayLimit) throw RangeError("Array limit exceeded. Only " + t.arrayLimit + " element" + (t.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				a = e.indexOf(",", a + 1);
			}
			return e.split(",");
		}
		if (t.throwOnLimitExceeded && n >= t.arrayLimit) throw RangeError("Array limit exceeded. Only " + t.arrayLimit + " element" + (t.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
		return e;
	}, c = "utf8=%26%2310003%3B", l = "utf8=%E2%9C%93", u = function(e, t) {
		var u = { __proto__: null }, d = t.ignoreQueryPrefix ? e.replace(/^\?/, "") : e;
		d = d.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
		var f = t.parameterLimit === Infinity ? void 0 : t.parameterLimit, p = d.split(t.delimiter, t.throwOnLimitExceeded && f !== void 0 ? f + 1 : f);
		if (t.throwOnLimitExceeded && f !== void 0 && p.length > f) throw RangeError("Parameter limit exceeded. Only " + f + " parameter" + (f === 1 ? "" : "s") + " allowed.");
		var m = -1, h, g = t.charset;
		if (t.charsetSentinel) for (h = 0; h < p.length; ++h) p[h].indexOf("utf8=") === 0 && (p[h] === l ? g = "utf-8" : p[h] === c && (g = "iso-8859-1"), m = h, h = p.length);
		for (h = 0; h < p.length; ++h) if (h !== m) {
			var _ = p[h], v = _.indexOf("]="), y = v === -1 ? _.indexOf("=") : v + 1, b, x;
			if (y === -1 ? (b = t.decoder(_, a.decoder, g, "key"), x = t.strictNullHandling ? null : "") : (b = t.decoder(_.slice(0, y), a.decoder, g, "key"), b !== null && (x = n.maybeMap(s(_.slice(y + 1), t, i(u[b]) ? u[b].length : 0, _.indexOf("[]=") === -1), function(e) {
				return t.decoder(e, a.decoder, g, "value");
			}))), x && t.interpretNumericEntities && g === "iso-8859-1" && (x = o(String(x))), _.indexOf("[]=") > -1 && (x = i(x) ? [x] : x), t.comma && i(x) && x.length > t.arrayLimit && (x = n.combine([], x, t.arrayLimit, t.plainObjects, t.throwOnLimitExceeded)), b !== null) {
				var S = r.call(u, b);
				S && (t.duplicates === "combine" || _.indexOf("[]=") > -1) ? u[b] = n.combine(u[b], x, t.arrayLimit, t.plainObjects, t.throwOnLimitExceeded) : (!S || t.duplicates === "last") && (u[b] = x);
			}
		}
		return u;
	}, d = function(e, t, r, i) {
		var a = 0;
		if (e.length > 0 && e[e.length - 1] === "[]") {
			var o = e.slice(0, -1).join("");
			a = Array.isArray(t) && t[o] ? t[o].length : 0;
		}
		for (var c = i ? t : s(t, r, a), l = e.length - 1; l >= 0; --l) {
			var u, d = e[l];
			if (d === "[]" && r.parseArrays) u = n.isOverflow(c) ? c : r.allowEmptyArrays && (c === "" || r.strictNullHandling && c === null) ? [] : n.combine([], c, r.arrayLimit, r.plainObjects, r.throwOnLimitExceeded);
			else {
				u = r.plainObjects ? { __proto__: null } : {};
				var f = d.charAt(0) === "[" && d.charAt(d.length - 1) === "]" ? d.slice(1, -1) : d, p = r.decodeDotInKeys ? f.replace(/%2E/g, ".") : f, m = parseInt(p, 10), h = !isNaN(m) && d !== p && String(m) === p && m >= 0 && r.parseArrays;
				if (!r.parseArrays && p === "") u = { 0: c };
				else if (h && m < r.arrayLimit) u = [], u[m] = c;
				else if (h && r.throwOnLimitExceeded) throw RangeError("Array limit exceeded. Only " + r.arrayLimit + " element" + (r.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
				else h ? (u[m] = c, n.markOverflow(u, m)) : p !== "__proto__" && (u[p] = c);
			}
			c = u;
		}
		return c;
	}, f = function(e, t) {
		var n = t.allowDots ? e.replace(/\.([^.[]+)/g, "[$1]") : e;
		if (t.depth <= 0) return !t.plainObjects && r.call(Object.prototype, n) && !t.allowPrototypes ? void 0 : [n];
		var i = [], a = n.indexOf("["), o = a >= 0 ? n.slice(0, a) : n;
		if (o) {
			if (!t.plainObjects && r.call(Object.prototype, o) && !t.allowPrototypes) return;
			i[i.length] = o;
		}
		for (var s = n.length, c = a, l = 0; c >= 0 && l < t.depth;) {
			for (var u = 1, d = c + 1, f = -1; d < s && f < 0;) {
				var p = n.charCodeAt(d);
				p === 91 ? u += 1 : p === 93 && (--u, u === 0 && (f = d)), d += 1;
			}
			if (f < 0) return i[i.length] = "[" + n.slice(c) + "]", i;
			var m = n.slice(c, f + 1), h = m.slice(1, -1);
			if (!t.plainObjects && r.call(Object.prototype, h) && !t.allowPrototypes) return;
			i[i.length] = m, l += 1, c = n.indexOf("[", f + 1);
		}
		if (c >= 0) {
			if (t.strictDepth === !0) throw RangeError("Input depth exceeded depth option of " + t.depth + " and strictDepth is true");
			i[i.length] = "[" + n.slice(c) + "]";
		}
		return i;
	}, p = function(e, t, n, r) {
		if (e) {
			var i = f(e, n);
			if (i) return d(i, t, n, r);
		}
	}, m = function(e) {
		if (!e) return a;
		if (e.allowEmptyArrays !== void 0 && typeof e.allowEmptyArrays != "boolean") throw TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
		if (e.decodeDotInKeys !== void 0 && typeof e.decodeDotInKeys != "boolean") throw TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
		if (e.decoder !== null && e.decoder !== void 0 && typeof e.decoder != "function") throw TypeError("Decoder has to be a function.");
		if (e.charset !== void 0 && e.charset !== "utf-8" && e.charset !== "iso-8859-1") throw TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
		if (e.throwOnLimitExceeded !== void 0 && typeof e.throwOnLimitExceeded != "boolean") throw TypeError("`throwOnLimitExceeded` option must be a boolean");
		var t = e.charset === void 0 ? a.charset : e.charset, r = e.duplicates === void 0 ? a.duplicates : e.duplicates;
		if (r !== "combine" && r !== "first" && r !== "last") throw TypeError("The duplicates option must be either combine, first, or last");
		return {
			allowDots: e.allowDots === void 0 ? e.decodeDotInKeys === !0 || a.allowDots : !!e.allowDots,
			allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : a.allowEmptyArrays,
			allowPrototypes: typeof e.allowPrototypes == "boolean" ? e.allowPrototypes : a.allowPrototypes,
			allowSparse: typeof e.allowSparse == "boolean" ? e.allowSparse : a.allowSparse,
			arrayLimit: typeof e.arrayLimit == "number" ? e.arrayLimit : a.arrayLimit,
			charset: t,
			charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : a.charsetSentinel,
			comma: typeof e.comma == "boolean" ? e.comma : a.comma,
			decodeDotInKeys: typeof e.decodeDotInKeys == "boolean" ? e.decodeDotInKeys : a.decodeDotInKeys,
			decoder: typeof e.decoder == "function" ? e.decoder : a.decoder,
			delimiter: typeof e.delimiter == "string" || n.isRegExp(e.delimiter) ? e.delimiter : a.delimiter,
			depth: typeof e.depth == "number" || e.depth === !1 ? +e.depth : a.depth,
			duplicates: r,
			ignoreQueryPrefix: e.ignoreQueryPrefix === !0,
			interpretNumericEntities: typeof e.interpretNumericEntities == "boolean" ? e.interpretNumericEntities : a.interpretNumericEntities,
			parameterLimit: typeof e.parameterLimit == "number" ? e.parameterLimit : a.parameterLimit,
			parseArrays: e.parseArrays !== !1,
			plainObjects: typeof e.plainObjects == "boolean" ? e.plainObjects : a.plainObjects,
			strictDepth: typeof e.strictDepth == "boolean" ? !!e.strictDepth : a.strictDepth,
			strictMerge: typeof e.strictMerge == "boolean" ? !!e.strictMerge : a.strictMerge,
			strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : a.strictNullHandling,
			throwOnLimitExceeded: typeof e.throwOnLimitExceeded == "boolean" && e.throwOnLimitExceeded
		};
	};
	t.exports = function(e, t) {
		var r = m(t);
		if (e === "" || e == null) return r.plainObjects ? { __proto__: null } : {};
		for (var i = typeof e == "string" ? u(e, r) : e, a = r.plainObjects ? { __proto__: null } : {}, o = Object.keys(i), s = 0; s < o.length; ++s) {
			var c = o[s], l = p(c, i[c], r, typeof e == "string");
			a = n.merge(a, l, r);
		}
		return r.allowSparse === !0 ? a : n.compact(a);
	};
})), vp = /* @__PURE__ */ g((/* @__PURE__ */ p(((e, t) => {
	var n = gp(), r = _p();
	t.exports = {
		formats: mp(),
		parse: r,
		stringify: n
	};
})))()), yp = function(e) {
	e && (window.document.title = e);
}, bp = /*#__PURE__*/ function() {
	function e(t) {
		var n = this, r = t.windowTitle, i = t.writeDelay, a = i === void 0 ? 400 : i, o = t.createURL, s = t.parseURL, c = t.getLocation, l = t.start, u = t.dispose, d = t.push, f = t.cleanUrlOnDispose;
		bd(this, e), G(this, "$$type", "ais.browser"), G(this, "windowTitle", void 0), G(this, "writeDelay", void 0), G(this, "_createURL", void 0), G(this, "parseURL", void 0), G(this, "getLocation", void 0), G(this, "writeTimer", void 0), G(this, "_onPopState", void 0), G(this, "inPopState", !1), G(this, "isDisposed", !1), G(this, "latestAcknowledgedHistory", 0), G(this, "_start", void 0), G(this, "_dispose", void 0), G(this, "_push", void 0), G(this, "_cleanUrlOnDispose", void 0), this.windowTitle = r, this.writeTimer = void 0, this.writeDelay = a, this._createURL = o, this.parseURL = s, this.getLocation = c, this._start = l, this._dispose = u, this._push = d, this._cleanUrlOnDispose = f === void 0 || f, fd(function(e) {
			var t = e.window;
			yp(n.windowTitle && n.windowTitle(n.read())), n.latestAcknowledgedHistory = t.history.length;
		});
	}
	return Sd(e, [
		{
			key: "read",
			value: function() {
				return this.parseURL({
					qsModule: vp.default,
					location: this.getLocation()
				});
			}
		},
		{
			key: "write",
			value: function(e) {
				var t = this;
				fd(function(n) {
					var r = n.window, i = t.createURL(e), a = t.windowTitle && t.windowTitle(e);
					t.writeTimer && clearTimeout(t.writeTimer), t.writeTimer = setTimeout(function() {
						yp(a), t.shouldWrite(i) && (t._push ? t._push(i) : r.history.pushState(e, a || "", i), t.latestAcknowledgedHistory = r.history.length), t.inPopState = !1, t.writeTimer = void 0;
					}, t.writeDelay);
				});
			}
		},
		{
			key: "onUpdate",
			value: function(e) {
				var t = this;
				this._start && this._start(function() {
					e(t.read());
				}), this._onPopState = function() {
					t.writeTimer &&= (clearTimeout(t.writeTimer), void 0), t.inPopState = !0, e(t.read());
				}, fd(function(e) {
					e.window.addEventListener("popstate", t._onPopState);
				});
			}
		},
		{
			key: "createURL",
			value: function(e) {
				return this._createURL({
					qsModule: vp.default,
					routeState: e,
					location: this.getLocation()
				});
			}
		},
		{
			key: "dispose",
			value: function() {
				var e = this;
				this._dispose && this._dispose(), this.isDisposed = !0, fd(function(t) {
					var n = t.window;
					e._onPopState && n.removeEventListener("popstate", e._onPopState);
				}), this.writeTimer && clearTimeout(this.writeTimer), this._cleanUrlOnDispose && this.write({});
			}
		},
		{
			key: "start",
			value: function() {
				this.isDisposed = !1;
			}
		},
		{
			key: "shouldWrite",
			value: function(e) {
				var t = this;
				return fd(function(n) {
					var r = n.window;
					if (t.isDisposed && !t._cleanUrlOnDispose) return !1;
					var i = !(t.isDisposed && t.latestAcknowledgedHistory !== r.history.length);
					return !t.inPopState && i && e !== r.location.href;
				});
			}
		}
	]), e;
}();
function xp() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.createURL, n = t === void 0 ? function(e) {
		var t = e.qsModule, n = e.routeState, r = e.location, i = r.protocol, a = r.hostname, o = r.port, s = o === void 0 ? "" : o, c = r.pathname, l = r.hash, u = t.stringify(n), d = s === "" ? "" : `:${s}`;
		return u ? `${i}//${a}${d}${c}?${u}${l}` : `${i}//${a}${d}${c}${l}`;
	} : t, r = e.parseURL, i = r === void 0 ? function(e) {
		var t = e.qsModule, n = e.location;
		return t.parse(n.search.slice(1), { arrayLimit: 99 });
	} : r, a = e.writeDelay, o = a === void 0 ? 400 : a, s = e.windowTitle, c = e.getLocation, l = c === void 0 ? function() {
		return fd(function(e) {
			return e.window.location;
		}, { fallback: function() {
			throw Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
		} });
	} : c, u = e.start, d = e.dispose, f = e.push, p = e.cleanUrlOnDispose;
	return new bp({
		createURL: n,
		parseURL: i,
		writeDelay: o,
		windowTitle: s,
		getLocation: l,
		start: u,
		dispose: d,
		push: f,
		cleanUrlOnDispose: p
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index51.js
function Sp(e) {
	return e.configure, J(e, ["configure"]);
}
function Cp() {
	return {
		$$type: "ais.simple",
		stateToRoute: function(e) {
			return Object.keys(e).reduce(function(t, n) {
				return q(K({}, t), G({}, n, Sp(e[n])));
			}, {});
		},
		routeToState: function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
			return Object.keys(e).reduce(function(t, n) {
				var r = e[n];
				return (r === void 0 ? "undefined" : ku(r)) !== "object" || r === null ? t : q(K({}, t), G({}, n, Sp(r)));
			}, {});
		}
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/index16.js
var wp = function() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.router, n = t === void 0 ? xp() : t, r = e.stateMapping, i = r === void 0 ? Cp() : r, a = e.$$internal, o = a !== void 0 && a;
	return function(e) {
		var t = e.instantSearchInstance;
		function r(e) {
			var r = t.mainIndex.getWidgets().length === 0 ? t._initialUiState : t.mainIndex.getWidgetUiState({}), a = Object.keys(e).reduce(function(t, n) {
				return q(K({}, t), G({}, n, e[n]));
			}, r), o = i.stateToRoute(a);
			return n.createURL(o);
		}
		t._createURL = r;
		var a = void 0, s = t._initialUiState;
		return {
			$$type: `ais.router({router:${n.$$type || "__unknown__"}, stateMapping:${i.$$type || "__unknown__"}})`,
			$$internal: o,
			onStateChange: function(e) {
				var t = e.uiState, r = i.stateToRoute(t);
				(a === void 0 || !dd(a, r)) && (n.write(r), a = r);
			},
			subscribe: function() {
				t._initialUiState = K({}, s, i.routeToState(n.read())), n.onUpdate(function(e) {
					t.mainIndex.getWidgets().length > 0 && t.setUiState(i.routeToState(e));
				});
			},
			started: function() {
				var e;
				(e = n.start) == null || e.call(n);
			},
			unsubscribe: function() {
				n.dispose();
			}
		};
	};
}, Tp = 0;
function Ep(e) {
	e.dependsOn === "recommend" && (e.$$id = Tp++);
}
//#endregion
//#region node_modules/instantsearch.js/es/index22.js
function Dp(e) {
	var t = e.name, n = e.connector;
	return [
		"https://www.algolia.com/doc/api-reference/widgets/",
		t,
		"/js/",
		n !== void 0 && n ? "#connector" : ""
	].join("");
}
function Op() {
	var e = [...arguments].map(function(e) {
		return Dp(e);
	}).join(", ");
	return function(t) {
		return [t, `See documentation: ${e}`].filter(Boolean).join("\n\n");
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/index39.js
function kp(e, t) {
	if (!Array.isArray(e)) return -1;
	for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
	return -1;
}
//#endregion
//#region node_modules/instantsearch.js/es/index44.js
function Ap(e) {
	return e.filter(function(e, t, n) {
		return n.indexOf(e) === t;
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index43.js
var jp = function(e, t) {
	t.facets, t.disjunctiveFacets, t.facetsRefinements, t.facetsExcludes, t.disjunctiveFacetsRefinements, t.numericRefinements, t.tagRefinements, t.hierarchicalFacets, t.hierarchicalFacetsRefinements, t.ruleContexts;
	var n = J(t, [
		"facets",
		"disjunctiveFacets",
		"facetsRefinements",
		"facetsExcludes",
		"disjunctiveFacetsRefinements",
		"numericRefinements",
		"tagRefinements",
		"hierarchicalFacets",
		"hierarchicalFacetsRefinements",
		"ruleContexts"
	]);
	return e.setQueryParameters(n);
}, Mp = function(e, t) {
	return t.facets.reduce(function(e, t) {
		return e.addFacet(t);
	}, e);
}, Np = function(e, t) {
	return t.disjunctiveFacets.reduce(function(e, t) {
		return e.addDisjunctiveFacet(t);
	}, e);
}, Pp = function(e, t) {
	return e.setQueryParameters({ hierarchicalFacets: t.hierarchicalFacets.reduce(function(e, t) {
		var n = kp(e, function(e) {
			return e.name === t.name;
		});
		if (n === -1) return e.concat(t);
		var r = e.slice();
		return r.splice(n, 1, t), r;
	}, e.hierarchicalFacets) });
}, Fp = function(e, t) {
	return t.tagRefinements.reduce(function(e, t) {
		return e.addTagRefinement(t);
	}, e);
}, Ip = function(e, t) {
	return e.setQueryParameters({ facetsRefinements: K({}, e.facetsRefinements, t.facetsRefinements) });
}, Lp = function(e, t) {
	return e.setQueryParameters({ facetsExcludes: K({}, e.facetsExcludes, t.facetsExcludes) });
}, Rp = function(e, t) {
	return e.setQueryParameters({ disjunctiveFacetsRefinements: K({}, e.disjunctiveFacetsRefinements, t.disjunctiveFacetsRefinements) });
}, zp = function(e, t) {
	return e.setQueryParameters({ numericRefinements: K({}, e.numericRefinements, t.numericRefinements) });
}, Bp = function(e, t) {
	return e.setQueryParameters({ hierarchicalFacetsRefinements: K({}, e.hierarchicalFacetsRefinements, t.hierarchicalFacetsRefinements) });
}, Vp = function(e, t) {
	var n = Ap([].concat(e.ruleContexts, t.ruleContexts).filter(Boolean));
	return n.length > 0 ? e.setQueryParameters({ ruleContexts: n }) : e;
}, Hp = function() {
	return [...arguments].reduce(function(e, t) {
		return jp(Mp(Vp(Np(Ip(Lp(Rp(zp(Fp(Pp(Bp(e, t), t), t), t), t), t), t), t), t), t), t);
	});
};
//#endregion
//#region node_modules/instantsearch.js/es/index49.js
function Up(e) {
	for (var t = e.getParent(), n = [e.getHelper().state]; t !== null;) n = [t.getHelper().state].concat(n), t = t.getParent();
	return n;
}
//#endregion
//#region node_modules/instantsearch.js/es/index17.js
var Wp = Op({ name: "index-widget" });
function Gp(e, t) {
	var n = t.state, r = t.recommendState, i = t.isPageReset, a = t._uiState;
	n !== e.state && (e.state = n, e.emit("change", {
		state: e.state,
		results: e.lastResults,
		isPageReset: i,
		_uiState: a
	})), r !== e.recommendState && (e.recommendState = r);
}
function Kp(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	return e.reduce(function(e, n) {
		return cf(n) || !n.getWidgetUiState && !n.getWidgetState ? e : n.getWidgetUiState ? n.getWidgetUiState(e, t) : n.getWidgetState(e, t);
	}, n);
}
function qp(e, t) {
	var n = t.initialSearchParameters, r = J(t, ["initialSearchParameters"]);
	return e.reduce(function(e, t) {
		return !t.getWidgetSearchParameters || cf(t) ? e : t.dependsOn === "search" && t.getWidgetParameters ? t.getWidgetParameters(e, r) : t.getWidgetSearchParameters(e, r);
	}, n);
}
function Jp(e, t) {
	var n = t.initialRecommendParameters, r = J(t, ["initialRecommendParameters"]);
	return e.reduce(function(e, t) {
		return !cf(t) && t.dependsOn === "recommend" && t.getWidgetParameters ? t.getWidgetParameters(e, r) : e;
	}, n);
}
function Yp(e) {
	var t = e.filter(cf);
	t.length !== 0 && t.forEach(function(e) {
		var t = e.getHelper();
		Gp(t, {
			state: t.state.resetPage(),
			recommendState: t.recommendState,
			isPageReset: !0
		}), Yp(e.getWidgets());
	});
}
function Xp(e) {
	return e.filter(cf).reduce(function(e, t) {
		var n;
		return (n = e).concat.apply(n, [{
			indexId: t.getIndexId(),
			results: t.getResults(),
			helper: t.getHelper()
		}].concat(W(Xp(t.getWidgets()))));
	}, []);
}
function Zp(e) {
	return e.reduce(function(e, t) {
		if (cf(t)) {
			if (t._isolated) return e;
			var n = Zp(t.getWidgets());
			return {
				hasSearchWidget: e.hasSearchWidget || n.hasSearchWidget,
				hasRecommendWidget: e.hasRecommendWidget || n.hasRecommendWidget
			};
		}
		return t.dependsOn === "recommend" ? q(K({}, e), { hasRecommendWidget: !0 }) : t.dependsOn === "none" ? e : q(K({}, e), { hasSearchWidget: !0 });
	}, {
		hasSearchWidget: !1,
		hasRecommendWidget: !1
	});
}
function Qp(e) {
	var t = Zp(e.mainIndex.getWidgets()), n = t.hasSearchWidget, r = t.hasRecommendWidget;
	e._hasSearchWidget = n, e._hasRecommendWidget = r;
}
var $p = function(e) {
	if (e === void 0 || e.indexName === void 0 && !e.EXPERIMENTAL_isolated) throw Error(Wp("The `indexName` option is required."));
	var t = e.indexName, n = t === void 0 ? "" : t, r = e.indexId, i = r === void 0 ? n : r, a = e.EXPERIMENTAL_isolated, o = a !== void 0 && a, s = [], c = {}, l = null, u = null, d = null, f = null, p = null, m = function() {
		l && Qp(l);
	};
	return {
		$$type: "ais.index",
		$$widgetType: "ais.index",
		_isolated: o,
		getIndexName: function() {
			return n;
		},
		getIndexId: function() {
			return i;
		},
		getHelper: function() {
			return d;
		},
		getResults: function() {
			return f?.lastResults ? (f.lastResults._state = d.state, f.lastResults) : null;
		},
		getResultsForWidget: function(e) {
			return e.dependsOn !== "recommend" || cf(e) || e.$$id === void 0 ? this.getResults() : d?.lastRecommendResults ? d.lastRecommendResults[e.$$id] : null;
		},
		getPreviousState: function() {
			return p;
		},
		getScopedResults: function() {
			var e = this.getParent();
			return Xp(e ? e.getWidgets() : n.length === 0 ? this.getWidgets() : [this]);
		},
		getParent: function() {
			return o ? null : u;
		},
		createURL: function(e) {
			return typeof e == "function" ? l._createURL(G({}, i, e(c))) : l._createURL(G({}, i, Kp(s, {
				searchParameters: e,
				helper: d
			})));
		},
		scheduleLocalSearch: Mu(function() {
			o && d?.search();
		}),
		getWidgets: function() {
			return s;
		},
		addWidgets: function(e) {
			var t = this;
			if (!Array.isArray(e)) throw Error(Wp("The `addWidgets` method expects an array of widgets."));
			var n = e.reduce(function(e, t) {
				return e.concat(Array.isArray(t) ? t : [t]);
			}, []);
			if (n.some(function(e) {
				return typeof e.init != "function" && typeof e.render != "function";
			})) throw Error(Wp("The widget definition expects a `render` and/or an `init` method."));
			return n.forEach(function(e) {
				e.parent = t, cf(e) || Ep(e);
			}), s = s.concat(n), m(), l && n.length && (Gp(d, {
				state: qp(s, {
					uiState: c,
					initialSearchParameters: d.state
				}),
				recommendState: Jp(s, {
					uiState: c,
					initialRecommendParameters: d.recommendState
				}),
				_uiState: c
			}), n.forEach(function(e) {
				e.getRenderState && df({
					renderState: e.getRenderState(l.renderState[t.getIndexId()] || {}, lf(l, t, l._initialUiState)),
					instantSearchInstance: l,
					parent: t
				});
			}), n.forEach(function(e) {
				e.init && e.init(lf(l, t, l._initialUiState));
			}), o ? this.scheduleLocalSearch() : l.scheduleSearch()), this;
		},
		removeWidgets: function(e) {
			var t = this;
			if (!Array.isArray(e)) throw Error(Wp("The `removeWidgets` method expects an array of widgets."));
			var n = e.reduce(function(e, t) {
				return e.concat(Array.isArray(t) ? t : [t]);
			}, []);
			if (n.some(function(e) {
				return typeof e.dispose != "function";
			})) throw Error(Wp("The widget definition expects a `dispose` method."));
			if (s = s.filter(function(e) {
				return n.indexOf(e) === -1;
			}), n.forEach(function(e) {
				e.parent = void 0;
			}), m(), l && n.length) {
				var r = n.reduce(function(e, n) {
					var r = n.dispose({
						helper: d,
						state: e.cleanedSearchState,
						recommendState: e.cleanedRecommendState,
						parent: t
					});
					return Nu(r, Y.default.RecommendParameters) ? e.cleanedRecommendState = r : r && (e.cleanedSearchState = r), e;
				}, {
					cleanedSearchState: d.state,
					cleanedRecommendState: d.recommendState
				}), i = r.cleanedSearchState, a = r.cleanedRecommendState, u = l.future.preserveSharedStateOnUnmount ? qp(s, {
					uiState: c,
					initialSearchParameters: new Y.default.SearchParameters({ index: this.getIndexName() })
				}) : qp(s, {
					uiState: Kp(s, {
						searchParameters: i,
						helper: d
					}),
					initialSearchParameters: i
				});
				c = Kp(s, {
					searchParameters: u,
					helper: d
				}), d.setState(u), d.recommendState = a, s.length && (o ? this.scheduleLocalSearch() : l.scheduleSearch());
			}
			return this;
		},
		init: function(e) {
			var t = this, r = e.instantSearchInstance, a = e.parent, h = e.uiState;
			if (d === null) {
				l = r, u = a, c = h[i] || {};
				var g = r.mainHelper, _ = qp(s, {
					uiState: c,
					initialSearchParameters: new Y.default.SearchParameters({ index: n })
				}), v = Jp(s, {
					uiState: c,
					initialRecommendParameters: new Y.default.RecommendParameters()
				});
				d = (0, Y.default)(g.getClient(), _.index, _), d.recommendState = v, d.search = function() {
					return o ? (r.status = "loading", t.render({ instantSearchInstance: r }), r.compositionID ? d.searchWithComposition() : d.searchOnlyWithDerivedHelpers()) : r.onStateChange ? (r.onStateChange({
						uiState: r.mainIndex.getWidgetUiState({}),
						setUiState: function(e) {
							return r.setUiState(e, !1);
						}
					}), g) : g.search();
				}, d.searchWithoutTriggeringOnStateChange = function() {
					return g.search();
				}, d.searchForFacetValues = function(e, n, r, i) {
					var a = Hp.apply(void 0, [g.state].concat(W(Up(t)))).setQueryParameters(i);
					return g.searchForFacetValues(e, n, r, a);
				};
				var y = n ? d : (0, Y.default)({}, "__empty_index__", {});
				f = (o ? y : em(a, g)).derive(function() {
					return Hp.apply(void 0, [g.state].concat(W(Up(t))));
				}, function() {
					return t.getHelper().recommendState;
				});
				var b = r._initialResults?.[this.getIndexId()];
				if (b?.results) {
					var x = new Y.default.SearchResults(new Y.default.SearchParameters(b.state), b.results);
					f.lastResults = x, d.lastResults = x;
				}
				if (b?.recommendResults) {
					var S = new Y.default.RecommendResults(new Y.default.RecommendParameters({ params: b.recommendResults.params }), b.recommendResults.results);
					f.lastRecommendResults = S, d.lastRecommendResults = S;
				}
				d.on("change", function(e) {
					e.isPageReset && Yp(s);
				}), f.on("search", function() {
					r.scheduleStalledRender();
				}), f.on("result", function(e) {
					var t = e.results;
					r.scheduleRender(), d.lastResults = t, p = t?._state;
				}), f.on("recommend:result", function(e) {
					var t = e.recommend;
					r.scheduleRender(), d.lastRecommendResults = t.results;
				}), s.forEach(function(e) {
					e.getRenderState && df({
						renderState: e.getRenderState(r.renderState[t.getIndexId()] || {}, lf(r, t, h)),
						instantSearchInstance: r,
						parent: t
					});
				}), s.forEach(function(e) {
					e.init && e.init(lf(r, t, h));
				}), d.on("change", function(e) {
					var t = e.state, n = e._uiState;
					c = Kp(s, {
						searchParameters: t,
						helper: d
					}, n || {}), r.onStateChange || r.onInternalStateChange();
				}), b && r.scheduleRender(), m();
			}
		},
		render: function(e) {
			var t = this, r = e.instantSearchInstance;
			r.status === "error" && !r.mainHelper.hasPendingRequests() && p && d.setState(p);
			var i = this.getResults() || f?.lastRecommendResults || o && !n ? s : s.filter(function(e) {
				return e.shouldRender;
			});
			i = i.filter(function(e) {
				return !e.shouldRender || e.shouldRender({ instantSearchInstance: r });
			}), i.forEach(function(e) {
				e.getRenderState && df({
					renderState: e.getRenderState(r.renderState[t.getIndexId()] || {}, uf(r, t, e)),
					instantSearchInstance: r,
					parent: t
				});
			}), i.forEach(function(e) {
				e.render && e.render(uf(r, t, e));
			});
		},
		dispose: function() {
			var e = this;
			s.forEach(function(t) {
				t.dispose && d && t.dispose({
					helper: d,
					state: d.state,
					recommendState: d.recommendState,
					parent: e
				});
			}), l = null, u = null, d?.removeAllListeners(), d = null, f?.detach(), f = null;
		},
		getWidgetUiState: function(e) {
			return s.filter(cf).filter(function(e) {
				return !e._isolated;
			}).reduce(function(e, t) {
				return t.getWidgetUiState(e);
			}, q(K({}, e), G({}, i, K({}, e[i], c))));
		},
		getWidgetState: function(e) {
			return this.getWidgetUiState(e);
		},
		getWidgetSearchParameters: function(e, t) {
			var n = t.uiState;
			return qp(s, {
				uiState: n,
				initialSearchParameters: e
			});
		},
		shouldRender: function() {
			return !0;
		},
		refreshUiState: function() {
			c = Kp(s, {
				searchParameters: this.getHelper().state,
				helper: this.getHelper()
			}, c);
		},
		setIndexUiState: function(e) {
			var t = typeof e == "function" ? e(c) : e;
			l.setUiState(function(e) {
				return q(K({}, e), G({}, i, t));
			});
		}
	};
};
function em(e, t) {
	for (; e;) {
		if (e._isolated) return e.getHelper();
		e = e.getParent();
	}
	return t;
}
//#endregion
//#region node_modules/instantsearch.js/es/index52.js
function tm(e, t) {
	return e.toLocaleString(t);
}
//#endregion
//#region node_modules/instantsearch.js/es/index18.js
function nm(e) {
	var t = e.numberLocale;
	return {
		formatNumber: function(e, n) {
			return tm(Number(n(e)), t);
		},
		highlight: function(e, t) {
			try {
				return t(Lu(q(K({}, JSON.parse(e)), { hit: this })));
			} catch {
				throw Error("\nThe highlight helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
			}
		},
		reverseHighlight: function(e, t) {
			try {
				return t(Ju(q(K({}, JSON.parse(e)), { hit: this })));
			} catch {
				throw Error("\n  The reverseHighlight helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
			}
		},
		snippet: function(e, t) {
			try {
				return t(Xu(q(K({}, JSON.parse(e)), { hit: this })));
			} catch {
				throw Error("\nThe snippet helper expects a JSON object of the format:\n{ \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
			}
		},
		reverseSnippet: function(e, t) {
			try {
				return t(Qu(q(K({}, JSON.parse(e)), { hit: this })));
			} catch {
				throw Error("\n  The reverseSnippet helper expects a JSON object of the format:\n  { \"attribute\": \"name\", \"highlightedTagName\": \"mark\" }");
			}
		},
		insights: function(e, t) {
			try {
				var n = JSON.parse(e), r = n.method, i = n.payload;
				return t(ad(r, K({ objectIDs: [this.objectID] }, i)));
			} catch {
				throw Error("\nThe insights helper expects a JSON object of the format:\n{ \"method\": \"method-name\", \"payload\": { \"eventName\": \"name of the event\" } }");
			}
		}
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/index20.js
function rm(e, t) {
	var n = e[t.getIndexId()] || {};
	t.getHelper().setState(t.getWidgetSearchParameters(t.getHelper().state, { uiState: n })), t.getWidgets().filter(cf).forEach(function(t) {
		return rm(e, t);
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/index23.js
function im(e, t) {
	e._recommendCache = Object.keys(t).reduce(function(e, n) {
		var r = t[n];
		return r.recommendResults ? K({}, e, r.recommendResults.results) : e;
	}, {});
}
//#endregion
//#region node_modules/instantsearch.js/es/index24.js
function am(e) {
	return e.compositionFeedsResults?.length ? e.compositionFeedsResults : e.results || [];
}
function om(e, t) {
	if (t && !((!("transporter" in e) || e._cacheHydrated) && (!e._useCache || typeof e.addAlgoliaAgent != "function"))) {
		var n = [Object.keys(t).reduce(function(e, n) {
			var r = t[n], i = r.state, a = r.requestParams, o = am(r), s = o && i ? o.map(function(e, t) {
				return K({ indexName: i.index || e.index }, a?.[t] || e.params ? { params: cm(a?.[t] || sm(e.params)) } : {});
			}) : [];
			return e.concat(s);
		}, [])], r = Object.keys(t).reduce(function(e, n) {
			var r = am(t[n]);
			return r ? e.concat(r) : e;
		}, []);
		if ("transporter" in e && !e._cacheHydrated) {
			e._cacheHydrated = !0;
			var i = e.search.bind(e);
			e.search = function(t) {
				var n = [...arguments].slice(1), r = Array.isArray(t) ? t.map(function(e) {
					return q(K({}, e), { params: cm(e.params) });
				}) : cm(t.requestBody.params);
				return e.transporter.responsesCache.get({
					method: "search",
					args: [r].concat(W(n))
				}, function() {
					return i.apply(void 0, [t].concat(W(n)));
				});
			}, e.transporter.responsesCache.set({
				method: "search",
				args: n
			}, { results: r });
		}
		if (!("transporter" in e)) {
			var a = `/1/indexes/*/queries_body_${JSON.stringify({ requests: n })}`;
			e.cache = q(K({}, e.cache), G({}, a, JSON.stringify({ results: Object.keys(t).map(function(e) {
				return am(t[e]);
			}) })));
		}
	}
}
function sm(e) {
	return e.split("&").reduce(function(e, t) {
		var n = U(t.split("="), 2), r = n[0], i = n[1];
		return e[r] = i ? decodeURIComponent(i) : "", e;
	}, {});
}
function cm(e) {
	var t = function(e) {
		return Object.prototype.toString.call(e) === "[object Object]" || Object.prototype.toString.call(e) === "[object Array]";
	}, n = function(e) {
		var t = [...arguments].slice(1), n = 0;
		return e.replace(/%s/g, function() {
			return encodeURIComponent(t[n++]);
		});
	};
	return Object.keys(e).map(function(r) {
		return n("%s=%s", r, t(e[r]) ? JSON.stringify(e[r]) : e[r]);
	}).join("&");
}
//#endregion
//#region node_modules/instantsearch.js/es/index9.js
var lm = Op({ name: "instantsearch" });
function um() {
	return "#";
}
var dm = {
	preserveSharedStateOnUnmount: !1,
	persistHierarchicalRootCount: !1
}, fm = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t(e) {
		bd(this, t);
		var n = yd(this, t);
		G(n, "client", void 0), G(n, "indexName", void 0), G(n, "compositionID", void 0), G(n, "insightsClient", void 0), G(n, "onStateChange", null), G(n, "future", void 0), G(n, "helper", void 0), G(n, "mainHelper", void 0), G(n, "mainIndex", void 0), G(n, "started", void 0), G(n, "templatesConfig", void 0), G(n, "renderState", {}), G(n, "_stalledSearchDelay", void 0), G(n, "_searchStalledTimer", void 0), G(n, "_initialUiState", void 0), G(n, "_initialResults", void 0), G(n, "_manuallyResetScheduleSearch", !1), G(n, "_resetScheduleSearch", void 0), G(n, "_createURL", void 0), G(n, "_searchFunction", void 0), G(n, "_mainHelperSearch", void 0), G(n, "_hasSearchWidget", !1), G(n, "_hasRecommendWidget", !1), G(n, "_insights", void 0), G(n, "_initialOptions", void 0), G(n, "middleware", []), G(n, "sendEventToInsights", void 0), G(n, "_createdAt", hf()), G(n, "status", "idle"), G(n, "error", void 0), G(n, "scheduleSearch", Mu(function() {
			n.started && n.mainHelper.search();
		})), G(n, "scheduleRender", Mu(function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
			n.mainHelper?.hasPendingRequests() || (clearTimeout(n._searchStalledTimer), n._searchStalledTimer = null, e && (n.status = "idle", n.error = void 0)), n.mainIndex.render({ instantSearchInstance: n }), n.emit("render");
		})), G(n, "onInternalStateChange", Mu(function() {
			var e = n.mainIndex.getWidgetUiState({});
			n.middleware.forEach(function(t) {
				t.instance.onStateChange({ uiState: e });
			});
		})), n.setMaxListeners(100);
		var r = e.indexName, i = r === void 0 ? "" : r, a = e.compositionID, o = e.numberLocale, s = e.initialUiState, c = s === void 0 ? {} : s, l = e.routing, u = l === void 0 ? null : l, d = e.insights, f = d === void 0 ? void 0 : d, p = e.searchFunction, m = e.stalledSearchDelay, h = m === void 0 ? 200 : m, g = e.searchClient, _ = g === void 0 ? null : g, v = e.insightsClient, y = v === void 0 ? null : v, b = e.onStateChange, x = b === void 0 ? null : b, S = e.future, C = S === void 0 ? K({}, dm, e.future || {}) : S;
		if (_ === null) throw Error(lm("The `searchClient` option is required."));
		if (typeof _.search != "function") throw Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
		if (typeof _.addAlgoliaAgent == "function" && _.addAlgoliaAgent(`instantsearch.js (${gf})`), y && typeof y != "function") throw Error(lm("The `insightsClient` option should be a function."));
		if (n._initialOptions = e, n.client = _, n.future = C, n.insightsClient = y, n.indexName = i, n.compositionID = a, n.helper = null, n.mainHelper = null, n.mainIndex = $p({ indexName: n.compositionID || n.indexName }), n.onStateChange = x, n.started = !1, n.templatesConfig = {
			helpers: nm({ numberLocale: o }),
			compileOptions: {}
		}, n._stalledSearchDelay = h, n._searchStalledTimer = null, n._createURL = um, n._initialUiState = c, n._initialResults = null, n._insights = f, p && (n._searchFunction = p), n.sendEventToInsights = tf, u) {
			var w = typeof u == "boolean" ? {} : u;
			w.$$internal = !0, n.use(wp(w));
		}
		if (f) {
			var T = typeof f == "boolean" ? {} : f;
			T.$$internal = !0, n.use(bf(T));
		}
		return Ef() && n.use(Df({ $$internal: !0 })), n;
	}
	return Sd(t, [
		{
			key: "_isSearchStalled",
			get: function() {
				return this.status === "stalled";
			}
		},
		{
			key: "use",
			value: function() {
				var e = this, t = [...arguments].map(function(t) {
					var n = K({
						$$type: "__unknown__",
						$$internal: !1,
						subscribe: tf,
						started: tf,
						unsubscribe: tf,
						onStateChange: tf
					}, t({ instantSearchInstance: e }));
					return e.middleware.push({
						creator: t,
						instance: n
					}), n;
				});
				return this.started && t.forEach(function(e) {
					e.subscribe(), e.started();
				}), this;
			}
		},
		{
			key: "unuse",
			value: function() {
				var e = [...arguments];
				return this.middleware.filter(function(t) {
					return e.includes(t.creator);
				}).forEach(function(e) {
					return e.instance.unsubscribe();
				}), this.middleware = this.middleware.filter(function(t) {
					return !e.includes(t.creator);
				}), this;
			}
		},
		{
			key: "EXPERIMENTAL_use",
			value: function() {
				var e = [...arguments];
				return this.use.apply(this, W(e));
			}
		},
		{
			key: "addWidget",
			value: function(e) {
				return this.addWidgets([e]);
			}
		},
		{
			key: "addWidgets",
			value: function(e) {
				if (!Array.isArray(e)) throw Error(lm("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
				if (this.compositionID && e.some(function(e) {
					return !Array.isArray(e) && cf(e) && !e._isolated;
				})) throw Error(lm("The `index` widget cannot be used with a composition-based InstantSearch implementation."));
				return this.mainIndex.addWidgets(e), this;
			}
		},
		{
			key: "removeWidget",
			value: function(e) {
				return this.removeWidgets([e]);
			}
		},
		{
			key: "removeWidgets",
			value: function(e) {
				if (!Array.isArray(e)) throw Error(lm("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
				return this.mainIndex.removeWidgets(e), this;
			}
		},
		{
			key: "start",
			value: function() {
				var e = this;
				if (this.started) throw Error(lm("The `start` method has already been called once."));
				var t = this.mainHelper || (0, Y.default)(this.client, this.indexName, void 0, { persistHierarchicalRootCount: this.future.persistHierarchicalRootCount });
				if (this.compositionID && (t.searchForFacetValues = t.searchForCompositionFacetValues.bind(t)), t.search = function() {
					var n = e._hasSearchWidget || e._hasRecommendWidget;
					return n && (e.status = "loading"), e.scheduleRender(!n), e._hasSearchWidget && (e.compositionID ? t.searchWithComposition() : t.searchOnlyWithDerivedHelpers()), e._hasRecommendWidget && t.recommend(), t;
				}, this._searchFunction) {
					var n = { search: function() {
						return new Promise(tf);
					} };
					this._mainHelperSearch = t.search.bind(t), t.search = function() {
						var r = e.mainIndex.getHelper(), i = (0, Y.default)(n, r.state.index, r.state);
						return i.once("search", function(t) {
							var n = t.state;
							r.overrideStateWithoutTriggeringChangeEvent(n), e._mainHelperSearch();
						}), i.on("change", function(e) {
							var t = e.state;
							r.setState(t);
						}), e._searchFunction(i), t;
					};
				}
				if (t.on("error", function(t) {
					var n = t.error;
					if (!Nu(n, Error)) {
						var r = n;
						n = Object.keys(r).reduce(function(e, t) {
							return e[t] = r[t], e;
						}, Error(r.message));
					}
					n.error = n, e.error = n, e.status = "error", e.scheduleRender(!e._hasSearchWidget && !e._hasRecommendWidget), e.emit("error", n);
				}), this.mainHelper = t, this.middleware.forEach(function(e) {
					e.instance.subscribe();
				}), this.mainIndex.init({
					instantSearchInstance: this,
					parent: null,
					uiState: this._initialUiState
				}), this._initialResults) {
					om(this.client, this._initialResults), im(this.mainHelper, this._initialResults);
					var r = this.scheduleSearch;
					this.scheduleSearch = Mu(tf), this._manuallyResetScheduleSearch ? this._resetScheduleSearch = function() {
						e.scheduleSearch = r;
					} : Mu(function() {
						e.scheduleSearch = r;
					})();
				} else this.mainIndex.getWidgets().length > 0 && this.scheduleSearch();
				this.helper = this.mainIndex.getHelper(), this.started = !0, this.middleware.forEach(function(e) {
					e.instance.started();
				}), this._insights === void 0 && t.derivedHelpers[0].once("result", function() {
					e.mainIndex.getScopedResults().some(function(e) {
						return e.results?._automaticInsights;
					}) && e.use(bf({
						$$internal: !0,
						$$automatic: !0
					}));
				});
			}
		},
		{
			key: "dispose",
			value: function() {
				var e;
				this.scheduleSearch.cancel(), this.scheduleRender.cancel(), clearTimeout(this._searchStalledTimer), this.removeWidgets(this.mainIndex.getWidgets()), this.mainIndex.dispose(), this.started = !1, this.removeAllListeners(), (e = this.mainHelper) == null || e.removeAllListeners(), this.mainHelper = null, this.helper = null, this.middleware.forEach(function(e) {
					e.instance.unsubscribe();
				}), this._initialOptions = null;
			}
		},
		{
			key: "scheduleStalledRender",
			value: function() {
				var e = this;
				this._searchStalledTimer ||= setTimeout(function() {
					e.status = "stalled", e.scheduleRender();
				}, this._stalledSearchDelay);
			}
		},
		{
			key: "setUiState",
			value: function(e) {
				var t = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
				if (!this.mainHelper) throw Error(lm("The `start` method needs to be called before `setUiState`."));
				this.mainIndex.refreshUiState();
				var r = typeof e == "function" ? e(this.mainIndex.getWidgetUiState({})) : e;
				this.onStateChange && n ? this.onStateChange({
					uiState: r,
					setUiState: function(e) {
						rm(typeof e == "function" ? e(r) : e, t.mainIndex), t.scheduleSearch(), t.onInternalStateChange();
					}
				}) : (rm(r, this.mainIndex), this.scheduleSearch(), this.onInternalStateChange());
			}
		},
		{
			key: "getUiState",
			value: function() {
				return this.started && this.mainIndex.refreshUiState(), this.mainIndex.getWidgetUiState({});
			}
		},
		{
			key: "createURL",
			value: function() {
				var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
				if (!this.started) throw Error(lm("The `start` method needs to be called before `createURL`."));
				return this._createURL(e);
			}
		},
		{
			key: "refresh",
			value: function() {
				if (!this.mainHelper) throw Error(lm("The `start` method needs to be called before `refresh`."));
				this.mainHelper.clearCache().search();
			}
		}
	]), t;
}(ef.default), pm = function(e, t) {
	return e;
}, mm = function(e) {
	return new fm(e);
};
mm.version = gf, mm.createInfiniteHitsSessionStorageCache = pm(md), mm.highlight = pm(Lu), mm.reverseHighlight = pm(Ju), mm.snippet = pm(Xu), mm.reverseSnippet = pm(Qu), mm.insights = ad, mm.getInsightsAnonymousUserToken = ld, Object.defineProperty(mm, "widgets", { get: function() {
	throw ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets/index.js'");
} }), Object.defineProperty(mm, "connectors", { get: function() {
	throw ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors/index.js'");
} }), Object.defineProperty(mm, "templates", { get: function() {
	throw ReferenceError("\"instantsearch.templates\" are not available from the ES build.\n\nTo import the templates:\n\nimport { carousel } from 'instantsearch.js/es/templates/index.js'");
} });
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/documentation.js
function hm(e) {
	var t = e.name, n = e.connector;
	return [
		"https://www.algolia.com/doc/api-reference/widgets/",
		t,
		"/js/",
		n !== void 0 && n ? "#connector" : ""
	].join("");
}
function X() {
	var e = [...arguments].map(function(e) {
		return hm(e);
	}).join(", ");
	return function(t) {
		return [t, `See documentation: ${e}`].filter(Boolean).join("\n\n");
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/getObjectType.js
function gm(e) {
	return Object.prototype.toString.call(e).slice(8, -1);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/checkRendering.js
function _m(e, t) {
	if (e === void 0 || typeof e != "function") throw Error(`The render function is not valid (received type ${gm(e)}).

${t}`);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/escape-html.js
var vm = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, ym = /[&<>"']/g, bm = RegExp(ym.source);
function xm(e) {
	return e && bm.test(e) ? e.replace(ym, function(e) {
		return vm[e];
	}) : e;
}
var Sm = {
	"&amp;": "&",
	"&lt;": "<",
	"&gt;": ">",
	"&quot;": "\"",
	"&#39;": "'"
}, Cm = /&(amp|quot|lt|gt|#39);/g, wm = RegExp(Cm.source);
function Tm(e) {
	return e && wm.test(e) ? e.replace(Cm, function(e) {
		return Sm[e];
	}) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isPlainObject.js
function Em(e) {
	return e === null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function Dm(e) {
	return (e === void 0 ? "undefined" : ku(e)) === "object" && e !== null;
}
function Om(e) {
	if (!Dm(e) || Em(e) !== "[object Object]") return !1;
	if (Object.getPrototypeOf(e) === null) return !0;
	for (var t = e; Object.getPrototypeOf(t) !== null;) t = Object.getPrototypeOf(t);
	return Object.getPrototypeOf(e) === t;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/escape-highlight.js
var km = {
	highlightPreTag: "__ais-highlight__",
	highlightPostTag: "__/ais-highlight__"
}, Am = {
	highlightPreTag: "<mark>",
	highlightPostTag: "</mark>"
};
function jm(e) {
	return xm(e).replace(new RegExp(km.highlightPreTag, "g"), Am.highlightPreTag).replace(new RegExp(km.highlightPostTag, "g"), Am.highlightPostTag);
}
function Mm(e) {
	return Om(e) && typeof e.value != "string" ? Object.keys(e).reduce(function(t, n) {
		return q(K({}, t), G({}, n, Mm(e[n])));
	}, {}) : Array.isArray(e) ? e.map(Mm) : q(K({}, e), { value: jm(e.value) });
}
function Nm(e) {
	return e.__escaped === void 0 && (e = e.map(function(e) {
		Du(e);
		var t = Eu({}, e);
		return t._highlightResult &&= Mm(t._highlightResult), t._snippetResult &&= Mm(t._snippetResult), t;
	}), e.__escaped = !0), e;
}
function Pm(e) {
	return e.map(function(e) {
		return q(K({}, e), { highlighted: jm(e.highlighted) });
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/hits-absolute-position.js
function Fm(e, t, n) {
	return e.map(function(e, r) {
		return q(K({}, e), { __position: n * t + r + 1 });
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/hits-query-id.js
function Im(e, t) {
	return t ? e.map(function(e) {
		return q(K({}, e), { __queryID: t });
	}) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/noop.js
function Z() {}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/findIndex.js
function Lm(e, t) {
	if (!Array.isArray(e)) return -1;
	for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
	return -1;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/uniq.js
function Rm(e) {
	return e.filter(function(e, t, n) {
		return n.indexOf(e) === t;
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/mergeSearchParameters.js
var zm = function(e, t) {
	t.facets, t.disjunctiveFacets, t.facetsRefinements, t.facetsExcludes, t.disjunctiveFacetsRefinements, t.numericRefinements, t.tagRefinements, t.hierarchicalFacets, t.hierarchicalFacetsRefinements, t.ruleContexts;
	var n = J(t, [
		"facets",
		"disjunctiveFacets",
		"facetsRefinements",
		"facetsExcludes",
		"disjunctiveFacetsRefinements",
		"numericRefinements",
		"tagRefinements",
		"hierarchicalFacets",
		"hierarchicalFacetsRefinements",
		"ruleContexts"
	]);
	return e.setQueryParameters(n);
}, Bm = function(e, t) {
	return t.facets.reduce(function(e, t) {
		return e.addFacet(t);
	}, e);
}, Vm = function(e, t) {
	return t.disjunctiveFacets.reduce(function(e, t) {
		return e.addDisjunctiveFacet(t);
	}, e);
}, Hm = function(e, t) {
	return e.setQueryParameters({ hierarchicalFacets: t.hierarchicalFacets.reduce(function(e, t) {
		var n = Lm(e, function(e) {
			return e.name === t.name;
		});
		if (n === -1) return e.concat(t);
		var r = e.slice();
		return r.splice(n, 1, t), r;
	}, e.hierarchicalFacets) });
}, Um = function(e, t) {
	return t.tagRefinements.reduce(function(e, t) {
		return e.addTagRefinement(t);
	}, e);
}, Wm = function(e, t) {
	return e.setQueryParameters({ facetsRefinements: K({}, e.facetsRefinements, t.facetsRefinements) });
}, Gm = function(e, t) {
	return e.setQueryParameters({ facetsExcludes: K({}, e.facetsExcludes, t.facetsExcludes) });
}, Km = function(e, t) {
	return e.setQueryParameters({ disjunctiveFacetsRefinements: K({}, e.disjunctiveFacetsRefinements, t.disjunctiveFacetsRefinements) });
}, qm = function(e, t) {
	return e.setQueryParameters({ numericRefinements: K({}, e.numericRefinements, t.numericRefinements) });
}, Jm = function(e, t) {
	return e.setQueryParameters({ hierarchicalFacetsRefinements: K({}, e.hierarchicalFacetsRefinements, t.hierarchicalFacetsRefinements) });
}, Ym = function(e, t) {
	var n = Rm([].concat(e.ruleContexts, t.ruleContexts).filter(Boolean));
	return n.length > 0 ? e.setQueryParameters({ ruleContexts: n }) : e;
}, Xm = function() {
	return [...arguments].reduce(function(e, t) {
		return zm(Bm(Ym(Vm(Wm(Gm(Km(qm(Um(Hm(Jm(e, t), t), t), t), t), t), t), t), t), t), t);
	});
}, Zm = X({
	name: "configure",
	connector: !0
});
function Qm(e, t) {
	return e.setQueryParameters(Object.keys(t.searchParameters).reduce(function(e, t) {
		return q(K({}, e), G({}, t, void 0));
	}, {}));
}
var $m = function() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Z, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return function(n) {
		if (!n || !Om(n.searchParameters)) throw Error(Zm("The `searchParameters` option expects an object."));
		var r = {};
		function i(e) {
			return function(t) {
				var r = Xm(Qm(e.state, n), new Y.default.SearchParameters(t));
				n.searchParameters = t, e.setState(r).search();
			};
		}
		return {
			$$type: "ais.configure",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var r = e.state;
				return t(), Qm(r, n);
			},
			getRenderState: function(e, t) {
				var n = this.getWidgetRenderState(t);
				return q(K({}, e), { configure: q(K({}, n), { widgetParams: q(K({}, n.widgetParams), { searchParameters: Xm(new Y.default.SearchParameters(e.configure?.widgetParams.searchParameters), new Y.default.SearchParameters(n.widgetParams.searchParameters)).getQueryParams() }) }) });
			},
			getWidgetRenderState: function(e) {
				var t = e.helper;
				return r.refine ||= i(t), {
					refine: r.refine,
					widgetParams: n
				};
			},
			getWidgetSearchParameters: function(e, t) {
				var r = t.uiState;
				return Xm(e, new Y.default.SearchParameters(K({}, r.configure, n.searchParameters)));
			},
			getWidgetUiState: function(e) {
				return q(K({}, e), { configure: K({}, e.configure, n.searchParameters) });
			}
		};
	};
};
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/getPropertyByPath.js
function eh(e, t) {
	return (Array.isArray(t) ? t : t.split(".")).reduce(function(e, t) {
		return e && e[t];
	}, e);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/escapeFacetValue.js
function th(e) {
	return typeof e == "string" ? e.replace(/^\\-/, "-") : e;
}
function nh(e) {
	return typeof e == "number" && e < 0 || typeof e == "string" ? String(e).replace(/^-/, "\\-") : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/find.js
function rh(e, t) {
	for (var n, r = 0; r < e.length; r++) if (n = e[r], t(n, r, e)) return n;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/getRefinements.js
function ih(e, t, n, r) {
	var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], a = {
		type: t,
		attribute: n,
		name: r,
		escapedValue: nh(r)
	}, o = rh(i, function(e) {
		return e.name === n;
	}), s;
	if (t === "hierarchical") {
		for (var c = function(e) {
			o = o && o.data && rh(Object.keys(o.data).map(d(o.data)), function(t) {
				return t.name === u[e];
			});
		}, l = e.getHierarchicalFacetByName(n), u = r.split(l.separator), d = function(e) {
			return function(t) {
				return e[t];
			};
		}, f = 0; o !== void 0 && f < u.length; ++f) c(f);
		s = o && o.count;
	} else s = o && o.data && o.data[a.name];
	return s !== void 0 && (a.count = s), o && o.exhaustive !== void 0 && (a.exhaustive = o.exhaustive), a;
}
function ah(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = e || {}, i = [], a = t.facetsRefinements, o = a === void 0 ? {} : a, s = t.facetsExcludes, c = s === void 0 ? {} : s, l = t.disjunctiveFacetsRefinements, u = l === void 0 ? {} : l, d = t.hierarchicalFacetsRefinements, f = d === void 0 ? {} : d, p = t.numericRefinements, m = p === void 0 ? {} : p, h = t.tagRefinements, g = h === void 0 ? [] : h;
	return Object.keys(o).forEach(function(e) {
		o[e].forEach(function(n) {
			i.push(ih(t, "facet", e, n, r.facets));
		});
	}), Object.keys(c).forEach(function(e) {
		c[e].forEach(function(t) {
			i.push({
				type: "exclude",
				attribute: e,
				name: t,
				exclude: !0
			});
		});
	}), Object.keys(u).forEach(function(e) {
		u[e].forEach(function(n) {
			i.push(ih(t, "disjunctive", e, th(n), r.disjunctiveFacets));
		});
	}), Object.keys(f).forEach(function(e) {
		f[e].forEach(function(n) {
			i.push(ih(t, "hierarchical", e, n, r.hierarchicalFacets));
		});
	}), Object.keys(m).forEach(function(e) {
		var t = m[e];
		Object.keys(t).forEach(function(n) {
			var r = n, a = t[r];
			(Array.isArray(a) ? a : [a]).forEach(function(t) {
				i.push({
					type: "numeric",
					attribute: e,
					name: `${t}`,
					numericValue: t,
					operator: r
				});
			});
		});
	}), g.forEach(function(e) {
		i.push({
			type: "tag",
			attribute: "_tags",
			name: e
		});
	}), n && t.query && t.query.trim() && i.push({
		attribute: "query",
		type: "query",
		name: t.query,
		query: t.query
	}), i;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/clearRefinements.js
function oh(e) {
	var t = e.helper, n = e.attributesToClear, r = n === void 0 ? [] : n, i = t.state.setPage(0);
	return i = r.reduce(function(e, t) {
		return i.isNumericRefined(t) ? e.removeNumericRefinement(t) : i.isHierarchicalFacet(t) ? e.removeHierarchicalFacetRefinement(t) : i.isDisjunctiveFacet(t) ? e.removeDisjunctiveFacetRefinement(t) : i.isConjunctiveFacet(t) ? e.removeFacetRefinement(t) : e;
	}, i), r.indexOf("query") !== -1 && (i = i.setQuery("")), i;
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/clear-refinements/connectClearRefinements.js
var sh = X({
	name: "clear-refinements",
	connector: !0
}), ch = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, sh()), function(n) {
		var r = n || {}, i = r.includedAttributes, a = i === void 0 ? [] : i, o = r.excludedAttributes, s = o === void 0 ? ["query"] : o, c = r.transformItems, l = c === void 0 ? function(e) {
			return e;
		} : c;
		if (n && n.includedAttributes && n.excludedAttributes) throw Error(sh("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
		var u = {
			refine: Z,
			createURL: function() {
				return "";
			},
			attributesToClear: []
		}, d = function() {
			return u.refine();
		}, f = function() {
			return u.createURL();
		};
		return {
			$$type: "ais.clearRefinements",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function() {
				t();
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { clearRefinements: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.createURL, r = e.scopedResults, i = e.results;
				u.attributesToClear = r.reduce(function(e, t) {
					return e.concat(lh({
						scopedResult: t,
						includedAttributes: a,
						excludedAttributes: s,
						transformItems: l,
						results: i
					}));
				}, []), u.refine = function() {
					u.attributesToClear.forEach(function(e) {
						var t = e.helper, n = e.items;
						t.setState(oh({
							helper: t,
							attributesToClear: n
						})).search();
					});
				}, u.createURL = function() {
					return t(Xm.apply(void 0, W(u.attributesToClear.map(function(e) {
						var t = e.helper, n = e.items;
						return oh({
							helper: t,
							attributesToClear: n
						});
					}))));
				};
				var o = u.attributesToClear.some(function(e) {
					return e.items.length > 0;
				});
				return {
					canRefine: o,
					hasRefinements: o,
					refine: d,
					createURL: f,
					widgetParams: n
				};
			}
		};
	};
};
function lh(e) {
	var t = e.scopedResult, n = e.includedAttributes, r = e.excludedAttributes, i = e.transformItems, a = e.results, o = n.indexOf("query") !== -1 || r.indexOf("query") === -1;
	return {
		helper: t.helper,
		items: i(Rm(ah(t.results, t.helper.state, o).map(function(e) {
			return e.attribute;
		}).filter(function(e) {
			return n.length === 0 || n.indexOf(e) !== -1;
		}).filter(function(e) {
			return e === "query" && o || r.indexOf(e) === -1;
		})), { results: a })
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements.js
var uh = X({
	name: "current-refinements",
	connector: !0
}), dh = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, uh()), function(n) {
		if ((n || {}).includedAttributes && (n || {}).excludedAttributes) throw Error(uh("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
		var r = n || {}, i = r.includedAttributes, a = r.excludedAttributes, o = a === void 0 ? ["query"] : a, s = r.transformItems, c = s === void 0 ? function(e) {
			return e;
		} : s;
		return {
			$$type: "ais.currentRefinements",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function() {
				t();
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { currentRefinements: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, r = e.scopedResults, a = e.createURL, s = e.helper;
				function l() {
					return t ? r.reduce(function(e, n) {
						return e.concat(c(fh({
							results: n.results,
							helper: n.helper,
							indexId: n.indexId,
							includedAttributes: i,
							excludedAttributes: o
						}), { results: t }));
					}, []) : c(fh({
						results: null,
						helper: s,
						indexId: s.state.index,
						includedAttributes: i,
						excludedAttributes: o
					}), { results: t });
				}
				var u = l();
				return {
					items: u,
					canRefine: u.length > 0,
					refine: function(e) {
						return mh(s, e);
					},
					createURL: function(e) {
						return a(ph(s.state, e));
					},
					widgetParams: n
				};
			}
		};
	};
};
function fh(e) {
	var t = e.results, n = e.helper, r = e.indexId, i = e.includedAttributes, a = e.excludedAttributes, o = (i || []).indexOf("query") !== -1 || (a || []).indexOf("query") === -1, s = i ? function(e) {
		return i.indexOf(e.attribute) !== -1;
	} : function(e) {
		return a.indexOf(e.attribute) === -1;
	}, c = ah(t, n.state, o).map(gh).filter(s);
	return c.reduce(function(e, t) {
		return W(e.filter(function(e) {
			return e.attribute !== t.attribute;
		})).concat([{
			indexName: n.state.index,
			indexId: r,
			attribute: t.attribute,
			label: t.attribute,
			refinements: c.filter(function(e) {
				return e.attribute === t.attribute;
			}).sort(function(e, t) {
				return e.type === "numeric" ? e.value - t.value : 0;
			}),
			refine: function(e) {
				return mh(n, e);
			}
		}]);
	}, []);
}
function ph(e, t) {
	switch (e = e.resetPage(), t.type) {
		case "facet": return e.removeFacetRefinement(t.attribute, String(t.value));
		case "disjunctive": return e.removeDisjunctiveFacetRefinement(t.attribute, String(t.value));
		case "hierarchical": return e.removeHierarchicalFacetRefinement(t.attribute);
		case "exclude": return e.removeExcludeRefinement(t.attribute, String(t.value));
		case "numeric": return e.removeNumericRefinement(t.attribute, t.operator, String(t.value));
		case "tag": return e.removeTagRefinement(String(t.value));
		case "query": return e.setQueryParameter("query", "");
		default: return e;
	}
}
function mh(e, t) {
	e.setState(ph(e.state, t)).search();
}
function hh(e) {
	switch (e) {
		case ">=": return "≥";
		case "<=": return "≤";
		default: return e;
	}
}
function gh(e) {
	var t = _h(e), n = e.operator ? `${hh(e.operator)} ${e.name}` : e.name, r = {
		attribute: e.attribute,
		type: e.type,
		value: t,
		label: n
	};
	return e.operator !== void 0 && (r.operator = e.operator), e.count !== void 0 && (r.count = e.count), e.exhaustive !== void 0 && (r.exhaustive = e.exhaustive), r;
}
function _h(e) {
	return e.type === "numeric" ? Number(e.name) : "escapedValue" in e ? e.escapedValue : e.name;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isFacetRefined.js
function vh(e, t, n) {
	return e.state.isHierarchicalFacet(t) ? e.state.isHierarchicalFacetRefined(t, n) : e.state.isConjunctiveFacet(t) ? e.state.isFacetRefined(t, n) : e.state.isDisjunctiveFacetRefined(t, n);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/createSendEventForFacet.js
function yh(e) {
	var t = e.instantSearchInstance, n = e.helper, r = e.attribute, i = e.widgetType;
	return function() {
		var e = [...arguments], a = U(e, 4), o = a[1], s = a[2], c = s === void 0 ? "Filter Applied" : s, l = a[3], u = l === void 0 ? {} : l, d = U(e[0].split(":"), 2), f = d[0], p = d[1], m = typeof r == "string" ? r : r(o);
		e.length === 1 && ku(e[0]) === "object" ? t.sendEventToInsights(e[0]) : f === "click" && e.length >= 2 && e.length <= 4 && !vh(n, m, o) && t.sendEventToInsights({
			insightsMethod: "clickedFilters",
			widgetType: i,
			eventType: f,
			eventModifier: p,
			payload: K({
				eventName: c,
				index: n.lastResults?.index || n.state.index,
				filters: [`${m}:${o}`]
			}, u),
			attribute: m
		});
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/hierarchical-menu/connectHierarchicalMenu.js
var bh = X({
	name: "hierarchical-menu",
	connector: !0
}), xh = ["name:asc"], Sh = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, bh()), function(n) {
		var r = n || {}, i = r.attributes, a = r.separator, o = a === void 0 ? " > " : a, s = r.rootPath, c = s === void 0 ? null : s, l = r.showParentLevel, u = l === void 0 || l, d = r.limit, f = d === void 0 ? 10 : d, p = r.showMore, m = p !== void 0 && p, h = r.showMoreLimit, g = h === void 0 ? 20 : h, _ = r.sortBy, v = _ === void 0 ? xh : _, y = r.transformItems, b = y === void 0 ? function(e) {
			return e;
		} : y;
		if (!i || !Array.isArray(i) || i.length === 0) throw Error(bh("The `attributes` option expects an array of strings."));
		if (m === !0 && g <= f) throw Error(bh("The `showMoreLimit` option must be greater than `limit`."));
		var x = U(i, 1)[0], S, C = function() {};
		function w() {
			C();
		}
		var T, E = !1;
		function D(e, t) {
			return function() {
				E = !E, t.render(e);
			};
		}
		function ee() {
			return E ? g : f;
		}
		function O(e) {
			return e.slice(0, ee()).map(function(e) {
				var t = e.name, n = e.escapedValue, r = e.data;
				e.path;
				var i = q(K({}, J(e, [
					"name",
					"escapedValue",
					"data",
					"path"
				])), {
					value: n,
					label: t,
					data: null
				});
				return Array.isArray(r) && (i.data = O(r)), i;
			});
		}
		function k(e, t) {
			var n = ee();
			return !(t > n ? e.length <= n : e.length < n) || e.slice(0, f).some(function(e) {
				return Array.isArray(e.data) && e.data.length > 0 && k(e.data, t);
			});
		}
		return {
			$$type: "ais.hierarchicalMenu",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				C = D(t, this), e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeHierarchicalFacet(x).setQueryParameter("maxValuesPerFacet", void 0);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { hierarchicalMenu: q(K({}, e.hierarchicalMenu), G({}, x, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = this, r = e.results, a = e.state, s = e.createURL, c = e.instantSearchInstance, l = e.helper, u = [], d = !1, f = function(e) {
					return s(function(n) {
						return t.getWidgetUiState(n, {
							searchParameters: a.resetPage().toggleFacetRefinement(x, e),
							helper: l
						});
					});
				};
				if (S ||= yh({
					instantSearchInstance: c,
					helper: l,
					attribute: function(e) {
						return i[e.split(o).length - 1];
					},
					widgetType: this.$$type
				}), T ||= function(e) {
					S("click:internal", e), l.toggleFacetRefinement(x, e).search();
				}, r) {
					var p = r.getFacetValues(x, {
						sortBy: v,
						facetOrdering: v === xh
					}), h = p && !Array.isArray(p) && p.data ? p.data : [], g = k(h, a.maxValuesPerFacet || 0);
					d = m && (E || g), u = b(O(h), { results: r });
				}
				return {
					items: u,
					refine: T,
					canRefine: u.length > 0,
					createURL: f,
					sendEvent: S,
					widgetParams: n,
					isShowingMore: E,
					toggleShowMore: w,
					canToggleShowMore: d
				};
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters.getHierarchicalFacetBreadcrumb(x);
				return Ch(q(K({}, e), { hierarchicalMenu: q(K({}, e.hierarchicalMenu), G({}, x, n)) }), x);
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = n.hierarchicalMenu && n.hierarchicalMenu[x];
				if (e.isConjunctiveFacet(x) || e.isDisjunctiveFacet(x)) return e;
				e.isHierarchicalFacet(x) && e.getHierarchicalFacetByName(x);
				var a = e.removeHierarchicalFacet(x).addHierarchicalFacet({
					name: x,
					attributes: i,
					separator: o,
					rootPath: c,
					showParentLevel: u
				}), s = a.maxValuesPerFacet || 0, l = Math.max(s, m ? g : f), d = a.setQueryParameter("maxValuesPerFacet", l);
				return r ? d.addHierarchicalFacetRefinement(x, r.join(o)) : d.setQueryParameters({ hierarchicalFacetsRefinements: q(K({}, d.hierarchicalFacetsRefinements), G({}, x, [])) });
			}
		};
	};
};
function Ch(e, t) {
	return e.hierarchicalMenu ? ((!e.hierarchicalMenu[t] || e.hierarchicalMenu[t].length === 0) && delete e.hierarchicalMenu[t], Object.keys(e.hierarchicalMenu).length === 0 && delete e.hierarchicalMenu, e) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/serializer.js
function wh(e) {
	return btoa(encodeURIComponent(JSON.stringify(e)));
}
function Th(e) {
	return JSON.parse(decodeURIComponent(atob(e)));
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/createSendEventForHits.js
function Eh(e) {
	for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20, n = [], r = 0; r < Math.ceil(e.length / t); r++) n.push(e.slice(r * t, (r + 1) * t));
	return n;
}
function Dh(e) {
	var t = e.helper, n = e.widgetType;
	e.methodName;
	var r = e.args, i = e.instantSearchInstance;
	if (r.length === 1 && ku(r[0]) === "object") return [r[0]];
	var a = U(r[0].split(":"), 2), o = a[0], s = a[1], c = r[1], l = r[2], u = r[3] || {};
	if (!c || (o === "click" || o === "conversion") && !l) return [];
	var d = Array.isArray(c) ? c : [c];
	if (d.length === 0) return [];
	var f = d[0].__queryID, p = Eh(d), m = p.map(function(e) {
		return e.map(function(e) {
			return e.objectID;
		});
	}), h = p.map(function(e) {
		return e.map(function(e) {
			return e.__position;
		});
	});
	return o === "view" ? i.status === "idle" ? p.map(function(e, r) {
		return {
			insightsMethod: "viewedObjectIDs",
			widgetType: n,
			eventType: o,
			payload: K({
				eventName: l || "Hits Viewed",
				index: t.lastResults?.index || t.state.index,
				objectIDs: m[r]
			}, u),
			hits: e,
			eventModifier: s
		};
	}) : [] : o === "click" ? p.map(function(e, r) {
		return {
			insightsMethod: "clickedObjectIDsAfterSearch",
			widgetType: n,
			eventType: o,
			payload: K({
				eventName: l || "Hit Clicked",
				index: t.lastResults?.index || t.state.index,
				queryID: f,
				objectIDs: m[r],
				positions: h[r]
			}, u),
			hits: e,
			eventModifier: s
		};
	}) : o === "conversion" ? p.map(function(e, r) {
		return {
			insightsMethod: "convertedObjectIDsAfterSearch",
			widgetType: n,
			eventType: o,
			payload: K({
				eventName: l || "Hit Converted",
				index: t.lastResults?.index || t.state.index,
				queryID: f,
				objectIDs: m[r]
			}, u),
			hits: e,
			eventModifier: s
		};
	}) : [];
}
function Oh(e) {
	var t = e.instantSearchInstance, n = e.helper, r = e.widgetType, i = {}, a = void 0;
	return function() {
		Dh({
			widgetType: r,
			helper: n,
			methodName: "sendEvent",
			args: [...arguments],
			instantSearchInstance: t
		}).forEach(function(e) {
			e.eventType === "click" && e.eventModifier === "internal" && i[e.eventType] || (i[e.eventType] = !0, t.sendEventToInsights(e));
		}), clearTimeout(a), a = setTimeout(function() {
			i = {};
		}, 0);
	};
}
function kh(e) {
	var t = e.helper, n = e.widgetType, r = e.instantSearchInstance;
	return function() {
		var e = Dh({
			widgetType: n,
			helper: t,
			methodName: "bindEvent",
			args: [...arguments],
			instantSearchInstance: r
		});
		return e.length ? `data-insights-event=${wh(e)}` : "";
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/hits/connectHits.js
var Ah = X({
	name: "hits",
	connector: !0
}), jh = (function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, Ah()), function(n) {
		var r = n || {}, i = r.escapeHTML, a = i === void 0 || i, o = r.transformItems, s = o === void 0 ? function(e) {
			return e;
		} : o, c, l;
		return {
			$$type: "ais.hits",
			init: function(t) {
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !0);
			},
			render: function(t) {
				var n = this.getWidgetRenderState(t);
				e(q(K({}, n), { instantSearchInstance: t.instantSearchInstance }), !1), n.sendEvent("view:internal", n.items);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { hits: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, r = e.helper, i = e.instantSearchInstance, o, u;
				if (c ||= Oh({
					instantSearchInstance: i,
					helper: r,
					widgetType: this.$$type
				}), l ||= kh({
					helper: r,
					widgetType: this.$$type,
					instantSearchInstance: i
				}), !t) return {
					hits: [],
					items: [],
					results: void 0,
					banner: void 0,
					sendEvent: c,
					bindEvent: l,
					widgetParams: n
				};
				a && t.hits.length > 0 && (t.hits = Nm(t.hits));
				var d = s(Im(Fm(t.hits, t.page, t.hitsPerPage), t.queryID), { results: t });
				return {
					hits: d,
					items: d,
					results: t,
					banner: (u = t.renderingContent) == null || (o = u.widgets) == null ? void 0 : o.banners?.[0],
					sendEvent: c,
					bindEvent: l,
					widgetParams: n
				};
			},
			dispose: function(e) {
				var n = e.state;
				return t(), a ? n.setQueryParameters(Object.keys(km).reduce(function(e, t) {
					return q(K({}, e), G({}, t, void 0));
				}, {})) : n;
			},
			getWidgetSearchParameters: function(e, t) {
				return a ? e.setQueryParameters(km) : e;
			}
		};
	};
}), Mh = function(e, t) {
	return t.map(function(t) {
		var n = rh(e, function(e) {
			return e.objectID === t;
		});
		if (n === void 0) throw Error(`Could not find objectID "${t}" passed to \`clickedObjectIDsAfterSearch\` in the returned hits. This is necessary to infer the absolute position and the query ID.`);
		return n;
	});
}, Nh = function(e) {
	var t = Rm(e.map(function(e) {
		return e.__queryID;
	}));
	if (t.length > 1) throw Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
	var n = t[0];
	if (typeof n != "string") throw Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
	return n;
}, Ph = function(e) {
	return e.map(function(e) {
		return e.__position;
	});
}, Fh = function(e) {
	var t = e.method, n = e.results, r = e.hits, i = e.objectIDs, a = n.index, o = Mh(r, i), s = Nh(o);
	switch (t) {
		case "clickedObjectIDsAfterSearch": return {
			index: a,
			queryID: s,
			objectIDs: i,
			positions: Ph(o)
		};
		case "convertedObjectIDsAfterSearch": return {
			index: a,
			queryID: s,
			objectIDs: i
		};
		default: throw Error(`Unsupported method passed to insights: "${t}".`);
	}
}, Ih = function(e, t, n) {
	return function(r) {
		var i = U([...arguments].slice(1), 1)[0];
		if (!e) {
			var a = X({ name: "instantsearch" });
			throw Error(a("The `insightsClient` option has not been provided to `instantsearch`."));
		}
		if (!Array.isArray(i.objectIDs)) throw TypeError("Expected `objectIDs` to be an array.");
		e(r, K({}, Fh({
			method: r,
			results: t,
			hits: n,
			objectIDs: i.objectIDs
		}), i));
	};
};
function Lh(e) {
	return function(t, n) {
		return e(function(e, n) {
			var r = e.results, i = e.hits, a = e.instantSearchInstance;
			if (r && i && a) {
				var o = Ih(a.insightsClient, r, i);
				return t(q(K({}, e), { insights: o }), n);
			}
			return t(e, n);
		}, n);
	};
}
//#endregion
//#region node_modules/instantsearch.js/es/types/widget.js
var Rh = ["ais.index", "ais.feedContainer"];
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isIndexWidget.js
function zh(e) {
	return Rh.includes(e.$$type);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isEqual.js
function Bh(e) {
	return e !== Object(e);
}
function Vh(e, t) {
	if (e === t) return !0;
	if (Bh(e) || Bh(t) || typeof e == "function" || typeof t == "function") return e === t;
	if (Object.keys(e).length !== Object.keys(t).length) return !1;
	var n = !0, r = !1, i = void 0;
	try {
		for (var a = Object.keys(e)[Symbol.iterator](), o; !(n = (o = a.next()).done); n = !0) {
			var s = o.value;
			if (!(s in t) || !Vh(e[s], t[s])) return !1;
		}
	} catch (e) {
		r = !0, i = e;
	} finally {
		try {
			!n && a.return != null && a.return();
		} finally {
			if (r) throw i;
		}
	}
	return !0;
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/menu/connectMenu.js
var Hh = X({
	name: "menu",
	connector: !0
}), Uh = ["isRefined", "name:asc"], Wh = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, Hh()), function(n) {
		var r = n || {}, i = r.attribute, a = r.limit, o = a === void 0 ? 10 : a, s = r.showMore, c = s !== void 0 && s, l = r.showMoreLimit, u = l === void 0 ? 20 : l, d = r.sortBy, f = d === void 0 ? Uh : d, p = r.transformItems, m = p === void 0 ? function(e) {
			return e;
		} : p;
		if (!i) throw Error(Hh("The `attribute` option is required."));
		if (c === !0 && u <= o) throw Error(Hh("The `showMoreLimit` option must be greater than `limit`."));
		var h, g, _, v = !1, y = function() {};
		function b(e, t) {
			return function() {
				v = !v, t.render(e);
			};
		}
		function x() {
			y();
		}
		function S() {
			return v ? u : o;
		}
		return {
			$$type: "ais.menu",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeHierarchicalFacet(i).setQueryParameter("maxValuesPerFacet", void 0);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { menu: q(K({}, e.menu), G({}, i, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = this, r = e.results, a = e.createURL, o = e.instantSearchInstance, s = e.helper, l = [], u = !1;
				if (h ||= yh({
					instantSearchInstance: o,
					helper: s,
					attribute: i,
					widgetType: this.$$type
				}), g ||= function(e) {
					return a(function(n) {
						return t.getWidgetUiState(n, {
							searchParameters: s.state.resetPage().toggleFacetRefinement(i, e),
							helper: s
						});
					});
				}, _ ||= function(e) {
					var t = U(s.getHierarchicalFacetBreadcrumb(i), 1)[0];
					h("click:internal", e || t), s.toggleFacetRefinement(i, e || t).search();
				}, e.results && (y = b(e, this)), r) {
					var d = r.getFacetValues(i, {
						sortBy: f,
						facetOrdering: f === Uh
					}), p = d && !Array.isArray(d) && d.data ? d.data : [];
					u = c && (v || p.length > S()), l = m(p.slice(0, S()).map(function(e) {
						var t = e.name, n = e.escapedValue;
						return e.path, q(K({}, J(e, [
							"name",
							"escapedValue",
							"path"
						])), {
							label: t,
							value: n
						});
					}), { results: r });
				}
				return {
					items: l,
					createURL: g,
					refine: _,
					sendEvent: h,
					canRefine: l.length > 0,
					widgetParams: n,
					isShowingMore: v,
					toggleShowMore: x,
					canToggleShowMore: u
				};
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters, r = U(n.getHierarchicalFacetBreadcrumb(i), 1)[0];
				return Gh(q(K({}, e), { menu: q(K({}, e.menu), G({}, i, r)) }), i);
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = n.menu && n.menu[i];
				if (e.isConjunctiveFacet(i) || e.isDisjunctiveFacet(i)) return e;
				var a = e.removeHierarchicalFacet(i).addHierarchicalFacet({
					name: i,
					attributes: [i]
				}), s = a.maxValuesPerFacet || 0, l = Math.max(s, c ? u : o), d = a.setQueryParameter("maxValuesPerFacet", l);
				return r ? d.addHierarchicalFacetRefinement(i, r) : d.setQueryParameters({ hierarchicalFacetsRefinements: q(K({}, d.hierarchicalFacetsRefinements), G({}, i, [])) });
			}
		};
	};
};
function Gh(e, t) {
	return e.menu ? (e.menu[t] === void 0 && delete e.menu[t], Object.keys(e.menu).length === 0 && delete e.menu, e) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isFiniteNumber.js
function Q(e) {
	return typeof e == "number" && isFinite(e);
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/numeric-menu/connectNumericMenu.js
var Kh = X({
	name: "numeric-menu",
	connector: !0
}), qh = "ais.numericMenu", Jh = function(e) {
	var t = e.instantSearchInstance;
	return function() {
		var e = [...arguments];
		if (e.length === 1) {
			t.sendEventToInsights(e[0]);
			return;
		}
	};
}, Yh = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, Kh()), function(n) {
		var r = n || {}, i = r.attribute, a = i === void 0 ? "" : i, o = r.items, s = o === void 0 ? [] : o, c = r.transformItems, l = c === void 0 ? function(e) {
			return e;
		} : c;
		if (a === "") throw Error(Kh("The `attribute` option is required."));
		if (!s || s.length === 0) throw Error(Kh("The `items` option expects an array of objects."));
		var u = function(e) {
			return s.map(function(t) {
				var n = t.start, r = t.end, i = t.label;
				return {
					label: i,
					value: encodeURI(JSON.stringify({
						start: n,
						end: r
					})),
					isRefined: Xh(e, a, {
						start: n,
						end: r,
						label: i
					})
				};
			});
		}, d = {};
		return {
			$$type: qh,
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeNumericRefinement(a);
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters.getNumericRefinements(a), r = n["="] && n["="][0];
				if (r || r === 0) return q(K({}, e), { numericMenu: q(K({}, e.numericMenu), G({}, a, `${n["="]}`)) });
				var i = n[">="] && n[">="][0] || "", o = n["<="] && n["<="][0] || "";
				return $h(q(K({}, e), { numericMenu: q(K({}, e.numericMenu), G({}, a, `${i}:${o}`)) }), a);
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = n.numericMenu && n.numericMenu[a], i = e.setQueryParameters({ numericRefinements: q(K({}, e.numericRefinements), G({}, a, {})) });
				if (!r) return i;
				if (r.indexOf(":") === -1) return i.addNumericRefinement(a, "=", Number(r));
				var o = U(r.split(":").map(parseFloat), 2), s = o[0], c = o[1], l = Q(s) ? i.addNumericRefinement(a, ">=", s) : i;
				return Q(c) ? l.addNumericRefinement(a, "<=", c) : l;
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { numericMenu: q(K({}, e.numericMenu), G({}, a, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = this, r = e.results, i = e.state, o = e.instantSearchInstance, s = e.helper, c = e.createURL;
				d.refine ||= function(e) {
					var t = Zh(s.state, a, e);
					d.sendEvent("click:internal", e), s.setState(t).search();
				}, d.createURL ||= function(e) {
					return function(n) {
						return c(function(r) {
							return t.getWidgetUiState(r, {
								searchParameters: Zh(e, a, n),
								helper: s
							});
						});
					};
				}, d.sendEvent ||= Jh({ instantSearchInstance: o });
				var f = !r || r.nbHits === 0, p = u(i), m = !0, h = !0, g = !1, _ = void 0;
				try {
					for (var v = p[Symbol.iterator](), y; !(h = (y = v.next()).done); h = !0) {
						var b = y.value;
						if (b.isRefined && decodeURI(b.value) !== "{}") {
							m = !1;
							break;
						}
					}
				} catch (e) {
					g = !0, _ = e;
				} finally {
					try {
						!h && v.return != null && v.return();
					} finally {
						if (g) throw _;
					}
				}
				return {
					createURL: d.createURL(i),
					items: l(p, { results: r }),
					hasNoResults: f,
					canRefine: !(f && m),
					refine: d.refine,
					sendEvent: d.sendEvent,
					widgetParams: n
				};
			}
		};
	};
};
function Xh(e, t, n) {
	var r = e.getNumericRefinements(t);
	return n.start !== void 0 && n.end !== void 0 ? n.start === n.end ? Qh(r, "=", n.start) : Qh(r, ">=", n.start) && Qh(r, "<=", n.end) : n.start === void 0 ? n.end === void 0 ? n.start === void 0 && n.end === void 0 && Object.keys(r).every(function(e) {
		return (r[e] || []).length === 0;
	}) : Qh(r, "<=", n.end) : Qh(r, ">=", n.start);
}
function Zh(e, t, n) {
	var r = e, i = JSON.parse(decodeURI(n)), a = r.getNumericRefinements(t);
	if (i.start === void 0 && i.end === void 0) return r.removeNumericRefinement(t);
	if (Xh(r, t, i) || (r = r.removeNumericRefinement(t)), i.start !== void 0 && i.end !== void 0) {
		if (i.start > i.end) throw Error("option.start should be > to option.end");
		if (i.start === i.end) return r = Qh(a, "=", i.start) ? r.removeNumericRefinement(t, "=", i.start) : r.addNumericRefinement(t, "=", i.start), r;
	}
	return i.start !== void 0 && (Qh(a, ">=", i.start) && (r = r.removeNumericRefinement(t, ">=", i.start)), r = r.addNumericRefinement(t, ">=", i.start)), i.end !== void 0 && (Qh(a, "<=", i.end) && (r = r.removeNumericRefinement(t, "<=", i.end)), r = r.addNumericRefinement(t, "<=", i.end)), typeof r.page == "number" && (r.page = 0), r;
}
function Qh(e, t, n) {
	var r = e[t];
	return r !== void 0 && r.includes(n);
}
function $h(e, t) {
	return e.numericMenu ? (e.numericMenu[t] === ":" && delete e.numericMenu[t], Object.keys(e.numericMenu).length === 0 && delete e.numericMenu, e) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/range.js
function eg(e) {
	var t = e.start, n = t === void 0 ? 0 : t, r = e.end, i = e.step, a = i === void 0 ? 1 : i, o = a === 0 ? 1 : a, s = Math.round((r - n) / o);
	return W(Array(s)).map(function(e, t) {
		return n + t * o;
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/pagination/Paginator.js
var tg = /*#__PURE__*/ function() {
	function e(t) {
		bd(this, e), G(this, "currentPage", void 0), G(this, "total", void 0), G(this, "padding", void 0), this.currentPage = t.currentPage, this.total = t.total, this.padding = t.padding;
	}
	return Sd(e, [
		{
			key: "pages",
			value: function() {
				var e = this, t = e.total, n = e.currentPage, r = e.padding;
				if (t === 0) return [0];
				var i = this.nbPagesDisplayed(r, t);
				if (i === t) return eg({ end: t });
				var a = this.calculatePaddingLeft(n, r, t, i), o = i - a;
				return eg({
					start: n - a,
					end: n + o
				});
			}
		},
		{
			key: "nbPagesDisplayed",
			value: function(e, t) {
				return Math.min(2 * e + 1, t);
			}
		},
		{
			key: "calculatePaddingLeft",
			value: function(e, t, n, r) {
				return e <= t ? e : e >= n - t ? r - (n - e) : t;
			}
		},
		{
			key: "isLastPage",
			value: function() {
				return this.currentPage >= this.total - 1;
			}
		},
		{
			key: "isFirstPage",
			value: function() {
				return this.currentPage <= 0;
			}
		}
	]), e;
}(), ng = X({
	name: "pagination",
	connector: !0
}), rg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, ng()), function(n) {
		var r = n || {}, i = r.totalPages, a = r.padding, o = new tg({
			currentPage: 0,
			total: 0,
			padding: a === void 0 ? 3 : a
		}), s = {};
		function c(e) {
			var t = e.nbPages;
			return i === void 0 ? t : Math.min(i, t);
		}
		return {
			$$type: "ais.pagination",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.setQueryParameter("page", void 0);
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters.page || 0;
				return n ? q(K({}, e), { page: n + 1 }) : e;
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = n.page ? n.page - 1 : 0;
				return e.setQueryParameter("page", r);
			},
			getWidgetRenderState: function(e) {
				var t = e.results, r = e.helper, i = e.state, a = e.createURL;
				s.refine ||= function(e) {
					r.setPage(e), r.search();
				}, s.createURL ||= function(e) {
					return a(function(t) {
						return q(K({}, t), { page: e + 1 });
					});
				};
				var l = i.page || 0, u = c(t || { nbPages: 0 });
				return o.currentPage = l, o.total = u, {
					createURL: s.createURL,
					refine: s.refine,
					canRefine: u > 1,
					currentRefinement: l,
					nbHits: t?.nbHits || 0,
					nbPages: u,
					pages: t ? o.pages() : [],
					isFirstPage: o.isFirstPage(),
					isLastPage: o.isLastPage(),
					widgetParams: n
				};
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { pagination: this.getWidgetRenderState(t) });
			}
		};
	};
}, ig = X({
	name: "range-input",
	connector: !0
}, {
	name: "range-slider",
	connector: !0
}), ag = "ais.range";
function og(e) {
	var t = e.min, n = e.max, r = 10 ** e.precision;
	return {
		min: t && Math.floor(t * r) / r,
		max: n && Math.ceil(n * r) / r
	};
}
var sg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, ig()), function(n) {
		var r = n || {}, i = r.attribute, a = i === void 0 ? "" : i, o = r.min, s = r.max, c = r.precision, l = c === void 0 ? 0 : c;
		if (!a) throw Error(ig("The `attribute` option is required."));
		if (Q(o) && Q(s) && o > s) throw Error(ig("The `max` option can't be lower than `min`."));
		var u = function(e) {
			return Number(Number(e).toFixed(l));
		}, d = {
			from: function(e) {
				return e.toLocaleString();
			},
			to: function(e) {
				return u(e).toLocaleString();
			}
		}, f = function(e, t, n, r) {
			var i = e.state, c = t.min, u = t.max, d = U(i.getNumericRefinement(a, ">=") || [], 1)[0], f = U(i.getNumericRefinement(a, "<=") || [], 1)[0], p = n === void 0 || n === "", m = r === void 0 || r === "", h = og({
				min: p ? void 0 : parseFloat(n),
				max: m ? void 0 : parseFloat(r),
				precision: l
			}), g = h.min, _ = h.max, v = !Q(o) && c === g ? void 0 : Q(o) && p ? o : g, y = !Q(s) && u === _ ? void 0 : Q(s) && m ? s : _, b = v === void 0, x = Q(c) && c <= v, S = b || Q(v) && (!Q(c) || x), C = y === void 0, w = Q(y) && u >= y, T = C || Q(y) && (!Q(u) || w);
			return (d !== v || f !== y) && S && T ? (i = i.removeNumericRefinement(a), Q(v) && (i = i.addNumericRefinement(a, ">=", v)), Q(y) && (i = i.addNumericRefinement(a, "<=", y)), i.resetPage()) : null;
		}, p = function(e) {
			return function() {
				var t = [...arguments];
				if (t.length === 1) {
					e.sendEventToInsights(t[0]);
					return;
				}
			};
		};
		function m(e) {
			return og({
				min: Q(o) ? o : Q(e.min) ? e.min : 0,
				max: Q(s) ? s : Q(e.max) ? e.max : 0,
				precision: l
			});
		}
		function h(e) {
			var t = U(e.getNumericRefinement(a, ">=") || [], 1)[0], n = U(e.getNumericRefinement(a, "<=") || [], 1)[0];
			return [Q(t) ? t : -Infinity, Q(n) ? n : Infinity];
		}
		function g(e, t) {
			return function() {
				var n = U(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [void 0, void 0], 2), r = n[0], i = n[1], a = f(e, t, r, i);
				a && e.setState(a).search();
			};
		}
		return {
			$$type: ag,
			init: function(t) {
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !0);
			},
			render: function(t) {
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !1);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { range: q(K({}, e.range), G({}, a, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, r = e.helper, i = e.instantSearchInstance, o = rh(t && t.disjunctiveFacets || [], function(e) {
					return e.name === a;
				}), s = m(o && o.stats || {
					min: void 0,
					max: void 0
				}), c = h(r);
				return {
					refine: t ? g(r, s) : g(r, {
						min: void 0,
						max: void 0
					}),
					canRefine: s.min !== s.max,
					format: d,
					range: s,
					sendEvent: p(i),
					widgetParams: q(K({}, n), { precision: l }),
					start: c
				};
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeDisjunctiveFacet(a).removeNumericRefinement(a);
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters.getNumericRefinements(a), r = n[">="], i = r === void 0 ? [] : r, o = n["<="], s = o === void 0 ? [] : o;
				return i.length === 0 && s.length === 0 ? e : q(K({}, e), { range: q(K({}, e.range), G({}, a, `${i}:${s}`)) });
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = e.addDisjunctiveFacet(a).setQueryParameters({ numericRefinements: q(K({}, e.numericRefinements), G({}, a, {})) });
				Q(o) && (r = r.addNumericRefinement(a, ">=", o)), Q(s) && (r = r.addNumericRefinement(a, "<=", s));
				var i = n.range && n.range[a];
				if (!i || i.indexOf(":") === -1) return r;
				var c = U(i.split(":").map(parseFloat), 2), l = c[0], u = c[1];
				return Q(l) && (!Q(o) || o < l) && (r = r.removeNumericRefinement(a, ">="), r = r.addNumericRefinement(a, ">=", l)), Q(u) && (!Q(s) || u < s) && (r = r.removeNumericRefinement(a, "<="), r = r.addNumericRefinement(a, "<=", u)), r;
			}
		};
	};
}, cg = X({
	name: "refinement-list",
	connector: !0
}), lg = [
	"isRefined",
	"count:desc",
	"name:asc"
], ug = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, cg()), function(n) {
		var r = n || {}, i = r.attribute, a = r.operator, o = a === void 0 ? "or" : a, s = r.limit, c = s === void 0 ? 10 : s, l = r.showMore, u = l !== void 0 && l, d = r.showMoreLimit, f = d === void 0 ? 20 : d, p = r.sortBy, m = p === void 0 ? lg : p, h = r.escapeFacetValues, g = h === void 0 || h, _ = r.transformItems, v = _ === void 0 ? function(e) {
			return e;
		} : _;
		if (!i) throw Error(cg("The `attribute` option is required."));
		if (!/^(and|or)$/.test(o)) throw Error(cg(`The \`operator\` must one of: \`"and"\`, \`"or"\` (got "${o}").`));
		if (u === !0 && f <= c) throw Error(cg("`showMoreLimit` should be greater than `limit`."));
		var y = function(e) {
			var t = e.name, n = e.escapedValue;
			return q(K({}, J(e, ["name", "escapedValue"])), {
				value: n,
				label: t,
				highlighted: t
			});
		}, b, x = [], S = !0, C, w, T = !1, E = function() {};
		function D() {
			E();
		}
		function ee(e, t) {
			return function() {
				T = !T, t.render(e);
			};
		}
		function O() {
			return T ? f : c;
		}
		var k = function() {
			return function() {};
		}, A = function(t, n) {
			return function(r) {
				return function(a) {
					var o = r.instantSearchInstance, s = r.results;
					if (a === "" && x) e(q(K({}, n.getWidgetRenderState(q(K({}, r), { results: b }))), { instantSearchInstance: o }), !1);
					else {
						var c = {
							highlightPreTag: g ? km.highlightPreTag : Am.highlightPreTag,
							highlightPostTag: g ? km.highlightPostTag : Am.highlightPostTag
						};
						t.searchForFacetValues(i, a, Math.min(O(), 100), c).then(function(t) {
							var i = v((g ? Pm(t.facetHits) : t.facetHits).map(function(e) {
								var t = e.escapedValue, n = e.value;
								return q(K({}, J(e, ["escapedValue", "value"])), {
									value: t,
									label: n
								});
							}), { results: s });
							e(q(K({}, n.getWidgetRenderState(q(K({}, r), { results: b }))), {
								items: i,
								canToggleShowMore: !1,
								canRefine: !0,
								isFromSearch: !0,
								instantSearchInstance: o
							}), !1);
						});
					}
				};
			};
		};
		return {
			$$type: "ais.refinementList",
			init: function(t) {
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !0);
			},
			render: function(t) {
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: t.instantSearchInstance }), !1);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { refinementList: q(K({}, e.refinementList), G({}, i, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = this, r = e.results, a = e.state, o = e.createURL, s = e.instantSearchInstance, l = e.helper, d = [], f = [];
				if ((!w || !C || !k) && (w = yh({
					instantSearchInstance: s,
					helper: l,
					attribute: i,
					widgetType: this.$$type
				}), C = function(e) {
					w("click:internal", e), l.toggleFacetRefinement(i, e).search();
				}, k = A(l, this)), r) {
					var p = r.getFacetValues(i, {
						sortBy: m,
						facetOrdering: m === lg
					});
					f = p && Array.isArray(p) ? p : [], d = v(f.slice(0, O()).map(y), { results: r });
					var h = a.maxValuesPerFacet, g = O();
					S = h > g ? f.length <= g : f.length < g, b = r, x = d, e.results && (E = ee(e, this));
				}
				var _ = k && k(e), j = T && x.length > c || u && !S;
				return {
					createURL: function(e) {
						return o(function(n) {
							return t.getWidgetUiState(n, {
								searchParameters: a.resetPage().toggleFacetRefinement(i, e),
								helper: l
							});
						});
					},
					items: d,
					refine: C,
					searchForItems: _,
					isFromSearch: !1,
					canRefine: d.length > 0,
					widgetParams: n,
					isShowingMore: T,
					canToggleShowMore: j,
					toggleShowMore: D,
					sendEvent: w,
					hasExhaustiveItems: S
				};
			},
			dispose: function(e) {
				var n = e.state;
				t();
				var r = n.setQueryParameter("maxValuesPerFacet", void 0);
				return o === "and" ? r.removeFacet(i) : r.removeDisjunctiveFacet(i);
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters, r = o === "or" ? n.getDisjunctiveRefinements(i) : n.getConjunctiveRefinements(i);
				return dg(q(K({}, e), { refinementList: q(K({}, e.refinementList), G({}, i, r)) }), i);
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = o === "or";
				if (e.isHierarchicalFacet(i) || r && e.isConjunctiveFacet(i) || !r && e.isDisjunctiveFacet(i)) return e;
				var a = n.refinementList && n.refinementList[i], s = r ? e.addDisjunctiveFacet(i).removeDisjunctiveFacetRefinement(i) : e.addFacet(i).removeFacetRefinement(i), l = s.maxValuesPerFacet || 0, d = Math.max(l, u ? f : c), p = s.setQueryParameter("maxValuesPerFacet", d);
				if (!a) {
					var m = r ? "disjunctiveFacetsRefinements" : "facetsRefinements";
					return p.setQueryParameters(G({}, m, q(K({}, p[m]), G({}, i, []))));
				}
				return a.reduce(function(e, t) {
					return r ? e.addDisjunctiveFacetRefinement(i, t) : e.addFacetRefinement(i, t);
				}, p);
			}
		};
	};
};
function dg(e, t) {
	return e.refinementList ? ((!e.refinementList[t] || e.refinementList[t].length === 0) && delete e.refinementList[t], Object.keys(e.refinementList).length === 0 && delete e.refinementList, e) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/search-box/connectSearchBox.js
var fg = X({
	name: "search-box",
	connector: !0
}), pg = function(e, t) {
	return t(e);
}, mg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, fg()), function(n) {
		var r = (n || {}).queryHook, i = r === void 0 ? pg : r, a, o;
		return {
			$$type: "ais.searchBox",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.setQueryParameter("query", void 0);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { searchBox: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.helper, r = e.instantSearchInstance, s = e.state;
				return a || (a = function(e) {
					i(e, function(e) {
						return t.setQuery(e).search();
					});
				}, o = function() {
					t.setQuery("").search();
				}), {
					query: s.query || "",
					refine: a,
					clear: o,
					widgetParams: n,
					isSearchStalled: r.status === "stalled"
				};
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters.query || "";
				return n === "" || e && e.query === n ? e : q(K({}, e), { query: n });
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState;
				return e.setQueryParameter("query", n.query || "");
			}
		};
	};
}, hg = X({
	name: "sort-by",
	connector: !0
});
function gg(e) {
	return "strategy" in e && e.strategy !== void 0;
}
function _g(e) {
	return gg(e) ? e.strategy : e.value;
}
function vg(e, t) {
	if (!t) return !1;
	var n = e[t];
	return n !== void 0 && gg(n);
}
var yg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	_m(e, hg());
	var n = {};
	return function(r) {
		var i = r || {}, a = i.items, o = i.transformItems, s = o === void 0 ? function(e) {
			return e;
		} : o;
		if (!Array.isArray(a)) throw Error(hg("The `items` option expects an array of objects."));
		var c = {};
		return a.forEach(function(e, t) {
			var n = "value" in e && e.value !== void 0, r = "strategy" in e && e.strategy !== void 0;
			if (n && r) throw Error(hg(`Item at index ${t} cannot have both "value" and "strategy" properties.`));
			if (!n && !r) throw Error(hg(`Item at index ${t} must have either a "value" or "strategy" property.`));
			var i = _g(e);
			c[i] = e;
		}), n.itemsLookup = c, {
			$$type: "ais.sortBy",
			init: function(t) {
				var n = t.instantSearchInstance;
				if (a.some(function(e) {
					return "strategy" in e && e.strategy;
				}) && !n.compositionID) throw Error(hg("Sorting strategies can only be used in composition mode. Please provide a \"compositionID\" to your InstantSearch instance."));
				var r = this.getWidgetRenderState(t), i = r.currentRefinement;
				rh(a, function(e) {
					return _g(e) === i;
				}), e(q(K({}, r), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var r = e.state;
				return t(), n.isUsingComposition && r.sortBy && (r = r.setQueryParameter("sortBy", void 0)), n.initialValue && r.index !== n.initialValue ? r.setIndex(n.initialValue) : r;
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { sortBy: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, i = e.helper, o = e.state, c = e.parent, l = e.instantSearchInstance;
				!n.initialValue && c && (n.initialValue = c.getIndexName()), n.refine ||= (n.isUsingComposition = !!l?.compositionID, function(e) {
					var t = n.itemsLookup[e];
					t && gg(t) ? i.setQueryParameter("sortBy", t.strategy).search() : i.setQueryParameter("sortBy", void 0).setIndex(e).search();
				});
				var u = s(a, { results: t }).map(function(e) {
					return {
						label: e.label,
						value: _g(e)
					};
				}), d = n.isUsingComposition && vg(n.itemsLookup, o.sortBy) ? o.sortBy : o.index, f = !t || t.nbHits === 0;
				return {
					currentRefinement: d,
					options: u,
					refine: n.refine,
					hasNoResults: f,
					canRefine: !f && a.length > 0,
					widgetParams: r
				};
			},
			getWidgetUiState: function(e, t) {
				var r = t.searchParameters, i = n.isUsingComposition && vg(n.itemsLookup, r.sortBy) ? r.sortBy : r.index;
				return q(K({}, e), { sortBy: i === n.initialValue ? void 0 : i });
			},
			getWidgetSearchParameters: function(e, t) {
				var r = t.uiState, i = (!r.sortBy || Object.prototype.hasOwnProperty.call(n.itemsLookup, r.sortBy) ? r.sortBy : void 0) || n.initialValue || e.index;
				if (vg(n.itemsLookup, i)) {
					var a = n.itemsLookup[i];
					return e.setQueryParameter("sortBy", a.strategy);
				}
				return e.setQueryParameter("index", i);
			}
		};
	};
}, bg = X({
	name: "rating-menu",
	connector: !0
}), xg = "ais.ratingMenu", Sg = 1, Cg = function(e) {
	var t = e.instantSearchInstance, n = e.helper, r = e.getRefinedStar, i = e.attribute;
	return function() {
		var e = [...arguments];
		if (e.length === 1) {
			t.sendEventToInsights(e[0]);
			return;
		}
		var a = U(e, 3), o = a[1], s = a[2], c = s === void 0 ? "Filter Applied" : s, l = U(e[0].split(":"), 2), u = l[0], d = l[1];
		u === "click" && r() !== Number(o) && t.sendEventToInsights({
			insightsMethod: "clickedFilters",
			widgetType: xg,
			eventType: u,
			eventModifier: d,
			payload: {
				eventName: c,
				index: n.lastResults?.index || n.state.index,
				filters: [`${i}>=${o}`]
			},
			attribute: i
		});
	};
}, wg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, bg()), function(n) {
		var r = n || {}, i = r.attribute, a = r.max, o = a === void 0 ? 5 : a, s;
		if (!i) throw Error(bg("The `attribute` option is required."));
		var c = function(e) {
			var t = e.getNumericRefinements(i);
			if (t[">="]?.length) return t[">="][0];
		}, l = function(e) {
			var t = 0;
			return e.forEach(function(e) {
				var n = U(e.name.split("."), 2)[1];
				t = Math.max(t, (n === void 0 ? "" : n).length);
			}), t;
		};
		function u(e, t) {
			var n = c(e) === Number(t), r = e.resetPage().removeNumericRefinement(i);
			return n ? r : r.addNumericRefinement(i, "<=", o).addNumericRefinement(i, ">=", Number(t));
		}
		var d = function(e, t) {
			s("click:internal", t), e.setState(u(e.state, t)).search();
		}, f = {
			toggleRefinementFactory: function(e) {
				return d.bind(null, e);
			},
			createURLFactory: function(e) {
				var t = e.state, n = e.createURL, r = e.getWidgetUiState, i = e.helper;
				return function(e) {
					return n(function(n) {
						return r(n, {
							searchParameters: u(t, e),
							helper: i
						});
					});
				};
			}
		};
		return {
			$$type: xg,
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { ratingMenu: q(K({}, e.ratingMenu), G({}, i, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = e.helper, r = e.results, a = e.state, u = e.instantSearchInstance, d = e.createURL, p = [];
				s ||= Cg({
					instantSearchInstance: u,
					helper: t,
					getRefinedStar: function() {
						return c(t.state);
					},
					attribute: i
				});
				var m = !1, h = 0, g = r?.getFacetValues(i, {});
				if (r && g) {
					var _ = function(e) {
						var t = v === e;
						m ||= t;
						var n = g.filter(function(t) {
							return Number(t.name) >= e && Number(t.name) <= o;
						}).map(function(e) {
							return e.count;
						}).reduce(function(e, t) {
							return e + t;
						}, 0);
						if (h += n, v && !t && n === 0) return "continue";
						var r = W(Array(Math.floor(o / Sg))).map(function(t, n) {
							return n * Sg < e;
						});
						p.push({
							stars: r,
							name: String(e),
							label: String(e),
							value: String(e),
							count: n,
							isRefined: t
						});
					};
					g.length, l(g);
					for (var v = c(a), y = Sg; y < o; y += Sg) _(y);
				}
				p = p.reverse();
				var b = !r || r.nbHits === 0;
				return {
					items: p,
					hasNoResults: b,
					canRefine: (!b || m) && h > 0,
					refine: f.toggleRefinementFactory(t),
					sendEvent: s,
					createURL: f.createURLFactory({
						state: a,
						createURL: d,
						helper: t,
						getWidgetUiState: this.getWidgetUiState
					}),
					widgetParams: n
				};
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeNumericRefinement(i);
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters, r = c(n);
				return Tg(q(K({}, e), { ratingMenu: q(K({}, e.ratingMenu), G({}, i, typeof r == "number" ? r : void 0)) }), i);
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState, r = n.ratingMenu && n.ratingMenu[i], a = e.addDisjunctiveFacet(i).removeNumericRefinement(i).removeDisjunctiveFacetRefinement(i);
				return r ? a.addNumericRefinement(i, "<=", o).addNumericRefinement(i, ">=", r) : a.setQueryParameters({ numericRefinements: q(K({}, a.numericRefinements), G({}, i, {})) });
			}
		};
	};
};
function Tg(e, t) {
	return e.ratingMenu ? (typeof e.ratingMenu[t] != "number" && delete e.ratingMenu[t], Object.keys(e.ratingMenu).length === 0 && delete e.ratingMenu, e) : e;
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/stats/connectStats.js
var Eg = X({
	name: "stats",
	connector: !0
}), Dg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, Eg()), function(n) {
		return {
			$$type: "ais.stats",
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function() {
				t();
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { stats: this.getWidgetRenderState(t) });
			},
			getWidgetRenderState: function(e) {
				var t = e.results, r = e.state;
				return t ? {
					hitsPerPage: t.hitsPerPage,
					nbHits: t.nbHits,
					nbSortedHits: t.nbSortedHits,
					areHitsSorted: t.appliedRelevancyStrictness !== void 0 && t.appliedRelevancyStrictness > 0 && t.nbSortedHits !== t.nbHits,
					nbPages: t.nbPages,
					page: t.page,
					processingTimeMS: t.processingTimeMS,
					query: t.query,
					widgetParams: n
				} : {
					hitsPerPage: r.hitsPerPage,
					nbHits: 0,
					nbSortedHits: void 0,
					areHitsSorted: !1,
					nbPages: 0,
					page: r.page || 0,
					processingTimeMS: -1,
					query: r.query || "",
					widgetParams: n
				};
			}
		};
	};
};
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/toArray.js
function Og(e) {
	return Array.isArray(e) ? e : [e];
}
//#endregion
//#region node_modules/instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement.js
var kg = X({
	name: "toggle-refinement",
	connector: !0
}), Ag = "ais.toggleRefinement", jg = function(e) {
	var t = e.instantSearchInstance, n = e.helper, r = e.attribute, i = e.on;
	return function() {
		var e = [...arguments];
		if (e.length === 1) {
			t.sendEventToInsights(e[0]);
			return;
		}
		var a = U(e, 3), o = a[1], s = a[2], c = s === void 0 ? "Filter Applied" : s, l = U(e[0].split(":"), 2), u = l[0], d = l[1];
		!(u !== "click" || i === void 0) && !o && t.sendEventToInsights({
			insightsMethod: "clickedFilters",
			widgetType: Ag,
			eventType: u,
			eventModifier: d,
			payload: {
				eventName: c,
				index: n.lastResults?.index || n.state.index,
				filters: i.map(function(e) {
					return `${r}:${e}`;
				})
			},
			attribute: r
		});
	};
}, Mg = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Z;
	return _m(e, kg()), function(n) {
		var r = n || {}, i = r.attribute, a = r.on, o = a === void 0 || a, s = r.off;
		if (!i) throw Error(kg("The `attribute` option is required."));
		var c = s !== void 0, l = Og(o).map(nh), u = c ? Og(s).map(nh) : void 0, d, f = function(e) {
			return function() {
				var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { isRefined: !1 }).isRefined;
				t ? (l.forEach(function(t) {
					return e.removeDisjunctiveFacetRefinement(i, t);
				}), c && u.forEach(function(t) {
					return e.addDisjunctiveFacetRefinement(i, t);
				})) : (d("click:internal", t), c && u.forEach(function(t) {
					return e.removeDisjunctiveFacetRefinement(i, t);
				}), l.forEach(function(t) {
					return e.addDisjunctiveFacetRefinement(i, t);
				})), e.search();
			};
		}, p = { createURLFactory: function(e, t) {
			var n = t.state, r = t.createURL, a = t.getWidgetUiState, o = t.helper;
			return function() {
				n = n.resetPage();
				var t = e ? l : u;
				t && t.forEach(function(e) {
					n = n.removeDisjunctiveFacetRefinement(i, e);
				});
				var s = e ? u : l;
				return s && s.forEach(function(e) {
					n = n.addDisjunctiveFacetRefinement(i, e);
				}), r(function(e) {
					return a(e, {
						searchParameters: n,
						helper: o
					});
				});
			};
		} };
		return {
			$$type: Ag,
			init: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !0);
			},
			render: function(t) {
				var n = t.instantSearchInstance;
				e(q(K({}, this.getWidgetRenderState(t)), { instantSearchInstance: n }), !1);
			},
			dispose: function(e) {
				var n = e.state;
				return t(), n.removeDisjunctiveFacet(i);
			},
			getRenderState: function(e, t) {
				return q(K({}, e), { toggleRefinement: q(K({}, e.toggleRefinement), G({}, i, this.getWidgetRenderState(t))) });
			},
			getWidgetRenderState: function(e) {
				var t = e.state, r = e.helper, a = e.results, o = e.createURL, s = e.instantSearchInstance, m = l.every(function(e) {
					return t.isDisjunctiveFacetRefined(i, e);
				}), h = {
					isRefined: m,
					count: 0
				}, g = {
					isRefined: c && !m,
					count: 0
				};
				if (a) {
					var _ = Og(u || !1), v = a.getFacetValues(i, {}) || [], y = l.map(function(e) {
						return rh(v, function(t) {
							return t.escapedValue === nh(String(e));
						});
					}).filter(function(e) {
						return e !== void 0;
					}), b = c ? _.map(function(e) {
						return rh(v, function(t) {
							return t.escapedValue === nh(String(e));
						});
					}).filter(function(e) {
						return e !== void 0;
					}) : [];
					h = {
						isRefined: y.length ? y.every(function(e) {
							return e.isRefined;
						}) : !1,
						count: y.reduce(function(e, t) {
							return e + t.count;
						}, 0) || null
					}, g = {
						isRefined: b.length ? b.every(function(e) {
							return e.isRefined;
						}) : !1,
						count: b.reduce(function(e, t) {
							return e + t.count;
						}, 0) || v.reduce(function(e, t) {
							return e + t.count;
						}, 0)
					};
				}
				d ||= jg({
					instantSearchInstance: s,
					attribute: i,
					on: l,
					helper: r
				});
				var x = m ? g : h;
				return {
					value: {
						name: i,
						isRefined: m,
						count: a ? x.count : null,
						onFacetValue: h,
						offFacetValue: g
					},
					createURL: p.createURLFactory(m, {
						state: t,
						createURL: o,
						helper: r,
						getWidgetUiState: this.getWidgetUiState
					}),
					sendEvent: d,
					canRefine: !!(a && x.count),
					refine: f(r),
					widgetParams: n
				};
			},
			getWidgetUiState: function(e, t) {
				var n = t.searchParameters, r = l && l.every(function(e) {
					return n.isDisjunctiveFacetRefined(i, e);
				});
				if (!r) {
					var a;
					return (a = e.toggle) == null || delete a[i], e;
				}
				return q(K({}, e), { toggle: q(K({}, e.toggle), G({}, i, r)) });
			},
			getWidgetSearchParameters: function(e, t) {
				var n = t.uiState;
				if (e.isHierarchicalFacet(i) || e.isConjunctiveFacet(i)) return e;
				var r = e.addDisjunctiveFacet(i).removeDisjunctiveFacetRefinement(i);
				return n.toggle && n.toggle[i] ? (l && l.forEach(function(e) {
					r = r.addDisjunctiveFacetRefinement(i, e);
				}), r) : c ? (u && u.forEach(function(e) {
					r = r.addDisjunctiveFacetRefinement(i, e);
				}), r) : r.setQueryParameters({ disjunctiveFacetsRefinements: q(K({}, e.disjunctiveFacetsRefinements), G({}, i, [])) });
			}
		};
	};
};
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/safelyRunOnBrowser.js
function Ng(e) {
	var t = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { fallback: function() {} }).fallback;
	return typeof window > "u" ? t() : e({ window });
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/routers/history.js
var Pg = function(e) {
	e && (window.document.title = e);
}, Fg = /*#__PURE__*/ function() {
	function e(t) {
		var n = this, r = t.windowTitle, i = t.writeDelay, a = i === void 0 ? 400 : i, o = t.createURL, s = t.parseURL, c = t.getLocation, l = t.start, u = t.dispose, d = t.push, f = t.cleanUrlOnDispose;
		bd(this, e), G(this, "$$type", "ais.browser"), G(this, "windowTitle", void 0), G(this, "writeDelay", void 0), G(this, "_createURL", void 0), G(this, "parseURL", void 0), G(this, "getLocation", void 0), G(this, "writeTimer", void 0), G(this, "_onPopState", void 0), G(this, "inPopState", !1), G(this, "isDisposed", !1), G(this, "latestAcknowledgedHistory", 0), G(this, "_start", void 0), G(this, "_dispose", void 0), G(this, "_push", void 0), G(this, "_cleanUrlOnDispose", void 0), this.windowTitle = r, this.writeTimer = void 0, this.writeDelay = a, this._createURL = o, this.parseURL = s, this.getLocation = c, this._start = l, this._dispose = u, this._push = d, this._cleanUrlOnDispose = f === void 0 || f, Ng(function(e) {
			var t = e.window;
			Pg(n.windowTitle && n.windowTitle(n.read())), n.latestAcknowledgedHistory = t.history.length;
		});
	}
	return Sd(e, [
		{
			key: "read",
			value: function() {
				return this.parseURL({
					qsModule: vp.default,
					location: this.getLocation()
				});
			}
		},
		{
			key: "write",
			value: function(e) {
				var t = this;
				Ng(function(n) {
					var r = n.window, i = t.createURL(e), a = t.windowTitle && t.windowTitle(e);
					t.writeTimer && clearTimeout(t.writeTimer), t.writeTimer = setTimeout(function() {
						Pg(a), t.shouldWrite(i) && (t._push ? t._push(i) : r.history.pushState(e, a || "", i), t.latestAcknowledgedHistory = r.history.length), t.inPopState = !1, t.writeTimer = void 0;
					}, t.writeDelay);
				});
			}
		},
		{
			key: "onUpdate",
			value: function(e) {
				var t = this;
				this._start && this._start(function() {
					e(t.read());
				}), this._onPopState = function() {
					t.writeTimer &&= (clearTimeout(t.writeTimer), void 0), t.inPopState = !0, e(t.read());
				}, Ng(function(e) {
					e.window.addEventListener("popstate", t._onPopState);
				});
			}
		},
		{
			key: "createURL",
			value: function(e) {
				return this._createURL({
					qsModule: vp.default,
					routeState: e,
					location: this.getLocation()
				});
			}
		},
		{
			key: "dispose",
			value: function() {
				var e = this;
				this._dispose && this._dispose(), this.isDisposed = !0, Ng(function(t) {
					var n = t.window;
					e._onPopState && n.removeEventListener("popstate", e._onPopState);
				}), this.writeTimer && clearTimeout(this.writeTimer), this._cleanUrlOnDispose && this.write({});
			}
		},
		{
			key: "start",
			value: function() {
				this.isDisposed = !1;
			}
		},
		{
			key: "shouldWrite",
			value: function(e) {
				var t = this;
				return Ng(function(n) {
					var r = n.window;
					if (t.isDisposed && !t._cleanUrlOnDispose) return !1;
					var i = !(t.isDisposed && t.latestAcknowledgedHistory !== r.history.length);
					return !t.inPopState && i && e !== r.location.href;
				});
			}
		}
	]), e;
}();
function Ig() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.createURL, n = t === void 0 ? function(e) {
		var t = e.qsModule, n = e.routeState, r = e.location, i = r.protocol, a = r.hostname, o = r.port, s = o === void 0 ? "" : o, c = r.pathname, l = r.hash, u = t.stringify(n), d = s === "" ? "" : `:${s}`;
		return u ? `${i}//${a}${d}${c}?${u}${l}` : `${i}//${a}${d}${c}${l}`;
	} : t, r = e.parseURL, i = r === void 0 ? function(e) {
		var t = e.qsModule, n = e.location;
		return t.parse(n.search.slice(1), { arrayLimit: 99 });
	} : r, a = e.writeDelay, o = a === void 0 ? 400 : a, s = e.windowTitle, c = e.getLocation, l = c === void 0 ? function() {
		return Ng(function(e) {
			return e.window.location;
		}, { fallback: function() {
			throw Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
		} });
	} : c, u = e.start, d = e.dispose, f = e.push, p = e.cleanUrlOnDispose;
	return new Fg({
		createURL: n,
		parseURL: i,
		writeDelay: o,
		windowTitle: s,
		getLocation: l,
		start: u,
		dispose: d,
		push: f,
		cleanUrlOnDispose: p
	});
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/stateMappings/singleIndex.js
function Lg(e) {
	return e.configure, J(e, ["configure"]);
}
function Rg(e) {
	return {
		$$type: "ais.singleIndex",
		stateToRoute: function(t) {
			return Lg(t[e] || {});
		},
		routeToState: function() {
			return G({}, e, Lg(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}));
		}
	};
}
//#endregion
//#region node_modules/instantsearch-ui-components/dist/es/lib/cx.js
function $() {
	return [...arguments].reduce(function(e, t) {
		return Array.isArray(t) ? e.concat(t) : e.concat([t]);
	}, []).filter(Boolean).join(" ");
}
//#endregion
//#region node_modules/instantsearch-ui-components/dist/es/components/Highlight.js
function zg(e) {
	var t = e.createElement;
	return function(e) {
		var n = e.classNames, r = e.children, i = e.highlightedTagName, a = e.isHighlighted, o = e.nonHighlightedTagName;
		return /*#__PURE__*/ t(a ? i : o, { className: a ? n.highlighted : n.nonHighlighted }, r);
	};
}
function Bg(e) {
	var t = e.createElement, n = e.Fragment, r = zg({
		createElement: t,
		Fragment: n
	});
	return function(e) {
		var i = e.parts, a = e.highlightedTagName, o = a === void 0 ? "mark" : a, s = e.nonHighlightedTagName, c = s === void 0 ? "span" : s, l = e.separator, u = l === void 0 ? ", " : l, d = e.className, f = e.classNames, p = f === void 0 ? {} : f;
		return /*#__PURE__*/ t("span", q(K({}, J(e, [
			"parts",
			"highlightedTagName",
			"nonHighlightedTagName",
			"separator",
			"className",
			"classNames"
		])), { className: $(p.root, d) }), i.map(function(e, a) {
			var s = a === i.length - 1;
			return /*#__PURE__*/ t(n, { key: a }, e.map(function(e, n) {
				return /*#__PURE__*/ t(r, {
					key: n,
					classNames: p,
					highlightedTagName: o,
					nonHighlightedTagName: c,
					isHighlighted: e.isHighlighted
				}, e.value);
			}), !s && /*#__PURE__*/ t("span", { className: p.separator }, u));
		}));
	};
}
//#endregion
//#region node_modules/instantsearch-ui-components/dist/es/components/Hits.js
function Vg(e) {
	var t = e.createElement;
	return function(e) {
		var n = e.classNames, r = e.banner;
		return r.image.urls[0].url ? /*#__PURE__*/ t("aside", { className: $("ais-Hits-banner", n.bannerRoot) }, r.link ? /*#__PURE__*/ t("a", {
			className: $("ais-Hits-banner-link", n.bannerLink),
			href: r.link.url,
			target: r.link.target
		}, /*#__PURE__*/ t("img", {
			className: $("ais-Hits-banner-image", n.bannerImage),
			src: r.image.urls[0].url,
			alt: r.image.title
		})) : /*#__PURE__*/ t("img", {
			className: $("ais-Hits-banner-image", n.bannerImage),
			src: r.image.urls[0].url,
			alt: r.image.title
		})) : null;
	};
}
function Hg(e) {
	var t = e.createElement, n = e.Fragment, r = Vg({
		createElement: t,
		Fragment: n
	});
	return function(e) {
		var n = e.classNames, i = n === void 0 ? {} : n, a = e.hits, o = e.itemComponent, s = e.sendEvent, c = e.emptyComponent, l = e.banner, u = e.bannerComponent, d = J(e, [
			"classNames",
			"hits",
			"itemComponent",
			"sendEvent",
			"emptyComponent",
			"banner",
			"bannerComponent"
		]);
		return /*#__PURE__*/ t("div", q(K({}, d), { className: $("ais-Hits", i.root, a.length === 0 && $("ais-Hits--empty", i.emptyRoot), d.className) }), l && (u ? /*#__PURE__*/ t(u, {
			className: $("ais-Hits-banner", i.bannerRoot),
			banner: l
		}) : /*#__PURE__*/ t(r, {
			classNames: i,
			banner: l
		})), a.length === 0 && c ? /*#__PURE__*/ t(c, null) : /*#__PURE__*/ t("ol", { className: $("ais-Hits-list", i.list) }, a.map(function(e, n) {
			return /*#__PURE__*/ t(o, {
				key: e.objectID,
				hit: e,
				index: n,
				className: $("ais-Hits-item", i.item),
				onClick: function() {
					s("click:internal", e, "Hit Clicked");
				},
				onAuxClick: function() {
					s("click:internal", e, "Hit Clicked");
				}
			});
		})));
	};
}
//#endregion
//#region node_modules/hogan.js/lib/compiler.js
var Ug = /* @__PURE__ */ p(((e) => {
	(function(e) {
		var t = /\S/, n = /\"/g, r = /\n/g, i = /\r/g, a = /\\/g, o = /\u2028/, s = /\u2029/;
		e.tags = {
			"#": 1,
			"^": 2,
			"<": 3,
			$: 4,
			"/": 5,
			"!": 6,
			">": 7,
			"=": 8,
			_v: 9,
			"{": 10,
			"&": 11,
			_t: 12
		}, e.scan = function(n, r) {
			var i = n.length, a = 0, o = 1, s = 2, d = a, f = null, p = null, m = "", h = [], g = !1, _ = 0, v = 0, y = "{{", b = "}}";
			function x() {
				m.length > 0 && (h.push({
					tag: "_t",
					text: new String(m)
				}), m = "");
			}
			function S() {
				for (var n = !0, r = v; r < h.length; r++) if (n = e.tags[h[r].tag] < e.tags._v || h[r].tag == "_t" && h[r].text.match(t) === null, !n) return !1;
				return n;
			}
			function C(e, t) {
				if (x(), e && S()) for (var n = v, r; n < h.length; n++) h[n].text && ((r = h[n + 1]) && r.tag == ">" && (r.indent = h[n].text.toString()), h.splice(n, 1));
				else t || h.push({ tag: "\n" });
				g = !1, v = h.length;
			}
			function w(e, t) {
				var n = "=" + b, r = e.indexOf(n, t), i = l(e.substring(e.indexOf("=", t) + 1, r)).split(" ");
				return y = i[0], b = i[i.length - 1], r + n.length - 1;
			}
			for (r && (r = r.split(" "), y = r[0], b = r[1]), _ = 0; _ < i; _++) d == a ? u(y, n, _) ? (--_, x(), d = o) : n.charAt(_) == "\n" ? C(g) : m += n.charAt(_) : d == o ? (_ += y.length - 1, p = e.tags[n.charAt(_ + 1)], f = p ? n.charAt(_ + 1) : "_v", f == "=" ? (_ = w(n, _), d = a) : (p && _++, d = s), g = _) : u(b, n, _) ? (h.push({
				tag: f,
				n: l(m),
				otag: y,
				ctag: b,
				i: f == "/" ? g - y.length : _ + b.length
			}), m = "", _ += b.length - 1, d = a, f == "{" && (b == "}}" ? _++ : c(h[h.length - 1]))) : m += n.charAt(_);
			return C(g, !0), h;
		};
		function c(e) {
			e.n.substr(e.n.length - 1) === "}" && (e.n = e.n.substring(0, e.n.length - 1));
		}
		function l(e) {
			return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, "");
		}
		function u(e, t, n) {
			if (t.charAt(n) != e.charAt(0)) return !1;
			for (var r = 1, i = e.length; r < i; r++) if (t.charAt(n + r) != e.charAt(r)) return !1;
			return !0;
		}
		var d = {
			_t: !0,
			"\n": !0,
			$: !0,
			"/": !0
		};
		function f(t, n, r, i) {
			var a = [], o = null, s = null, c = null;
			for (s = r[r.length - 1]; t.length > 0;) {
				if (c = t.shift(), s && s.tag == "<" && !(c.tag in d)) throw Error("Illegal content in < super tag.");
				if (e.tags[c.tag] <= e.tags.$ || p(c, i)) r.push(c), c.nodes = f(t, c.tag, r, i);
				else if (c.tag == "/") {
					if (r.length === 0) throw Error("Closing tag without opener: /" + c.n);
					if (o = r.pop(), c.n != o.n && !m(c.n, o.n, i)) throw Error("Nesting error: " + o.n + " vs. " + c.n);
					return o.end = c.i, a;
				} else c.tag == "\n" && (c.last = t.length == 0 || t[0].tag == "\n");
				a.push(c);
			}
			if (r.length > 0) throw Error("missing closing tag: " + r.pop().n);
			return a;
		}
		function p(e, t) {
			for (var n = 0, r = t.length; n < r; n++) if (t[n].o == e.n) return e.tag = "#", !0;
		}
		function m(e, t, n) {
			for (var r = 0, i = n.length; r < i; r++) if (n[r].c == e && n[r].o == t) return !0;
		}
		function h(e) {
			var t = [];
			for (var n in e) t.push("\"" + v(n) + "\": function(c,p,t,i) {" + e[n] + "}");
			return "{ " + t.join(",") + " }";
		}
		function g(e) {
			var t = [];
			for (var n in e.partials) t.push("\"" + v(n) + "\":{name:\"" + v(e.partials[n].name) + "\", " + g(e.partials[n]) + "}");
			return "partials: {" + t.join(",") + "}, subs: " + h(e.subs);
		}
		e.stringify = function(t, n, r) {
			return "{code: function (c,p,i) { " + e.wrapMain(t.code) + " }," + g(t) + "}";
		};
		var _ = 0;
		e.generate = function(t, n, r) {
			_ = 0;
			var i = {
				code: "",
				subs: {},
				partials: {}
			};
			return e.walk(t, i), r.asString ? this.stringify(i, n, r) : this.makeTemplate(i, n, r);
		}, e.wrapMain = function(e) {
			return "var t=this;t.b(i=i||\"\");" + e + "return t.fl();";
		}, e.template = e.Template, e.makeTemplate = function(e, t, n) {
			var r = this.makePartials(e);
			return r.code = Function("c", "p", "i", this.wrapMain(e.code)), new this.template(r, t, this, n);
		}, e.makePartials = function(e) {
			var t, n = {
				subs: {},
				partials: e.partials,
				name: e.name
			};
			for (t in n.partials) n.partials[t] = this.makePartials(n.partials[t]);
			for (t in e.subs) n.subs[t] = Function("c", "p", "t", "i", e.subs[t]);
			return n;
		};
		function v(e) {
			return e.replace(a, "\\\\").replace(n, "\\\"").replace(r, "\\n").replace(i, "\\r").replace(o, "\\u2028").replace(s, "\\u2029");
		}
		function y(e) {
			return ~e.indexOf(".") ? "d" : "f";
		}
		function b(e, t) {
			var n = "<" + (t.prefix || "") + e.n + _++;
			return t.partials[n] = {
				name: e.n,
				partials: {}
			}, t.code += "t.b(t.rp(\"" + v(n) + "\",c,p,\"" + (e.indent || "") + "\"));", n;
		}
		e.codegen = {
			"#": function(t, n) {
				n.code += "if(t.s(t." + y(t.n) + "(\"" + v(t.n) + "\",c,p,1),c,p,0," + t.i + "," + t.end + ",\"" + t.otag + " " + t.ctag + "\")){t.rs(c,p,function(c,p,t){", e.walk(t.nodes, n), n.code += "});c.pop();}";
			},
			"^": function(t, n) {
				n.code += "if(!t.s(t." + y(t.n) + "(\"" + v(t.n) + "\",c,p,1),c,p,1,0,0,\"\")){", e.walk(t.nodes, n), n.code += "};";
			},
			">": b,
			"<": function(t, n) {
				var r = {
					partials: {},
					code: "",
					subs: {},
					inPartial: !0
				};
				e.walk(t.nodes, r);
				var i = n.partials[b(t, n)];
				i.subs = r.subs, i.partials = r.partials;
			},
			$: function(t, n) {
				var r = {
					subs: {},
					code: "",
					partials: n.partials,
					prefix: t.n
				};
				e.walk(t.nodes, r), n.subs[t.n] = r.code, n.inPartial || (n.code += "t.sub(\"" + v(t.n) + "\",c,p,i);");
			},
			"\n": function(e, t) {
				t.code += S("\"\\n\"" + (e.last ? "" : " + i"));
			},
			_v: function(e, t) {
				t.code += "t.b(t.v(t." + y(e.n) + "(\"" + v(e.n) + "\",c,p,0)));";
			},
			_t: function(e, t) {
				t.code += S("\"" + v(e.text) + "\"");
			},
			"{": x,
			"&": x
		};
		function x(e, t) {
			t.code += "t.b(t.t(t." + y(e.n) + "(\"" + v(e.n) + "\",c,p,0)));";
		}
		function S(e) {
			return "t.b(" + e + ");";
		}
		e.walk = function(t, n) {
			for (var r, i = 0, a = t.length; i < a; i++) r = e.codegen[t[i].tag], r && r(t[i], n);
			return n;
		}, e.parse = function(e, t, n) {
			return n ||= {}, f(e, "", [], n.sectionTags || []);
		}, e.cache = {}, e.cacheKey = function(e, t) {
			return [
				e,
				!!t.asString,
				!!t.disableLambda,
				t.delimiters,
				!!t.modelGet
			].join("||");
		}, e.compile = function(t, n) {
			n ||= {};
			var r = e.cacheKey(t, n), i = this.cache[r];
			if (i) {
				var a = i.partials;
				for (var o in a) delete a[o].instance;
				return i;
			}
			return i = this.generate(this.parse(this.scan(t, n.delimiters), t, n), t, n), this.cache[r] = i;
		};
	})(e === void 0 ? Hogan : e);
})), Wg = /* @__PURE__ */ p(((e) => {
	(function(e) {
		e.Template = function(e, t, n, r) {
			e ||= {}, this.r = e.code || this.r, this.c = n, this.options = r || {}, this.text = t || "", this.partials = e.partials || {}, this.subs = e.subs || {}, this.buf = "";
		}, e.Template.prototype = {
			r: function(e, t, n) {
				return "";
			},
			v: u,
			t: l,
			render: function(e, t, n) {
				return this.ri([e], t || {}, n);
			},
			ri: function(e, t, n) {
				return this.r(e, t, n);
			},
			ep: function(e, t) {
				var r = this.partials[e], i = t[r.name];
				if (r.instance && r.base == i) return r.instance;
				if (typeof i == "string") {
					if (!this.c) throw Error("No compiler available.");
					i = this.c.compile(i, this.options);
				}
				if (!i) return null;
				if (this.partials[e].base = i, r.subs) {
					for (key in t.stackText ||= {}, r.subs) t.stackText[key] || (t.stackText[key] = this.activeSub !== void 0 && t.stackText[this.activeSub] ? t.stackText[this.activeSub] : this.text);
					i = n(i, r.subs, r.partials, this.stackSubs, this.stackPartials, t.stackText);
				}
				return this.partials[e].instance = i, i;
			},
			rp: function(e, t, n, r) {
				var i = this.ep(e, n);
				return i ? i.ri(t, n, r) : "";
			},
			rs: function(e, t, n) {
				var r = e[e.length - 1];
				if (!d(r)) {
					n(e, t, this);
					return;
				}
				for (var i = 0; i < r.length; i++) e.push(r[i]), n(e, t, this), e.pop();
			},
			s: function(e, t, n, r, i, a, o) {
				var s;
				return d(e) && e.length === 0 ? !1 : (typeof e == "function" && (e = this.ms(e, t, n, r, i, a, o)), s = !!e, !r && s && t && t.push(typeof e == "object" ? e : t[t.length - 1]), s);
			},
			d: function(e, n, r, i) {
				var a, o = e.split("."), s = this.f(o[0], n, r, i), c = this.options.modelGet, l = null;
				if (e === "." && d(n[n.length - 2])) s = n[n.length - 1];
				else for (var u = 1; u < o.length; u++) a = t(o[u], s, c), a === void 0 ? s = "" : (l = s, s = a);
				return i && !s ? !1 : (!i && typeof s == "function" && (n.push(l), s = this.mv(s, n, r), n.pop()), s);
			},
			f: function(e, n, r, i) {
				for (var a = !1, o = null, s = !1, c = this.options.modelGet, l = n.length - 1; l >= 0; l--) if (o = n[l], a = t(e, o, c), a !== void 0) {
					s = !0;
					break;
				}
				return s ? (!i && typeof a == "function" && (a = this.mv(a, n, r)), a) : !i && "";
			},
			ls: function(e, t, n, r, i) {
				var a = this.options.delimiters;
				return this.options.delimiters = i, this.b(this.ct(l(e.call(t, r)), t, n)), this.options.delimiters = a, !1;
			},
			ct: function(e, t, n) {
				if (this.options.disableLambda) throw Error("Lambda features disabled.");
				return this.c.compile(e, this.options).render(t, n);
			},
			b: function(e) {
				this.buf += e;
			},
			fl: function() {
				var e = this.buf;
				return this.buf = "", e;
			},
			ms: function(e, t, n, r, i, a, o) {
				var s, c = t[t.length - 1], l = e.call(c);
				return typeof l == "function" ? r ? !0 : (s = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text, this.ls(l, c, n, s.substring(i, a), o)) : l;
			},
			mv: function(e, t, n) {
				var r = t[t.length - 1], i = e.call(r);
				return typeof i == "function" ? this.ct(l(i.call(r)), r, n) : i;
			},
			sub: function(e, t, n, r) {
				var i = this.subs[e];
				i && (this.activeSub = e, i(t, n, this, r), this.activeSub = !1);
			}
		};
		function t(e, t, n) {
			var r;
			return t && typeof t == "object" && (t[e] === void 0 ? n && t.get && typeof t.get == "function" && (r = t.get(e)) : r = t[e]), r;
		}
		function n(e, t, n, r, i, a) {
			function o() {}
			o.prototype = e;
			function s() {}
			s.prototype = e.subs;
			var c, l = new o();
			for (c in l.subs = new s(), l.subsText = {}, l.buf = "", r ||= {}, l.stackSubs = r, l.subsText = a, t) r[c] || (r[c] = t[c]);
			for (c in r) l.subs[c] = r[c];
			for (c in i ||= {}, l.stackPartials = i, n) i[c] || (i[c] = n[c]);
			for (c in i) l.partials[c] = i[c];
			return l;
		}
		var r = /&/g, i = /</g, a = />/g, o = /\'/g, s = /\"/g, c = /[&<>\"\']/;
		function l(e) {
			return String(e ?? "");
		}
		function u(e) {
			return e = l(e), c.test(e) ? e.replace(r, "&amp;").replace(i, "&lt;").replace(a, "&gt;").replace(o, "&#39;").replace(s, "&quot;") : e;
		}
		var d = Array.isArray || function(e) {
			return Object.prototype.toString.call(e) === "[object Array]";
		};
	})(e === void 0 ? {} : e);
})), Gg = /* @__PURE__ */ p(((e, t) => {
	var n = Ug();
	n.Template = Wg().Template, n.template = n.Template, t.exports = n;
})), Kg = Er.bind(R), qg = Bg({
	createElement: R,
	Fragment: ra
});
//#endregion
//#region node_modules/instantsearch.js/es/components/Highlight/Highlight.js
function Jg(e) {
	var t = e.classNames, n = t === void 0 ? {} : t, r = J(e, ["classNames"]);
	return /*#__PURE__*/ R(qg, K({ classNames: {
		root: $("ais-Highlight", n.root),
		highlighted: $("ais-Highlight-highlighted", n.highlighted),
		nonHighlighted: $("ais-Highlight-nonHighlighted", n.nonHighlighted),
		separator: $("ais-Highlight-separator", n.separator)
	} }, r));
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/getHighlightedParts.js
function Yg(e) {
	var t = Am.highlightPostTag, n = Am.highlightPreTag, r = e.split(n), i = r.shift(), a = i ? [{
		value: i,
		isHighlighted: !1
	}] : [];
	return r.forEach(function(e) {
		var n = e.split(t);
		a.push({
			value: n[0],
			isHighlighted: !0
		}), n[1] !== "" && a.push({
			value: n[1],
			isHighlighted: !1
		});
	}), a;
}
//#endregion
//#region node_modules/instantsearch.js/es/helpers/components/Highlight.js
function Xg(e) {
	var t = e.hit, n = e.attribute, r = e.cssClasses, i = J(e, [
		"hit",
		"attribute",
		"cssClasses"
	]), a = Og(eh(t._highlightResult, n) || []).map(function(e) {
		var t = e.value;
		return Yg(Tm(t || ""));
	});
	return /*#__PURE__*/ R(Jg, q(K({}, i), {
		parts: a,
		classNames: r
	}));
}
//#endregion
//#region node_modules/instantsearch.js/es/components/ReverseHighlight/ReverseHighlight.js
function Zg(e) {
	var t = e.classNames, n = t === void 0 ? {} : t, r = J(e, ["classNames"]);
	return /*#__PURE__*/ R(qg, K({ classNames: {
		root: $("ais-ReverseHighlight", n.root),
		highlighted: $("ais-ReverseHighlight-highlighted", n.highlighted),
		nonHighlighted: $("ais-ReverseHighlight-nonHighlighted", n.nonHighlighted),
		separator: $("ais-ReverseHighlight-separator", n.separator)
	} }, r));
}
//#endregion
//#region node_modules/instantsearch.js/es/helpers/components/ReverseHighlight.js
function Qg(e) {
	var t = e.hit, n = e.attribute, r = e.cssClasses, i = J(e, [
		"hit",
		"attribute",
		"cssClasses"
	]), a = Og(eh(t._highlightResult, n) || []).map(function(e) {
		var t = e.value;
		return Yg(Tm(t || "")).map(function(e) {
			var t = e.isHighlighted;
			return q(K({}, J(e, ["isHighlighted"])), { isHighlighted: !t });
		});
	});
	return /*#__PURE__*/ R(Zg, q(K({}, i), {
		parts: a,
		classNames: r
	}));
}
//#endregion
//#region node_modules/instantsearch.js/es/components/Snippet/Snippet.js
function $g(e) {
	var t = e.classNames, n = t === void 0 ? {} : t, r = J(e, ["classNames"]);
	return /*#__PURE__*/ R(qg, K({ classNames: {
		root: $("ais-Snippet", n.root),
		highlighted: $("ais-Snippet-highlighted", n.highlighted),
		nonHighlighted: $("ais-Snippet-nonHighlighted", n.nonHighlighted),
		separator: $("ais-Snippet-separator", n.separator)
	} }, r));
}
//#endregion
//#region node_modules/instantsearch.js/es/helpers/components/Snippet.js
function e_(e) {
	var t = e.hit, n = e.attribute, r = e.cssClasses, i = J(e, [
		"hit",
		"attribute",
		"cssClasses"
	]), a = Og(eh(t._snippetResult, n) || []).map(function(e) {
		var t = e.value;
		return Yg(Tm(t || ""));
	});
	return /*#__PURE__*/ R($g, q(K({}, i), {
		parts: a,
		classNames: r
	}));
}
//#endregion
//#region node_modules/instantsearch.js/es/components/ReverseSnippet/ReverseSnippet.js
function t_(e) {
	var t = e.classNames, n = t === void 0 ? {} : t, r = J(e, ["classNames"]);
	return /*#__PURE__*/ R(qg, K({ classNames: {
		root: $("ais-ReverseSnippet", n.root),
		highlighted: $("ais-ReverseSnippet-highlighted", n.highlighted),
		nonHighlighted: $("ais-ReverseSnippet-nonHighlighted", n.nonHighlighted),
		separator: $("ais-ReverseSnippet-separator", n.separator)
	} }, r));
}
//#endregion
//#region node_modules/instantsearch.js/es/helpers/components/ReverseSnippet.js
function n_(e) {
	var t = e.hit, n = e.attribute, r = e.cssClasses, i = J(e, [
		"hit",
		"attribute",
		"cssClasses"
	]), a = Og(eh(t._snippetResult, n) || []).map(function(e) {
		var t = e.value;
		return Yg(Tm(t || "")).map(function(e) {
			var t = e.isHighlighted;
			return q(K({}, J(e, ["isHighlighted"])), { isHighlighted: !t });
		});
	});
	return /*#__PURE__*/ R(t_, q(K({}, i), {
		parts: a,
		classNames: r
	}));
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/templating/renderTemplate.js
var r_ = /* @__PURE__ */ g(Gg());
function i_() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 ? arguments[2] : void 0;
	return Object.keys(e).reduce(function(r, i) {
		return q(K({}, r), G({}, i, function() {
			var r = this;
			return function(a) {
				return e[i].call(n, a, function(e) {
					return r_.default.compile(e, t).render(r);
				});
			};
		}));
	}, {});
}
function a_(e) {
	var t = e.templates, n = e.templateKey, r = e.compileOptions, i = e.helpers, a = e.data, o = e.bindEvent, s = e.sendEvent, c = t[n];
	if (typeof c != "string" && typeof c != "function") throw Error(`Template must be 'string' or 'function', was '${c === void 0 ? "undefined" : ku(c)}' (key: ${n})`);
	if (typeof c == "function") {
		var l = o || {};
		return l.html = Kg, l.sendEvent = s, l.components = {
			Highlight: Xg,
			ReverseHighlight: Qg,
			Snippet: e_,
			ReverseSnippet: n_
		}, c(a, l);
	}
	var u = i_(i, r, a);
	return r_.default.compile(c, r).render(q(K({}, a), { helpers: u })).replace(/[ \n\r\t\f\xA0]+/g, function(e) {
		return e.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
	}).trim();
}
//#endregion
//#region node_modules/instantsearch.js/es/components/Template/Template.js
var o_ = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t() {
		bd(this, t);
		var e = yd(this, t, arguments);
		return G(e, "ref", na()), G(e, "nodes", []), e;
	}
	return Sd(t, [
		{
			key: "componentDidMount",
			value: function() {
				var e = new DocumentFragment(), t = document.createElement("div");
				t.innerHTML = this.props.content, this.nodes = W(t.childNodes), this.nodes.forEach(function(t) {
					return e.appendChild(t);
				}), this.ref.current.replaceWith(e);
			}
		},
		{
			key: "componentWillUnmount",
			value: function() {
				this.nodes.forEach(function(e) {
					if (Nu(e, Element)) {
						e.outerHTML = "";
						return;
					}
					e.nodeValue = "";
				}), this.nodes[0] && this.nodes[0].nodeValue && (this.nodes[0].nodeValue = "");
			}
		},
		{
			key: "render",
			value: function() {
				return /*#__PURE__*/ R("div", { ref: this.ref });
			}
		}
	]), t;
}(ia), s_ = {
	data: {},
	rootTagName: "div",
	useCustomCompileOptions: {},
	templates: {},
	templatesConfig: {}
}, c_ = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t() {
		return bd(this, t), yd(this, t, arguments);
	}
	return Sd(t, [{
		key: "shouldComponentUpdate",
		value: function(e) {
			return !Vh(this.props.data, e.data) || this.props.templateKey !== e.templateKey || !Vh(this.props.rootProps, e.rootProps);
		}
	}, {
		key: "render",
		value: function() {
			var e = this.props.rootTagName === "fragment" ? ra : this.props.rootTagName, t = this.props.useCustomCompileOptions[this.props.templateKey] ? this.props.templatesConfig.compileOptions : {}, n = a_({
				templates: this.props.templates,
				templateKey: this.props.templateKey,
				compileOptions: t,
				helpers: this.props.templatesConfig.helpers,
				data: this.props.data,
				bindEvent: this.props.bindEvent,
				sendEvent: this.props.sendEvent
			});
			return n === null ? null : (n === void 0 ? "undefined" : ku(n)) === "object" ? /*#__PURE__*/ R(e, this.props.rootProps, n) : e === ra ? /*#__PURE__*/ R(o_, {
				content: n,
				key: Math.random()
			}) : /*#__PURE__*/ R(e, q(K({}, this.props.rootProps), { dangerouslySetInnerHTML: { __html: n } }));
		}
	}]), t;
}(ia);
G(c_, "defaultProps", s_);
//#endregion
//#region node_modules/instantsearch.js/es/lib/suit.js
var l_ = "ais", u_ = function(e) {
	return function() {
		var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.descendantName, r = t.modifierName;
		return `${l_}-${e}${n ? `-${n}` : ""}${r ? `--${r}` : ""}`;
	};
};
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isDomElement.js
function d_(e) {
	return Nu(e, HTMLElement) || !!e && e.nodeType > 0;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/getContainerNode.js
function f_(e) {
	var t = typeof e == "string", n = t ? document.querySelector(e) : e;
	if (!d_(n)) {
		var r = "Container must be `string` or `HTMLElement`.";
		throw t && (r += ` Unable to find ${e}`), Error(r);
	}
	return n;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/templating/prepareTemplateProps.js
function p_(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	return Rm(W(Object.keys(e || {})).concat(W(Object.keys(t)))).reduce(function(n, r) {
		var i = e ? e[r] : void 0, a = t[r], o = a !== void 0 && a !== i;
		return n.templates[r] = o ? a : i, n.useCustomCompileOptions[r] = o, n;
	}, {
		templates: {},
		useCustomCompileOptions: {}
	});
}
function m_(e) {
	var t = e.defaultTemplates, n = e.templates, r = e.templatesConfig, i = p_(t, n);
	return K({ templatesConfig: r }, i);
}
//#endregion
//#region node_modules/preact/hooks/dist/hooks.module.js
var h_, g_, __, v_, y_ = 0, b_ = [], x_ = L, S_ = x_.__b, C_ = x_.__r, w_ = x_.diffed, T_ = x_.__c, E_ = x_.unmount, D_ = x_.__;
function O_(e, t) {
	x_.__h && x_.__h(g_, e, y_ || t), y_ = 0;
	var n = g_.__H ||= {
		__: [],
		__h: []
	};
	return e >= n.__.length && n.__.push({}), n.__[e];
}
function k_(e) {
	return y_ = 1, A_(B_, e);
}
function A_(e, t, n) {
	var r = O_(h_++, 2);
	if (r.t = e, !r.__c && (r.__ = [n ? n(t) : B_(void 0, t), function(e) {
		var t = r.__N ? r.__N[0] : r.__[0], n = r.t(t, e);
		t !== n && (r.__N = [n, r.__[1]], r.__c.setState({}));
	}], r.__c = g_, !g_.__f)) {
		var i = function(e, t, n) {
			if (!r.__c.__H) return !0;
			var i = !1, o = r.__c.props !== e;
			if (r.__c.__H.__.some(function(e) {
				if (e.__N) {
					i = !0;
					var t = e.__[0];
					e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0);
				}
			}), a) {
				var s = a.call(this, e, t, n);
				return i ? s || o : s;
			}
			return !i || o;
		};
		g_.__f = !0;
		var a = g_.shouldComponentUpdate, o = g_.componentWillUpdate;
		g_.componentWillUpdate = function(e, t, n) {
			if (this.__e) {
				var r = a;
				a = void 0, i(e, t, n), a = r;
			}
			o && o.call(this, e, t, n);
		}, g_.shouldComponentUpdate = i;
	}
	return r.__N || r.__;
}
function j_(e, t) {
	var n = O_(h_++, 3);
	!x_.__s && z_(n.__H, t) && (n.__ = e, n.u = t, g_.__H.__h.push(n));
}
function M_(e) {
	return y_ = 5, N_(function() {
		return { current: e };
	}, []);
}
function N_(e, t) {
	var n = O_(h_++, 7);
	return z_(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
}
function P_() {
	for (var e; e = b_.shift();) {
		var t = e.__H;
		if (e.__P && t) try {
			t.__h.some(L_), t.__h.some(R_), t.__h = [];
		} catch (n) {
			t.__h = [], x_.__e(n, e.__v);
		}
	}
}
x_.__b = function(e) {
	g_ = null, S_ && S_(e);
}, x_.__ = function(e, t) {
	e && t.__k && t.__k.__m && (e.__m = t.__k.__m), D_ && D_(e, t);
}, x_.__r = function(e) {
	C_ && C_(e), h_ = 0;
	var t = (g_ = e.__c).__H;
	t && (__ === g_ ? (t.__h = [], g_.__h = [], t.__.some(function(e) {
		e.__N && (e.__ = e.__N), e.u = e.__N = void 0;
	})) : (t.__h.some(L_), t.__h.some(R_), t.__h = [], h_ = 0)), __ = g_;
}, x_.diffed = function(e) {
	w_ && w_(e);
	var t = e.__c;
	t && t.__H && (t.__H.__h.length && (b_.push(t) !== 1 && v_ === x_.requestAnimationFrame || ((v_ = x_.requestAnimationFrame) || I_)(P_)), t.__H.__.some(function(e) {
		e.u &&= (e.__H = e.u, void 0);
	})), __ = g_ = null;
}, x_.__c = function(e, t) {
	t.some(function(e) {
		try {
			e.__h.some(L_), e.__h = e.__h.filter(function(e) {
				return !e.__ || R_(e);
			});
		} catch (n) {
			t.some(function(e) {
				e.__h &&= [];
			}), t = [], x_.__e(n, e.__v);
		}
	}), T_ && T_(e, t);
}, x_.unmount = function(e) {
	E_ && E_(e);
	var t, n = e.__c;
	n && n.__H && (n.__H.__.some(function(e) {
		try {
			L_(e);
		} catch (e) {
			t = e;
		}
	}), n.__H = void 0, t && x_.__e(t, n.__v));
};
var F_ = typeof requestAnimationFrame == "function";
function I_(e) {
	var t, n = function() {
		clearTimeout(r), F_ && cancelAnimationFrame(t), setTimeout(e);
	}, r = setTimeout(n, 35);
	F_ && (t = requestAnimationFrame(n));
}
function L_(e) {
	var t = g_, n = e.__c;
	typeof n == "function" && (e.__c = void 0, n()), g_ = t;
}
function R_(e) {
	var t = g_;
	e.__c = e.__(), g_ = t;
}
function z_(e, t) {
	return !e || e.length !== t.length || t.some(function(t, n) {
		return t !== e[n];
	});
}
function B_(e, t) {
	return typeof t == "function" ? t(e) : t;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/render-args.js
function V_(e, t, n) {
	var r = t.getHelper();
	return {
		uiState: n,
		helper: r,
		parent: t,
		instantSearchInstance: e,
		state: r.state,
		renderState: e.renderState,
		templatesConfig: e.templatesConfig,
		createURL: t.createURL,
		scopedResults: [],
		searchMetadata: { isSearchStalled: e.status === "stalled" },
		status: e.status,
		error: e.error
	};
}
function H_(e, t, n) {
	var r = t.getResultsForWidget(n), i = t.getHelper();
	return {
		helper: i,
		parent: t,
		instantSearchInstance: e,
		results: r,
		scopedResults: t.getScopedResults(),
		state: r && "_state" in r ? r._state : i.state,
		renderState: e.renderState,
		templatesConfig: e.templatesConfig,
		createURL: t.createURL,
		searchMetadata: { isSearchStalled: e.status === "stalled" },
		status: e.status,
		error: e.error
	};
}
function U_(e) {
	var t = e.renderState, n = e.instantSearchInstance, r = e.parent, i = r ? r.getIndexId() : n.mainIndex.getIndexId();
	n.renderState = q(K({}, n.renderState), G({}, i, K({}, n.renderState[i], t)));
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/configure/configure.js
var W_ = function(e) {
	return q(K({}, $m(Z)({ searchParameters: e })), { $$widgetType: "ais.configure" });
}, G_ = 0;
function K_(e) {
	e.dependsOn === "recommend" && (e.$$id = G_++);
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/defer.js
var q_ = Promise.resolve();
function J_(e) {
	var t = null, n = !1, r = function() {
		var r = [...arguments];
		t === null && (t = q_.then(function() {
			if (t = null, n) {
				n = !1;
				return;
			}
			e.apply(void 0, W(r));
		}));
	};
	return r.wait = function() {
		if (t === null) throw Error("The deferred function should be called before calling `wait()`");
		return t;
	}, r.cancel = function() {
		t !== null && (n = !0);
	}, r;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/resolveSearchParameters.js
function Y_(e) {
	for (var t = e.getParent(), n = [e.getHelper().state]; t !== null;) n = [t.getHelper().state].concat(n), t = t.getParent();
	return n;
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/index/index.js
var X_ = X({ name: "index-widget" });
function Z_(e, t) {
	var n = t.state, r = t.recommendState, i = t.isPageReset, a = t._uiState;
	n !== e.state && (e.state = n, e.emit("change", {
		state: e.state,
		results: e.lastResults,
		isPageReset: i,
		_uiState: a
	})), r !== e.recommendState && (e.recommendState = r);
}
function Q_(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	return e.reduce(function(e, n) {
		return zh(n) || !n.getWidgetUiState && !n.getWidgetState ? e : n.getWidgetUiState ? n.getWidgetUiState(e, t) : n.getWidgetState(e, t);
	}, n);
}
function $_(e, t) {
	var n = t.initialSearchParameters, r = J(t, ["initialSearchParameters"]);
	return e.reduce(function(e, t) {
		return !t.getWidgetSearchParameters || zh(t) ? e : t.dependsOn === "search" && t.getWidgetParameters ? t.getWidgetParameters(e, r) : t.getWidgetSearchParameters(e, r);
	}, n);
}
function ev(e, t) {
	var n = t.initialRecommendParameters, r = J(t, ["initialRecommendParameters"]);
	return e.reduce(function(e, t) {
		return !zh(t) && t.dependsOn === "recommend" && t.getWidgetParameters ? t.getWidgetParameters(e, r) : e;
	}, n);
}
function tv(e) {
	var t = e.filter(zh);
	t.length !== 0 && t.forEach(function(e) {
		var t = e.getHelper();
		Z_(t, {
			state: t.state.resetPage(),
			recommendState: t.recommendState,
			isPageReset: !0
		}), tv(e.getWidgets());
	});
}
function nv(e) {
	return e.filter(zh).reduce(function(e, t) {
		var n;
		return (n = e).concat.apply(n, [{
			indexId: t.getIndexId(),
			results: t.getResults(),
			helper: t.getHelper()
		}].concat(W(nv(t.getWidgets()))));
	}, []);
}
function rv(e) {
	return e.reduce(function(e, t) {
		if (zh(t)) {
			if (t._isolated) return e;
			var n = rv(t.getWidgets());
			return {
				hasSearchWidget: e.hasSearchWidget || n.hasSearchWidget,
				hasRecommendWidget: e.hasRecommendWidget || n.hasRecommendWidget
			};
		}
		return t.dependsOn === "recommend" ? q(K({}, e), { hasRecommendWidget: !0 }) : t.dependsOn === "none" ? e : q(K({}, e), { hasSearchWidget: !0 });
	}, {
		hasSearchWidget: !1,
		hasRecommendWidget: !1
	});
}
function iv(e) {
	var t = rv(e.mainIndex.getWidgets()), n = t.hasSearchWidget, r = t.hasRecommendWidget;
	e._hasSearchWidget = n, e._hasRecommendWidget = r;
}
var av = function(e) {
	if (e === void 0 || e.indexName === void 0 && !e.EXPERIMENTAL_isolated) throw Error(X_("The `indexName` option is required."));
	var t = e.indexName, n = t === void 0 ? "" : t, r = e.indexId, i = r === void 0 ? n : r, a = e.EXPERIMENTAL_isolated, o = a !== void 0 && a, s = [], c = {}, l = null, u = null, d = null, f = null, p = null, m = function() {
		l && iv(l);
	};
	return {
		$$type: "ais.index",
		$$widgetType: "ais.index",
		_isolated: o,
		getIndexName: function() {
			return n;
		},
		getIndexId: function() {
			return i;
		},
		getHelper: function() {
			return d;
		},
		getResults: function() {
			return f?.lastResults ? (f.lastResults._state = d.state, f.lastResults) : null;
		},
		getResultsForWidget: function(e) {
			return e.dependsOn !== "recommend" || zh(e) || e.$$id === void 0 ? this.getResults() : d?.lastRecommendResults ? d.lastRecommendResults[e.$$id] : null;
		},
		getPreviousState: function() {
			return p;
		},
		getScopedResults: function() {
			var e = this.getParent();
			return nv(e ? e.getWidgets() : n.length === 0 ? this.getWidgets() : [this]);
		},
		getParent: function() {
			return o ? null : u;
		},
		createURL: function(e) {
			return typeof e == "function" ? l._createURL(G({}, i, e(c))) : l._createURL(G({}, i, Q_(s, {
				searchParameters: e,
				helper: d
			})));
		},
		scheduleLocalSearch: J_(function() {
			o && d?.search();
		}),
		getWidgets: function() {
			return s;
		},
		addWidgets: function(e) {
			var t = this;
			if (!Array.isArray(e)) throw Error(X_("The `addWidgets` method expects an array of widgets."));
			var n = e.reduce(function(e, t) {
				return e.concat(Array.isArray(t) ? t : [t]);
			}, []);
			if (n.some(function(e) {
				return typeof e.init != "function" && typeof e.render != "function";
			})) throw Error(X_("The widget definition expects a `render` and/or an `init` method."));
			return n.forEach(function(e) {
				e.parent = t, zh(e) || K_(e);
			}), s = s.concat(n), m(), l && n.length && (Z_(d, {
				state: $_(s, {
					uiState: c,
					initialSearchParameters: d.state
				}),
				recommendState: ev(s, {
					uiState: c,
					initialRecommendParameters: d.recommendState
				}),
				_uiState: c
			}), n.forEach(function(e) {
				e.getRenderState && U_({
					renderState: e.getRenderState(l.renderState[t.getIndexId()] || {}, V_(l, t, l._initialUiState)),
					instantSearchInstance: l,
					parent: t
				});
			}), n.forEach(function(e) {
				e.init && e.init(V_(l, t, l._initialUiState));
			}), o ? this.scheduleLocalSearch() : l.scheduleSearch()), this;
		},
		removeWidgets: function(e) {
			var t = this;
			if (!Array.isArray(e)) throw Error(X_("The `removeWidgets` method expects an array of widgets."));
			var n = e.reduce(function(e, t) {
				return e.concat(Array.isArray(t) ? t : [t]);
			}, []);
			if (n.some(function(e) {
				return typeof e.dispose != "function";
			})) throw Error(X_("The widget definition expects a `dispose` method."));
			if (s = s.filter(function(e) {
				return n.indexOf(e) === -1;
			}), n.forEach(function(e) {
				e.parent = void 0;
			}), m(), l && n.length) {
				var r = n.reduce(function(e, n) {
					var r = n.dispose({
						helper: d,
						state: e.cleanedSearchState,
						recommendState: e.cleanedRecommendState,
						parent: t
					});
					return Nu(r, Y.default.RecommendParameters) ? e.cleanedRecommendState = r : r && (e.cleanedSearchState = r), e;
				}, {
					cleanedSearchState: d.state,
					cleanedRecommendState: d.recommendState
				}), i = r.cleanedSearchState, a = r.cleanedRecommendState, u = l.future.preserveSharedStateOnUnmount ? $_(s, {
					uiState: c,
					initialSearchParameters: new Y.default.SearchParameters({ index: this.getIndexName() })
				}) : $_(s, {
					uiState: Q_(s, {
						searchParameters: i,
						helper: d
					}),
					initialSearchParameters: i
				});
				c = Q_(s, {
					searchParameters: u,
					helper: d
				}), d.setState(u), d.recommendState = a, s.length && (o ? this.scheduleLocalSearch() : l.scheduleSearch());
			}
			return this;
		},
		init: function(e) {
			var t = this, r = e.instantSearchInstance, a = e.parent, h = e.uiState;
			if (d === null) {
				l = r, u = a, c = h[i] || {};
				var g = r.mainHelper, _ = $_(s, {
					uiState: c,
					initialSearchParameters: new Y.default.SearchParameters({ index: n })
				}), v = ev(s, {
					uiState: c,
					initialRecommendParameters: new Y.default.RecommendParameters()
				});
				d = (0, Y.default)(g.getClient(), _.index, _), d.recommendState = v, d.search = function() {
					return o ? (r.status = "loading", t.render({ instantSearchInstance: r }), r.compositionID ? d.searchWithComposition() : d.searchOnlyWithDerivedHelpers()) : r.onStateChange ? (r.onStateChange({
						uiState: r.mainIndex.getWidgetUiState({}),
						setUiState: function(e) {
							return r.setUiState(e, !1);
						}
					}), g) : g.search();
				}, d.searchWithoutTriggeringOnStateChange = function() {
					return g.search();
				}, d.searchForFacetValues = function(e, n, r, i) {
					var a = Xm.apply(void 0, [g.state].concat(W(Y_(t)))).setQueryParameters(i);
					return g.searchForFacetValues(e, n, r, a);
				};
				var y = n ? d : (0, Y.default)({}, "__empty_index__", {});
				f = (o ? y : ov(a, g)).derive(function() {
					return Xm.apply(void 0, [g.state].concat(W(Y_(t))));
				}, function() {
					return t.getHelper().recommendState;
				});
				var b = r._initialResults?.[this.getIndexId()];
				if (b?.results) {
					var x = new Y.default.SearchResults(new Y.default.SearchParameters(b.state), b.results);
					f.lastResults = x, d.lastResults = x;
				}
				if (b?.recommendResults) {
					var S = new Y.default.RecommendResults(new Y.default.RecommendParameters({ params: b.recommendResults.params }), b.recommendResults.results);
					f.lastRecommendResults = S, d.lastRecommendResults = S;
				}
				d.on("change", function(e) {
					e.isPageReset && tv(s);
				}), f.on("search", function() {
					r.scheduleStalledRender();
				}), f.on("result", function(e) {
					var t = e.results;
					r.scheduleRender(), d.lastResults = t, p = t?._state;
				}), f.on("recommend:result", function(e) {
					var t = e.recommend;
					r.scheduleRender(), d.lastRecommendResults = t.results;
				}), s.forEach(function(e) {
					e.getRenderState && U_({
						renderState: e.getRenderState(r.renderState[t.getIndexId()] || {}, V_(r, t, h)),
						instantSearchInstance: r,
						parent: t
					});
				}), s.forEach(function(e) {
					e.init && e.init(V_(r, t, h));
				}), d.on("change", function(e) {
					var t = e.state, n = e._uiState;
					c = Q_(s, {
						searchParameters: t,
						helper: d
					}, n || {}), r.onStateChange || r.onInternalStateChange();
				}), b && r.scheduleRender(), m();
			}
		},
		render: function(e) {
			var t = this, r = e.instantSearchInstance;
			r.status === "error" && !r.mainHelper.hasPendingRequests() && p && d.setState(p);
			var i = this.getResults() || f?.lastRecommendResults || o && !n ? s : s.filter(function(e) {
				return e.shouldRender;
			});
			i = i.filter(function(e) {
				return !e.shouldRender || e.shouldRender({ instantSearchInstance: r });
			}), i.forEach(function(e) {
				e.getRenderState && U_({
					renderState: e.getRenderState(r.renderState[t.getIndexId()] || {}, H_(r, t, e)),
					instantSearchInstance: r,
					parent: t
				});
			}), i.forEach(function(e) {
				e.render && e.render(H_(r, t, e));
			});
		},
		dispose: function() {
			var e = this;
			s.forEach(function(t) {
				t.dispose && d && t.dispose({
					helper: d,
					state: d.state,
					recommendState: d.recommendState,
					parent: e
				});
			}), l = null, u = null, d?.removeAllListeners(), d = null, f?.detach(), f = null;
		},
		getWidgetUiState: function(e) {
			return s.filter(zh).filter(function(e) {
				return !e._isolated;
			}).reduce(function(e, t) {
				return t.getWidgetUiState(e);
			}, q(K({}, e), G({}, i, K({}, e[i], c))));
		},
		getWidgetState: function(e) {
			return this.getWidgetUiState(e);
		},
		getWidgetSearchParameters: function(e, t) {
			var n = t.uiState;
			return $_(s, {
				uiState: n,
				initialSearchParameters: e
			});
		},
		shouldRender: function() {
			return !0;
		},
		refreshUiState: function() {
			c = Q_(s, {
				searchParameters: this.getHelper().state,
				helper: this.getHelper()
			}, c);
		},
		setIndexUiState: function(e) {
			var t = typeof e == "function" ? e(c) : e;
			l.setUiState(function(e) {
				return q(K({}, e), G({}, i, t));
			});
		}
	};
};
function ov(e, t) {
	for (; e;) {
		if (e._isolated) return e.getHelper();
		e = e.getParent();
	}
	return t;
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/isSpecialClick.js
function sv(e) {
	return e.button === 1 || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
}
//#endregion
//#region node_modules/instantsearch.js/es/components/ClearRefinements/ClearRefinements.js
var cv = function(e) {
	var t = e.hasRefinements, n = e.refine, r = e.cssClasses, i = e.templateProps;
	return /*#__PURE__*/ R("div", { className: r.root }, /*#__PURE__*/ R(c_, q(K({}, i), {
		templateKey: "resetLabel",
		rootTagName: "button",
		rootProps: {
			className: $(r.button, !t && r.disabledButton),
			onClick: n,
			disabled: !t
		},
		data: { hasRefinements: t }
	})));
}, lv = { resetLabel: function() {
	return "Clear refinements";
} }, uv = X({ name: "clear-refinements" }), dv = u_("ClearRefinements"), fv = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.renderState, i = e.templates;
	return function(e, a) {
		var o = e.refine, s = e.canRefine, c = e.instantSearchInstance;
		if (a) {
			r.templateProps = m_({
				defaultTemplates: lv,
				templatesConfig: c.templatesConfig,
				templates: i
			});
			return;
		}
		z(/*#__PURE__*/ R(cv, {
			refine: o,
			cssClasses: n,
			hasRefinements: s,
			templateProps: r.templateProps
		}), t);
	};
}, pv = function(e) {
	var t = e || {}, n = t.container, r = t.templates, i = r === void 0 ? {} : r, a = t.includedAttributes, o = t.excludedAttributes, s = t.transformItems, c = t.cssClasses, l = c === void 0 ? {} : c;
	if (!n) throw Error(uv("The `container` option is required."));
	var u = f_(n);
	return q(K({}, ch(fv({
		containerNode: u,
		cssClasses: {
			root: $(dv(), l.root),
			button: $(dv({ descendantName: "button" }), l.button),
			disabledButton: $(dv({
				descendantName: "button",
				modifierName: "disabled"
			}), l.disabledButton)
		},
		renderState: {},
		templates: i
	}), function() {
		return z(null, u);
	})({
		includedAttributes: a,
		excludedAttributes: o,
		transformItems: s
	})), { $$widgetType: "ais.clearRefinements" });
};
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/capitalize.js
function mv(e) {
	return e.toString().charAt(0).toUpperCase() + e.toString().slice(1);
}
//#endregion
//#region node_modules/instantsearch.js/es/components/CurrentRefinements/CurrentRefinements.js
var hv = function(e) {
	var t = e.attribute, n = e.value;
	return [
		t,
		e.type,
		n,
		e.operator
	].map(function(e) {
		return e;
	}).filter(Boolean).join(":");
}, gv = function(e) {
	return function(t) {
		sv(t) || (t.preventDefault(), e());
	};
}, _v = function(e) {
	var t = e.items, n = e.cssClasses, r = e.canRefine;
	return /*#__PURE__*/ R("div", { className: $(n.root, !r && n.noRefinementRoot) }, /*#__PURE__*/ R("ul", { className: n.list }, t.map(function(e, t) {
		return /*#__PURE__*/ R("li", {
			key: `${e.indexName}-${e.attribute}-${t}`,
			className: n.item
		}, /*#__PURE__*/ R("span", { className: n.label }, mv(e.label), ": "), e.refinements.map(function(t) {
			return /*#__PURE__*/ R("span", {
				key: hv(t),
				className: n.category
			}, /*#__PURE__*/ R("span", { className: n.categoryLabel }, t.attribute === "query" ? /*#__PURE__*/ R("q", null, t.label) : t.label), /*#__PURE__*/ R("button", {
				className: n.delete,
				type: "button",
				onClick: gv(e.refine.bind(null, t))
			}, "✕"));
		}));
	})));
}, vv = X({ name: "current-refinements" }), yv = u_("CurrentRefinements"), bv = function(e, t) {
	var n = e.items, r = e.widgetParams, i = e.canRefine;
	if (!t) {
		var a = r.container, o = r.cssClasses;
		z(/*#__PURE__*/ R(_v, {
			cssClasses: o,
			items: n,
			canRefine: i
		}), a);
	}
}, xv = function(e) {
	var t = e || {}, n = t.container, r = t.includedAttributes, i = t.excludedAttributes, a = t.cssClasses, o = a === void 0 ? {} : a, s = t.transformItems;
	if (!n) throw Error(vv("The `container` option is required."));
	var c = f_(n), l = {
		root: $(yv(), o.root),
		noRefinementRoot: $(yv({ modifierName: "noRefinement" }), o.noRefinementRoot),
		list: $(yv({ descendantName: "list" }), o.list),
		item: $(yv({ descendantName: "item" }), o.item),
		label: $(yv({ descendantName: "label" }), o.label),
		category: $(yv({ descendantName: "category" }), o.category),
		categoryLabel: $(yv({ descendantName: "categoryLabel" }), o.categoryLabel),
		delete: $(yv({ descendantName: "delete" }), o.delete)
	};
	return q(K({}, dh(bv, function() {
		return z(null, c);
	})({
		container: c,
		cssClasses: l,
		includedAttributes: r,
		excludedAttributes: i,
		transformItems: s
	})), { $$widgetType: "ais.currentRefinements" });
}, Sv = {
	query: "",
	showSubmit: !0,
	showReset: !0,
	showLoadingIndicator: !0,
	autofocus: !1,
	searchAsYouType: !0,
	ignoreCompositionEvents: !1,
	isSearchStalled: !1,
	disabled: !1,
	ariaLabel: "Search",
	submitTitle: "Submit the search query",
	resetTitle: "Clear the search query",
	onChange: Z,
	onSubmit: Z,
	onReset: Z,
	refine: Z,
	inputProps: {}
}, Cv = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t() {
		bd(this, t);
		var e = yd(this, t, arguments);
		return G(e, "state", {
			query: e.props.query,
			focused: !1
		}), G(e, "input", na()), G(e, "onInput", function(t) {
			var n, r;
			(n = (r = e.props.inputProps).onInput) == null || n.call(r, t);
			var i = e.props, a = i.searchAsYouType, o = i.refine, s = i.onChange, c = t.target.value;
			e.props.ignoreCompositionEvents && t.isComposing || (a && o(c), e.setState({ query: c }), s(t));
		}), G(e, "onSubmit", function(t) {
			var n = e.props, r = n.searchAsYouType, i = n.refine, a = n.onSubmit;
			return t.preventDefault(), t.stopPropagation(), e.input.current && e.input.current.blur(), r || i(e.state.query), a(t), !1;
		}), G(e, "onReset", function(t) {
			var n = e.props, r = n.refine, i = n.onReset, a = "";
			e.input.current && e.input.current.focus(), r(a), e.setState({ query: a }), i(t);
		}), G(e, "onBlur", function(t) {
			var n, r;
			(n = (r = e.props.inputProps).onBlur) == null || n.call(r, t), e.setState({ focused: !1 });
		}), G(e, "onFocus", function(t) {
			var n, r;
			(n = (r = e.props.inputProps).onFocus) == null || n.call(r, t), e.setState({ focused: !0 });
		}), G(e, "onAiModeClick", function(t) {
			var n, r;
			t.preventDefault(), (n = (r = e.props).onAiModeClick) == null || n.call(r, e.state.query);
		}), e;
	}
	return Sd(t, [
		{
			key: "resetInput",
			value: function() {
				this.setState({ query: "" });
			}
		},
		{
			key: "componentWillReceiveProps",
			value: function(e) {
				!this.state.focused && e.query !== this.state.query && this.setState({ query: e.query });
			}
		},
		{
			key: "render",
			value: function() {
				var e = this.props, t = e.cssClasses, n = e.placeholder, r = e.autofocus, i = e.showSubmit, a = e.showReset, o = e.showLoadingIndicator, s = e.templates, c = e.isSearchStalled, l = e.ariaLabel, u = e.inputProps, d = e.onAiModeClick, f = e.aiModeButtonDisabled;
				return /*#__PURE__*/ R("div", { className: t.root }, /*#__PURE__*/ R("form", {
					action: "",
					role: "search",
					className: t.form,
					noValidate: !0,
					onSubmit: this.onSubmit,
					onReset: this.onReset
				}, /*#__PURE__*/ R("input", q(K({}, u), {
					ref: this.input,
					value: this.state.query,
					disabled: this.props.disabled,
					className: t.input,
					type: "search",
					placeholder: n,
					autoFocus: r,
					autoComplete: "off",
					autoCorrect: "off",
					autoCapitalize: "off",
					spellCheck: "false",
					maxLength: 512,
					onInput: this.onInput,
					oncompositionend: this.onInput,
					onBlur: this.onBlur,
					onFocus: this.onFocus,
					"aria-label": l
				})), /*#__PURE__*/ R(c_, {
					templateKey: "submit",
					rootTagName: "button",
					rootProps: {
						className: t.submit,
						type: "submit",
						title: this.props.submitTitle,
						"aria-label": this.props.submitTitle,
						hidden: !i
					},
					templates: s,
					data: { cssClasses: t }
				}), /*#__PURE__*/ R(c_, {
					templateKey: "reset",
					rootTagName: "button",
					rootProps: {
						className: t.reset,
						type: "reset",
						title: this.props.resetTitle,
						"aria-label": this.props.resetTitle,
						hidden: !(a && this.state.query.trim() && !c)
					},
					templates: s,
					data: { cssClasses: t }
				}), o && /*#__PURE__*/ R(c_, {
					templateKey: "loadingIndicator",
					rootTagName: "span",
					rootProps: {
						className: t.loadingIndicator,
						hidden: !c
					},
					templates: s,
					data: { cssClasses: t }
				}), d && /*#__PURE__*/ R(c_, {
					templateKey: "aiMode",
					rootTagName: "button",
					rootProps: {
						className: t.aiModeButton,
						type: "button",
						title: "AI Mode",
						disabled: f,
						onClick: this.onAiModeClick
					},
					templates: s,
					data: { cssClasses: t }
				})));
			}
		}
	]), t;
}(ia);
G(Cv, "defaultProps", Sv);
//#endregion
//#region node_modules/instantsearch.js/es/components/RefinementList/RefinementListItem.js
function wv(e) {
	var t = e.className, n = e.handleClick, r = e.facetValueToRefine, i = e.isRefined, a = e.templateProps, o = e.templateKey, s = e.templateData, c = e.subItems;
	return /*#__PURE__*/ R("li", {
		className: t,
		onClick: function(e) {
			n({
				facetValueToRefine: r,
				isRefined: i,
				originalEvent: e
			});
		}
	}, /*#__PURE__*/ R(c_, q(K({}, a), {
		templateKey: o,
		data: s
	})), c);
}
//#endregion
//#region node_modules/instantsearch.js/es/components/RefinementList/RefinementList.js
var Tv = {
	cssClasses: {},
	depth: 0
};
function Ev(e) {
	return e.data !== void 0;
}
var Dv = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t() {
		bd(this, t);
		var e = yd(this, t, arguments);
		return G(e, "listRef", na()), G(e, "searchBox", na()), G(e, "lastRefinedValue", void 0), G(e, "_generateFacetItem", function(n) {
			var r;
			if (Ev(n) && Array.isArray(n.data) && n.data.length > 0) {
				var i = e.props.cssClasses;
				i.root;
				var a = J(i, ["root"]);
				r = /*#__PURE__*/ R(t, q(K({}, e.props), {
					cssClasses: a,
					depth: e.props.depth + 1,
					facetValues: n.data,
					showMore: !1,
					className: e.props.cssClasses.childList
				}));
			}
			var o = e.props.createURL(n.value), s = q(K({}, n), {
				url: o,
				attribute: e.props.attribute,
				cssClasses: e.props.cssClasses,
				isFromSearch: e.props.isFromSearch
			}), c = n.value;
			n.isRefined !== void 0 && (c += `/${n.isRefined}`), n.count !== void 0 && (c += `/${n.count}`);
			var l = $(e.props.cssClasses.item, n.isRefined && e.props.cssClasses.selectedItem, !n.count && e.props.cssClasses.disabledItem, !!(Ev(n) && Array.isArray(n.data) && n.data.length > 0) && e.props.cssClasses.parentItem);
			return /*#__PURE__*/ R(wv, {
				templateKey: "item",
				key: c,
				facetValueToRefine: n.value,
				handleClick: e.handleItemClick,
				isRefined: n.isRefined,
				className: l,
				subItems: r,
				templateData: s,
				templateProps: e.props.templateProps
			});
		}), G(e, "handleItemClick", function(t) {
			var n = t.facetValueToRefine, r = t.isRefined, i = t.originalEvent;
			if (!sv(i)) {
				var a = i.target;
				if (!(a === null || a.parentNode === null) && !(r && a.parentNode.querySelector("input[type=\"radio\"]:checked"))) {
					if (a.tagName === "INPUT") {
						e.refine(n);
						return;
					}
					for (; a !== i.currentTarget;) {
						if (a.tagName === "LABEL" && (a.querySelector("input[type=\"checkbox\"]") || a.querySelector("input[type=\"radio\"]"))) return;
						a.tagName === "A" && a.href && i.preventDefault(), a = a.parentNode;
					}
					i.stopPropagation(), e.refine(n);
				}
			}
		}), e;
	}
	return Sd(t, [
		{
			key: "shouldComponentUpdate",
			value: function(e) {
				return !Vh(this.props.facetValues, e.facetValues);
			}
		},
		{
			key: "refine",
			value: function(e) {
				this.lastRefinedValue = e, this.props.toggleRefinement(e);
			}
		},
		{
			key: "componentWillReceiveProps",
			value: function(e) {
				this.searchBox.current && !e.isFromSearch && this.searchBox.current.resetInput();
			}
		},
		{
			key: "componentDidUpdate",
			value: function() {
				for (var e = this.listRef.current?.getElementsByTagName("input") || [], t = 0; t < e.length; t++) if (e[t].value === this.lastRefinedValue) {
					e[t].focus();
					break;
				}
				this.lastRefinedValue = void 0;
			}
		},
		{
			key: "refineFirstValue",
			value: function() {
				if (this.props.searchableSelectOnSubmit !== !1) {
					var e = this.props.facetValues && this.props.facetValues[0];
					if (e) {
						var t = e.value;
						this.props.toggleRefinement(t);
					}
				}
			}
		},
		{
			key: "render",
			value: function() {
				var e = this, t = $(this.props.cssClasses.showMore, !(this.props.showMore === !0 && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore), n = this.props.showMore === !0 && /*#__PURE__*/ R(c_, q(K({}, this.props.templateProps), {
					templateKey: "showMoreText",
					rootTagName: "button",
					rootProps: {
						className: t,
						disabled: !this.props.canToggleShowMore,
						onClick: this.props.toggleShowMore,
						"aria-expanded": !!this.props.isShowingMore,
						"aria-label": this.props.showMoreButtonLabel
					},
					data: { isShowingMore: this.props.isShowingMore }
				})), r = this.props.searchIsAlwaysActive !== !0 && !(this.props.isFromSearch || !this.props.hasExhaustiveItems), i = this.props.searchFacetValues && /*#__PURE__*/ R("div", { className: this.props.cssClasses.searchBox }, /*#__PURE__*/ R(Cv, {
					ref: this.searchBox,
					placeholder: this.props.searchPlaceholder,
					disabled: r,
					cssClasses: this.props.cssClasses.searchable,
					templates: this.props.searchBoxTemplateProps.templates,
					onChange: function(t) {
						return e.props.searchFacetValues(t.target.value);
					},
					onReset: function() {
						return e.props.searchFacetValues("");
					},
					onSubmit: function() {
						return e.refineFirstValue();
					},
					searchAsYouType: !1,
					ariaLabel: "Search for filters"
				})), a = this.props.facetValues && this.props.facetValues.length > 0 && /*#__PURE__*/ R("ul", {
					ref: this.listRef,
					className: this.props.cssClasses.list
				}, this.props.facetValues.map(this._generateFacetItem, this)), o = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || this.props.facetValues.length === 0) && /*#__PURE__*/ R(c_, q(K({}, this.props.templateProps), {
					templateKey: "searchableNoResults",
					rootProps: { className: this.props.cssClasses.noResults }
				}));
				return /*#__PURE__*/ R("div", { className: $(this.props.cssClasses.root, (!this.props.facetValues || this.props.facetValues.length === 0) && this.props.cssClasses.noRefinementRoot, this.props.className) }, this.props.children, i, a, o, n);
			}
		}
	]), t;
}(ia);
G(Dv, "defaultProps", Tv);
//#endregion
//#region node_modules/instantsearch.js/es/lib/formatNumber.js
function Ov(e, t) {
	return e.toLocaleString(t);
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/hierarchical-menu/defaultTemplates.js
var kv = {
	item: function(e) {
		var t = e.url, n = e.label, r = e.count, i = e.cssClasses, a = e.isRefined;
		return /*#__PURE__*/ R("a", {
			className: $($(i.link), $(a ? i.selectedItemLink : void 0)),
			href: t
		}, /*#__PURE__*/ R("span", { className: $(i.label) }, n), /*#__PURE__*/ R("span", { className: $(i.count) }, Ov(r)));
	},
	showMoreText: function(e) {
		return e.isShowingMore ? "Show less" : "Show more";
	}
}, Av = X({ name: "hierarchical-menu" }), jv = u_("HierarchicalMenu"), Mv = function(e) {
	var t = e.cssClasses, n = e.containerNode, r = e.showMore, i = e.templates, a = e.renderState;
	return function(e, o) {
		var s = e.createURL, c = e.items, l = e.refine, u = e.instantSearchInstance, d = e.isShowingMore, f = e.toggleShowMore, p = e.canToggleShowMore;
		if (o) {
			a.templateProps = m_({
				defaultTemplates: kv,
				templatesConfig: u.templatesConfig,
				templates: i
			});
			return;
		}
		z(/*#__PURE__*/ R(Dv, {
			createURL: s,
			cssClasses: t,
			facetValues: c,
			templateProps: a.templateProps,
			toggleRefinement: l,
			showMore: r,
			toggleShowMore: f,
			isShowingMore: d,
			canToggleShowMore: p
		}), n);
	};
}, Nv = function(e) {
	var t = e || {}, n = t.container, r = t.attributes, i = t.separator, a = t.rootPath, o = t.showParentLevel, s = t.limit, c = t.showMore, l = c !== void 0 && c, u = t.showMoreLimit, d = t.sortBy, f = t.transformItems, p = t.templates, m = p === void 0 ? {} : p, h = t.cssClasses, g = h === void 0 ? {} : h;
	if (!n) throw Error(Av("The `container` option is required."));
	var _ = f_(n);
	return q(K({}, Sh(Mv({
		cssClasses: {
			root: $(jv(), g.root),
			noRefinementRoot: $(jv({ modifierName: "noRefinement" }), g.noRefinementRoot),
			list: $(jv({ descendantName: "list" }), g.list),
			childList: $(jv({
				descendantName: "list",
				modifierName: "child"
			}), g.childList),
			item: $(jv({ descendantName: "item" }), g.item),
			selectedItem: $(jv({
				descendantName: "item",
				modifierName: "selected"
			}), g.selectedItem),
			parentItem: $(jv({
				descendantName: "item",
				modifierName: "parent"
			}), g.parentItem),
			link: $(jv({ descendantName: "link" }), g.link),
			selectedItemLink: $(jv({
				descendantName: "link",
				modifierName: "selected"
			}), g.selectedItemLink),
			label: $(jv({ descendantName: "label" }), g.label),
			count: $(jv({ descendantName: "count" }), g.count),
			showMore: $(jv({ descendantName: "showMore" }), g.showMore),
			disabledShowMore: $(jv({
				descendantName: "showMore",
				modifierName: "disabled"
			}), g.disabledShowMore)
		},
		containerNode: _,
		templates: m,
		showMore: l,
		renderState: {}
	}), function() {
		return z(null, _);
	})({
		attributes: r,
		separator: i,
		rootPath: a,
		showParentLevel: o,
		limit: s,
		showMore: l,
		showMoreLimit: u,
		sortBy: d,
		transformItems: f
	})), { $$widgetType: "ais.hierarchicalMenu" });
};
//#endregion
//#region node_modules/instantsearch.js/es/helpers/insights.js
function Pv(e) {
	var t = e.getAttribute("data-insights-method"), n = e.getAttribute("data-insights-payload");
	if (typeof n != "string") throw Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
	try {
		return {
			method: t,
			payload: Th(n)
		};
	} catch {
		throw Error("The insights helper was unable to parse `data-insights-payload`.");
	}
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/insights/listener.js
var Fv = function(e) {
	var t = e.insights, n = e.sendEvent;
	return function(e) {
		var r = Iv(e.target, e.currentTarget, function(e) {
			return e.hasAttribute("data-insights-event");
		});
		r && Lv(r).forEach(function(e) {
			return n(e);
		});
		var i = Iv(e.target, e.currentTarget, function(e) {
			return e.hasAttribute("data-insights-method") && e.hasAttribute("data-insights-payload");
		});
		if (i) {
			var a = Pv(i), o = a.method, s = a.payload;
			t(o, s);
		}
	};
};
function Iv(e, t, n) {
	for (var r = e; r && !n(r);) {
		if (r === t) return null;
		r = r.parentElement;
	}
	return r;
}
function Lv(e) {
	var t = e.getAttribute("data-insights-event");
	if (typeof t != "string") throw Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
	try {
		return Th(t);
	} catch {
		throw Error("The insights middleware was unable to parse `data-insights-event`.");
	}
}
//#endregion
//#region node_modules/instantsearch.js/es/lib/utils/omit.js
function Rv(e, t) {
	return e == null ? e : Object.keys(e).reduce(function(n, r) {
		if (t.indexOf(r) >= 0) return n;
		var i = r;
		return n[i] = e[i], n;
	}, {});
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/hits/defaultTemplates.js
var zv = {
	empty: function() {
		return "No results";
	},
	item: function(e) {
		return /*#__PURE__*/ R(ra, null, JSON.stringify(Rv(e, ["__hitIndex"]), null, 2));
	}
}, Bv = X({ name: "hits" }), Vv = Hg({
	createElement: R,
	Fragment: ra
}), Hv = function(e) {
	var t = e.renderState, n = e.cssClasses, r = e.containerNode, i = e.templates;
	return function(e, a) {
		var o = e.items, s = e.results, c = e.instantSearchInstance, l = e.insights, u = e.bindEvent, d = e.sendEvent, f = e.banner;
		if (a) {
			t.templateProps = m_({
				defaultTemplates: zv,
				templatesConfig: c.templatesConfig,
				templates: i
			});
			return;
		}
		var p = Fv({
			insights: l,
			sendEvent: d
		});
		z(/*#__PURE__*/ R(Vv, {
			hits: o,
			itemComponent: function(e) {
				var n = e.hit, r = e.index, i = J(e, ["hit", "index"]);
				return /*#__PURE__*/ R(c_, q(K({}, t.templateProps), {
					templateKey: "item",
					rootTagName: "li",
					rootProps: q(K({}, i), {
						onClick: function(e) {
							p(e), i.onClick();
						},
						onAuxClick: function(e) {
							p(e), i.onAuxClick();
						}
					}),
					data: q(K({}, n), { get __hitIndex() {
						return r;
					} }),
					bindEvent: u,
					sendEvent: d
				}));
			},
			sendEvent: d,
			classNames: n,
			emptyComponent: function(e) {
				Du(e);
				var n = Eu({}, e);
				return /*#__PURE__*/ R(c_, q(K({}, t.templateProps), {
					rootProps: n,
					templateKey: "empty",
					data: s,
					rootTagName: "fragment"
				}));
			},
			banner: f,
			bannerComponent: i.banner ? function(e) {
				return /*#__PURE__*/ R(c_, q(K({}, t.templateProps), {
					templateKey: "banner",
					data: e,
					rootTagName: "fragment"
				}));
			} : void 0
		}), r);
	};
}, Uv = (function(e) {
	var t = e || {}, n = t.container, r = t.escapeHTML, i = t.transformItems, a = t.templates, o = a === void 0 ? {} : a, s = t.cssClasses, c = s === void 0 ? {} : s;
	if (!n) throw Error(Bv("The `container` option is required."));
	var l = f_(n), u = Hv({
		containerNode: l,
		cssClasses: c,
		renderState: {},
		templates: o
	});
	return q(K({}, Lh(jh)(u, function() {
		return z(null, l);
	})({
		escapeHTML: r,
		transformItems: i
	})), { $$widgetType: "ais.hits" });
});
//#endregion
//#region node_modules/instantsearch.js/es/components/Selector/Selector.js
function Wv(e) {
	var t = e.currentValue, n = e.options, r = e.cssClasses, i = e.setValue, a = e.ariaLabel;
	return /*#__PURE__*/ R("select", {
		className: $(r.select),
		onChange: function(e) {
			return i(e.target.value);
		},
		value: `${t}`,
		"aria-label": a
	}, n.map(function(e) {
		return /*#__PURE__*/ R("option", {
			className: $(r.option),
			key: e.label + e.value,
			value: `${e.value}`
		}, e.label);
	}));
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/menu/defaultTemplates.js
var Gv = {
	item: function(e) {
		var t = e.cssClasses, n = e.url, r = e.label, i = e.count;
		return /*#__PURE__*/ R("a", {
			className: $(t.link),
			href: n
		}, /*#__PURE__*/ R("span", { className: $(t.label) }, r), /*#__PURE__*/ R("span", { className: $(t.count) }, Ov(i)));
	},
	showMoreText: function(e) {
		return e.isShowingMore ? "Show less" : "Show more";
	}
}, Kv = X({ name: "menu" }), qv = u_("Menu"), Jv = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.renderState, i = e.templates, a = e.showMore;
	return function(e, o) {
		var s = e.refine, c = e.items, l = e.createURL, u = e.instantSearchInstance, d = e.isShowingMore, f = e.toggleShowMore, p = e.canToggleShowMore;
		if (o) {
			r.templateProps = m_({
				defaultTemplates: Gv,
				templatesConfig: u.templatesConfig,
				templates: i
			});
			return;
		}
		z(/*#__PURE__*/ R(Dv, {
			createURL: l,
			cssClasses: n,
			facetValues: c.map(function(e) {
				return q(K({}, e), { url: l(e.value) });
			}),
			showMore: a,
			templateProps: r.templateProps,
			toggleRefinement: s,
			toggleShowMore: f,
			isShowingMore: d,
			canToggleShowMore: p
		}), t);
	};
}, Yv = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.sortBy, a = t.limit, o = t.showMore, s = t.showMoreLimit, c = t.cssClasses, l = c === void 0 ? {} : c, u = t.templates, d = u === void 0 ? {} : u, f = t.transformItems;
	if (!n) throw Error(Kv("The `container` option is required."));
	var p = f_(n);
	return q(K({}, Wh(Jv({
		containerNode: p,
		cssClasses: {
			root: $(qv(), l.root),
			noRefinementRoot: $(qv({ modifierName: "noRefinement" }), l.noRefinementRoot),
			list: $(qv({ descendantName: "list" }), l.list),
			item: $(qv({ descendantName: "item" }), l.item),
			selectedItem: $(qv({
				descendantName: "item",
				modifierName: "selected"
			}), l.selectedItem),
			link: $(qv({ descendantName: "link" }), l.link),
			label: $(qv({ descendantName: "label" }), l.label),
			count: $(qv({ descendantName: "count" }), l.count),
			showMore: $(qv({ descendantName: "showMore" }), l.showMore),
			disabledShowMore: $(qv({
				descendantName: "showMore",
				modifierName: "disabled"
			}), l.disabledShowMore)
		},
		renderState: {},
		templates: d,
		showMore: o
	}), function() {
		return z(null, p);
	})({
		attribute: r,
		limit: a,
		showMore: o,
		showMoreLimit: s,
		sortBy: i,
		transformItems: f
	})), { $$widgetType: "ais.menu" });
};
//#endregion
//#region node_modules/instantsearch.js/es/components/MenuSelect/MenuSelect.js
function Xv(e) {
	var t = e.cssClasses, n = e.templateProps, r = e.items, i = e.refine, a = (rh(r, function(e) {
		return e.isRefined;
	}) || { value: "" }).value;
	return /*#__PURE__*/ R("div", { className: $(t.root, r.length === 0 && t.noRefinementRoot) }, /*#__PURE__*/ R("select", {
		className: t.select,
		value: a,
		onChange: function(e) {
			i(e.target.value);
		}
	}, /*#__PURE__*/ R(c_, q(K({}, n), {
		templateKey: "defaultOption",
		rootTagName: "option",
		rootProps: {
			value: "",
			className: t.option
		}
	})), r.map(function(e) {
		return /*#__PURE__*/ R(c_, q(K({}, n), {
			templateKey: "item",
			rootTagName: "option",
			rootProps: {
				value: e.value,
				className: t.option
			},
			key: e.value,
			data: e
		}));
	})));
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/menu-select/defaultTemplates.js
var Zv = {
	item: function(e) {
		var t = e.label, n = e.count;
		return `${t} (${Ov(n)})`;
	},
	defaultOption: function() {
		return "See all";
	}
}, Qv = X({ name: "menu-select" }), $v = u_("MenuSelect"), ey = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.renderState, i = e.templates;
	return function(e, a) {
		var o = e.refine, s = e.items, c = e.instantSearchInstance;
		if (a) {
			r.templateProps = m_({
				defaultTemplates: Zv,
				templatesConfig: c.templatesConfig,
				templates: i
			});
			return;
		}
		z(/*#__PURE__*/ R(Xv, {
			cssClasses: n,
			items: s,
			refine: o,
			templateProps: r.templateProps
		}), t);
	};
}, ty = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.sortBy, a = i === void 0 ? ["name:asc"] : i, o = t.limit, s = o === void 0 ? 10 : o, c = t.cssClasses, l = c === void 0 ? {} : c, u = t.templates, d = u === void 0 ? {} : u, f = t.transformItems;
	if (!n) throw Error(Qv("The `container` option is required."));
	var p = f_(n);
	return q(K({}, Wh(ey({
		containerNode: p,
		cssClasses: {
			root: $($v(), l.root),
			noRefinementRoot: $($v({ modifierName: "noRefinement" }), l.noRefinementRoot),
			select: $($v({ descendantName: "select" }), l.select),
			option: $($v({ descendantName: "option" }), l.option)
		},
		renderState: {},
		templates: d
	}), function() {
		return z(null, p);
	})({
		attribute: r,
		limit: s,
		sortBy: a,
		transformItems: f
	})), { $$widgetType: "ais.menuSelect" });
}, ny = { item: function(e) {
	var t = e.cssClasses, n = e.attribute, r = e.label, i = e.isRefined;
	return /*#__PURE__*/ R("label", { className: t.label }, /*#__PURE__*/ R("input", {
		type: "radio",
		className: t.radio,
		name: n,
		defaultChecked: i
	}), /*#__PURE__*/ R("span", { className: t.labelText }, r));
} }, ry = X({ name: "numeric-menu" }), iy = u_("NumericMenu"), ay = function(e) {
	var t = e.containerNode, n = e.attribute, r = e.cssClasses, i = e.renderState, a = e.templates;
	return function(e, o) {
		var s = e.createURL, c = e.instantSearchInstance, l = e.refine, u = e.items;
		if (o) {
			i.templateProps = m_({
				defaultTemplates: ny,
				templatesConfig: c.templatesConfig,
				templates: a
			});
			return;
		}
		z(/*#__PURE__*/ R(Dv, {
			createURL: s,
			cssClasses: r,
			facetValues: u,
			templateProps: i.templateProps,
			toggleRefinement: l,
			attribute: n
		}), t);
	};
}, oy = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.items, a = t.cssClasses, o = a === void 0 ? {} : a, s = t.templates, c = s === void 0 ? {} : s, l = t.transformItems;
	if (!n) throw Error(ry("The `container` option is required."));
	var u = f_(n);
	return q(K({}, Yh(ay({
		containerNode: u,
		attribute: r,
		cssClasses: {
			root: $(iy(), o.root),
			noRefinementRoot: $(iy({ modifierName: "noRefinement" }), o.noRefinementRoot),
			list: $(iy({ descendantName: "list" }), o.list),
			item: $(iy({ descendantName: "item" }), o.item),
			selectedItem: $(iy({
				descendantName: "item",
				modifierName: "selected"
			}), o.selectedItem),
			label: $(iy({ descendantName: "label" }), o.label),
			radio: $(iy({ descendantName: "radio" }), o.radio),
			labelText: $(iy({ descendantName: "labelText" }), o.labelText)
		},
		renderState: {},
		templates: c
	}), function() {
		return z(null, u);
	})({
		attribute: r,
		items: i,
		transformItems: l
	})), { $$widgetType: "ais.numericMenu" });
};
//#endregion
//#region node_modules/instantsearch.js/es/components/Pagination/Pagination.js
function sy(e) {
	function t(t) {
		return function(n) {
			sv(n) || (n.preventDefault(), e.setCurrentPage(t));
		};
	}
	return /*#__PURE__*/ R("div", { className: $(e.cssClasses.root, e.nbPages <= 1 && e.cssClasses.noRefinementRoot) }, /*#__PURE__*/ R("ul", { className: e.cssClasses.list }, e.showFirst && /*#__PURE__*/ R(cy, {
		ariaLabel: "First Page",
		className: e.cssClasses.firstPageItem,
		isDisabled: e.isFirstPage,
		templates: e.templates,
		templateKey: "first",
		pageNumber: 0,
		createURL: e.createURL,
		cssClasses: e.cssClasses,
		createClickHandler: t
	}), e.showPrevious && /*#__PURE__*/ R(cy, {
		ariaLabel: "Previous Page",
		className: e.cssClasses.previousPageItem,
		isDisabled: e.isFirstPage,
		templates: e.templates,
		templateKey: "previous",
		pageNumber: e.currentPage - 1,
		createURL: e.createURL,
		cssClasses: e.cssClasses,
		createClickHandler: t
	}), e.pages.map(function(n) {
		return /*#__PURE__*/ R(cy, {
			key: n,
			ariaLabel: `Page ${n + 1}`,
			className: e.cssClasses.pageItem,
			isSelected: n === e.currentPage,
			templates: e.templates,
			templateKey: "page",
			pageNumber: n,
			createURL: e.createURL,
			cssClasses: e.cssClasses,
			createClickHandler: t
		});
	}), e.showNext && /*#__PURE__*/ R(cy, {
		ariaLabel: "Next Page",
		className: e.cssClasses.nextPageItem,
		isDisabled: e.isLastPage,
		templates: e.templates,
		templateKey: "next",
		pageNumber: e.currentPage + 1,
		createURL: e.createURL,
		cssClasses: e.cssClasses,
		createClickHandler: t
	}), e.showLast && /*#__PURE__*/ R(cy, {
		ariaLabel: `Last Page, Page ${e.nbPages}`,
		className: e.cssClasses.lastPageItem,
		isDisabled: e.isLastPage,
		templates: e.templates,
		templateKey: "last",
		pageNumber: e.nbPages - 1,
		createURL: e.createURL,
		cssClasses: e.cssClasses,
		createClickHandler: t
	})));
}
function cy(e) {
	var t = e.templates, n = e.templateKey, r = e.ariaLabel, i = e.pageNumber, a = e.className, o = e.isDisabled, s = o !== void 0 && o, c = e.isSelected, l = c !== void 0 && c, u = e.cssClasses, d = e.createURL, f = e.createClickHandler;
	return /*#__PURE__*/ R("li", { className: $(u.item, s && u.disabledItem, a, l && u.selectedItem) }, s ? /*#__PURE__*/ R(c_, {
		rootTagName: "span",
		rootProps: {
			className: u.link,
			"aria-label": r
		},
		templateKey: n,
		templates: t,
		data: { page: i + 1 }
	}) : /*#__PURE__*/ R(c_, {
		rootTagName: "a",
		rootProps: {
			className: u.link,
			"aria-label": r,
			"aria-current": l ? "page" : void 0,
			href: d(i),
			onClick: f(i)
		},
		templateKey: n,
		templates: t,
		data: { page: i + 1 }
	}));
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/pagination/pagination.js
var ly = u_("Pagination"), uy = X({ name: "pagination" }), dy = {
	previous: function() {
		return "‹";
	},
	next: function() {
		return "›";
	},
	page: function(e) {
		return `${e.page}`;
	},
	first: function() {
		return "«";
	},
	last: function() {
		return "»";
	}
}, fy = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.templates, i = e.showFirst, a = e.showLast, o = e.showPrevious, s = e.showNext, c = e.scrollToNode;
	return function(e, l) {
		var u = e.createURL, d = e.currentRefinement, f = e.nbPages, p = e.pages, m = e.isFirstPage, h = e.isLastPage, g = e.refine;
		l || z(/*#__PURE__*/ R(sy, {
			createURL: u,
			cssClasses: n,
			currentPage: d,
			templates: r,
			nbPages: f,
			pages: p,
			isFirstPage: m,
			isLastPage: h,
			setCurrentPage: function(e) {
				g(e), c !== !1 && c.scrollIntoView();
			},
			showFirst: i,
			showLast: a,
			showPrevious: o,
			showNext: s
		}), t);
	};
}, py = function(e) {
	var t = e || {}, n = t.container, r = t.templates, i = r === void 0 ? {} : r, a = t.cssClasses, o = a === void 0 ? {} : a, s = t.totalPages, c = t.padding, l = t.showFirst, u = l === void 0 || l, d = t.showLast, f = d === void 0 || d, p = t.showPrevious, m = p === void 0 || p, h = t.showNext, g = h === void 0 || h, _ = t.scrollTo, v = _ === void 0 ? "body" : _;
	if (!n) throw Error(uy("The `container` option is required."));
	var y = f_(n), b = v === !0 ? "body" : v, x = b !== !1 && f_(b);
	return q(K({}, rg(fy({
		containerNode: y,
		cssClasses: {
			root: $(ly(), o.root),
			noRefinementRoot: $(ly({ modifierName: "noRefinement" }), o.noRefinementRoot),
			list: $(ly({ descendantName: "list" }), o.list),
			item: $(ly({ descendantName: "item" }), o.item),
			firstPageItem: $(ly({
				descendantName: "item",
				modifierName: "firstPage"
			}), o.firstPageItem),
			lastPageItem: $(ly({
				descendantName: "item",
				modifierName: "lastPage"
			}), o.lastPageItem),
			previousPageItem: $(ly({
				descendantName: "item",
				modifierName: "previousPage"
			}), o.previousPageItem),
			nextPageItem: $(ly({
				descendantName: "item",
				modifierName: "nextPage"
			}), o.nextPageItem),
			pageItem: $(ly({
				descendantName: "item",
				modifierName: "page"
			}), o.pageItem),
			selectedItem: $(ly({
				descendantName: "item",
				modifierName: "selected"
			}), o.selectedItem),
			disabledItem: $(ly({
				descendantName: "item",
				modifierName: "disabled"
			}), o.disabledItem),
			link: $(ly({ descendantName: "link" }), o.link)
		},
		templates: K({}, dy, i),
		showFirst: u,
		showLast: f,
		showPrevious: m,
		showNext: g,
		scrollToNode: x
	}), function() {
		return z(null, y);
	})({
		totalPages: s,
		padding: c
	})), { $$widgetType: "ais.pagination" });
};
//#endregion
//#region node_modules/instantsearch.js/es/components/Panel/Panel.js
function my(e) {
	var t = U(k_(e.isCollapsed), 2), n = t[0], r = t[1], i = U(k_(!1), 2), a = i[0], o = i[1], s = M_(null);
	return j_(function() {
		var t = s.current;
		if (t) return t.appendChild(e.bodyElement), function() {
			t.removeChild(e.bodyElement);
		};
	}, [s, e.bodyElement]), !a && e.isCollapsed !== n && r(e.isCollapsed), /*#__PURE__*/ R("div", {
		className: $(e.cssClasses.root, e.hidden && e.cssClasses.noRefinementRoot, e.collapsible && e.cssClasses.collapsibleRoot, n && e.cssClasses.collapsedRoot),
		hidden: e.hidden
	}, e.templates.header && /*#__PURE__*/ R("div", { className: e.cssClasses.header }, /*#__PURE__*/ R(c_, {
		templates: e.templates,
		templateKey: "header",
		rootTagName: "span",
		data: e.data
	}), e.collapsible && /*#__PURE__*/ R("button", {
		className: e.cssClasses.collapseButton,
		"aria-expanded": !n,
		onClick: function(e) {
			e.preventDefault(), o(!0), r(function(e) {
				return !e;
			});
		}
	}, /*#__PURE__*/ R(c_, {
		templates: e.templates,
		templateKey: "collapseButtonText",
		rootTagName: "span",
		data: { collapsed: n }
	}))), /*#__PURE__*/ R("div", {
		className: e.cssClasses.body,
		ref: s
	}), e.templates.footer && /*#__PURE__*/ R(c_, {
		templates: e.templates,
		templateKey: "footer",
		rootProps: { className: e.cssClasses.footer },
		data: e.data
	}));
}
//#endregion
//#region node_modules/instantsearch.js/es/widgets/panel/panel.js
var hy = X({ name: "panel" }), gy = u_("Panel"), _y = function(e) {
	var t = e.containerNode, n = e.bodyContainerNode, r = e.cssClasses, i = e.templates;
	return function(e) {
		var a = e.options, o = e.hidden, s = e.collapsible, c = e.collapsed;
		z(/*#__PURE__*/ R(my, {
			cssClasses: r,
			hidden: o,
			collapsible: s,
			isCollapsed: c,
			templates: i,
			data: a,
			bodyElement: n
		}), t);
	};
}, vy = function(e) {
	var t = e || {}, n = t.templates, r = n === void 0 ? {} : n, i = t.hidden, a = i === void 0 ? function() {
		return !1;
	} : i, o = t.collapsed, s = t.cssClasses, c = s === void 0 ? {} : s, l = document.createElement("div"), u = !!o, d = typeof o == "function" ? o : function() {
		return !1;
	}, f = {
		root: $(gy(), c.root),
		noRefinementRoot: $(gy({ modifierName: "noRefinement" }), c.noRefinementRoot),
		collapsibleRoot: $(gy({ modifierName: "collapsible" }), c.collapsibleRoot),
		collapsedRoot: $(gy({ modifierName: "collapsed" }), c.collapsedRoot),
		collapseButton: $(gy({ descendantName: "collapseButton" }), c.collapseButton),
		collapseIcon: $(gy({ descendantName: "collapseIcon" }), c.collapseIcon),
		body: $(gy({ descendantName: "body" }), c.body),
		header: $(gy({ descendantName: "header" }), c.header),
		footer: $(gy({ descendantName: "footer" }), c.footer)
	};
	return function(e) {
		return function(t) {
			if (!(t && t.container)) throw Error(hy("The `container` option is required in the widget within the panel."));
			var n = f_(t.container), i = _y({
				containerNode: n,
				bodyContainerNode: l,
				cssClasses: f,
				templates: K({}, { collapseButtonText: function(e) {
					var t = e.collapsed;
					return `<svg
          class="${f.collapseIcon}"
          style="width: 1em; height: 1em;"
          viewBox="0 0 500 500"
        >
        <path d="${t ? "M100 250l300-150v300z" : "M250 400l150-300H100z"}" fill="currentColor" />
        </svg>`;
				} }, r)
			}), o = e(q(K({}, t), { container: l }));
			return q(K({}, o), {
				init: function() {
					var e = [...arguments], t = U(e, 1)[0];
					if (i({
						options: K({}, o.getWidgetRenderState ? o.getWidgetRenderState(t) : {}, t),
						hidden: !0,
						collapsible: u,
						collapsed: !1
					}), typeof o.init == "function") {
						var n;
						(n = o.init).call.apply(n, [this].concat(W(e)));
					}
				},
				render: function() {
					var e = [...arguments], t = U(e, 1)[0], n = K({}, o.getWidgetRenderState ? o.getWidgetRenderState(t) : {}, t);
					if (i({
						options: n,
						hidden: !!a(n),
						collapsible: u,
						collapsed: !!d(n)
					}), typeof o.render == "function") {
						var r;
						(r = o.render).call.apply(r, [this].concat(W(e)));
					}
				},
				dispose: function() {
					var e = [...arguments];
					if (z(null, n), typeof o.dispose == "function") {
						var t;
						return (t = o.dispose).call.apply(t, [this].concat(W(e)));
					}
				}
			});
		};
	};
};
//#endregion
//#region node_modules/instantsearch.js/es/components/RangeInput/RangeInput.js
function yy(e) {
	return e.replace(/^(0+)\d/, function(e) {
		return Number(e).toString();
	});
}
var by = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t() {
		bd(this, t);
		var e = yd(this, t, arguments);
		return G(e, "state", {
			min: e.props.values.min?.toString(),
			max: e.props.values.max?.toString()
		}), G(e, "onInput", function(t) {
			return function(n) {
				var r = n.currentTarget.value;
				e.setState(G({}, t, r));
			};
		}), G(e, "onSubmit", function(t) {
			t.preventDefault();
			var n = e.state, r = n.min, i = n.max;
			e.props.refine([r ? Number(r) : void 0, i ? Number(i) : void 0]);
		}), e;
	}
	return Sd(t, [{
		key: "componentWillReceiveProps",
		value: function(e) {
			this.setState({
				min: e.values.min?.toString(),
				max: e.values.max?.toString()
			});
		}
	}, {
		key: "render",
		value: function() {
			var e = this.state, t = e.min, n = e.max, r = this.props, i = r.min, a = r.max, o = r.step, s = r.cssClasses, c = r.templateProps, l = i && a ? i >= a : !1, u = !!(t || n);
			return /*#__PURE__*/ R("div", { className: $(s.root, !u && s.noRefinement) }, /*#__PURE__*/ R("form", {
				className: s.form,
				onSubmit: this.onSubmit
			}, /*#__PURE__*/ R("label", { className: s.label }, /*#__PURE__*/ R("input", {
				className: $(s.input, s.inputMin),
				type: "number",
				min: i,
				max: a,
				step: o,
				value: yy(t ?? ""),
				onInput: this.onInput("min"),
				placeholder: i?.toString(),
				disabled: l
			})), /*#__PURE__*/ R(c_, q(K({}, c), {
				templateKey: "separatorText",
				rootTagName: "span",
				rootProps: { className: s.separator }
			})), /*#__PURE__*/ R("label", { className: s.label }, /*#__PURE__*/ R("input", {
				className: $(s.input, s.inputMax),
				type: "number",
				min: i,
				max: a,
				step: o,
				value: yy(n ?? ""),
				onInput: this.onInput("max"),
				placeholder: a?.toString(),
				disabled: l
			})), /*#__PURE__*/ R(c_, q(K({}, c), {
				templateKey: "submitText",
				rootTagName: "button",
				rootProps: {
					type: "submit",
					className: s.submit,
					disabled: l
				}
			}))));
		}
	}]), t;
}(ia), xy = X({ name: "range-input" }), Sy = u_("RangeInput"), Cy = {
	separatorText: function() {
		return "to";
	},
	submitText: function() {
		return "Go";
	}
}, wy = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.renderState, i = e.templates;
	return function(e, a) {
		var o = e.refine, s = e.range, c = e.start, l = e.widgetParams, u = e.instantSearchInstance;
		if (a) {
			r.templateProps = m_({
				defaultTemplates: Cy,
				templatesConfig: u.templatesConfig,
				templates: i
			});
			return;
		}
		var d = s.min, f = s.max, p = U(c, 2), m = p[0], h = p[1];
		z(/*#__PURE__*/ R(by, {
			min: d,
			max: f,
			step: 1 / 10 ** (l.precision || 0),
			values: {
				min: m !== -Infinity && m !== d ? m : void 0,
				max: h !== Infinity && h !== f ? h : void 0
			},
			cssClasses: n,
			refine: o,
			templateProps: r.templateProps
		}), t);
	};
}, Ty = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.min, a = t.max, o = t.precision, s = o === void 0 ? 0 : o, c = t.cssClasses, l = c === void 0 ? {} : c, u = t.templates, d = u === void 0 ? {} : u;
	if (!n) throw Error(xy("The `container` option is required."));
	var f = f_(n);
	return q(K({}, sg(wy({
		containerNode: f,
		cssClasses: {
			root: $(Sy(), l.root),
			noRefinement: $(Sy({ modifierName: "noRefinement" })),
			form: $(Sy({ descendantName: "form" }), l.form),
			label: $(Sy({ descendantName: "label" }), l.label),
			input: $(Sy({ descendantName: "input" }), l.input),
			inputMin: $(Sy({
				descendantName: "input",
				modifierName: "min"
			}), l.inputMin),
			inputMax: $(Sy({
				descendantName: "input",
				modifierName: "max"
			}), l.inputMax),
			separator: $(Sy({ descendantName: "separator" }), l.separator),
			submit: $(Sy({ descendantName: "submit" }), l.submit)
		},
		templates: d,
		renderState: {}
	}), function() {
		return z(null, f);
	})({
		attribute: r,
		min: i,
		max: a,
		precision: s
	})), {
		$$type: "ais.rangeInput",
		$$widgetType: "ais.rangeInput"
	});
}, Ey = function(e) {
	var t = e.style, n = e.children, r = Math.round(parseFloat(t.left)), i = [
		0,
		50,
		100
	].includes(r), a = Math.round(parseInt(n, 10) * 100) / 100;
	return /*#__PURE__*/ R("div", {
		style: q(K({}, t), { marginLeft: r === 100 ? "-2px" : 0 }),
		className: $("rheostat-marker", "rheostat-marker-horizontal", i && "rheostat-marker-large")
	}, i && /*#__PURE__*/ R("div", { className: "rheostat-value" }, a));
}, Dy = {
	DOWN: 40,
	END: 35,
	ESC: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	RIGHT: 39,
	UP: 38
}, Oy = 0, ky = 100;
function Ay(e, t, n) {
	return (e - t) / (n - t) * 100;
}
function jy(e, t, n) {
	var r = e / 100;
	return e === 0 ? t : e === 100 ? n : Math.round((n - t) * r + t);
}
function My(e) {
	return ["rheostat", e.orientation === "vertical" ? "rheostat-vertical" : "rheostat-horizontal"].concat(e.className.split(" ")).join(" ");
}
function Ny(e) {
	return Number(e.currentTarget.getAttribute("data-handle-key"));
}
function Py(e) {
	e.stopPropagation(), e.preventDefault();
}
function Fy(e) {
	return /*#__PURE__*/ R("button", q(K({}, e), { type: "button" }));
}
var Iy = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t() {
		bd(this, t);
		var e = yd(this, t, arguments);
		return G(e, "x", [0, 0].map(function(e) {
			return e;
		})), G(e, "state", {
			className: My(e.props),
			handlePos: e.props.values.map(function(t) {
				return Ay(t, e.props.min, e.props.max);
			}),
			handleDimensions: 0,
			mousePos: null,
			sliderBox: {},
			slidingIndex: null,
			values: e.props.values
		}), G(e, "rheostat", na()), G(e, "componentWillReceiveProps", function(t) {
			var n = e.props, r = n.className, i = n.disabled, a = n.min, o = n.max, s = n.orientation, c = e.state, l = c.values, u = c.slidingIndex, d = t.min !== a || t.max !== o, f = l.length !== t.values.length || l.some(function(e, n) {
				return t.values[n] !== e;
			}), p = t.className !== r || t.orientation !== s, m = t.disabled && !i;
			p && e.setState({ className: My(t) }), (d || f) && e.updateNewValues(t), m && u !== null && e.endSlide();
		}), G(e, "getPublicState", function() {
			var t = e.props, n = t.min;
			return {
				max: t.max,
				min: n,
				values: e.state.values
			};
		}), G(e, "getSliderBoundingBox", function() {
			var t = e.rheostat.current, n = t.getBoundingClientRect();
			return {
				height: n.height || t.clientHeight,
				left: n.left,
				top: n.top,
				width: n.width || t.clientWidth
			};
		}), G(e, "getProgressStyle", function(t) {
			var n = e.state.handlePos, r = n[t];
			if (t === 0) return e.props.orientation === "vertical" ? {
				height: `${r}%`,
				top: 0
			} : {
				left: 0,
				width: `${r}%`
			};
			var i = n[t - 1], a = r - i;
			return e.props.orientation === "vertical" ? {
				height: `${a}%`,
				top: `${i}%`
			} : {
				left: `${i}%`,
				width: `${a}%`
			};
		}), G(e, "getMinValue", function(t) {
			return e.state.values[t - 1] ? Math.max(e.props.min, e.state.values[t - 1]) : e.props.min;
		}), G(e, "getMaxValue", function(t) {
			return e.state.values[t + 1] ? Math.min(e.props.max, e.state.values[t + 1]) : e.props.max;
		}), G(e, "getHandleDimensions", function(t, n) {
			var r = t.currentTarget || null;
			return r ? e.props.orientation === "vertical" ? r.clientHeight / n.height * ky / 2 : r.clientWidth / n.width * ky / 2 : 0;
		}), G(e, "getClosestSnapPoint", function(t) {
			return e.props.snapPoints.length ? e.props.snapPoints.reduce(function(e, n) {
				return Math.abs(e - t) < Math.abs(n - t) ? e : n;
			}) : t;
		}), G(e, "getSnapPosition", function(t) {
			if (!e.props.snap) return t;
			var n = e.props, r = n.max, i = n.min, a = jy(t, i, r);
			return Ay(e.getClosestSnapPoint(a), i, r);
		}), G(e, "getNextPositionForKey", function(t, n) {
			var r = e.state, i = r.handlePos, a = r.values, o = e.props, s = o.max, c = o.min, l = o.snapPoints, u = !!(e.props.snap && l.length), d = a[t], f = i[t], p = f, m = 1;
			s >= 100 ? f = Math.round(f) : m = 100 / (s - c);
			var h = null;
			u && (h = l.indexOf(e.getClosestSnapPoint(a[t])));
			var g, _ = (g = {}, G(g, Dy.LEFT, function(e) {
				return e * -1;
			}), G(g, Dy.RIGHT, function(e) {
				return e;
			}), G(g, Dy.UP, function(e) {
				return e;
			}), G(g, Dy.DOWN, function(e) {
				return e * -1;
			}), G(g, Dy.PAGE_DOWN, function(e) {
				return e > 1 ? -e : e * -10;
			}), G(g, Dy.PAGE_UP, function(e) {
				return e > 1 ? e : e * 10;
			}), g);
			if (Object.prototype.hasOwnProperty.call(_, n)) f += _[n](m), u && h && (f > p ? h < l.length - 1 && (d = l[h + 1]) : h > 0 && (d = l[h - 1]));
			else if (n === Dy.HOME) f = Oy, u && (d = l[0]);
			else if (n === Dy.END) f = ky, u && (d = l[l.length - 1]);
			else return null;
			return u ? Ay(d, c, s) : f;
		}), G(e, "getNextState", function(t, n) {
			var r = e.state.handlePos, i = e.props, a = i.max, o = i.min, s = e.validatePosition(t, n), c = r.map(function(e, n) {
				return n === t ? s : e;
			});
			return {
				handlePos: c,
				values: c.map(function(e) {
					return jy(e, o, a);
				})
			};
		}), G(e, "getClosestHandle", function(t) {
			var n = e.state.handlePos;
			return n.reduce(function(e, r, i) {
				return Math.abs(n[i] - t) < Math.abs(n[e] - t) ? i : e;
			}, 0);
		}), G(e, "setStartSlide", function(t, n, r) {
			var i = e.getSliderBoundingBox();
			e.setState({
				handleDimensions: e.getHandleDimensions(t, i),
				mousePos: {
					x: n,
					y: r
				},
				sliderBox: i,
				slidingIndex: Ny(t)
			});
		}), G(e, "startMouseSlide", function(t) {
			e.setStartSlide(t, t.clientX, t.clientY), document.addEventListener("mousemove", e.handleMouseSlide, !1), document.addEventListener("mouseup", e.endSlide, !1), Py(t);
		}), G(e, "startTouchSlide", function(t) {
			if (!(t.changedTouches.length > 1)) {
				var n = t.changedTouches[0];
				e.setStartSlide(t, n.clientX, n.clientY), document.addEventListener("touchmove", e.handleTouchSlide, !1), document.addEventListener("touchend", e.endSlide, !1), e.props.onSliderDragStart && e.props.onSliderDragStart(), Py(t);
			}
		}), G(e, "handleMouseSlide", function(t) {
			e.state.slidingIndex !== null && (e.handleSlide(t.clientX, t.clientY), Py(t));
		}), G(e, "handleTouchSlide", function(t) {
			if (e.state.slidingIndex !== null) {
				if (t.changedTouches.length > 1) {
					e.endSlide();
					return;
				}
				var n = t.changedTouches[0];
				e.handleSlide(n.clientX, n.clientY), Py(t);
			}
		}), G(e, "handleSlide", function(t, n) {
			var r = e.state, i = r.slidingIndex, a = r.sliderBox, o = e.props.orientation === "vertical" ? (n - a.top) / a.height * ky : (t - a.left) / a.width * ky;
			e.slideTo(i, o), e.canMove(i, o) && (e.setState({ mousePos: {
				x: t,
				y: n
			} }), e.props.onSliderDragMove && e.props.onSliderDragMove());
		}), G(e, "endSlide", function() {
			var t = e.state.slidingIndex;
			if (e.setState({ slidingIndex: null }), document.removeEventListener("mouseup", e.endSlide, !1), document.removeEventListener("touchend", e.endSlide, !1), document.removeEventListener("touchmove", e.handleTouchSlide, !1), document.removeEventListener("mousemove", e.handleMouseSlide, !1), e.props.onSliderDragEnd && e.props.onSliderDragEnd(), e.props.snap) {
				var n = e.getSnapPosition(e.state.handlePos[t]);
				e.slideTo(t, n, function() {
					return e.fireChangeEvent();
				});
			} else e.fireChangeEvent();
		}), G(e, "handleClick", function(t) {
			if (!t.target.getAttribute("data-handle-key")) {
				var n = e.getSliderBoundingBox(), r = (e.props.orientation === "vertical" ? (t.clientY - n.top) / n.height : (t.clientX - n.left) / n.width) * ky, i = e.getClosestHandle(r), a = e.getSnapPosition(r);
				e.slideTo(i, a, function() {
					return e.fireChangeEvent();
				}), e.props.onClick && e.props.onClick();
			}
		}), G(e, "handleKeydown", function(t) {
			var n = Ny(t);
			if (t.keyCode === Dy.ESC) {
				t.currentTarget.blur();
				return;
			}
			var r = e.getNextPositionForKey(n, t.keyCode);
			r !== null && (e.canMove(n, r) && (e.slideTo(n, r, function() {
				return e.fireChangeEvent();
			}), e.props.onKeyPress && e.props.onKeyPress()), Py(t));
		}), G(e, "validatePosition", function(t, n) {
			var r = e.state, i = r.handlePos, a = r.handleDimensions;
			return Math.max(Math.min(n, i[t + 1] === void 0 ? ky : i[t + 1] - a), i[t - 1] === void 0 ? Oy : i[t - 1] + a);
		}), G(e, "validateValues", function(t, n) {
			var r = n || e.props, i = r.max, a = r.min;
			return t.map(function(e, t, n) {
				var r = Math.max(Math.min(e, i), a);
				return n.length && r < n[t - 1] ? n[t - 1] : r;
			});
		}), G(e, "canMove", function(t, n) {
			var r = e.state, i = r.handlePos, a = r.handleDimensions;
			return !(n < Oy || n > ky || n > (i[t + 1] === void 0 ? Infinity : i[t + 1] - a) || n < (i[t - 1] === void 0 ? -Infinity : i[t - 1] + a));
		}), G(e, "fireChangeEvent", function() {
			var t = e.props.onChange;
			t && t(e.getPublicState());
		}), G(e, "slideTo", function(t, n, r) {
			var i = e.getNextState(t, n);
			e.setState(i, function() {
				var t = e.props.onValuesUpdated;
				t && t(e.getPublicState()), r && r();
			});
		}), G(e, "updateNewValues", function(t) {
			if (e.state.slidingIndex === null) {
				var n = t.max, r = t.min, i = t.values, a = e.validateValues(i, t);
				e.setState({
					handlePos: a.map(function(e) {
						return Ay(e, r, n);
					}),
					values: a
				}, function() {
					return e.fireChangeEvent();
				});
			}
		}), G(e, "render", function() {
			var t = e.props, n = t.children, r = t.disabled, i = t.handle, a = t.max, o = t.min, s = t.orientation, c = t.pitComponent, l = t.pitPoints, u = t.progressBar, d = e.state, f = d.className, p = d.handlePos, m = d.values;
			return /*#__PURE__*/ R("div", {
				className: f,
				ref: e.rheostat,
				onClick: r ? void 0 : e.handleClick,
				style: { position: "relative" }
			}, /*#__PURE__*/ R("div", { className: "rheostat-background" }), p.map(function(t, n) {
				var a = s === "vertical" ? {
					top: `${t}%`,
					position: "absolute"
				} : {
					left: `${t}%`,
					position: "absolute"
				};
				return /*#__PURE__*/ R(i, {
					"aria-valuemax": e.getMaxValue(n),
					"aria-valuemin": e.getMinValue(n),
					"aria-valuenow": m[n],
					"aria-disabled": r,
					"data-handle-key": n,
					className: "rheostat-handle",
					key: `handle-${n}`,
					onClick: Py,
					onKeyDown: r ? void 0 : e.handleKeydown,
					onMouseDown: r ? void 0 : e.startMouseSlide,
					onTouchStart: r ? void 0 : e.startTouchSlide,
					role: "slider",
					style: a,
					tabIndex: 0
				});
			}), p.map(function(t, n, r) {
				return n === 0 && r.length > 1 ? null : /*#__PURE__*/ R(u, {
					className: "rheostat-progress",
					key: `progress-bar-${n}`,
					style: e.getProgressStyle(n)
				});
			}), c && l.map(function(e) {
				var t = Ay(e, o, a), n = s === "vertical" ? {
					top: `${t}%`,
					position: "absolute"
				} : {
					left: `${t}%`,
					position: "absolute"
				};
				return /*#__PURE__*/ R(c, {
					key: `pit-${e}`,
					style: n
				}, e);
			}), n);
		}), e;
	}
	return t;
}(ia);
G(Iy, "defaultProps", {
	className: "",
	children: null,
	disabled: !1,
	handle: Fy,
	max: ky,
	min: Oy,
	onClick: null,
	onChange: null,
	onKeyPress: null,
	onSliderDragEnd: null,
	onSliderDragMove: null,
	onSliderDragStart: null,
	onValuesUpdated: null,
	orientation: "horizontal",
	pitComponent: null,
	pitPoints: [],
	progressBar: "div",
	snap: !1,
	snapPoints: [],
	values: [Oy]
});
//#endregion
//#region node_modules/instantsearch.js/es/components/Slider/Slider.js
var Ly = /*#__PURE__*/ function(e) {
	wd(t, e);
	function t() {
		bd(this, t);
		var e = yd(this, t, arguments);
		return G(e, "handleChange", function(t) {
			var n = t.values;
			e.isDisabled || e.props.refine(n);
		}), G(e, "createHandleComponent", function(e) {
			return function(t) {
				var n = Math.round(parseFloat(t["aria-valuenow"]) * 100) / 100, r = (e === void 0 ? "undefined" : ku(e)) === "object" && e.format ? e.format(n) : n, i = $(t.className, t["data-handle-key"] === 0 && "rheostat-handle-lower", t["data-handle-key"] === 1 && "rheostat-handle-upper"), a = t["data-handle-key"] === 0 ? "Minimum Filter Handle" : "Maximum Filter Handle";
				return /*#__PURE__*/ R("div", q(K({}, t), {
					className: i,
					"aria-label": a
				}), e && /*#__PURE__*/ R("div", { className: "rheostat-tooltip" }, r));
			};
		}), e;
	}
	return Sd(t, [
		{
			key: "isDisabled",
			get: function() {
				return this.props.min >= this.props.max;
			}
		},
		{
			key: "computeDefaultPitPoints",
			value: function(e) {
				var t = e.min, n = e.max, r = n - t, i = 34, a = r / i;
				return [t].concat(W(eg({ end: i - 1 }).map(function(e) {
					return t + a * (e + 1);
				})), [n]);
			}
		},
		{
			key: "computeSnapPoints",
			value: function(e) {
				var t = e.min, n = e.max, r = e.step;
				if (r) return W(eg({
					start: t,
					end: n,
					step: r
				})).concat([n]);
			}
		},
		{
			key: "render",
			value: function() {
				var e = this.props, t = e.tooltips, n = e.step, r = e.pips, i = e.values, a = e.cssClasses, o = this.isDisabled ? {
					min: this.props.min,
					max: this.props.max + .001
				} : this.props, s = o.min, c = o.max, l = this.computeSnapPoints({
					min: s,
					max: c,
					step: n
				}), u = r === !1 ? [] : this.computeDefaultPitPoints({
					min: s,
					max: c
				});
				return /*#__PURE__*/ R("div", { className: $(a.root, this.isDisabled && a.disabledRoot) }, /*#__PURE__*/ R(Iy, {
					handle: this.createHandleComponent(t),
					onChange: this.handleChange,
					min: s,
					max: c,
					pitComponent: Ey,
					pitPoints: u,
					snap: !0,
					snapPoints: l,
					values: this.isDisabled ? [s, c] : i,
					disabled: this.isDisabled
				}));
			}
		}
	]), t;
}(ia), Ry = X({ name: "range-slider" }), zy = u_("RangeSlider"), By = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.pips, i = e.step, a = e.tooltips;
	return function(e, o) {
		var s = e.refine, c = e.range, l = e.start;
		if (!o) {
			var u = c.min, d = c.max, f = U(l, 2), p = f[0], m = f[1], h = p === -Infinity ? u : p, g = m === Infinity ? d : m;
			z(/*#__PURE__*/ R(Ly, {
				cssClasses: n,
				refine: s,
				min: u,
				max: d,
				values: [h > d ? d : h, g < u ? u : g],
				tooltips: a,
				step: i,
				pips: r
			}), t);
		}
	};
}, Vy = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.min, a = t.max, o = t.cssClasses, s = o === void 0 ? {} : o, c = t.step, l = t.pips, u = l === void 0 || l, d = t.precision, f = d === void 0 ? 0 : d, p = t.tooltips, m = p === void 0 || p;
	if (!n) throw Error(Ry("The `container` option is required."));
	var h = f_(n);
	return q(K({}, sg(By({
		containerNode: h,
		step: c,
		pips: u,
		tooltips: m,
		cssClasses: {
			root: $(zy(), s.root),
			disabledRoot: $(zy({ modifierName: "disabled" }), s.disabledRoot)
		}
	}), function() {
		return z(null, h);
	})({
		attribute: r,
		min: i,
		max: a,
		precision: f
	})), {
		$$type: "ais.rangeSlider",
		$$widgetType: "ais.rangeSlider"
	});
};
//#endregion
//#region node_modules/instantsearch.js/es/widgets/rating-menu/defaultTemplates.js
function Hy(e) {
	var t = e.children, n = e.count, r = e.value, i = e.url, a = e.cssClasses;
	return n ? /*#__PURE__*/ R("a", {
		className: $(a.link),
		"aria-label": `${r} & up`,
		href: i
	}, t) : /*#__PURE__*/ R("div", {
		className: $(a.link),
		"aria-label": `${r} & up`,
		disabled: !0
	}, t);
}
var Uy = { item: function(e) {
	var t = e.count, n = e.value, r = e.url, i = e.stars, a = e.cssClasses;
	return /*#__PURE__*/ R(Hy, {
		count: t,
		value: n,
		url: r,
		cssClasses: a
	}, i.map(function(e, t) {
		return /*#__PURE__*/ R("svg", {
			key: t,
			className: $(a.starIcon, e ? a.fullStarIcon : a.emptyStarIcon),
			"aria-hidden": "true",
			width: "24",
			height: "24"
		}, /*#__PURE__*/ R("use", { xlinkHref: e ? "#ais-RatingMenu-starSymbol" : "#ais-RatingMenu-starEmptySymbol" }));
	}), /*#__PURE__*/ R("span", {
		"aria-hidden": "true",
		className: $(a.label)
	}, "& Up"), t && /*#__PURE__*/ R("span", { className: $(a.count) }, Ov(t)));
} }, Wy = X({ name: "rating-menu" }), Gy = u_("RatingMenu"), Ky = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.templates, i = e.renderState;
	return function(e, a) {
		var o = e.refine, s = e.items, c = e.createURL, l = e.instantSearchInstance;
		if (a) {
			i.templateProps = m_({
				defaultTemplates: Uy,
				templatesConfig: l.templatesConfig,
				templates: r
			});
			return;
		}
		z(/*#__PURE__*/ R(Dv, {
			createURL: c,
			cssClasses: n,
			facetValues: s,
			templateProps: i.templateProps,
			toggleRefinement: o
		}, /*#__PURE__*/ R("svg", { style: "display:none;" }, /*#__PURE__*/ R("symbol", {
			id: Gy({ descendantName: "starSymbol" }),
			viewBox: "0 0 24 24"
		}, /*#__PURE__*/ R("path", { d: "M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z" })), /*#__PURE__*/ R("symbol", {
			id: Gy({ descendantName: "starEmptySymbol" }),
			viewBox: "0 0 24 24"
		}, /*#__PURE__*/ R("path", { d: "M12 6.76l1.379 4.246h4.465l-3.612 2.625 1.379 4.246-3.611-2.625-3.612 2.625 1.379-4.246-3.612-2.625h4.465l1.38-4.246zm0-6.472l-2.833 8.718h-9.167l7.416 5.389-2.833 8.718 7.417-5.388 7.416 5.388-2.833-8.718 7.417-5.389h-9.167l-2.833-8.718z" })))), t);
	};
}, qy = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.max, a = i === void 0 ? 5 : i, o = t.cssClasses, s = o === void 0 ? {} : o, c = t.templates, l = c === void 0 ? {} : c;
	if (!n) throw Error(Wy("The `container` option is required."));
	var u = f_(n);
	return q(K({}, wg(Ky({
		containerNode: u,
		cssClasses: {
			root: $(Gy(), s.root),
			noRefinementRoot: $(Gy({ modifierName: "noRefinement" }), s.noRefinementRoot),
			list: $(Gy({ descendantName: "list" }), s.list),
			item: $(Gy({ descendantName: "item" }), s.item),
			selectedItem: $(Gy({
				descendantName: "item",
				modifierName: "selected"
			}), s.selectedItem),
			disabledItem: $(Gy({
				descendantName: "item",
				modifierName: "disabled"
			}), s.disabledItem),
			link: $(Gy({ descendantName: "link" }), s.link),
			starIcon: $(Gy({ descendantName: "starIcon" }), s.starIcon),
			fullStarIcon: $(Gy({
				descendantName: "starIcon",
				modifierName: "full"
			}), s.fullStarIcon),
			emptyStarIcon: $(Gy({
				descendantName: "starIcon",
				modifierName: "empty"
			}), s.emptyStarIcon),
			label: $(Gy({ descendantName: "label" }), s.label),
			count: $(Gy({ descendantName: "count" }), s.count)
		},
		renderState: {},
		templates: l
	}), function() {
		return z(null, u);
	})({
		attribute: r,
		max: a
	})), { $$widgetType: "ais.ratingMenu" });
}, Jy = {
	aiMode: function(e) {
		var t = e.cssClasses;
		return /*#__PURE__*/ R(ra, null, /*#__PURE__*/ R("svg", {
			className: t.aiModeIcon,
			xmlns: "http://www.w3.org/2000/svg",
			fill: "none",
			viewBox: "0 0 20 20",
			width: "16",
			height: "16",
			"aria-hidden": "true"
		}, /*#__PURE__*/ R("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M10 1.875c.27 0 .51.173.594.43l1.593 4.844a1.043 1.043 0 0 0 .664.664l4.844 1.593a.625.625 0 0 1 0 1.188l-4.844 1.593a1.043 1.043 0 0 0-.664.664l-1.593 4.844a.625.625 0 0 1-1.188 0l-1.593-4.844a1.042 1.042 0 0 0-.664-.664l-4.844-1.593a.625.625 0 0 1 0-1.188l4.844-1.593a1.042 1.042 0 0 0 .664-.664l1.593-4.844a.625.625 0 0 1 .594-.43ZM9 7.539A2.292 2.292 0 0 1 7.54 9L4.5 10l3.04 1A2.292 2.292 0 0 1 9 12.46l1 3.04 1-3.04A2.293 2.293 0 0 1 12.46 11l3.04-1-3.04-1A2.292 2.292 0 0 1 11 7.54L10 4.5 9 7.54ZM4.167 1.875c.345 0 .625.28.625.625v3.333a.625.625 0 0 1-1.25 0V2.5c0-.345.28-.625.625-.625ZM15.833 13.542c.345 0 .625.28.625.625V17.5a.625.625 0 1 1-1.25 0v-3.333c0-.345.28-.625.625-.625Z",
			"clip-rule": "evenodd"
		}), /*#__PURE__*/ R("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M1.875 4.167c0-.346.28-.625.625-.625h3.333a.625.625 0 1 1 0 1.25H2.5a.625.625 0 0 1-.625-.625ZM13.542 15.833c0-.345.28-.625.625-.625H17.5a.625.625 0 0 1 0 1.25h-3.333a.625.625 0 0 1-.625-.625Z",
			"clip-rule": "evenodd"
		})), /*#__PURE__*/ R("span", { className: t.aiModeLabel }, "AI Mode"));
	},
	reset: function(e) {
		var t = e.cssClasses;
		return /*#__PURE__*/ R("svg", {
			className: t.resetIcon,
			viewBox: "0 0 20 20",
			width: "10",
			height: "10",
			"aria-hidden": "true"
		}, /*#__PURE__*/ R("path", { d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" }));
	},
	submit: function(e) {
		var t = e.cssClasses;
		return /*#__PURE__*/ R("svg", {
			className: t.submitIcon,
			width: "10",
			height: "10",
			viewBox: "0 0 40 40",
			"aria-hidden": "true"
		}, /*#__PURE__*/ R("path", { d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" }));
	},
	loadingIndicator: function(e) {
		var t = e.cssClasses;
		return /*#__PURE__*/ R("svg", {
			"aria-label": "Results are loading",
			className: t.loadingIcon,
			width: "16",
			height: "16",
			viewBox: "0 0 38 38",
			stroke: "#444",
			"aria-hidden": "true"
		}, /*#__PURE__*/ R("g", {
			fill: "none",
			"fill-rule": "evenodd"
		}, /*#__PURE__*/ R("g", {
			transform: "translate(1 1)",
			"stroke-width": "2"
		}, /*#__PURE__*/ R("circle", {
			"stroke-opacity": ".5",
			cx: "18",
			cy: "18",
			r: "18"
		}), /*#__PURE__*/ R("path", { d: "M36 18c0-9.94-8.06-18-18-18" }, /*#__PURE__*/ R("animateTransform", {
			attributeName: "transform",
			type: "rotate",
			from: "0 18 18",
			to: "360 18 18",
			dur: "1s",
			repeatCount: "indefinite"
		})))));
	}
}, Yy = {
	item: function(e) {
		var t = e.cssClasses, n = e.count, r = e.value, i = e.highlighted, a = e.isRefined, o = e.isFromSearch;
		return /*#__PURE__*/ R("label", { className: $(t.label) }, /*#__PURE__*/ R("input", {
			type: "checkbox",
			className: $(t.checkbox),
			value: r,
			defaultChecked: a
		}), /*#__PURE__*/ R("span", {
			className: $(t.labelText),
			dangerouslySetInnerHTML: o ? { __html: i } : void 0
		}, !o && i), /*#__PURE__*/ R("span", { className: $(t.count) }, Ov(n)));
	},
	showMoreText: function(e) {
		return e.isShowingMore ? "Show less" : "Show more";
	},
	searchableNoResults: function() {
		return "No results";
	}
}, Xy = X({ name: "refinement-list" }), Zy = u_("RefinementList"), Qy = u_("SearchBox"), $y = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.templates, i = e.searchBoxTemplates, a = e.renderState, o = e.showMore, s = e.showMoreButtonLabel, c = e.searchable, l = e.searchablePlaceholder, u = e.searchableIsAlwaysActive, d = e.searchableSelectOnSubmit;
	return function(e, f) {
		var p = e.refine, m = e.items, h = e.createURL, g = e.searchForItems, _ = e.isFromSearch, v = e.instantSearchInstance, y = e.toggleShowMore, b = e.isShowingMore, x = e.hasExhaustiveItems, S = e.canToggleShowMore;
		if (f) {
			a.templateProps = m_({
				defaultTemplates: Yy,
				templatesConfig: v.templatesConfig,
				templates: r
			}), a.searchBoxTemplateProps = m_({
				defaultTemplates: Jy,
				templatesConfig: v.templatesConfig,
				templates: i
			});
			return;
		}
		z(/*#__PURE__*/ R(Dv, {
			createURL: h,
			cssClasses: n,
			facetValues: m,
			templateProps: a.templateProps,
			searchBoxTemplateProps: a.searchBoxTemplateProps,
			toggleRefinement: p,
			searchFacetValues: c ? g : void 0,
			searchPlaceholder: l,
			searchIsAlwaysActive: u,
			isFromSearch: _,
			showMore: o && !_ && m.length > 0,
			showMoreButtonLabel: s,
			toggleShowMore: y,
			isShowingMore: b,
			hasExhaustiveItems: x,
			canToggleShowMore: S,
			searchableSelectOnSubmit: d
		}), t);
	};
}, eb = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.operator, a = t.sortBy, o = t.limit, s = t.showMore, c = t.showMoreLimit, l = t.showMoreButtonLabel, u = t.searchable, d = u !== void 0 && u, f = t.searchablePlaceholder, p = f === void 0 ? "Search..." : f, m = t.searchableEscapeFacetValues, h = m === void 0 || m, g = t.searchableIsAlwaysActive, _ = g === void 0 || g, v = t.searchableSelectOnSubmit, y = v === void 0 || v, b = t.cssClasses, x = b === void 0 ? {} : b, S = t.templates, C = S === void 0 ? {} : S, w = t.transformItems;
	if (!n) throw Error(Xy("The `container` option is required."));
	var T = d ? !!h : !1, E = f_(n);
	return q(K({}, ug($y({
		containerNode: E,
		cssClasses: {
			root: $(Zy(), x.root),
			noRefinementRoot: $(Zy({ modifierName: "noRefinement" }), x.noRefinementRoot),
			list: $(Zy({ descendantName: "list" }), x.list),
			item: $(Zy({ descendantName: "item" }), x.item),
			selectedItem: $(Zy({
				descendantName: "item",
				modifierName: "selected"
			}), x.selectedItem),
			searchBox: $(Zy({ descendantName: "searchBox" }), x.searchBox),
			label: $(Zy({ descendantName: "label" }), x.label),
			checkbox: $(Zy({ descendantName: "checkbox" }), x.checkbox),
			labelText: $(Zy({ descendantName: "labelText" }), x.labelText),
			count: $(Zy({ descendantName: "count" }), x.count),
			noResults: $(Zy({ descendantName: "noResults" }), x.noResults),
			showMore: $(Zy({ descendantName: "showMore" }), x.showMore),
			disabledShowMore: $(Zy({
				descendantName: "showMore",
				modifierName: "disabled"
			}), x.disabledShowMore),
			searchable: {
				root: $(Qy(), x.searchableRoot),
				form: $(Qy({ descendantName: "form" }), x.searchableForm),
				input: $(Qy({ descendantName: "input" }), x.searchableInput),
				submit: $(Qy({ descendantName: "submit" }), x.searchableSubmit),
				submitIcon: $(Qy({ descendantName: "submitIcon" }), x.searchableSubmitIcon),
				reset: $(Qy({ descendantName: "reset" }), x.searchableReset),
				resetIcon: $(Qy({ descendantName: "resetIcon" }), x.searchableResetIcon),
				loadingIndicator: $(Qy({ descendantName: "loadingIndicator" }), x.searchableLoadingIndicator),
				loadingIcon: $(Qy({ descendantName: "loadingIcon" }), x.searchableLoadingIcon)
			}
		},
		templates: C,
		searchBoxTemplates: {
			submit: C.searchableSubmit,
			reset: C.searchableReset,
			loadingIndicator: C.searchableLoadingIndicator
		},
		renderState: {},
		searchable: d,
		searchablePlaceholder: p,
		searchableIsAlwaysActive: _,
		searchableSelectOnSubmit: y,
		showMore: s,
		showMoreButtonLabel: l
	}), function() {
		return z(null, E);
	})({
		attribute: r,
		operator: i,
		limit: o,
		showMore: s,
		showMoreLimit: c,
		sortBy: a,
		escapeFacetValues: T,
		transformItems: w
	})), { $$widgetType: "ais.refinementList" });
}, tb = X({ name: "sort-by" }), nb = u_("SortBy"), rb = function(e) {
	var t = e.containerNode, n = e.cssClasses;
	return function(e, r) {
		var i = e.currentRefinement, a = e.options, o = e.refine;
		r || z(/*#__PURE__*/ R("div", { className: n.root }, /*#__PURE__*/ R(Wv, {
			cssClasses: n,
			currentValue: i,
			options: a,
			setValue: o,
			ariaLabel: "Sort results by"
		})), t);
	};
}, ib = function(e) {
	var t = e || {}, n = t.container, r = t.items, i = t.cssClasses, a = i === void 0 ? {} : i, o = t.transformItems;
	if (!n) throw Error(tb("The `container` option is required."));
	var s = f_(n);
	return q(K({}, yg(rb({
		containerNode: s,
		cssClasses: {
			root: $(nb(), a.root),
			select: $(nb({ descendantName: "select" }), a.select),
			option: $(nb({ descendantName: "option" }), a.option)
		}
	}), function() {
		return z(null, s);
	})({
		container: s,
		items: r,
		transformItems: o
	})), { $$widgetType: "ais.sortBy" });
}, ab = function(e) {
	var t = e.currentRefinement, n = e.refine, r = e.cssClasses, i = e.templateProps;
	return /*#__PURE__*/ R("div", { className: r.root }, /*#__PURE__*/ R("label", { className: r.label }, /*#__PURE__*/ R("input", {
		className: r.checkbox,
		type: "checkbox",
		checked: t.isRefined,
		onChange: function(e) {
			return n({ isRefined: !e.target.checked });
		}
	}), /*#__PURE__*/ R(c_, q(K({}, i), {
		rootTagName: "span",
		rootProps: { className: r.labelText },
		templateKey: "labelText",
		data: t
	}))));
}, ob = { labelText: function(e) {
	return e.name;
} }, sb = X({ name: "toggle-refinement" }), cb = u_("ToggleRefinement"), lb = function(e) {
	var t = e.containerNode, n = e.cssClasses, r = e.renderState, i = e.templates;
	return function(e, a) {
		var o = e.value, s = e.refine, c = e.instantSearchInstance;
		if (a) {
			r.templateProps = m_({
				defaultTemplates: ob,
				templatesConfig: c.templatesConfig,
				templates: i
			});
			return;
		}
		z(/*#__PURE__*/ R(ab, {
			cssClasses: n,
			currentRefinement: o,
			templateProps: r.templateProps,
			refine: s
		}), t);
	};
}, ub = function(e) {
	var t = e || {}, n = t.container, r = t.attribute, i = t.cssClasses, a = i === void 0 ? {} : i, o = t.templates, s = o === void 0 ? {} : o, c = t.on, l = c === void 0 || c, u = t.off;
	if (!n) throw Error(sb("The `container` option is required."));
	var d = f_(n);
	return q(K({}, Mg(lb({
		containerNode: d,
		cssClasses: {
			root: $(cb(), a.root),
			label: $(cb({ descendantName: "label" }), a.label),
			checkbox: $(cb({ descendantName: "checkbox" }), a.checkbox),
			labelText: $(cb({ descendantName: "labelText" }), a.labelText)
		},
		renderState: {},
		templates: s
	}), function() {
		return z(null, d);
	})({
		attribute: r,
		on: l,
		off: u
	})), { $$widgetType: "ais.toggleRefinement" });
}, db = /* @__PURE__ */ new Set([
	"list",
	"menu",
	"select",
	"toggle",
	"range",
	"input",
	"numeric",
	"rating",
	"hierarchical"
]), fb = "list", pb = /* @__PURE__ */ new Set([
	"limit",
	"more",
	"sort",
	"maxlabel",
	"format",
	"items",
	"on",
	"max",
	"precision",
	"attributes",
	"separator"
]), mb = /^([a-z]+)[=:](.*)$/, hb = {
	count: ["count:desc", "name:asc"],
	name: ["name:asc", "count:desc"]
};
function gb(e) {
	let t = e.split(",").map((e) => e.trim()).filter(Boolean);
	if (t.length === 0) return null;
	let n = {};
	for (let e of t) {
		let t = mb.exec(e);
		if (!t || !pb.has(t[1])) return null;
		n[t[1]] = t[2].trim();
	}
	return n;
}
function _b(e, t) {
	let n = Number.parseInt(e ?? "", 10);
	return Number.isFinite(n) && n > 0 ? n : t;
}
var vb = /^([A-Za-z_][\w.]*)\s*[=:](\S.*)$/, yb = /^([A-Za-z_][\w.]*)\s*[=:]\s*(.+)$/, bb = /^(-?\d*(?:\.\d+)?):(-?\d*(?:\.\d+)?)$/;
function xb(e) {
	let t = Number.parseFloat(e);
	return Number.isFinite(t) ? t : void 0;
}
function Sb(e) {
	let t = bb.exec(e);
	return t ? {
		min: xb(t[1]),
		max: xb(t[2])
	} : null;
}
function Cb(e) {
	let [t, ...n] = e.split("|").map((e) => e.trim());
	if (!t) return null;
	let r = fb, i = "", a = {};
	for (let e of n) {
		if (!e) continue;
		if (db.has(e)) {
			r = e;
			continue;
		}
		let t = gb(e);
		t ? a = {
			...a,
			...t
		} : i ||= e;
	}
	return {
		attribute: t,
		type: r,
		label: i,
		limit: _b(a.limit, 8),
		showMoreLimit: _b(a.more, 20),
		maxLabelLength: _b(a.maxlabel, void 0),
		sortBy: hb[a.sort],
		format: a.format,
		items: a.items ? a.items.split(";").map((e) => Sb(e.trim())).filter((e) => e && (e.min !== void 0 || e.max !== void 0)) : void 0,
		on: a.on,
		max: _b(a.max, 5),
		precision: _b(a.precision, void 0) ?? 0,
		attributes: a.attributes ? a.attributes.split(";").map((e) => e.trim()).filter(Boolean) : void 0,
		separator: a.separator
	};
}
function wb(e, t) {
	return String(e ?? "").split("\n").map((e) => e.trim()).filter((e) => e && !e.startsWith("#")).map(t).filter(Boolean);
}
function Tb(e) {
	return wb(e, Cb);
}
function Eb(e) {
	return wb(e, (e) => {
		let t = e.split("|").map((e) => e.trim()), n = t.some((e) => vb.test(e)) ? vb : yb, r = t.find((e) => n.test(e));
		if (!r) return null;
		let [, i, a] = n.exec(r), o = a.trim(), s = t.find((e) => e && e !== r), c = Sb(o);
		return c ? c.min === void 0 && c.max === void 0 ? null : {
			attribute: i,
			label: s || r,
			...c
		} : {
			attribute: i,
			value: o,
			label: s || o
		};
	});
}
//#endregion
//#region render/collection-button.js
var Db = {
	konsole: (e) => e`
    <rect x="2.5" y="6" width="19" height="12" rx="2.5" />
    <path d="M6 10v4M4 12h4" />
    <circle cx="16.5" cy="11" r=".9" fill="currentColor" stroke="none" />
    <circle cx="18.8" cy="13.4" r=".9" fill="currentColor" stroke="none" />
  `,
	spiele: (e) => e`
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <path d="M8 3v18" />
    <path d="M12 7h4M12 10h4" />
  `,
	zubehoer: (e) => e`
    <path
      d="M7.5 7h9a5 5 0 0 1 4.9 4l.5 4.6A2.6 2.6 0 0 1 17 17.2L15.6 15H8.4L7 17.2a2.6 2.6 0 0 1-4.9-1.6L2.6 11A5 5 0 0 1 7.5 7Z"
    />
    <path d="M7 10.5v2.2M5.9 11.6h2.2M16 10.9h.01M18 13h.01" />
  `,
	fallback: (e) => e`
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  `
};
function Ob(e) {
	let t = e.toLowerCase();
	return t.includes("zubehör") || t.includes("zubehoer") ? Db.zubehoer : t.includes("spiel") ? Db.spiele : t.includes("konsole") ? Db.konsole : Db.fallback;
}
function kb(e, t) {
	let n = qo(e), r = e.product_count ?? 0;
	return t`
    <a class="kk-collection-card" href="${$o(e)}">
      <span class="kk-collection-card__icon" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          ${Ob(n)(t)}
        </svg>
      </span>
      <span class="kk-collection-card__body">
        <span class="kk-collection-card__label">${n}</span>
        <span class="kk-collection-card__count">
          ${B(r === 1 ? "product_count_one" : "product_count_other", { count: r })}
        </span>
      </span>
      <span class="kk-collection-card__arrow" aria-hidden="true">→</span>
    </a>
  `;
}
//#endregion
//#region render/hit-card.js
var Ab = 500;
function jb(e, t) {
	let n = e.available !== !1, r = Math.round(e.max_saving_percent ?? 0), i = Xo(e.image, Ab), a = (e.variant_count ?? 1) > 1 ? B("price_from", { price: Yo(e.price_from) }) : Yo(e.price_from);
	return t`
    <a class="kk-hit-card${n ? "" : " kk-hit-card--unavailable"}" href="${Qo(e)}">
      <span class="kk-hit-card__media">
        ${i ? t`<img class="kk-hit-card__image" src="${i}" alt="" loading="lazy" decoding="async" />` : t`<span class="kk-hit-card__image kk-hit-card__image--empty" aria-hidden="true"></span>`}
        ${r > 0 ? t`<span class="kk-hit-card__badge">-${r}%</span>` : ""}
        ${n ? "" : t`<span class="kk-hit-card__badge kk-hit-card__badge--muted">${B("unavailable")}</span>`}
      </span>
      <span class="kk-hit-card__title">${qo(e)}</span>
      <span class="kk-hit-card__subtitle">${Jo(e)}</span>
      <span class="kk-hit-card__price">${a}</span>
    </a>
  `;
}
//#endregion
//#region pages/search-page.js
var Mb = [
	{
		preset: "catalog-search-topseller",
		labelKey: "sort_topseller",
		symbol: "★"
	},
	{
		preset: "catalog-search-price-asc",
		labelKey: "sort_price_asc",
		symbol: "↑"
	},
	{
		preset: "catalog-search-price-desc",
		labelKey: "sort_price_desc",
		symbol: "↓"
	},
	{
		preset: "catalog-search-discount",
		labelKey: "sort_discount",
		symbol: "%"
	},
	{
		preset: "catalog-search-name-az",
		labelKey: "sort_name_az",
		symbol: "↑"
	},
	{
		preset: "catalog-search-name-za",
		labelKey: "sort_name_za",
		symbol: "↓"
	},
	{
		preset: "catalog-search-new",
		labelKey: "sort_new",
		symbol: "✦"
	},
	{
		preset: "catalog-search-back-in-stock",
		labelKey: "sort_back_in_stock",
		symbol: "↻"
	}
], Nb = (e) => `${Ql}/sort/_preset:${e}`, Pb = ({ attribute: e, label: t }) => t || B(`facet_${e}`) || e;
function Fb(e, t) {
	let n = document.createElement("div");
	n.className = "kk-search-page__facet";
	let r = document.createElement("h3");
	r.className = "kk-search-page__facet-title", r.textContent = Pb(t);
	let i = document.createElement("div");
	return n.append(r, i), e.append(n), i;
}
var Ib = (e) => (t) => e.format === "money" ? Yo(t) : String(Math.round(t));
function Lb({ min: e, max: t }, n) {
	return e !== void 0 && t !== void 0 ? `${n(e)} – ${n(t)}` : t === void 0 ? `≥ ${n(e)}` : `≤ ${n(t)}`;
}
function Rb(e, t, n, r = !1) {
	let i = document.createElement("div");
	i.className = "kk-search-page__range-footer";
	let a = document.createElement("span");
	a.className = "kk-search-page__range-text", a.hidden = !r;
	let o = document.createElement("button");
	return o.type = "button", o.className = "kk-search-page__range-reset", o.textContent = B("reset"), o.hidden = !0, i.append(a, o), e.append(i), sg((e, n) => {
		let { range: i, start: s } = e;
		if (n && o.addEventListener("click", () => e.refine([void 0, void 0])), r) {
			let { min: e, max: n } = i;
			a.textContent = e === void 0 || n === void 0 ? "" : `${t(e)} – ${t(n)}`;
		}
		o.hidden = !Number.isFinite(s[0]) && !Number.isFinite(s[1]);
	})({ attribute: n });
}
function zb(e, t) {
	let { attribute: n, type: r, limit: i, showMoreLimit: a, sortBy: o, maxLabelLength: s } = t, c = Ib(t), l = (e) => vy({ hidden: e }), u = () => l(({ items: e }) => !e || e.length <= 1), d = () => l(({ canRefine: e }) => !e), f = {
		container: e,
		attribute: n,
		limit: i,
		...o ? { sortBy: o } : {},
		...s ? { transformItems: (e) => e.filter((e) => e.label.length <= s) } : {}
	}, p = { showMoreText: ({ isShowingMore: e }) => B(e ? "show_less" : "show_more") };
	switch (r) {
		case "menu": return u()(Yv)({
			...f,
			showMore: !0,
			showMoreLimit: a,
			templates: p
		});
		case "select": return u()(ty)({
			...f,
			templates: { defaultOption: () => B("facet_all") }
		});
		case "toggle": return l(({ onFacetValue: e }) => !e || e.count === 0)(ub)({
			container: e,
			attribute: n,
			on: t.on ?? !0,
			templates: { labelText: () => B(`toggle_${n}`) || Pb(t) }
		});
		case "range": return [d()(Vy)({
			container: e,
			attribute: n,
			pips: !1,
			tooltips: { format: c }
		}), Rb(e.parentElement ?? e, c, n)];
		case "input": return [d()(Ty)({
			container: e,
			attribute: n,
			precision: t.precision,
			templates: {
				separatorText: () => B("range_to"),
				submitText: () => "✓"
			}
		}), Rb(e.parentElement ?? e, c, n, !0)];
		case "numeric": return t.items?.length ? l(({ hasNoResults: e }) => e)(oy)({
			container: e,
			attribute: n,
			items: [{ label: B("facet_all") }, ...t.items.map((e) => ({
				label: Lb(e, c),
				start: e.min,
				end: e.max
			}))]
		}) : null;
		case "rating": return l(({ items: e }) => !e || e.length === 0)(qy)({
			container: e,
			attribute: n,
			max: t.max
		});
		case "hierarchical": return t.attributes?.length ? u()(Nv)({
			container: e,
			attributes: t.attributes,
			limit: i,
			showMore: !0,
			showMoreLimit: a,
			...t.separator ? { separator: t.separator } : {},
			templates: p
		}) : null;
		default: return u()(eb)({
			...f,
			showMore: !0,
			showMoreLimit: a,
			templates: p
		});
	}
}
var Bb = matchMedia("(min-width: 990px)");
function Vb(e, t, n) {
	if (!e || !t || !n) return;
	let r = () => (Bb.matches ? t : n).append(e);
	r(), Bb.addEventListener("change", r);
}
function Hb(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
	for (let i of t) {
		let t = document.createElement("button");
		t.type = "button", t.className = "kk-search-page__badge", t.textContent = i.label, t.setAttribute("aria-pressed", "false"), e.append(t);
		let a = i.value === void 0 ? r : n;
		a.set(i.attribute, [...a.get(i.attribute) ?? [], {
			badge: i,
			button: t
		}]);
	}
	let i = [...n].map(([e, t]) => ug((e, n) => {
		let { items: r } = e;
		for (let { badge: i, button: a } of t) {
			n && a.addEventListener("click", () => e.refine(i.value));
			let t = r.find((e) => e.value === i.value), o = !!t?.isRefined;
			a.setAttribute("aria-pressed", String(o)), a.classList.toggle("kk-search-page__badge--active", o), a.hidden = !t && r.length > 0;
		}
	})({
		attribute: e,
		limit: 1e3
	})), a = [...r].map(([e, t]) => sg((e, n) => {
		let { range: r, start: i } = e, a = (e) => Number.isFinite(e) ? e : void 0, o = ({ min: e, max: t }) => a(i[0]) === e && a(i[1]) === t;
		for (let { badge: i, button: a } of t) {
			n && a.addEventListener("click", () => e.refine(o(i) ? [void 0, void 0] : [i.min, i.max]));
			let t = o(i);
			a.setAttribute("aria-pressed", String(t)), a.classList.toggle("kk-search-page__badge--active", t), a.hidden = !t && Number.isFinite(r.min) && Number.isFinite(r.max) && (i.min !== void 0 && i.min > r.max || i.max !== void 0 && i.max < r.min);
		}
	})({ attribute: e }));
	return [...i, ...a];
}
function Ub(e, t) {
	let n = Rg(e);
	return {
		stateToRoute: (e) => {
			let { query: t, ...r } = n.stateToRoute(e);
			return t === void 0 ? r : {
				q: t,
				...r
			};
		},
		routeToState: (r = {}) => {
			let { q: i, ...a } = r, o = n.routeToState(i === void 0 ? a : {
				query: i,
				...a
			});
			return o[e].sortBy ??= t, o;
		}
	};
}
function Wb(e) {
	return mg((t, n) => {
		let { query: r } = t;
		for (let i of e) {
			if (n) {
				i.addEventListener("input", (e) => t.refine(e.target.value)), i.form?.addEventListener("submit", (e) => e.preventDefault());
				continue;
			}
			document.activeElement !== i && (i.value = r);
		}
	})({});
}
function Gb() {
	let e = document.querySelector("[data-kk-search-page]"), t = document.querySelector(".search-page-input");
	if (!e || !(t instanceof HTMLInputElement)) return;
	let n = [t, ...document.querySelectorAll("[data-kk-header-search]")].filter((e) => e instanceof HTMLInputElement);
	for (let e of document.querySelectorAll("[data-kk-focus-search]")) e.addEventListener("click", () => {
		t.scrollIntoView({
			behavior: i() ? "instant" : "smooth",
			block: "center"
		}), t.focus();
	});
	let a = e.querySelector("[data-kk-hits]"), o = e.querySelector("[data-kk-pagination]"), s = e.querySelector("[data-kk-sort]"), c = e.querySelector("[data-kk-clear-refinements]"), l = document.querySelector("[data-kk-search-title]"), u = document.querySelector("[data-kk-search-count]"), d = e.querySelector("[data-kk-collections]"), f = e.querySelector("[data-kk-facets]"), p = e.querySelector("[data-kk-current-refinements]"), m = e.querySelector("[data-kk-badges]"), h = e.querySelector("[data-kk-sheet-count]");
	if (!a || !o || !s || !c) return;
	Vb(e.querySelector("[data-kk-facets-panel]"), e.querySelector("[data-kk-facets-home]"), e.querySelector("[data-kk-facets-sheet]")), s.replaceChildren(), m?.replaceChildren();
	let g = () => {
		for (let e of document.querySelectorAll("[data-kk-skeleton]")) e.remove();
	}, _ = mm({
		indexName: Ql,
		searchClient: ru().searchClient,
		routing: {
			router: Ig(),
			stateMapping: Ub(Ql, Nb(Mb[0].preset))
		}
	});
	_.on("error", ({ error: e }) => {
		let t = e?.message ?? String(e), n = /facet field named `([^`]+)`/.exec(t)?.[1];
		n ? console.error(`[kk-search] "${n}" is listed in the search facets theme setting, but is not facetable in the catalog schema. Remove it from the setting, or have the connector index it as a facet.`) : console.error("[kk-search] search request failed:", t), g(), u && (u.textContent = B("error"));
	});
	let v = f ? Tb(Go.facets).flatMap((e) => zb(Fb(f, e), e) ?? []).filter(Boolean) : [];
	_.addWidgets([
		Wb(n),
		av({ indexName: Ql }).addWidgets([
			W_({ hitsPerPage: 48 }),
			Dg(({ nbHits: e, query: t, processingTimeMS: n }) => {
				n >= 0 && g(), l && (l.textContent = t ? B("results_for", { terms: t }) : B("results_title")), u && (u.textContent = B(e === 1 ? "count_short_one" : "count_short_other", { count: e }));
			})({}),
			ib({
				container: s,
				items: Mb.map(({ preset: e, labelKey: t, symbol: n }) => ({
					value: Nb(e),
					label: `${n}  ${B(t)}`
				}))
			}),
			...v,
			...p ? [xv({ container: p })] : [],
			...m ? Hb(m, Eb(Go.badges)) : [],
			...h ? [Dg(({ nbHits: e }) => {
				h.textContent = B(e === 1 ? "show_results_one" : "show_results_other", { count: e });
			})({})] : [],
			pv({
				container: c,
				templates: { resetLabel: () => B("clear_filters") }
			}),
			Uv({
				container: a,
				templates: {
					item: (e, { html: t }) => jb(e, t),
					empty: ({ query: e }, { html: t }) => t`<p class="kk-search-page__message">${B("no_results", { terms: e })}</p>`
				}
			}),
			py({ container: o })
		]),
		...d ? [av({ indexName: $l }).addWidgets([W_({ hitsPerPage: r() ? 3 : 5 }), Uv({
			container: d,
			templates: {
				item: (e, { html: t }) => kb(e, t),
				empty: () => ""
			}
		})])] : []
	]), _.start();
}
//#endregion
//#region index.js
Ko && (du(), hu(), Gb());
//#endregion
